const pincodeData = [
  { pincode: 560026, min_days: 1, max_days: 2 },
{ pincode: 560068, min_days: 1, max_days: 2 },
{ pincode: 560098, min_days: 1, max_days: 2 },
{ pincode: 560047, min_days: 1, max_days: 2 },
{ pincode: 560005, min_days: 1, max_days: 2 },
{ pincode: 560007, min_days: 1, max_days: 2 },
{ pincode: 560008, min_days: 1, max_days: 2 },
{ pincode: 560016, min_days: 1, max_days: 2 },
{ pincode: 560017, min_days: 1, max_days: 2 },
{ pincode: 560025, min_days: 1, max_days: 2 },
{ pincode: 560027, min_days: 1, max_days: 2 },
{ pincode: 560033, min_days: 1, max_days: 2 },
{ pincode: 560002, min_days: 1, max_days: 2 },
{ pincode: 560004, min_days: 1, max_days: 2 },
{ pincode: 560009, min_days: 1, max_days: 2 },
{ pincode: 560011, min_days: 1, max_days: 2 },
{ pincode: 560018, min_days: 1, max_days: 2 },
{ pincode: 560019, min_days: 1, max_days: 2 },
{ pincode: 560028, min_days: 1, max_days: 2 },
{ pincode: 560029, min_days: 1, max_days: 2 },
{ pincode: 560039, min_days: 1, max_days: 2 },
{ pincode: 560041, min_days: 1, max_days: 2 },
{ pincode: 560050, min_days: 1, max_days: 2 },
{ pincode: 560053, min_days: 1, max_days: 2 },
{ pincode: 560056, min_days: 1, max_days: 2 },
{ pincode: 560059, min_days: 1, max_days: 2 },
{ pincode: 560060, min_days: 1, max_days: 2 },
{ pincode: 560061, min_days: 1, max_days: 2 },
{ pincode: 560062, min_days: 1, max_days: 2 },
{ pincode: 560069, min_days: 1, max_days: 2 },
{ pincode: 560070, min_days: 1, max_days: 2 },
{ pincode: 560076, min_days: 1, max_days: 2 },
{ pincode: 560078, min_days: 1, max_days: 2 },
{ pincode: 560083, min_days: 1, max_days: 2 },
{ pincode: 560085, min_days: 1, max_days: 2 },
{ pincode: 560098, min_days: 1, max_days: 2 },
{ pincode: 560108, min_days: 1, max_days: 2 },
{ pincode: 560082, min_days: 1, max_days: 2 },
{ pincode: 560109, min_days: 1, max_days: 2 },
{ pincode: 560038, min_days: 1, max_days: 2 },
{ pincode: 560042, min_days: 1, max_days: 2 },
{ pincode: 560046, min_days: 1, max_days: 2 },
{ pincode: 560051, min_days: 1, max_days: 2 },
{ pincode: 560052, min_days: 1, max_days: 2 },
{ pincode: 560071, min_days: 1, max_days: 2 },
{ pincode: 560075, min_days: 1, max_days: 2 },
{ pincode: 560093, min_days: 1, max_days: 2 },
{ pincode: 560096, min_days: 1, max_days: 2 },
{ pincode: 560001, min_days: 1, max_days: 2 },
{ pincode: 560030, min_days: 1, max_days: 2 },
{ pincode: 560003, min_days: 1, max_days: 2 },
{ pincode: 560006, min_days: 1, max_days: 2 },
{ pincode: 560010, min_days: 1, max_days: 2 },
{ pincode: 560012, min_days: 1, max_days: 2 },
{ pincode: 560013, min_days: 1, max_days: 2 },
{ pincode: 560014, min_days: 1, max_days: 2 },
{ pincode: 560015, min_days: 1, max_days: 2 },
{ pincode: 560020, min_days: 1, max_days: 2 },
{ pincode: 560021, min_days: 1, max_days: 2 },
{ pincode: 560022, min_days: 1, max_days: 2 },
{ pincode: 560023, min_days: 1, max_days: 2 },
{ pincode: 560034, min_days: 1, max_days: 2 },
{ pincode: 560040, min_days: 1, max_days: 2 },
{ pincode: 560054, min_days: 1, max_days: 2 },
{ pincode: 560055, min_days: 1, max_days: 2 },
{ pincode: 560057, min_days: 1, max_days: 2 },
{ pincode: 560058, min_days: 1, max_days: 2 },
{ pincode: 560072, min_days: 1, max_days: 2 },
{ pincode: 560079, min_days: 1, max_days: 2 },
{ pincode: 560080, min_days: 1, max_days: 2 },
{ pincode: 560086, min_days: 1, max_days: 2 },
{ pincode: 560091, min_days: 1, max_days: 2 },
{ pincode: 560073, min_days: 1, max_days: 2 },
{ pincode: 560095, min_days: 1, max_days: 2 },
{ pincode: 560100, min_days: 1, max_days: 2 },
{ pincode: 560102, min_days: 1, max_days: 2 },
{ pincode: 560104, min_days: 1, max_days: 2 },
{ pincode: 560105, min_days: 1, max_days: 2 },
{ pincode: 560024, min_days: 1, max_days: 2 },
{ pincode: 560032, min_days: 1, max_days: 2 },
{ pincode: 560036, min_days: 1, max_days: 2 },
{ pincode: 560043, min_days: 1, max_days: 2 },
{ pincode: 560045, min_days: 1, max_days: 2 },
{ pincode: 560049, min_days: 1, max_days: 2 },
{ pincode: 560063, min_days: 1, max_days: 2 },
{ pincode: 560064, min_days: 1, max_days: 2 },
{ pincode: 560065, min_days: 1, max_days: 2 },
{ pincode: 560077, min_days: 1, max_days: 2 },
{ pincode: 560084, min_days: 1, max_days: 2 },
{ pincode: 560092, min_days: 1, max_days: 2 },
{ pincode: 560094, min_days: 1, max_days: 2 },
{ pincode: 560097, min_days: 1, max_days: 2 },
{ pincode: 560035, min_days: 1, max_days: 2 },
{ pincode: 560037, min_days: 1, max_days: 2 },
{ pincode: 560048, min_days: 1, max_days: 2 },
{ pincode: 560066, min_days: 1, max_days: 2 },
{ pincode: 560087, min_days: 1, max_days: 2 },
{ pincode: 560103, min_days: 1, max_days: 2 },
{ pincode: 560067, min_days: 1, max_days: 2 },
{ pincode: 110063, min_days: 1, max_days: 2 },
{ pincode: 110070, min_days: 1, max_days: 2 },
{ pincode: 110062, min_days: 1, max_days: 2 },
{ pincode: 110068, min_days: 1, max_days: 2 },
{ pincode: 110020, min_days: 1, max_days: 2 },
{ pincode: 110034, min_days: 1, max_days: 2 },
{ pincode: 110012, min_days: 1, max_days: 2 },
{ pincode: 110019, min_days: 1, max_days: 2 },
{ pincode: 110010, min_days: 1, max_days: 2 },
{ pincode: 110058, min_days: 1, max_days: 2 },
{ pincode: 110001, min_days: 1, max_days: 2 },
{ pincode: 110009, min_days: 1, max_days: 2 },
{ pincode: 110003, min_days: 1, max_days: 2 },
{ pincode: 110018, min_days: 1, max_days: 2 },
{ pincode: 110078, min_days: 1, max_days: 2 },
{ pincode: 110085, min_days: 1, max_days: 2 },
{ pincode: 110088, min_days: 1, max_days: 2 },
{ pincode: 110024, min_days: 1, max_days: 2 },
{ pincode: 110023, min_days: 1, max_days: 2 },
{ pincode: 110096, min_days: 1, max_days: 2 },
{ pincode: 110016, min_days: 1, max_days: 2 },
{ pincode: 110017, min_days: 1, max_days: 2 },
{ pincode: 110002, min_days: 1, max_days: 2 },
{ pincode: 110087, min_days: 1, max_days: 2 },
{ pincode: 110049, min_days: 1, max_days: 2 },
{ pincode: 110025, min_days: 1, max_days: 2 },
{ pincode: 110059, min_days: 1, max_days: 2 },
{ pincode: 110030, min_days: 1, max_days: 2 },
{ pincode: 110057, min_days: 1, max_days: 2 },
{ pincode: 110022, min_days: 1, max_days: 2 },
{ pincode: 110008, min_days: 1, max_days: 2 },
{ pincode: 110075, min_days: 1, max_days: 2 },
{ pincode: 110001, min_days: 1, max_days: 2 },
{ pincode: 110029, min_days: 1, max_days: 2 },
{ pincode: 110007, min_days: 1, max_days: 2 },
{ pincode: 110076, min_days: 1, max_days: 2 },
{ pincode: 110060, min_days: 1, max_days: 2 },
{ pincode: 110074, min_days: 1, max_days: 2 },
{ pincode: 110065, min_days: 1, max_days: 2 },
{ pincode: 110015, min_days: 1, max_days: 2 },
{ pincode: 110092, min_days: 1, max_days: 2 },
{ pincode: 110048, min_days: 1, max_days: 2 },
{ pincode: 110089, min_days: 1, max_days: 2 },
{ pincode: 110021, min_days: 1, max_days: 2 },
{ pincode: 110068, min_days: 1, max_days: 2 },
{ pincode: 110070, min_days: 1, max_days: 2 },
{ pincode: 110074, min_days: 1, max_days: 2 },
{ pincode: 110017, min_days: 1, max_days: 2 },
{ pincode: 110048, min_days: 1, max_days: 2 },
{ pincode: 110067, min_days: 1, max_days: 2 },
{ pincode: 110003, min_days: 1, max_days: 2 },
{ pincode: 110005, min_days: 1, max_days: 2 },
{ pincode: 110091, min_days: 1, max_days: 2 },
{ pincode: 110007, min_days: 1, max_days: 2 },
{ pincode: 110013, min_days: 1, max_days: 2 },
{ pincode: 110014, min_days: 1, max_days: 2 },
{ pincode: 110029, min_days: 1, max_days: 2 },
{ pincode: 110032, min_days: 1, max_days: 2 },
{ pincode: 110043, min_days: 1, max_days: 2 },
{ pincode: 110075, min_days: 1, max_days: 2 },
{ pincode: 110045, min_days: 1, max_days: 2 },
{ pincode: 110018, min_days: 1, max_days: 2 },
{ pincode: 110009, min_days: 1, max_days: 2 },
{ pincode: 110019, min_days: 1, max_days: 2 },
{ pincode: 110077, min_days: 1, max_days: 2 },
{ pincode: 110058, min_days: 1, max_days: 2 },
{ pincode: 110092, min_days: 1, max_days: 2 },
{ pincode: 110010, min_days: 1, max_days: 2 },
{ pincode: 110086, min_days: 1, max_days: 2 },
{ pincode: 110063, min_days: 1, max_days: 2 },
{ pincode: 110096, min_days: 1, max_days: 2 },
{ pincode: 110025, min_days: 1, max_days: 2 },
{ pincode: 110016, min_days: 1, max_days: 2 },
{ pincode: 110065, min_days: 1, max_days: 2 },
{ pincode: 110051, min_days: 1, max_days: 2 },
{ pincode: 110085, min_days: 1, max_days: 2 },
{ pincode: 110095, min_days: 1, max_days: 2 },
{ pincode: 110052, min_days: 1, max_days: 2 },
{ pincode: 110034, min_days: 1, max_days: 2 },
{ pincode: 110087, min_days: 1, max_days: 2 },
{ pincode: 110028, min_days: 1, max_days: 2 },
{ pincode: 110089, min_days: 1, max_days: 2 },
{ pincode: 110076, min_days: 1, max_days: 2 },
{ pincode: 110060, min_days: 1, max_days: 2 },
{ pincode: 110024, min_days: 1, max_days: 2 },
{ pincode: 110037, min_days: 1, max_days: 2 },
{ pincode: 110078, min_days: 1, max_days: 2 },
{ pincode: 110057, min_days: 1, max_days: 2 },
{ pincode: 110062, min_days: 1, max_days: 2 },
{ pincode: 110015, min_days: 1, max_days: 2 },
{ pincode: 110059, min_days: 1, max_days: 2 },
{ pincode: 110040, min_days: 1, max_days: 2 },
{ pincode: 110023, min_days: 1, max_days: 2 },
{ pincode: 110027, min_days: 1, max_days: 2 },
{ pincode: 110026, min_days: 1, max_days: 2 },
{ pincode: 110054, min_days: 1, max_days: 2 },
{ pincode: 110006, min_days: 1, max_days: 2 },
{ pincode: 110012, min_days: 1, max_days: 2 },
{ pincode: 110064, min_days: 1, max_days: 2 },
{ pincode: 110030, min_days: 1, max_days: 2 },
{ pincode: 110042, min_days: 1, max_days: 2 },
{ pincode: 110020, min_days: 1, max_days: 2 },
{ pincode: 110047, min_days: 1, max_days: 2 },
{ pincode: 110049, min_days: 1, max_days: 2 },
{ pincode: 110022, min_days: 1, max_days: 2 },
{ pincode: 110088, min_days: 1, max_days: 2 },
{ pincode: 110046, min_days: 1, max_days: 2 },
{ pincode: 110084, min_days: 1, max_days: 2 },
{ pincode: 110041, min_days: 1, max_days: 2 },
{ pincode: 110038, min_days: 1, max_days: 2 },
{ pincode: 110002, min_days: 1, max_days: 2 },
{ pincode: 110066, min_days: 1, max_days: 2 },
{ pincode: 110031, min_days: 1, max_days: 2 },
{ pincode: 110053, min_days: 1, max_days: 2 },
{ pincode: 110044, min_days: 1, max_days: 2 },
{ pincode: 110055, min_days: 1, max_days: 2 },
{ pincode: 110035, min_days: 1, max_days: 2 },
{ pincode: 110033, min_days: 1, max_days: 2 },
{ pincode: 110094, min_days: 1, max_days: 2 },
{ pincode: 110011, min_days: 1, max_days: 2 },
{ pincode: 110080, min_days: 1, max_days: 2 },
{ pincode: 110093, min_days: 1, max_days: 2 },
{ pincode: 110056, min_days: 1, max_days: 2 },
{ pincode: 400057, min_days: 1, max_days: 2 },
{ pincode: 400059, min_days: 1, max_days: 2 },
{ pincode: 400069, min_days: 1, max_days: 2 },
{ pincode: 400072, min_days: 1, max_days: 2 },
{ pincode: 400076, min_days: 1, max_days: 2 },
{ pincode: 400087, min_days: 1, max_days: 2 },
{ pincode: 400093, min_days: 1, max_days: 2 },
{ pincode: 400096, min_days: 1, max_days: 2 },
{ pincode: 400099, min_days: 1, max_days: 2 },
{ pincode: 400049, min_days: 1, max_days: 2 },
{ pincode: 400053, min_days: 1, max_days: 2 },
{ pincode: 400056, min_days: 1, max_days: 2 },
{ pincode: 400058, min_days: 1, max_days: 2 },
{ pincode: 400061, min_days: 1, max_days: 2 },
{ pincode: 400029, min_days: 1, max_days: 2 },
{ pincode: 400051, min_days: 1, max_days: 2 },
{ pincode: 400055, min_days: 1, max_days: 2 },
{ pincode: 400098, min_days: 1, max_days: 2 },
{ pincode: 400050, min_days: 1, max_days: 2 },
{ pincode: 400052, min_days: 1, max_days: 2 },
{ pincode: 400054, min_days: 1, max_days: 2 },
{ pincode: 400060, min_days: 1, max_days: 2 },
{ pincode: 400063, min_days: 1, max_days: 2 },
{ pincode: 400065, min_days: 1, max_days: 2 },
{ pincode: 400102, min_days: 1, max_days: 2 },
{ pincode: 400062, min_days: 1, max_days: 2 },
{ pincode: 400064, min_days: 1, max_days: 2 },
{ pincode: 400067, min_days: 1, max_days: 2 },
{ pincode: 400090, min_days: 1, max_days: 2 },
{ pincode: 400095, min_days: 1, max_days: 2 },
{ pincode: 400097, min_days: 1, max_days: 2 },
{ pincode: 400101, min_days: 1, max_days: 2 },
{ pincode: 400104, min_days: 1, max_days: 2 },
{ pincode: 401104, min_days: 1, max_days: 2 },
{ pincode: 401107, min_days: 1, max_days: 3 },
{ pincode: 400066, min_days: 1, max_days: 2 },
{ pincode: 400068, min_days: 1, max_days: 2 },
{ pincode: 400091, min_days: 1, max_days: 2 },
{ pincode: 400092, min_days: 1, max_days: 2 },
{ pincode: 400103, min_days: 1, max_days: 2 },
{ pincode: 400001, min_days: 1, max_days: 2 },
{ pincode: 400002, min_days: 1, max_days: 2 },
{ pincode: 400003, min_days: 1, max_days: 2 },
{ pincode: 400004, min_days: 1, max_days: 2 },
{ pincode: 400005, min_days: 1, max_days: 2 },
{ pincode: 400007, min_days: 1, max_days: 2 },
{ pincode: 400008, min_days: 1, max_days: 2 },
{ pincode: 400009, min_days: 1, max_days: 2 },
{ pincode: 400010, min_days: 1, max_days: 2 },
{ pincode: 400020, min_days: 1, max_days: 2 },
{ pincode: 400021, min_days: 1, max_days: 2 },
{ pincode: 400023, min_days: 1, max_days: 2 },
{ pincode: 400027, min_days: 1, max_days: 2 },
{ pincode: 400032, min_days: 1, max_days: 2 },
{ pincode: 400038, min_days: 1, max_days: 2 },
{ pincode: 400039, min_days: 1, max_days: 2 },
{ pincode: 400006, min_days: 1, max_days: 2 },
{ pincode: 400011, min_days: 1, max_days: 2 },
{ pincode: 400012, min_days: 1, max_days: 2 },
{ pincode: 400013, min_days: 1, max_days: 2 },
{ pincode: 400014, min_days: 1, max_days: 2 },
{ pincode: 400015, min_days: 1, max_days: 2 },
{ pincode: 400016, min_days: 1, max_days: 2 },
{ pincode: 400018, min_days: 1, max_days: 2 },
{ pincode: 400025, min_days: 1, max_days: 2 },
{ pincode: 400026, min_days: 1, max_days: 2 },
{ pincode: 400028, min_days: 1, max_days: 2 },
{ pincode: 400030, min_days: 1, max_days: 2 },
{ pincode: 400031, min_days: 1, max_days: 2 },
{ pincode: 400033, min_days: 1, max_days: 2 },
{ pincode: 400034, min_days: 1, max_days: 2 },
{ pincode: 400035, min_days: 1, max_days: 2 },
{ pincode: 400036, min_days: 1, max_days: 2 },
{ pincode: 400019, min_days: 1, max_days: 2 },
{ pincode: 400017, min_days: 1, max_days: 2 },
{ pincode: 400601, min_days: 1, max_days: 3 },
{ pincode: 400602, min_days: 1, max_days: 3 },
{ pincode: 400603, min_days: 1, max_days: 3 },
{ pincode: 400604, min_days: 1, max_days: 3 },
{ pincode: 400605, min_days: 1, max_days: 3 },
{ pincode: 400606, min_days: 1, max_days: 3 },
{ pincode: 400607, min_days: 1, max_days: 3 },
{ pincode: 400608, min_days: 1, max_days: 3 },
{ pincode: 400609, min_days: 1, max_days: 3 },
{ pincode: 400610, min_days: 1, max_days: 3 },
{ pincode: 400615, min_days: 1, max_days: 3 },
{ pincode: 400042, min_days: 1, max_days: 2 },
{ pincode: 400044, min_days: 1, max_days: 2 },
{ pincode: 400046, min_days: 1, max_days: 2 },
{ pincode: 400073, min_days: 1, max_days: 2 },
{ pincode: 400075, min_days: 1, max_days: 2 },
{ pincode: 400077, min_days: 1, max_days: 2 },
{ pincode: 400078, min_days: 1, max_days: 2 },
{ pincode: 400079, min_days: 1, max_days: 2 },
{ pincode: 400083, min_days: 1, max_days: 2 },
{ pincode: 400084, min_days: 1, max_days: 2 },
{ pincode: 400086, min_days: 1, max_days: 2 },
{ pincode: 400080, min_days: 1, max_days: 2 },
{ pincode: 400081, min_days: 1, max_days: 2 },
{ pincode: 400082, min_days: 1, max_days: 2 },
{ pincode: 400614, min_days: 1, max_days: 3 },
{ pincode: 400703, min_days: 1, max_days: 3 },
{ pincode: 400705, min_days: 1, max_days: 3 },
{ pincode: 400706, min_days: 1, max_days: 3 },
{ pincode: 400710, min_days: 1, max_days: 3 },
{ pincode: 400701, min_days: 1, max_days: 3 },
{ pincode: 400708, min_days: 1, max_days: 3 },
{ pincode: 400709, min_days: 1, max_days: 3 },
{ pincode: 400022, min_days: 1, max_days: 2 },
{ pincode: 400024, min_days: 1, max_days: 2 },
{ pincode: 400037, min_days: 1, max_days: 2 },
{ pincode: 400043, min_days: 1, max_days: 2 },
{ pincode: 400070, min_days: 1, max_days: 2 },
{ pincode: 400071, min_days: 1, max_days: 2 },
{ pincode: 400074, min_days: 1, max_days: 2 },
{ pincode: 400085, min_days: 1, max_days: 2 },
{ pincode: 400088, min_days: 1, max_days: 2 },
{ pincode: 400089, min_days: 1, max_days: 2 },
{ pincode: 400094, min_days: 1, max_days: 2 },
{ pincode: 500002, min_days: 2, max_days: 3 },
{ pincode: 500006, min_days: 2, max_days: 3 },
{ pincode: 500008, min_days: 2, max_days: 3 },
{ pincode: 500019, min_days: 2, max_days: 3 },
{ pincode: 500021, min_days: 2, max_days: 3 },
{ pincode: 500023, min_days: 2, max_days: 3 },
{ pincode: 500028, min_days: 2, max_days: 3 },
{ pincode: 500030, min_days: 2, max_days: 3 },
{ pincode: 500031, min_days: 2, max_days: 3 },
{ pincode: 500032, min_days: 2, max_days: 3 },
{ pincode: 500033, min_days: 2, max_days: 3 },
{ pincode: 500034, min_days: 2, max_days: 3 },
{ pincode: 500041, min_days: 2, max_days: 3 },
{ pincode: 500046, min_days: 2, max_days: 3 },
{ pincode: 500048, min_days: 2, max_days: 3 },
{ pincode: 500049, min_days: 2, max_days: 3 },
{ pincode: 500050, min_days: 2, max_days: 3 },
{ pincode: 500052, min_days: 2, max_days: 3 },
{ pincode: 500053, min_days: 2, max_days: 3 },
{ pincode: 500054, min_days: 2, max_days: 3 },
{ pincode: 500055, min_days: 2, max_days: 3 },
{ pincode: 500057, min_days: 2, max_days: 3 },
{ pincode: 500059, min_days: 2, max_days: 3 },
{ pincode: 500064, min_days: 2, max_days: 3 },
{ pincode: 500065, min_days: 2, max_days: 3 },
{ pincode: 500066, min_days: 2, max_days: 3 },
{ pincode: 500072, min_days: 2, max_days: 3 },
{ pincode: 500075, min_days: 2, max_days: 3 },
{ pincode: 500077, min_days: 2, max_days: 3 },
{ pincode: 500081, min_days: 2, max_days: 3 },
{ pincode: 500082, min_days: 2, max_days: 3 },
{ pincode: 500084, min_days: 2, max_days: 3 },
{ pincode: 500085, min_days: 2, max_days: 3 },
{ pincode: 500086, min_days: 2, max_days: 3 },
{ pincode: 500087, min_days: 2, max_days: 3 },
{ pincode: 500089, min_days: 2, max_days: 3 },
{ pincode: 500090, min_days: 2, max_days: 3 },
{ pincode: 500091, min_days: 2, max_days: 3 },
{ pincode: 500096, min_days: 2, max_days: 3 },
{ pincode: 500099, min_days: 2, max_days: 3 },
{ pincode: 500012, min_days: 2, max_days: 3 },
{ pincode: 500037, min_days: 2, max_days: 3 },
{ pincode: 500078, min_days: 2, max_days: 3 },
{ pincode: 500056, min_days: 2, max_days: 3 },
{ pincode: 500058, min_days: 2, max_days: 3 },
{ pincode: 500001, min_days: 2, max_days: 3 },
{ pincode: 500003, min_days: 2, max_days: 3 },
{ pincode: 500007, min_days: 2, max_days: 3 },
{ pincode: 500009, min_days: 2, max_days: 3 },
{ pincode: 500010, min_days: 2, max_days: 3 },
{ pincode: 500011, min_days: 2, max_days: 3 },
{ pincode: 500013, min_days: 2, max_days: 3 },
{ pincode: 500014, min_days: 2, max_days: 3 },
{ pincode: 500015, min_days: 2, max_days: 3 },
{ pincode: 500016, min_days: 2, max_days: 3 },
{ pincode: 500017, min_days: 2, max_days: 3 },
{ pincode: 500018, min_days: 2, max_days: 3 },
{ pincode: 500020, min_days: 2, max_days: 3 },
{ pincode: 500022, min_days: 2, max_days: 3 },
{ pincode: 500025, min_days: 2, max_days: 3 },
{ pincode: 500026, min_days: 2, max_days: 3 },
{ pincode: 500027, min_days: 2, max_days: 3 },
{ pincode: 500029, min_days: 2, max_days: 3 },
{ pincode: 500035, min_days: 2, max_days: 3 },
{ pincode: 500036, min_days: 2, max_days: 3 },
{ pincode: 500038, min_days: 2, max_days: 3 },
{ pincode: 500039, min_days: 2, max_days: 3 },
{ pincode: 500040, min_days: 2, max_days: 3 },
{ pincode: 500042, min_days: 2, max_days: 3 },
{ pincode: 500043, min_days: 2, max_days: 3 },
{ pincode: 500044, min_days: 2, max_days: 3 },
{ pincode: 500045, min_days: 2, max_days: 3 },
{ pincode: 500047, min_days: 2, max_days: 3 },
{ pincode: 500051, min_days: 2, max_days: 3 },
{ pincode: 500004, min_days: 2, max_days: 3 },
{ pincode: 500005, min_days: 2, max_days: 3 },
{ pincode: 500024, min_days: 2, max_days: 3 },
{ pincode: 500060, min_days: 2, max_days: 3 },
{ pincode: 500061, min_days: 2, max_days: 3 },
{ pincode: 500062, min_days: 2, max_days: 3 },
{ pincode: 500063, min_days: 2, max_days: 3 },
{ pincode: 500067, min_days: 2, max_days: 3 },
{ pincode: 500068, min_days: 2, max_days: 3 },
{ pincode: 500069, min_days: 2, max_days: 3 },
{ pincode: 500070, min_days: 2, max_days: 3 },
{ pincode: 500071, min_days: 2, max_days: 3 },
{ pincode: 500073, min_days: 2, max_days: 3 },
{ pincode: 500074, min_days: 2, max_days: 3 },
{ pincode: 500076, min_days: 2, max_days: 3 },
{ pincode: 500079, min_days: 2, max_days: 3 },
{ pincode: 500080, min_days: 2, max_days: 3 },
{ pincode: 500083, min_days: 2, max_days: 3 },
{ pincode: 500088, min_days: 2, max_days: 3 },
{ pincode: 500092, min_days: 2, max_days: 3 },
{ pincode: 500093, min_days: 2, max_days: 3 },
{ pincode: 500094, min_days: 2, max_days: 3 },
{ pincode: 500095, min_days: 2, max_days: 3 },
{ pincode: 500097, min_days: 2, max_days: 3 },
{ pincode: 500098, min_days: 2, max_days: 3 },
{ pincode: 600001, min_days: 1, max_days: 2 },
{ pincode: 600002, min_days: 1, max_days: 2 },
{ pincode: 600003, min_days: 1, max_days: 2 },
{ pincode: 600004, min_days: 1, max_days: 2 },
{ pincode: 600005, min_days: 1, max_days: 2 },
{ pincode: 600006, min_days: 1, max_days: 2 },
{ pincode: 600007, min_days: 1, max_days: 2 },
{ pincode: 600008, min_days: 1, max_days: 2 },
{ pincode: 600009, min_days: 1, max_days: 2 },
{ pincode: 600010, min_days: 1, max_days: 2 },
{ pincode: 600011, min_days: 1, max_days: 2 },
{ pincode: 600012, min_days: 1, max_days: 2 },
{ pincode: 600013, min_days: 1, max_days: 2 },
{ pincode: 600014, min_days: 1, max_days: 2 },
{ pincode: 600015, min_days: 1, max_days: 2 },
{ pincode: 600016, min_days: 1, max_days: 2 },
{ pincode: 600017, min_days: 1, max_days: 2 },
{ pincode: 600018, min_days: 1, max_days: 2 },
{ pincode: 600019, min_days: 1, max_days: 2 },
{ pincode: 600020, min_days: 1, max_days: 2 },
{ pincode: 600021, min_days: 1, max_days: 2 },
{ pincode: 600022, min_days: 1, max_days: 2 },
{ pincode: 600023, min_days: 1, max_days: 2 },
{ pincode: 600024, min_days: 1, max_days: 2 },
{ pincode: 600025, min_days: 1, max_days: 2 },
{ pincode: 600026, min_days: 1, max_days: 2 },
{ pincode: 600027, min_days: 1, max_days: 2 },
{ pincode: 600028, min_days: 1, max_days: 2 },
{ pincode: 600029, min_days: 1, max_days: 2 },
{ pincode: 600030, min_days: 1, max_days: 2 },
{ pincode: 600031, min_days: 1, max_days: 2 },
{ pincode: 600032, min_days: 1, max_days: 2 },
{ pincode: 600033, min_days: 1, max_days: 2 },
{ pincode: 600034, min_days: 1, max_days: 2 },
{ pincode: 600035, min_days: 1, max_days: 2 },
{ pincode: 600036, min_days: 1, max_days: 2 },
{ pincode: 600037, min_days: 1, max_days: 2 },
{ pincode: 600038, min_days: 1, max_days: 2 },
{ pincode: 600039, min_days: 1, max_days: 2 },
{ pincode: 600040, min_days: 1, max_days: 2 },
{ pincode: 600041, min_days: 1, max_days: 2 },
{ pincode: 600042, min_days: 1, max_days: 2 },
{ pincode: 600043, min_days: 1, max_days: 2 },
{ pincode: 600044, min_days: 1, max_days: 2 },
{ pincode: 600049, min_days: 1, max_days: 2 },
{ pincode: 600050, min_days: 1, max_days: 2 },
{ pincode: 600053, min_days: 1, max_days: 2 },
{ pincode: 600056, min_days: 1, max_days: 2 },
{ pincode: 600058, min_days: 1, max_days: 2 },
{ pincode: 600061, min_days: 1, max_days: 2 },
{ pincode: 600064, min_days: 1, max_days: 2 },
{ pincode: 600070, min_days: 1, max_days: 2 },
{ pincode: 600074, min_days: 1, max_days: 2 },
{ pincode: 600075, min_days: 1, max_days: 2 },
{ pincode: 600076, min_days: 1, max_days: 2 },
{ pincode: 600077, min_days: 1, max_days: 2 },
{ pincode: 600078, min_days: 1, max_days: 2 },
{ pincode: 600079, min_days: 1, max_days: 2 },
{ pincode: 600080, min_days: 1, max_days: 2 },
{ pincode: 600081, min_days: 1, max_days: 2 },
{ pincode: 600082, min_days: 1, max_days: 2 },
{ pincode: 600083, min_days: 1, max_days: 2 },
{ pincode: 600084, min_days: 1, max_days: 2 },
{ pincode: 600085, min_days: 1, max_days: 2 },
{ pincode: 600086, min_days: 1, max_days: 2 },
{ pincode: 600087, min_days: 1, max_days: 2 },
{ pincode: 600088, min_days: 1, max_days: 2 },
{ pincode: 600089, min_days: 1, max_days: 2 },
{ pincode: 600090, min_days: 1, max_days: 2 },
{ pincode: 600091, min_days: 1, max_days: 2 },
{ pincode: 600092, min_days: 1, max_days: 2 },
{ pincode: 600093, min_days: 1, max_days: 2 },
{ pincode: 600094, min_days: 1, max_days: 2 },
{ pincode: 600095, min_days: 1, max_days: 2 },
{ pincode: 600096, min_days: 1, max_days: 2 },
{ pincode: 600097, min_days: 1, max_days: 2 },
{ pincode: 600098, min_days: 1, max_days: 2 },
{ pincode: 600099, min_days: 1, max_days: 2 },
{ pincode: 600100, min_days: 1, max_days: 2 },
{ pincode: 600101, min_days: 1, max_days: 2 },
{ pincode: 600102, min_days: 1, max_days: 2 },
{ pincode: 600104, min_days: 1, max_days: 2 },
{ pincode: 600106, min_days: 1, max_days: 2 },
{ pincode: 600107, min_days: 1, max_days: 2 },
{ pincode: 600108, min_days: 1, max_days: 2 },
{ pincode: 600110, min_days: 1, max_days: 2 },
{ pincode: 600112, min_days: 1, max_days: 2 },
{ pincode: 600113, min_days: 1, max_days: 2 },
{ pincode: 600114, min_days: 1, max_days: 2 },
{ pincode: 600115, min_days: 1, max_days: 2 },
{ pincode: 600116, min_days: 1, max_days: 2 },
{ pincode: 600117, min_days: 1, max_days: 2 },
{ pincode: 600118, min_days: 1, max_days: 2 },
{ pincode: 600119, min_days: 1, max_days: 2 },
{ pincode: 600122, min_days: 1, max_days: 2 },
{ pincode: 600125, min_days: 1, max_days: 2 },
{ pincode: 600129, min_days: 1, max_days: 2 },
{ pincode: 603103, min_days: 1, max_days: 2 },
{ pincode: 600130, min_days: 1, max_days: 2 },
{ pincode: 600126, min_days: 1, max_days: 2 },
{ pincode: 600128, min_days: 1, max_days: 2 },
{ pincode: 600045, min_days: 1, max_days: 2 },
{ pincode: 600046, min_days: 1, max_days: 2 },
{ pincode: 600047, min_days: 1, max_days: 2 },
{ pincode: 600048, min_days: 1, max_days: 2 },
{ pincode: 600059, min_days: 1, max_days: 2 },
{ pincode: 600063, min_days: 1, max_days: 2 },
{ pincode: 600069, min_days: 1, max_days: 2 },
{ pincode: 600070, min_days: 1, max_days: 2 },
{ pincode: 600073, min_days: 1, max_days: 2 },
{ pincode: 600127, min_days: 1, max_days: 2 },
{ pincode: 122018, min_days: 1, max_days: 3 },
{ pincode: 121006, min_days: 1, max_days: 3 },
{ pincode: 201309, min_days: 1, max_days: 3 },
{ pincode: 122002, min_days: 1, max_days: 3 },
{ pincode: 122001, min_days: 1, max_days: 3 },
{ pincode: 201301, min_days: 1, max_days: 3 },
{ pincode: 201304, min_days: 1, max_days: 3 },
{ pincode: 201301, min_days: 1, max_days: 3 },
{ pincode: 122002, min_days: 1, max_days: 3 },
{ pincode: 201010, min_days: 1, max_days: 3 },
{ pincode: 122004, min_days: 1, max_days: 3 },
{ pincode: 122101, min_days: 1, max_days: 3 },
{ pincode: 122003, min_days: 1, max_days: 3 },
{ pincode: 201010, min_days: 1, max_days: 3 },
{ pincode: 201305, min_days: 1, max_days: 3 },
{ pincode: 201303, min_days: 1, max_days: 3 },
{ pincode: 122011, min_days: 1, max_days: 3 },
{ pincode: 201308, min_days: 1, max_days: 3 },
{ pincode: 121002, min_days: 1, max_days: 3 },
{ pincode: 121007, min_days: 1, max_days: 3 },
{ pincode: 122017, min_days: 1, max_days: 3 },
{ pincode: 201016, min_days: 1, max_days: 3 },
{ pincode: 122001, min_days: 1, max_days: 3 },
{ pincode: 121001, min_days: 1, max_days: 3 },
{ pincode: 122018, min_days: 1, max_days: 3 },
{ pincode: 121002, min_days: 1, max_days: 3 },
{ pincode: 122003, min_days: 1, max_days: 3 },
{ pincode: 201014, min_days: 1, max_days: 3 },
{ pincode: 201306, min_days: 1, max_days: 3 },
{ pincode: 122011, min_days: 1, max_days: 3 },
{ pincode: 122009, min_days: 1, max_days: 3 },
{ pincode: 201012, min_days: 1, max_days: 3 },
{ pincode: 122010, min_days: 1, max_days: 3 },
{ pincode: 122103, min_days: 1, max_days: 3 },
{ pincode: 122022, min_days: 1, max_days: 3 },
{ pincode: 201307, min_days: 1, max_days: 3 },
{ pincode: 121003, min_days: 1, max_days: 3 },
{ pincode: 201017, min_days: 1, max_days: 3 },
{ pincode: 201308, min_days: 1, max_days: 3 },
{ pincode: 201303, min_days: 1, max_days: 3 },
{ pincode: 201002, min_days: 1, max_days: 3 },
{ pincode: 201304, min_days: 1, max_days: 3 },
{ pincode: 122505, min_days: 1, max_days: 3 },
{ pincode: 122102, min_days: 1, max_days: 3 },
{ pincode: 122016, min_days: 1, max_days: 3 },
{ pincode: 121010, min_days: 1, max_days: 3 },
{ pincode: 201009, min_days: 1, max_days: 3 },
{ pincode: 201011, min_days: 1, max_days: 3 },
{ pincode: 122101, min_days: 1, max_days: 3 },
{ pincode: 201310, min_days: 1, max_days: 3 },
{ pincode: 122006, min_days: 1, max_days: 3 },
{ pincode: 121008, min_days: 1, max_days: 3 },
{ pincode: 121004, min_days: 1, max_days: 3 },
{ pincode: 122004, min_days: 1, max_days: 3 },
{ pincode: 201318, min_days: 1, max_days: 3 },
{ pincode: 121009, min_days: 1, max_days: 3 },
{ pincode: 201302, min_days: 1, max_days: 3 },
{ pincode: 122015, min_days: 1, max_days: 3 },
{ pincode: 121012, min_days: 1, max_days: 3 },
{ pincode: 201001, min_days: 1, max_days: 3 },
{ pincode: 122051, min_days: 1, max_days: 3 },
{ pincode: 122050, min_days: 1, max_days: 3 },
{ pincode: 201316, min_days: 1, max_days: 3 },
{ pincode: 201206, min_days: 1, max_days: 3 },
{ pincode: 201314, min_days: 1, max_days: 3 },
{ pincode: 110098, min_days: 3, max_days: 5 },
{ pincode: 110100, min_days: 3, max_days: 5 },
{ pincode: 110101, min_days: 3, max_days: 5 },
{ pincode: 110102, min_days: 3, max_days: 5 },
{ pincode: 110103, min_days: 3, max_days: 5 },
{ pincode: 110104, min_days: 3, max_days: 5 },
{ pincode: 110105, min_days: 3, max_days: 5 },
{ pincode: 110106, min_days: 3, max_days: 5 },
{ pincode: 110107, min_days: 3, max_days: 5 },
{ pincode: 110108, min_days: 3, max_days: 5 },
{ pincode: 110109, min_days: 3, max_days: 5 },
{ pincode: 110110, min_days: 3, max_days: 5 },
{ pincode: 110112, min_days: 3, max_days: 5 },
{ pincode: 110113, min_days: 3, max_days: 5 },
{ pincode: 110114, min_days: 3, max_days: 5 },
{ pincode: 110115, min_days: 3, max_days: 5 },
{ pincode: 110116, min_days: 3, max_days: 5 },
{ pincode: 110117, min_days: 3, max_days: 5 },
{ pincode: 110118, min_days: 3, max_days: 5 },
{ pincode: 110119, min_days: 3, max_days: 5 },
{ pincode: 110120, min_days: 3, max_days: 5 },
{ pincode: 110121, min_days: 3, max_days: 5 },
{ pincode: 110122, min_days: 3, max_days: 5 },
{ pincode: 110124, min_days: 3, max_days: 5 },
{ pincode: 110125, min_days: 3, max_days: 5 },
{ pincode: 110201, min_days: 3, max_days: 5 },
{ pincode: 110202, min_days: 3, max_days: 5 },
{ pincode: 110203, min_days: 3, max_days: 5 },
{ pincode: 110204, min_days: 3, max_days: 5 },
{ pincode: 110205, min_days: 3, max_days: 5 },
{ pincode: 110206, min_days: 3, max_days: 5 },
{ pincode: 110207, min_days: 3, max_days: 5 },
{ pincode: 110208, min_days: 3, max_days: 5 },
{ pincode: 110301, min_days: 3, max_days: 5 },
{ pincode: 110302, min_days: 3, max_days: 5 },
{ pincode: 110401, min_days: 3, max_days: 5 },
{ pincode: 110402, min_days: 3, max_days: 5 },
{ pincode: 110403, min_days: 3, max_days: 5 },
{ pincode: 110501, min_days: 3, max_days: 5 },
{ pincode: 110502, min_days: 3, max_days: 5 },
{ pincode: 110503, min_days: 3, max_days: 5 },
{ pincode: 110504, min_days: 3, max_days: 5 },
{ pincode: 110505, min_days: 3, max_days: 5 },
{ pincode: 110506, min_days: 3, max_days: 5 },
{ pincode: 110507, min_days: 3, max_days: 5 },
{ pincode: 110508, min_days: 3, max_days: 5 },
{ pincode: 110509, min_days: 3, max_days: 5 },
{ pincode: 110510, min_days: 3, max_days: 5 },
{ pincode: 110511, min_days: 3, max_days: 5 },
{ pincode: 110512, min_days: 3, max_days: 5 },
{ pincode: 110601, min_days: 3, max_days: 5 },
{ pincode: 110602, min_days: 3, max_days: 5 },
{ pincode: 110603, min_days: 3, max_days: 5 },
{ pincode: 110604, min_days: 3, max_days: 5 },
{ pincode: 110605, min_days: 3, max_days: 5 },
{ pincode: 110606, min_days: 3, max_days: 5 },
{ pincode: 110607, min_days: 3, max_days: 5 },
{ pincode: 110608, min_days: 3, max_days: 5 },
{ pincode: 110609, min_days: 3, max_days: 5 },
{ pincode: 110610, min_days: 3, max_days: 5 },
{ pincode: 110611, min_days: 3, max_days: 5 },
{ pincode: 111001, min_days: 3, max_days: 5 },
{ pincode: 111110, min_days: 3, max_days: 5 },
{ pincode: 111117, min_days: 3, max_days: 5 },
{ pincode: 111118, min_days: 3, max_days: 5 },
{ pincode: 120001, min_days: 3, max_days: 5 },
{ pincode: 120002, min_days: 3, max_days: 5 },
{ pincode: 120004, min_days: 3, max_days: 5 },
{ pincode: 121000, min_days: 3, max_days: 5 },
{ pincode: 121013, min_days: 3, max_days: 5 },
{ pincode: 121014, min_days: 3, max_days: 5 },
{ pincode: 121015, min_days: 3, max_days: 5 },
{ pincode: 121101, min_days: 3, max_days: 5 },
{ pincode: 121102, min_days: 3, max_days: 5 },
{ pincode: 121103, min_days: 3, max_days: 5 },
{ pincode: 121105, min_days: 3, max_days: 5 },
{ pincode: 121106, min_days: 3, max_days: 5 },
{ pincode: 121107, min_days: 3, max_days: 5 },
{ pincode: 121108, min_days: 3, max_days: 5 },
{ pincode: 121201, min_days: 3, max_days: 5 },
{ pincode: 121202, min_days: 3, max_days: 5 },
{ pincode: 121203, min_days: 3, max_days: 5 },
{ pincode: 121204, min_days: 3, max_days: 5 },
{ pincode: 121205, min_days: 3, max_days: 5 },
{ pincode: 121206, min_days: 3, max_days: 5 },
{ pincode: 121207, min_days: 3, max_days: 5 },
{ pincode: 121208, min_days: 3, max_days: 5 },
{ pincode: 121209, min_days: 3, max_days: 5 },
{ pincode: 121210, min_days: 3, max_days: 5 },
{ pincode: 121211, min_days: 3, max_days: 5 },
{ pincode: 121212, min_days: 3, max_days: 5 },
{ pincode: 121213, min_days: 3, max_days: 5 },
{ pincode: 121214, min_days: 3, max_days: 5 },
{ pincode: 121215, min_days: 3, max_days: 5 },
{ pincode: 121216, min_days: 3, max_days: 5 },
{ pincode: 121217, min_days: 3, max_days: 5 },
{ pincode: 121218, min_days: 3, max_days: 5 },
{ pincode: 121219, min_days: 3, max_days: 5 },
{ pincode: 121220, min_days: 3, max_days: 5 },
{ pincode: 122000, min_days: 3, max_days: 5 },
{ pincode: 122001, min_days: 3, max_days: 5 },
{ pincode: 122003, min_days: 3, max_days: 5 },
{ pincode: 122004, min_days: 3, max_days: 5 },
{ pincode: 122005, min_days: 3, max_days: 5 },
{ pincode: 122007, min_days: 3, max_days: 5 },
{ pincode: 122008, min_days: 3, max_days: 5 },
{ pincode: 122011, min_days: 3, max_days: 5 },
{ pincode: 122012, min_days: 3, max_days: 5 },
{ pincode: 122013, min_days: 3, max_days: 5 },
{ pincode: 122014, min_days: 3, max_days: 5 },
{ pincode: 122018, min_days: 3, max_days: 5 },
{ pincode: 122019, min_days: 3, max_days: 5 },
{ pincode: 122020, min_days: 3, max_days: 5 },
{ pincode: 122021, min_days: 3, max_days: 5 },
{ pincode: 122026, min_days: 3, max_days: 5 },
{ pincode: 122027, min_days: 3, max_days: 5 },
{ pincode: 122029, min_days: 3, max_days: 5 },
{ pincode: 122052, min_days: 3, max_days: 5 },
{ pincode: 122053, min_days: 3, max_days: 5 },
{ pincode: 122055, min_days: 3, max_days: 5 },
{ pincode: 122098, min_days: 3, max_days: 5 },
{ pincode: 122100, min_days: 3, max_days: 5 },
{ pincode: 122101, min_days: 3, max_days: 5 },
{ pincode: 122105, min_days: 3, max_days: 5 },
{ pincode: 122106, min_days: 3, max_days: 5 },
{ pincode: 122107, min_days: 3, max_days: 5 },
{ pincode: 122108, min_days: 3, max_days: 5 },
{ pincode: 122109, min_days: 3, max_days: 5 },
{ pincode: 122200, min_days: 3, max_days: 5 },
{ pincode: 122203, min_days: 3, max_days: 5 },
{ pincode: 122204, min_days: 3, max_days: 5 },
{ pincode: 122206, min_days: 3, max_days: 5 },
{ pincode: 122207, min_days: 3, max_days: 5 },
{ pincode: 122208, min_days: 3, max_days: 5 },
{ pincode: 122209, min_days: 3, max_days: 5 },
{ pincode: 122210, min_days: 3, max_days: 5 },
{ pincode: 122211, min_days: 3, max_days: 5 },
{ pincode: 122212, min_days: 3, max_days: 5 },
{ pincode: 122213, min_days: 3, max_days: 5 },
{ pincode: 122214, min_days: 3, max_days: 5 },
{ pincode: 122215, min_days: 3, max_days: 5 },
{ pincode: 122216, min_days: 3, max_days: 5 },
{ pincode: 122217, min_days: 3, max_days: 5 },
{ pincode: 122218, min_days: 3, max_days: 5 },
{ pincode: 122219, min_days: 3, max_days: 5 },
{ pincode: 122220, min_days: 3, max_days: 5 },
{ pincode: 122223, min_days: 3, max_days: 5 },
{ pincode: 122224, min_days: 3, max_days: 5 },
{ pincode: 122225, min_days: 3, max_days: 5 },
{ pincode: 122226, min_days: 3, max_days: 5 },
{ pincode: 122227, min_days: 3, max_days: 5 },
{ pincode: 122228, min_days: 3, max_days: 5 },
{ pincode: 122229, min_days: 3, max_days: 5 },
{ pincode: 122230, min_days: 3, max_days: 5 },
{ pincode: 122231, min_days: 3, max_days: 5 },
{ pincode: 122232, min_days: 3, max_days: 5 },
{ pincode: 122233, min_days: 3, max_days: 5 },
{ pincode: 122234, min_days: 3, max_days: 5 },
{ pincode: 122410, min_days: 3, max_days: 5 },
{ pincode: 122411, min_days: 3, max_days: 5 },
{ pincode: 122412, min_days: 3, max_days: 5 },
{ pincode: 122413, min_days: 3, max_days: 5 },
{ pincode: 122414, min_days: 3, max_days: 5 },
{ pincode: 122415, min_days: 3, max_days: 5 },
{ pincode: 122416, min_days: 3, max_days: 5 },
{ pincode: 122501, min_days: 3, max_days: 5 },
{ pincode: 122502, min_days: 3, max_days: 5 },
{ pincode: 122503, min_days: 3, max_days: 5 },
{ pincode: 122504, min_days: 3, max_days: 5 },
{ pincode: 122506, min_days: 3, max_days: 5 },
{ pincode: 122507, min_days: 3, max_days: 5 },
{ pincode: 123000, min_days: 3, max_days: 5 },
{ pincode: 123003, min_days: 3, max_days: 5 },
{ pincode: 123004, min_days: 3, max_days: 5 },
{ pincode: 123035, min_days: 3, max_days: 5 },
{ pincode: 123101, min_days: 3, max_days: 5 },
{ pincode: 123102, min_days: 3, max_days: 5 },
{ pincode: 123103, min_days: 3, max_days: 5 },
{ pincode: 123104, min_days: 3, max_days: 5 },
{ pincode: 123105, min_days: 3, max_days: 5 },
{ pincode: 123106, min_days: 3, max_days: 5 },
{ pincode: 123107, min_days: 3, max_days: 5 },
{ pincode: 123108, min_days: 3, max_days: 5 },
{ pincode: 123109, min_days: 3, max_days: 5 },
{ pincode: 123110, min_days: 3, max_days: 5 },
{ pincode: 123301, min_days: 3, max_days: 5 },
{ pincode: 123302, min_days: 3, max_days: 5 },
{ pincode: 123303, min_days: 3, max_days: 5 },
{ pincode: 123304, min_days: 3, max_days: 5 },
{ pincode: 123305, min_days: 3, max_days: 5 },
{ pincode: 123306, min_days: 3, max_days: 5 },
{ pincode: 123307, min_days: 3, max_days: 5 },
{ pincode: 123308, min_days: 3, max_days: 5 },
{ pincode: 123309, min_days: 3, max_days: 5 },
{ pincode: 123400, min_days: 3, max_days: 5 },
{ pincode: 123401, min_days: 3, max_days: 5 },
{ pincode: 123405, min_days: 3, max_days: 5 },
{ pincode: 123411, min_days: 3, max_days: 5 },
{ pincode: 123412, min_days: 3, max_days: 5 },
{ pincode: 123413, min_days: 3, max_days: 5 },
{ pincode: 123414, min_days: 3, max_days: 5 },
{ pincode: 123501, min_days: 3, max_days: 5 },
{ pincode: 123502, min_days: 3, max_days: 5 },
{ pincode: 123503, min_days: 3, max_days: 5 },
{ pincode: 123504, min_days: 3, max_days: 5 },
{ pincode: 123505, min_days: 3, max_days: 5 },
{ pincode: 123506, min_days: 3, max_days: 5 },
{ pincode: 123507, min_days: 3, max_days: 5 },
{ pincode: 123508, min_days: 3, max_days: 5 },
{ pincode: 124001, min_days: 3, max_days: 5 },
{ pincode: 124002, min_days: 3, max_days: 5 },
{ pincode: 124003, min_days: 3, max_days: 5 },
{ pincode: 124005, min_days: 3, max_days: 5 },
{ pincode: 124006, min_days: 3, max_days: 5 },
{ pincode: 124007, min_days: 3, max_days: 5 },
{ pincode: 124008, min_days: 3, max_days: 5 },
{ pincode: 124010, min_days: 3, max_days: 5 },
{ pincode: 124019, min_days: 3, max_days: 5 },
{ pincode: 124021, min_days: 3, max_days: 5 },
{ pincode: 124022, min_days: 3, max_days: 5 },
{ pincode: 124023, min_days: 3, max_days: 5 },
{ pincode: 124024, min_days: 3, max_days: 5 },
{ pincode: 124025, min_days: 3, max_days: 5 },
{ pincode: 124026, min_days: 3, max_days: 5 },
{ pincode: 124027, min_days: 3, max_days: 5 },
{ pincode: 124028, min_days: 3, max_days: 5 },
{ pincode: 124029, min_days: 3, max_days: 5 },
{ pincode: 124101, min_days: 3, max_days: 5 },
{ pincode: 124102, min_days: 3, max_days: 5 },
{ pincode: 124103, min_days: 3, max_days: 5 },
{ pincode: 124104, min_days: 3, max_days: 5 },
{ pincode: 124105, min_days: 3, max_days: 5 },
{ pincode: 124106, min_days: 3, max_days: 5 },
{ pincode: 124107, min_days: 3, max_days: 5 },
{ pincode: 124108, min_days: 3, max_days: 5 },
{ pincode: 124109, min_days: 3, max_days: 5 },
{ pincode: 124110, min_days: 3, max_days: 5 },
{ pincode: 124114, min_days: 3, max_days: 5 },
{ pincode: 124115, min_days: 3, max_days: 5 },
{ pincode: 124116, min_days: 3, max_days: 5 },
{ pincode: 124117, min_days: 3, max_days: 5 },
{ pincode: 124118, min_days: 3, max_days: 5 },
{ pincode: 124119, min_days: 3, max_days: 5 },
{ pincode: 124120, min_days: 3, max_days: 5 },
{ pincode: 124121, min_days: 3, max_days: 5 },
{ pincode: 124122, min_days: 3, max_days: 5 },
{ pincode: 124123, min_days: 3, max_days: 5 },
{ pincode: 124124, min_days: 3, max_days: 5 },
{ pincode: 124125, min_days: 3, max_days: 5 },
{ pincode: 124126, min_days: 3, max_days: 5 },
{ pincode: 124127, min_days: 3, max_days: 5 },
{ pincode: 124128, min_days: 3, max_days: 5 },
{ pincode: 124129, min_days: 3, max_days: 5 },
{ pincode: 124140, min_days: 3, max_days: 5 },
{ pincode: 124141, min_days: 3, max_days: 5 },
{ pincode: 124142, min_days: 3, max_days: 5 },
{ pincode: 124146, min_days: 3, max_days: 5 },
{ pincode: 124201, min_days: 3, max_days: 5 },
{ pincode: 124202, min_days: 3, max_days: 5 },
{ pincode: 124203, min_days: 3, max_days: 5 },
{ pincode: 124204, min_days: 3, max_days: 5 },
{ pincode: 124205, min_days: 3, max_days: 5 },
{ pincode: 124301, min_days: 3, max_days: 5 },
{ pincode: 124302, min_days: 3, max_days: 5 },
{ pincode: 124304, min_days: 3, max_days: 5 },
{ pincode: 124306, min_days: 3, max_days: 5 },
{ pincode: 124307, min_days: 3, max_days: 5 },
{ pincode: 124308, min_days: 3, max_days: 5 },
{ pincode: 124309, min_days: 3, max_days: 5 },
{ pincode: 124401, min_days: 3, max_days: 5 },
{ pincode: 124402, min_days: 3, max_days: 5 },
{ pincode: 124403, min_days: 3, max_days: 5 },
{ pincode: 124404, min_days: 3, max_days: 5 },
{ pincode: 124405, min_days: 3, max_days: 5 },
{ pincode: 124406, min_days: 3, max_days: 5 },
{ pincode: 124407, min_days: 3, max_days: 5 },
{ pincode: 124408, min_days: 3, max_days: 5 },
{ pincode: 124409, min_days: 3, max_days: 5 },
{ pincode: 124410, min_days: 3, max_days: 5 },
{ pincode: 124411, min_days: 3, max_days: 5 },
{ pincode: 124412, min_days: 3, max_days: 5 },
{ pincode: 124413, min_days: 3, max_days: 5 },
{ pincode: 124415, min_days: 3, max_days: 5 },
{ pincode: 124416, min_days: 3, max_days: 5 },
{ pincode: 124417, min_days: 3, max_days: 5 },
{ pincode: 124418, min_days: 3, max_days: 5 },
{ pincode: 124419, min_days: 3, max_days: 5 },
{ pincode: 124501, min_days: 3, max_days: 5 },
{ pincode: 124502, min_days: 3, max_days: 5 },
{ pincode: 124503, min_days: 3, max_days: 5 },
{ pincode: 124504, min_days: 3, max_days: 5 },
{ pincode: 124505, min_days: 3, max_days: 5 },
{ pincode: 124506, min_days: 3, max_days: 5 },
{ pincode: 124507, min_days: 3, max_days: 5 },
{ pincode: 124508, min_days: 3, max_days: 5 },
{ pincode: 124509, min_days: 3, max_days: 5 },
{ pincode: 124510, min_days: 3, max_days: 5 },
{ pincode: 124511, min_days: 3, max_days: 5 },
{ pincode: 124515, min_days: 3, max_days: 5 },
{ pincode: 124516, min_days: 3, max_days: 5 },
{ pincode: 124517, min_days: 3, max_days: 5 },
{ pincode: 124518, min_days: 3, max_days: 5 },
{ pincode: 124519, min_days: 3, max_days: 5 },
{ pincode: 124520, min_days: 3, max_days: 5 },
{ pincode: 124521, min_days: 3, max_days: 5 },
{ pincode: 124523, min_days: 3, max_days: 5 },
{ pincode: 124524, min_days: 3, max_days: 5 },
{ pincode: 124525, min_days: 3, max_days: 5 },
{ pincode: 124526, min_days: 3, max_days: 5 },
{ pincode: 124527, min_days: 3, max_days: 5 },
{ pincode: 124528, min_days: 3, max_days: 5 },
{ pincode: 124529, min_days: 3, max_days: 5 },
{ pincode: 125000, min_days: 3, max_days: 5 },
{ pincode: 125001, min_days: 3, max_days: 5 },
{ pincode: 125002, min_days: 3, max_days: 5 },
{ pincode: 125003, min_days: 3, max_days: 5 },
{ pincode: 125004, min_days: 3, max_days: 5 },
{ pincode: 125005, min_days: 3, max_days: 5 },
{ pincode: 125006, min_days: 3, max_days: 5 },
{ pincode: 125007, min_days: 3, max_days: 5 },
{ pincode: 125008, min_days: 3, max_days: 5 },
{ pincode: 125009, min_days: 3, max_days: 5 },
{ pincode: 125011, min_days: 3, max_days: 5 },
{ pincode: 125012, min_days: 3, max_days: 5 },
{ pincode: 125030, min_days: 3, max_days: 5 },
{ pincode: 125031, min_days: 3, max_days: 5 },
{ pincode: 125032, min_days: 3, max_days: 5 },
{ pincode: 125033, min_days: 3, max_days: 5 },
{ pincode: 125034, min_days: 3, max_days: 5 },
{ pincode: 125035, min_days: 3, max_days: 5 },
{ pincode: 125036, min_days: 3, max_days: 5 },
{ pincode: 125037, min_days: 3, max_days: 5 },
{ pincode: 125038, min_days: 3, max_days: 5 },
{ pincode: 125039, min_days: 3, max_days: 5 },
{ pincode: 125040, min_days: 3, max_days: 5 },
{ pincode: 125041, min_days: 3, max_days: 5 },
{ pincode: 125042, min_days: 3, max_days: 5 },
{ pincode: 125043, min_days: 3, max_days: 5 },
{ pincode: 125044, min_days: 3, max_days: 5 },
{ pincode: 125045, min_days: 3, max_days: 5 },
{ pincode: 125046, min_days: 3, max_days: 5 },
{ pincode: 125047, min_days: 3, max_days: 5 },
{ pincode: 125048, min_days: 3, max_days: 5 },
{ pincode: 125049, min_days: 3, max_days: 5 },
{ pincode: 125050, min_days: 3, max_days: 5 },
{ pincode: 125052, min_days: 3, max_days: 5 },
{ pincode: 125053, min_days: 3, max_days: 5 },
{ pincode: 125055, min_days: 3, max_days: 5 },
{ pincode: 125057, min_days: 3, max_days: 5 },
{ pincode: 125111, min_days: 3, max_days: 5 },
{ pincode: 125112, min_days: 3, max_days: 5 },
{ pincode: 125113, min_days: 3, max_days: 5 },
{ pincode: 125119, min_days: 3, max_days: 5 },
{ pincode: 125120, min_days: 3, max_days: 5 },
{ pincode: 125121, min_days: 3, max_days: 5 },
{ pincode: 126001, min_days: 3, max_days: 5 },
{ pincode: 126006, min_days: 3, max_days: 5 },
{ pincode: 126007, min_days: 3, max_days: 5 },
{ pincode: 126008, min_days: 3, max_days: 5 },
{ pincode: 126009, min_days: 3, max_days: 5 },
{ pincode: 126010, min_days: 3, max_days: 5 },
{ pincode: 126011, min_days: 3, max_days: 5 },
{ pincode: 126013, min_days: 3, max_days: 5 },
{ pincode: 126014, min_days: 3, max_days: 5 },
{ pincode: 126015, min_days: 3, max_days: 5 },
{ pincode: 126025, min_days: 3, max_days: 5 },
{ pincode: 126027, min_days: 3, max_days: 5 },
{ pincode: 127021, min_days: 3, max_days: 5 },
{ pincode: 127032, min_days: 3, max_days: 5 },
{ pincode: 127035, min_days: 3, max_days: 5 },
{ pincode: 127040, min_days: 3, max_days: 5 },
{ pincode: 127041, min_days: 3, max_days: 5 },
{ pincode: 127043, min_days: 3, max_days: 5 },
{ pincode: 127045, min_days: 3, max_days: 5 },
{ pincode: 127111, min_days: 3, max_days: 5 },
{ pincode: 131000, min_days: 3, max_days: 5 },
{ pincode: 131001, min_days: 3, max_days: 5 },
{ pincode: 131002, min_days: 3, max_days: 5 },
{ pincode: 131003, min_days: 3, max_days: 5 },
{ pincode: 131021, min_days: 3, max_days: 5 },
{ pincode: 131022, min_days: 3, max_days: 5 },
{ pincode: 131023, min_days: 3, max_days: 5 },
{ pincode: 131024, min_days: 3, max_days: 5 },
{ pincode: 131025, min_days: 3, max_days: 5 },
{ pincode: 131026, min_days: 3, max_days: 5 },
{ pincode: 131027, min_days: 3, max_days: 5 },
{ pincode: 131028, min_days: 3, max_days: 5 },
{ pincode: 131029, min_days: 3, max_days: 5 },
{ pincode: 131030, min_days: 3, max_days: 5 },
{ pincode: 131031, min_days: 3, max_days: 5 },
{ pincode: 131032, min_days: 3, max_days: 5 },
{ pincode: 131033, min_days: 3, max_days: 5 },
{ pincode: 131034, min_days: 3, max_days: 5 },
{ pincode: 131035, min_days: 3, max_days: 5 },
{ pincode: 131036, min_days: 3, max_days: 5 },
{ pincode: 131037, min_days: 3, max_days: 5 },
{ pincode: 131038, min_days: 3, max_days: 5 },
{ pincode: 131039, min_days: 3, max_days: 5 },
{ pincode: 131040, min_days: 3, max_days: 5 },
{ pincode: 131101, min_days: 3, max_days: 5 },
{ pincode: 131102, min_days: 3, max_days: 5 },
{ pincode: 131103, min_days: 3, max_days: 5 },
{ pincode: 131104, min_days: 3, max_days: 5 },
{ pincode: 131105, min_days: 3, max_days: 5 },
{ pincode: 131106, min_days: 3, max_days: 5 },
{ pincode: 131107, min_days: 3, max_days: 5 },
{ pincode: 131108, min_days: 3, max_days: 5 },
{ pincode: 131109, min_days: 3, max_days: 5 },
{ pincode: 131110, min_days: 3, max_days: 5 },
{ pincode: 131111, min_days: 3, max_days: 5 },
{ pincode: 131112, min_days: 3, max_days: 5 },
{ pincode: 131113, min_days: 3, max_days: 5 },
{ pincode: 131114, min_days: 3, max_days: 5 },
{ pincode: 131115, min_days: 3, max_days: 5 },
{ pincode: 131301, min_days: 3, max_days: 5 },
{ pincode: 131302, min_days: 3, max_days: 5 },
{ pincode: 131303, min_days: 3, max_days: 5 },
{ pincode: 131304, min_days: 3, max_days: 5 },
{ pincode: 131305, min_days: 3, max_days: 5 },
{ pincode: 131306, min_days: 3, max_days: 5 },
{ pincode: 131310, min_days: 3, max_days: 5 },
{ pincode: 131402, min_days: 3, max_days: 5 },
{ pincode: 131403, min_days: 3, max_days: 5 },
{ pincode: 131407, min_days: 3, max_days: 5 },
{ pincode: 131408, min_days: 3, max_days: 5 },
{ pincode: 131409, min_days: 3, max_days: 5 },
{ pincode: 132001, min_days: 3, max_days: 5 },
{ pincode: 132003, min_days: 3, max_days: 5 },
{ pincode: 132020, min_days: 3, max_days: 5 },
{ pincode: 132021, min_days: 3, max_days: 5 },
{ pincode: 132022, min_days: 3, max_days: 5 },
{ pincode: 132023, min_days: 3, max_days: 5 },
{ pincode: 132025, min_days: 3, max_days: 5 },
{ pincode: 132026, min_days: 3, max_days: 5 },
{ pincode: 132027, min_days: 3, max_days: 5 },
{ pincode: 132029, min_days: 3, max_days: 5 },
{ pincode: 132032, min_days: 3, max_days: 5 },
{ pincode: 132035, min_days: 3, max_days: 5 },
{ pincode: 132036, min_days: 3, max_days: 5 },
{ pincode: 132037, min_days: 3, max_days: 5 },
{ pincode: 132038, min_days: 3, max_days: 5 },
{ pincode: 132039, min_days: 3, max_days: 5 },
{ pincode: 132040, min_days: 3, max_days: 5 },
{ pincode: 132041, min_days: 3, max_days: 5 },
{ pincode: 132042, min_days: 3, max_days: 5 },
{ pincode: 132043, min_days: 3, max_days: 5 },
{ pincode: 132044, min_days: 3, max_days: 5 },
{ pincode: 132045, min_days: 3, max_days: 5 },
{ pincode: 132046, min_days: 3, max_days: 5 },
{ pincode: 132047, min_days: 3, max_days: 5 },
{ pincode: 132048, min_days: 3, max_days: 5 },
{ pincode: 132049, min_days: 3, max_days: 5 },
{ pincode: 132050, min_days: 3, max_days: 5 },
{ pincode: 132051, min_days: 3, max_days: 5 },
{ pincode: 132052, min_days: 3, max_days: 5 },
{ pincode: 132053, min_days: 3, max_days: 5 },
{ pincode: 132054, min_days: 3, max_days: 5 },
{ pincode: 132058, min_days: 3, max_days: 5 },
{ pincode: 132100, min_days: 3, max_days: 5 },
{ pincode: 132101, min_days: 3, max_days: 5 },
{ pincode: 132102, min_days: 3, max_days: 5 },
{ pincode: 132103, min_days: 3, max_days: 5 },
{ pincode: 132104, min_days: 3, max_days: 5 },
{ pincode: 132105, min_days: 3, max_days: 5 },
{ pincode: 132106, min_days: 3, max_days: 5 },
{ pincode: 132107, min_days: 3, max_days: 5 },
{ pincode: 132108, min_days: 3, max_days: 5 },
{ pincode: 132109, min_days: 3, max_days: 5 },
{ pincode: 132110, min_days: 3, max_days: 5 },
{ pincode: 132111, min_days: 3, max_days: 5 },
{ pincode: 132112, min_days: 3, max_days: 5 },
{ pincode: 132113, min_days: 3, max_days: 5 },
{ pincode: 132114, min_days: 3, max_days: 5 },
{ pincode: 132115, min_days: 3, max_days: 5 },
{ pincode: 132116, min_days: 3, max_days: 5 },
{ pincode: 132117, min_days: 3, max_days: 5 },
{ pincode: 132118, min_days: 3, max_days: 5 },
{ pincode: 132119, min_days: 3, max_days: 5 },
{ pincode: 132120, min_days: 3, max_days: 5 },
{ pincode: 132121, min_days: 3, max_days: 5 },
{ pincode: 132122, min_days: 3, max_days: 5 },
{ pincode: 132123, min_days: 3, max_days: 5 },
{ pincode: 132124, min_days: 3, max_days: 5 },
{ pincode: 132125, min_days: 3, max_days: 5 },
{ pincode: 132128, min_days: 3, max_days: 5 },
{ pincode: 132129, min_days: 3, max_days: 5 },
{ pincode: 132130, min_days: 3, max_days: 5 },
{ pincode: 132131, min_days: 3, max_days: 5 },
{ pincode: 132132, min_days: 3, max_days: 5 },
{ pincode: 132133, min_days: 3, max_days: 5 },
{ pincode: 132134, min_days: 3, max_days: 5 },
{ pincode: 132135, min_days: 3, max_days: 5 },
{ pincode: 132136, min_days: 3, max_days: 5 },
{ pincode: 132137, min_days: 3, max_days: 5 },
{ pincode: 132138, min_days: 3, max_days: 5 },
{ pincode: 132139, min_days: 3, max_days: 5 },
{ pincode: 132140, min_days: 3, max_days: 5 },
{ pincode: 132141, min_days: 3, max_days: 5 },
{ pincode: 132142, min_days: 3, max_days: 5 },
{ pincode: 132143, min_days: 3, max_days: 5 },
{ pincode: 132144, min_days: 3, max_days: 5 },
{ pincode: 132145, min_days: 3, max_days: 5 },
{ pincode: 132146, min_days: 3, max_days: 5 },
{ pincode: 132147, min_days: 3, max_days: 5 },
{ pincode: 132148, min_days: 3, max_days: 5 },
{ pincode: 132149, min_days: 3, max_days: 5 },
{ pincode: 132151, min_days: 3, max_days: 5 },
{ pincode: 133000, min_days: 3, max_days: 5 },
{ pincode: 133001, min_days: 3, max_days: 5 },
{ pincode: 133002, min_days: 3, max_days: 5 },
{ pincode: 133003, min_days: 3, max_days: 5 },
{ pincode: 133004, min_days: 3, max_days: 5 },
{ pincode: 133005, min_days: 3, max_days: 5 },
{ pincode: 133006, min_days: 3, max_days: 5 },
{ pincode: 133007, min_days: 3, max_days: 5 },
{ pincode: 133008, min_days: 3, max_days: 5 },
{ pincode: 133010, min_days: 3, max_days: 5 },
{ pincode: 133021, min_days: 3, max_days: 5 },
{ pincode: 133101, min_days: 3, max_days: 5 },
{ pincode: 133102, min_days: 3, max_days: 5 },
{ pincode: 133103, min_days: 3, max_days: 5 },
{ pincode: 133104, min_days: 3, max_days: 5 },
{ pincode: 133105, min_days: 3, max_days: 5 },
{ pincode: 133201, min_days: 3, max_days: 5 },
{ pincode: 133202, min_days: 3, max_days: 5 },
{ pincode: 133203, min_days: 3, max_days: 5 },
{ pincode: 133204, min_days: 3, max_days: 5 },
{ pincode: 133205, min_days: 3, max_days: 5 },
{ pincode: 133206, min_days: 3, max_days: 5 },
{ pincode: 133207, min_days: 3, max_days: 5 },
{ pincode: 133208, min_days: 3, max_days: 5 },
{ pincode: 133301, min_days: 3, max_days: 5 },
{ pincode: 133302, min_days: 3, max_days: 5 },
{ pincode: 134000, min_days: 3, max_days: 5 },
{ pincode: 134001, min_days: 3, max_days: 5 },
{ pincode: 134002, min_days: 3, max_days: 5 },
{ pincode: 134003, min_days: 3, max_days: 5 },
{ pincode: 134004, min_days: 3, max_days: 5 },
{ pincode: 134005, min_days: 3, max_days: 5 },
{ pincode: 134006, min_days: 3, max_days: 5 },
{ pincode: 134007, min_days: 3, max_days: 5 },
{ pincode: 134008, min_days: 3, max_days: 5 },
{ pincode: 134009, min_days: 3, max_days: 5 },
{ pincode: 134011, min_days: 3, max_days: 5 },
{ pincode: 134012, min_days: 3, max_days: 5 },
{ pincode: 134101, min_days: 3, max_days: 5 },
{ pincode: 134102, min_days: 3, max_days: 5 },
{ pincode: 134103, min_days: 3, max_days: 5 },
{ pincode: 134104, min_days: 3, max_days: 5 },
{ pincode: 134105, min_days: 3, max_days: 5 },
{ pincode: 134107, min_days: 3, max_days: 5 },
{ pincode: 134108, min_days: 3, max_days: 5 },
{ pincode: 134109, min_days: 3, max_days: 5 },
{ pincode: 134110, min_days: 3, max_days: 5 },
{ pincode: 134111, min_days: 3, max_days: 5 },
{ pincode: 134112, min_days: 3, max_days: 5 },
{ pincode: 134113, min_days: 3, max_days: 5 },
{ pincode: 134114, min_days: 3, max_days: 5 },
{ pincode: 134115, min_days: 3, max_days: 5 },
{ pincode: 134116, min_days: 3, max_days: 5 },
{ pincode: 134117, min_days: 3, max_days: 5 },
{ pincode: 134118, min_days: 3, max_days: 5 },
{ pincode: 134119, min_days: 3, max_days: 5 },
{ pincode: 134151, min_days: 3, max_days: 5 },
{ pincode: 134152, min_days: 3, max_days: 5 },
{ pincode: 134201, min_days: 3, max_days: 5 },
{ pincode: 134202, min_days: 3, max_days: 5 },
{ pincode: 134203, min_days: 3, max_days: 5 },
{ pincode: 134204, min_days: 3, max_days: 5 },
{ pincode: 134205, min_days: 3, max_days: 5 },
{ pincode: 134206, min_days: 3, max_days: 5 },
{ pincode: 134603, min_days: 3, max_days: 5 },
{ pincode: 135000, min_days: 3, max_days: 5 },
{ pincode: 135001, min_days: 3, max_days: 5 },
{ pincode: 135002, min_days: 3, max_days: 5 },
{ pincode: 135003, min_days: 3, max_days: 5 },
{ pincode: 135004, min_days: 3, max_days: 5 },
{ pincode: 135101, min_days: 3, max_days: 5 },
{ pincode: 135102, min_days: 3, max_days: 5 },
{ pincode: 135103, min_days: 3, max_days: 5 },
{ pincode: 135104, min_days: 3, max_days: 5 },
{ pincode: 135133, min_days: 3, max_days: 5 },
{ pincode: 135136, min_days: 3, max_days: 5 },
{ pincode: 136000, min_days: 3, max_days: 5 },
{ pincode: 136030, min_days: 3, max_days: 5 },
{ pincode: 136036, min_days: 3, max_days: 5 },
{ pincode: 136038, min_days: 3, max_days: 5 },
{ pincode: 136116, min_days: 3, max_days: 5 },
{ pincode: 136118, min_days: 3, max_days: 5 },
{ pincode: 136119, min_days: 3, max_days: 5 },
{ pincode: 136128, min_days: 3, max_days: 5 },
{ pincode: 136129, min_days: 3, max_days: 5 },
{ pincode: 136130, min_days: 3, max_days: 5 },
{ pincode: 136131, min_days: 3, max_days: 5 },
{ pincode: 136132, min_days: 3, max_days: 5 },
{ pincode: 136134, min_days: 3, max_days: 5 },
{ pincode: 136135, min_days: 3, max_days: 5 },
{ pincode: 136136, min_days: 3, max_days: 5 },
{ pincode: 136156, min_days: 3, max_days: 5 },
{ pincode: 140001, min_days: 3, max_days: 5 },
{ pincode: 140055, min_days: 3, max_days: 5 },
{ pincode: 140100, min_days: 3, max_days: 5 },
{ pincode: 140101, min_days: 3, max_days: 5 },
{ pincode: 140102, min_days: 3, max_days: 5 },
{ pincode: 140103, min_days: 3, max_days: 5 },
{ pincode: 140104, min_days: 3, max_days: 5 },
{ pincode: 140105, min_days: 3, max_days: 5 },
{ pincode: 140106, min_days: 3, max_days: 5 },
{ pincode: 140107, min_days: 3, max_days: 5 },
{ pincode: 140108, min_days: 3, max_days: 5 },
{ pincode: 140109, min_days: 3, max_days: 5 },
{ pincode: 140110, min_days: 3, max_days: 5 },
{ pincode: 140111, min_days: 3, max_days: 5 },
{ pincode: 140112, min_days: 3, max_days: 5 },
{ pincode: 140113, min_days: 3, max_days: 5 },
{ pincode: 140201, min_days: 3, max_days: 5 },
{ pincode: 140301, min_days: 3, max_days: 5 },
{ pincode: 140304, min_days: 3, max_days: 5 },
{ pincode: 140306, min_days: 3, max_days: 5 },
{ pincode: 140307, min_days: 3, max_days: 5 },
{ pincode: 140308, min_days: 3, max_days: 5 },
{ pincode: 140401, min_days: 3, max_days: 5 },
{ pincode: 140402, min_days: 3, max_days: 5 },
{ pincode: 140406, min_days: 3, max_days: 5 },
{ pincode: 140407, min_days: 3, max_days: 5 },
{ pincode: 140412, min_days: 3, max_days: 5 },
{ pincode: 140413, min_days: 3, max_days: 5 },
{ pincode: 140417, min_days: 3, max_days: 5 },
{ pincode: 140501, min_days: 3, max_days: 5 },
{ pincode: 140502, min_days: 3, max_days: 5 },
{ pincode: 140503, min_days: 3, max_days: 5 },
{ pincode: 140504, min_days: 3, max_days: 5 },
{ pincode: 140506, min_days: 3, max_days: 5 },
{ pincode: 140507, min_days: 3, max_days: 5 },
{ pincode: 140601, min_days: 3, max_days: 5 },
{ pincode: 140602, min_days: 3, max_days: 5 },
{ pincode: 140603, min_days: 3, max_days: 5 },
{ pincode: 140604, min_days: 3, max_days: 5 },
{ pincode: 140701, min_days: 3, max_days: 5 },
{ pincode: 140801, min_days: 3, max_days: 5 },
{ pincode: 140802, min_days: 3, max_days: 5 },
{ pincode: 140803, min_days: 3, max_days: 5 },
{ pincode: 140901, min_days: 3, max_days: 5 },
{ pincode: 141000, min_days: 3, max_days: 5 },
{ pincode: 141001, min_days: 3, max_days: 5 },
{ pincode: 141002, min_days: 3, max_days: 5 },
{ pincode: 141003, min_days: 3, max_days: 5 },
{ pincode: 141004, min_days: 3, max_days: 5 },
{ pincode: 141005, min_days: 3, max_days: 5 },
{ pincode: 141006, min_days: 3, max_days: 5 },
{ pincode: 141007, min_days: 3, max_days: 5 },
{ pincode: 141008, min_days: 3, max_days: 5 },
{ pincode: 141009, min_days: 3, max_days: 5 },
{ pincode: 141010, min_days: 3, max_days: 5 },
{ pincode: 141011, min_days: 3, max_days: 5 },
{ pincode: 141012, min_days: 3, max_days: 5 },
{ pincode: 141013, min_days: 3, max_days: 5 },
{ pincode: 141014, min_days: 3, max_days: 5 },
{ pincode: 141015, min_days: 3, max_days: 5 },
{ pincode: 141016, min_days: 3, max_days: 5 },
{ pincode: 141017, min_days: 3, max_days: 5 },
{ pincode: 141020, min_days: 3, max_days: 5 },
{ pincode: 141021, min_days: 3, max_days: 5 },
{ pincode: 141022, min_days: 3, max_days: 5 },
{ pincode: 141026, min_days: 3, max_days: 5 },
{ pincode: 141027, min_days: 3, max_days: 5 },
{ pincode: 141101, min_days: 3, max_days: 5 },
{ pincode: 141102, min_days: 3, max_days: 5 },
{ pincode: 141103, min_days: 3, max_days: 5 },
{ pincode: 141104, min_days: 3, max_days: 5 },
{ pincode: 141105, min_days: 3, max_days: 5 },
{ pincode: 141106, min_days: 3, max_days: 5 },
{ pincode: 141107, min_days: 3, max_days: 5 },
{ pincode: 141108, min_days: 3, max_days: 5 },
{ pincode: 141109, min_days: 3, max_days: 5 },
{ pincode: 141110, min_days: 3, max_days: 5 },
{ pincode: 141111, min_days: 3, max_days: 5 },
{ pincode: 141112, min_days: 3, max_days: 5 },
{ pincode: 141113, min_days: 3, max_days: 5 },
{ pincode: 141114, min_days: 3, max_days: 5 },
{ pincode: 141115, min_days: 3, max_days: 5 },
{ pincode: 141116, min_days: 3, max_days: 5 },
{ pincode: 141117, min_days: 3, max_days: 5 },
{ pincode: 141118, min_days: 3, max_days: 5 },
{ pincode: 141119, min_days: 3, max_days: 5 },
{ pincode: 141120, min_days: 3, max_days: 5 },
{ pincode: 141121, min_days: 3, max_days: 5 },
{ pincode: 141122, min_days: 3, max_days: 5 },
{ pincode: 141123, min_days: 3, max_days: 5 },
{ pincode: 141124, min_days: 3, max_days: 5 },
{ pincode: 141125, min_days: 3, max_days: 5 },
{ pincode: 141126, min_days: 3, max_days: 5 },
{ pincode: 141127, min_days: 3, max_days: 5 },
{ pincode: 141128, min_days: 3, max_days: 5 },
{ pincode: 141201, min_days: 3, max_days: 5 },
{ pincode: 141202, min_days: 3, max_days: 5 },
{ pincode: 141203, min_days: 3, max_days: 5 },
{ pincode: 141204, min_days: 3, max_days: 5 },
{ pincode: 141205, min_days: 3, max_days: 5 },
{ pincode: 141206, min_days: 3, max_days: 5 },
{ pincode: 141401, min_days: 3, max_days: 5 },
{ pincode: 141411, min_days: 3, max_days: 5 },
{ pincode: 141412, min_days: 3, max_days: 5 },
{ pincode: 141413, min_days: 3, max_days: 5 },
{ pincode: 141414, min_days: 3, max_days: 5 },
{ pincode: 141415, min_days: 3, max_days: 5 },
{ pincode: 141416, min_days: 3, max_days: 5 },
{ pincode: 141417, min_days: 3, max_days: 5 },
{ pincode: 141418, min_days: 3, max_days: 5 },
{ pincode: 141419, min_days: 3, max_days: 5 },
{ pincode: 141420, min_days: 3, max_days: 5 },
{ pincode: 141421, min_days: 3, max_days: 5 },
{ pincode: 141422, min_days: 3, max_days: 5 },
{ pincode: 141801, min_days: 3, max_days: 5 },
{ pincode: 142001, min_days: 3, max_days: 5 },
{ pincode: 142002, min_days: 3, max_days: 5 },
{ pincode: 142003, min_days: 3, max_days: 5 },
{ pincode: 142011, min_days: 3, max_days: 5 },
{ pincode: 142020, min_days: 3, max_days: 5 },
{ pincode: 142021, min_days: 3, max_days: 5 },
{ pincode: 142022, min_days: 3, max_days: 5 },
{ pincode: 142023, min_days: 3, max_days: 5 },
{ pincode: 142024, min_days: 3, max_days: 5 },
{ pincode: 142025, min_days: 3, max_days: 5 },
{ pincode: 142026, min_days: 3, max_days: 5 },
{ pincode: 142027, min_days: 3, max_days: 5 },
{ pincode: 142029, min_days: 3, max_days: 5 },
{ pincode: 142030, min_days: 3, max_days: 5 },
{ pincode: 142031, min_days: 3, max_days: 5 },
{ pincode: 142032, min_days: 3, max_days: 5 },
{ pincode: 142033, min_days: 3, max_days: 5 },
{ pincode: 142034, min_days: 3, max_days: 5 },
{ pincode: 142035, min_days: 3, max_days: 5 },
{ pincode: 142036, min_days: 3, max_days: 5 },
{ pincode: 142042, min_days: 3, max_days: 5 },
{ pincode: 142051, min_days: 3, max_days: 5 },
{ pincode: 142054, min_days: 3, max_days: 5 },
{ pincode: 142059, min_days: 3, max_days: 5 },
{ pincode: 143000, min_days: 3, max_days: 5 },
{ pincode: 143001, min_days: 3, max_days: 5 },
{ pincode: 143002, min_days: 3, max_days: 5 },
{ pincode: 143003, min_days: 3, max_days: 5 },
{ pincode: 143004, min_days: 3, max_days: 5 },
{ pincode: 143005, min_days: 3, max_days: 5 },
{ pincode: 143006, min_days: 3, max_days: 5 },
{ pincode: 143007, min_days: 3, max_days: 5 },
{ pincode: 143008, min_days: 3, max_days: 5 },
{ pincode: 143009, min_days: 3, max_days: 5 },
{ pincode: 143010, min_days: 3, max_days: 5 },
{ pincode: 143021, min_days: 3, max_days: 5 },
{ pincode: 143022, min_days: 3, max_days: 5 },
{ pincode: 143026, min_days: 3, max_days: 5 },
{ pincode: 143101, min_days: 3, max_days: 5 },
{ pincode: 143102, min_days: 3, max_days: 5 },
{ pincode: 143103, min_days: 3, max_days: 5 },
{ pincode: 143104, min_days: 3, max_days: 5 },
{ pincode: 143105, min_days: 3, max_days: 5 },
{ pincode: 143106, min_days: 3, max_days: 5 },
{ pincode: 143107, min_days: 3, max_days: 5 },
{ pincode: 143108, min_days: 3, max_days: 5 },
{ pincode: 143109, min_days: 3, max_days: 5 },
{ pincode: 143110, min_days: 3, max_days: 5 },
{ pincode: 143111, min_days: 3, max_days: 5 },
{ pincode: 143112, min_days: 3, max_days: 5 },
{ pincode: 143113, min_days: 3, max_days: 5 },
{ pincode: 143114, min_days: 3, max_days: 5 },
{ pincode: 143115, min_days: 3, max_days: 5 },
{ pincode: 143116, min_days: 3, max_days: 5 },
{ pincode: 143117, min_days: 3, max_days: 5 },
{ pincode: 143118, min_days: 3, max_days: 5 },
{ pincode: 143119, min_days: 3, max_days: 5 },
{ pincode: 143144, min_days: 3, max_days: 5 },
{ pincode: 143149, min_days: 3, max_days: 5 },
{ pincode: 143200, min_days: 3, max_days: 5 },
{ pincode: 143201, min_days: 3, max_days: 5 },
{ pincode: 143202, min_days: 3, max_days: 5 },
{ pincode: 143203, min_days: 3, max_days: 5 },
{ pincode: 143204, min_days: 3, max_days: 5 },
{ pincode: 143205, min_days: 3, max_days: 5 },
{ pincode: 143208, min_days: 3, max_days: 5 },
{ pincode: 143301, min_days: 3, max_days: 5 },
{ pincode: 143302, min_days: 3, max_days: 5 },
{ pincode: 143303, min_days: 3, max_days: 5 },
{ pincode: 143304, min_days: 3, max_days: 5 },
{ pincode: 143305, min_days: 3, max_days: 5 },
{ pincode: 143306, min_days: 3, max_days: 5 },
{ pincode: 143310, min_days: 3, max_days: 5 },
{ pincode: 143312, min_days: 3, max_days: 5 },
{ pincode: 143314, min_days: 3, max_days: 5 },
{ pincode: 143315, min_days: 3, max_days: 5 },
{ pincode: 143317, min_days: 3, max_days: 5 },
{ pincode: 143318, min_days: 3, max_days: 5 },
{ pincode: 143319, min_days: 3, max_days: 5 },
{ pincode: 143322, min_days: 3, max_days: 5 },
{ pincode: 143327, min_days: 3, max_days: 5 },
{ pincode: 143338, min_days: 3, max_days: 5 },
{ pincode: 143339, min_days: 3, max_days: 5 },
{ pincode: 143340, min_days: 3, max_days: 5 },
{ pincode: 143347, min_days: 3, max_days: 5 },
{ pincode: 143370, min_days: 3, max_days: 5 },
{ pincode: 143371, min_days: 3, max_days: 5 },
{ pincode: 143372, min_days: 3, max_days: 5 },
{ pincode: 143380, min_days: 3, max_days: 5 },
{ pincode: 143382, min_days: 3, max_days: 5 },
{ pincode: 143401, min_days: 3, max_days: 5 },
{ pincode: 143402, min_days: 3, max_days: 5 },
{ pincode: 143406, min_days: 3, max_days: 5 },
{ pincode: 143407, min_days: 3, max_days: 5 },
{ pincode: 143408, min_days: 3, max_days: 5 },
{ pincode: 143409, min_days: 3, max_days: 5 },
{ pincode: 143410, min_days: 3, max_days: 5 },
{ pincode: 143411, min_days: 3, max_days: 5 },
{ pincode: 143412, min_days: 3, max_days: 5 },
{ pincode: 143413, min_days: 3, max_days: 5 },
{ pincode: 143414, min_days: 3, max_days: 5 },
{ pincode: 143415, min_days: 3, max_days: 5 },
{ pincode: 143418, min_days: 3, max_days: 5 },
{ pincode: 143420, min_days: 3, max_days: 5 },
{ pincode: 143421, min_days: 3, max_days: 5 },
{ pincode: 143422, min_days: 3, max_days: 5 },
{ pincode: 143426, min_days: 3, max_days: 5 },
{ pincode: 143439, min_days: 3, max_days: 5 },
{ pincode: 143449, min_days: 3, max_days: 5 },
{ pincode: 143452, min_days: 3, max_days: 5 },
{ pincode: 143461, min_days: 3, max_days: 5 },
{ pincode: 143501, min_days: 3, max_days: 5 },
{ pincode: 143502, min_days: 3, max_days: 5 },
{ pincode: 143503, min_days: 3, max_days: 5 },
{ pincode: 143504, min_days: 3, max_days: 5 },
{ pincode: 143505, min_days: 3, max_days: 5 },
{ pincode: 143506, min_days: 3, max_days: 5 },
{ pincode: 143507, min_days: 3, max_days: 5 },
{ pincode: 143508, min_days: 3, max_days: 5 },
{ pincode: 143511, min_days: 3, max_days: 5 },
{ pincode: 143512, min_days: 3, max_days: 5 },
{ pincode: 143513, min_days: 3, max_days: 5 },
{ pincode: 143514, min_days: 3, max_days: 5 },
{ pincode: 143515, min_days: 3, max_days: 5 },
{ pincode: 143516, min_days: 3, max_days: 5 },
{ pincode: 143518, min_days: 3, max_days: 5 },
{ pincode: 143519, min_days: 3, max_days: 5 },
{ pincode: 143520, min_days: 3, max_days: 5 },
{ pincode: 143529, min_days: 3, max_days: 5 },
{ pincode: 143535, min_days: 3, max_days: 5 },
{ pincode: 143601, min_days: 3, max_days: 5 },
{ pincode: 143602, min_days: 3, max_days: 5 },
{ pincode: 143603, min_days: 3, max_days: 5 },
{ pincode: 143604, min_days: 3, max_days: 5 },
{ pincode: 143605, min_days: 3, max_days: 5 },
{ pincode: 143606, min_days: 3, max_days: 5 },
{ pincode: 143607, min_days: 3, max_days: 5 },
{ pincode: 144001, min_days: 3, max_days: 5 },
{ pincode: 144002, min_days: 3, max_days: 5 },
{ pincode: 144003, min_days: 3, max_days: 5 },
{ pincode: 144004, min_days: 3, max_days: 5 },
{ pincode: 144005, min_days: 3, max_days: 5 },
{ pincode: 144006, min_days: 3, max_days: 5 },
{ pincode: 144007, min_days: 3, max_days: 5 },
{ pincode: 144008, min_days: 3, max_days: 5 },
{ pincode: 144009, min_days: 3, max_days: 5 },
{ pincode: 144010, min_days: 3, max_days: 5 },
{ pincode: 144011, min_days: 3, max_days: 5 },
{ pincode: 144012, min_days: 3, max_days: 5 },
{ pincode: 144013, min_days: 3, max_days: 5 },
{ pincode: 144014, min_days: 3, max_days: 5 },
{ pincode: 144015, min_days: 3, max_days: 5 },
{ pincode: 144016, min_days: 3, max_days: 5 },
{ pincode: 144017, min_days: 3, max_days: 5 },
{ pincode: 144018, min_days: 3, max_days: 5 },
{ pincode: 144019, min_days: 3, max_days: 5 },
{ pincode: 144020, min_days: 3, max_days: 5 },
{ pincode: 144021, min_days: 3, max_days: 5 },
{ pincode: 144022, min_days: 3, max_days: 5 },
{ pincode: 144023, min_days: 3, max_days: 5 },
{ pincode: 144024, min_days: 3, max_days: 5 },
{ pincode: 144025, min_days: 3, max_days: 5 },
{ pincode: 144026, min_days: 3, max_days: 5 },
{ pincode: 144027, min_days: 3, max_days: 5 },
{ pincode: 144028, min_days: 3, max_days: 5 },
{ pincode: 144029, min_days: 3, max_days: 5 },
{ pincode: 144030, min_days: 3, max_days: 5 },
{ pincode: 144031, min_days: 3, max_days: 5 },
{ pincode: 144032, min_days: 3, max_days: 5 },
{ pincode: 144033, min_days: 3, max_days: 5 },
{ pincode: 144034, min_days: 3, max_days: 5 },
{ pincode: 144035, min_days: 3, max_days: 5 },
{ pincode: 144036, min_days: 3, max_days: 5 },
{ pincode: 144037, min_days: 3, max_days: 5 },
{ pincode: 144038, min_days: 3, max_days: 5 },
{ pincode: 144039, min_days: 3, max_days: 5 },
{ pincode: 144040, min_days: 3, max_days: 5 },
{ pincode: 144041, min_days: 3, max_days: 5 },
{ pincode: 144042, min_days: 3, max_days: 5 },
{ pincode: 144043, min_days: 3, max_days: 5 },
{ pincode: 144044, min_days: 3, max_days: 5 },
{ pincode: 144046, min_days: 3, max_days: 5 },
{ pincode: 144047, min_days: 3, max_days: 5 },
{ pincode: 144048, min_days: 3, max_days: 5 },
{ pincode: 144049, min_days: 3, max_days: 5 },
{ pincode: 144101, min_days: 3, max_days: 5 },
{ pincode: 144102, min_days: 3, max_days: 5 },
{ pincode: 144103, min_days: 3, max_days: 5 },
{ pincode: 144104, min_days: 3, max_days: 5 },
{ pincode: 144105, min_days: 3, max_days: 5 },
{ pincode: 144106, min_days: 3, max_days: 5 },
{ pincode: 144201, min_days: 3, max_days: 5 },
{ pincode: 144202, min_days: 3, max_days: 5 },
{ pincode: 144204, min_days: 3, max_days: 5 },
{ pincode: 144205, min_days: 3, max_days: 5 },
{ pincode: 144207, min_days: 3, max_days: 5 },
{ pincode: 144208, min_days: 3, max_days: 5 },
{ pincode: 144209, min_days: 3, max_days: 5 },
{ pincode: 144210, min_days: 3, max_days: 5 },
{ pincode: 144212, min_days: 3, max_days: 5 },
{ pincode: 144214, min_days: 3, max_days: 5 },
{ pincode: 144301, min_days: 3, max_days: 5 },
{ pincode: 144302, min_days: 3, max_days: 5 },
{ pincode: 144303, min_days: 3, max_days: 5 },
{ pincode: 144305, min_days: 3, max_days: 5 },
{ pincode: 144308, min_days: 3, max_days: 5 },
{ pincode: 144311, min_days: 3, max_days: 5 },
{ pincode: 144316, min_days: 3, max_days: 5 },
{ pincode: 144318, min_days: 3, max_days: 5 },
{ pincode: 144401, min_days: 3, max_days: 5 },
{ pincode: 144402, min_days: 3, max_days: 5 },
{ pincode: 144403, min_days: 3, max_days: 5 },
{ pincode: 144404, min_days: 3, max_days: 5 },
{ pincode: 144405, min_days: 3, max_days: 5 },
{ pincode: 144406, min_days: 3, max_days: 5 },
{ pincode: 144407, min_days: 3, max_days: 5 },
{ pincode: 144408, min_days: 3, max_days: 5 },
{ pincode: 144409, min_days: 3, max_days: 5 },
{ pincode: 144410, min_days: 3, max_days: 5 },
{ pincode: 144411, min_days: 3, max_days: 5 },
{ pincode: 144415, min_days: 3, max_days: 5 },
{ pincode: 144416, min_days: 3, max_days: 5 },
{ pincode: 144417, min_days: 3, max_days: 5 },
{ pincode: 144418, min_days: 3, max_days: 5 },
{ pincode: 144419, min_days: 3, max_days: 5 },
{ pincode: 144421, min_days: 3, max_days: 5 },
{ pincode: 144422, min_days: 3, max_days: 5 },
{ pincode: 144501, min_days: 3, max_days: 5 },
{ pincode: 144502, min_days: 3, max_days: 5 },
{ pincode: 144503, min_days: 3, max_days: 5 },
{ pincode: 144504, min_days: 3, max_days: 5 },
{ pincode: 144505, min_days: 3, max_days: 5 },
{ pincode: 144506, min_days: 3, max_days: 5 },
{ pincode: 144507, min_days: 3, max_days: 5 },
{ pincode: 144508, min_days: 3, max_days: 5 },
{ pincode: 144509, min_days: 3, max_days: 5 },
{ pincode: 144510, min_days: 3, max_days: 5 },
{ pincode: 144511, min_days: 3, max_days: 5 },
{ pincode: 144512, min_days: 3, max_days: 5 },
{ pincode: 144513, min_days: 3, max_days: 5 },
{ pincode: 144514, min_days: 3, max_days: 5 },
{ pincode: 144515, min_days: 3, max_days: 5 },
{ pincode: 144516, min_days: 3, max_days: 5 },
{ pincode: 144517, min_days: 3, max_days: 5 },
{ pincode: 144518, min_days: 3, max_days: 5 },
{ pincode: 144519, min_days: 3, max_days: 5 },
{ pincode: 144520, min_days: 3, max_days: 5 },
{ pincode: 144521, min_days: 3, max_days: 5 },
{ pincode: 144526, min_days: 3, max_days: 5 },
{ pincode: 144527, min_days: 3, max_days: 5 },
{ pincode: 144528, min_days: 3, max_days: 5 },
{ pincode: 144529, min_days: 3, max_days: 5 },
{ pincode: 144531, min_days: 3, max_days: 5 },
{ pincode: 144532, min_days: 3, max_days: 5 },
{ pincode: 144533, min_days: 3, max_days: 5 },
{ pincode: 144601, min_days: 3, max_days: 5 },
{ pincode: 144602, min_days: 3, max_days: 5 },
{ pincode: 144606, min_days: 3, max_days: 5 },
{ pincode: 144620, min_days: 3, max_days: 5 },
{ pincode: 144621, min_days: 3, max_days: 5 },
{ pincode: 144622, min_days: 3, max_days: 5 },
{ pincode: 144623, min_days: 3, max_days: 5 },
{ pincode: 144624, min_days: 3, max_days: 5 },
{ pincode: 144625, min_days: 3, max_days: 5 },
{ pincode: 144626, min_days: 3, max_days: 5 },
{ pincode: 144628, min_days: 3, max_days: 5 },
{ pincode: 144629, min_days: 3, max_days: 5 },
{ pincode: 144630, min_days: 3, max_days: 5 },
{ pincode: 144631, min_days: 3, max_days: 5 },
{ pincode: 144632, min_days: 3, max_days: 5 },
{ pincode: 144633, min_days: 3, max_days: 5 },
{ pincode: 144701, min_days: 3, max_days: 5 },
{ pincode: 144702, min_days: 3, max_days: 5 },
{ pincode: 144703, min_days: 3, max_days: 5 },
{ pincode: 144800, min_days: 3, max_days: 5 },
{ pincode: 144801, min_days: 3, max_days: 5 },
{ pincode: 144802, min_days: 3, max_days: 5 },
{ pincode: 144803, min_days: 3, max_days: 5 },
{ pincode: 144804, min_days: 3, max_days: 5 },
{ pincode: 144805, min_days: 3, max_days: 5 },
{ pincode: 144806, min_days: 3, max_days: 5 },
{ pincode: 144819, min_days: 3, max_days: 5 },
{ pincode: 145001, min_days: 3, max_days: 5 },
{ pincode: 145002, min_days: 3, max_days: 5 },
{ pincode: 145021, min_days: 3, max_days: 5 },
{ pincode: 146001, min_days: 3, max_days: 5 },
{ pincode: 146021, min_days: 3, max_days: 5 },
{ pincode: 146022, min_days: 3, max_days: 5 },
{ pincode: 146023, min_days: 3, max_days: 5 },
{ pincode: 146024, min_days: 3, max_days: 5 },
{ pincode: 146101, min_days: 3, max_days: 5 },
{ pincode: 146102, min_days: 3, max_days: 5 },
{ pincode: 146103, min_days: 3, max_days: 5 },
{ pincode: 146104, min_days: 3, max_days: 5 },
{ pincode: 146105, min_days: 3, max_days: 5 },
{ pincode: 146106, min_days: 3, max_days: 5 },
{ pincode: 146107, min_days: 3, max_days: 5 },
{ pincode: 146108, min_days: 3, max_days: 5 },
{ pincode: 146109, min_days: 3, max_days: 5 },
{ pincode: 146110, min_days: 3, max_days: 5 },
{ pincode: 146111, min_days: 3, max_days: 5 },
{ pincode: 146112, min_days: 3, max_days: 5 },
{ pincode: 146113, min_days: 3, max_days: 5 },
{ pincode: 146114, min_days: 3, max_days: 5 },
{ pincode: 146115, min_days: 3, max_days: 5 },
{ pincode: 146116, min_days: 3, max_days: 5 },
{ pincode: 147001, min_days: 3, max_days: 5 },
{ pincode: 147002, min_days: 3, max_days: 5 },
{ pincode: 147003, min_days: 3, max_days: 5 },
{ pincode: 147004, min_days: 3, max_days: 5 },
{ pincode: 147005, min_days: 3, max_days: 5 },
{ pincode: 147021, min_days: 3, max_days: 5 },
{ pincode: 147023, min_days: 3, max_days: 5 },
{ pincode: 147103, min_days: 3, max_days: 5 },
{ pincode: 147203, min_days: 3, max_days: 5 },
{ pincode: 147301, min_days: 3, max_days: 5 },
{ pincode: 148018, min_days: 3, max_days: 5 },
{ pincode: 148019, min_days: 3, max_days: 5 },
{ pincode: 148020, min_days: 3, max_days: 5 },
{ pincode: 148021, min_days: 3, max_days: 5 },
{ pincode: 148022, min_days: 3, max_days: 5 },
{ pincode: 148023, min_days: 3, max_days: 5 },
{ pincode: 148024, min_days: 3, max_days: 5 },
{ pincode: 148025, min_days: 3, max_days: 5 },
{ pincode: 151001, min_days: 7, max_days: 10 },
{ pincode: 151002, min_days: 7, max_days: 10 },
{ pincode: 151003, min_days: 7, max_days: 10 },
{ pincode: 151004, min_days: 7, max_days: 10 },
{ pincode: 151005, min_days: 7, max_days: 10 },
{ pincode: 151006, min_days: 7, max_days: 10 },
{ pincode: 151007, min_days: 7, max_days: 10 },
{ pincode: 151101, min_days: 7, max_days: 10 },
{ pincode: 151102, min_days: 7, max_days: 10 },
{ pincode: 151201, min_days: 7, max_days: 10 },
{ pincode: 152001, min_days: 7, max_days: 10 },
{ pincode: 152002, min_days: 7, max_days: 10 },
{ pincode: 152003, min_days: 7, max_days: 10 },
{ pincode: 152004, min_days: 7, max_days: 10 },
{ pincode: 152005, min_days: 7, max_days: 10 },
{ pincode: 160001, min_days: 7, max_days: 10 },
{ pincode: 160002, min_days: 7, max_days: 10 },
{ pincode: 160003, min_days: 7, max_days: 10 },
{ pincode: 160004, min_days: 7, max_days: 10 },
{ pincode: 160005, min_days: 7, max_days: 10 },
{ pincode: 160006, min_days: 7, max_days: 10 },
{ pincode: 160007, min_days: 7, max_days: 10 },
{ pincode: 160008, min_days: 7, max_days: 10 },
{ pincode: 160009, min_days: 7, max_days: 10 },
{ pincode: 160010, min_days: 7, max_days: 10 },
{ pincode: 160011, min_days: 7, max_days: 10 },
{ pincode: 160012, min_days: 7, max_days: 10 },
{ pincode: 160013, min_days: 7, max_days: 10 },
{ pincode: 160014, min_days: 7, max_days: 10 },
{ pincode: 160015, min_days: 7, max_days: 10 },
{ pincode: 160016, min_days: 7, max_days: 10 },
{ pincode: 160017, min_days: 7, max_days: 10 },
{ pincode: 160018, min_days: 7, max_days: 10 },
{ pincode: 160019, min_days: 7, max_days: 10 },
{ pincode: 160020, min_days: 7, max_days: 10 },
{ pincode: 160021, min_days: 7, max_days: 10 },
{ pincode: 160022, min_days: 7, max_days: 10 },
{ pincode: 160023, min_days: 7, max_days: 10 },
{ pincode: 160024, min_days: 7, max_days: 10 },
{ pincode: 160025, min_days: 7, max_days: 10 },
{ pincode: 160026, min_days: 7, max_days: 10 },
{ pincode: 160027, min_days: 7, max_days: 10 },
{ pincode: 160028, min_days: 7, max_days: 10 },
{ pincode: 160029, min_days: 7, max_days: 10 },
{ pincode: 160030, min_days: 7, max_days: 10 },
{ pincode: 160031, min_days: 7, max_days: 10 },
{ pincode: 160032, min_days: 7, max_days: 10 },
{ pincode: 160033, min_days: 7, max_days: 10 },
{ pincode: 160034, min_days: 7, max_days: 10 },
{ pincode: 160035, min_days: 7, max_days: 10 },
{ pincode: 160036, min_days: 7, max_days: 10 },
{ pincode: 160037, min_days: 7, max_days: 10 },
{ pincode: 160038, min_days: 7, max_days: 10 },
{ pincode: 160039, min_days: 7, max_days: 10 },
{ pincode: 160040, min_days: 7, max_days: 10 },
{ pincode: 160041, min_days: 7, max_days: 10 },
{ pincode: 160042, min_days: 7, max_days: 10 },
{ pincode: 160043, min_days: 7, max_days: 10 },
{ pincode: 160044, min_days: 7, max_days: 10 },
{ pincode: 160045, min_days: 7, max_days: 10 },
{ pincode: 160046, min_days: 7, max_days: 10 },
{ pincode: 160047, min_days: 7, max_days: 10 },
{ pincode: 160048, min_days: 7, max_days: 10 },
{ pincode: 160049, min_days: 7, max_days: 10 },
{ pincode: 160050, min_days: 7, max_days: 10 },
{ pincode: 160051, min_days: 7, max_days: 10 },
{ pincode: 160052, min_days: 7, max_days: 10 },
{ pincode: 160053, min_days: 7, max_days: 10 },
{ pincode: 160054, min_days: 7, max_days: 10 },
{ pincode: 160055, min_days: 7, max_days: 10 },
{ pincode: 160056, min_days: 7, max_days: 10 },
{ pincode: 160057, min_days: 7, max_days: 10 },
{ pincode: 160058, min_days: 7, max_days: 10 },
{ pincode: 160059, min_days: 7, max_days: 10 },
{ pincode: 160060, min_days: 7, max_days: 10 },
{ pincode: 160061, min_days: 7, max_days: 10 },
{ pincode: 160062, min_days: 7, max_days: 10 },
{ pincode: 160063, min_days: 7, max_days: 10 },
{ pincode: 160064, min_days: 7, max_days: 10 },
{ pincode: 160065, min_days: 7, max_days: 10 },
{ pincode: 160066, min_days: 7, max_days: 10 },
{ pincode: 160067, min_days: 7, max_days: 10 },
{ pincode: 160068, min_days: 7, max_days: 10 },
{ pincode: 160069, min_days: 7, max_days: 10 },
{ pincode: 160070, min_days: 7, max_days: 10 },
{ pincode: 160071, min_days: 7, max_days: 10 },
{ pincode: 160073, min_days: 7, max_days: 10 },
{ pincode: 160074, min_days: 7, max_days: 10 },
{ pincode: 160079, min_days: 7, max_days: 10 },
{ pincode: 160101, min_days: 7, max_days: 10 },
{ pincode: 160102, min_days: 7, max_days: 10 },
{ pincode: 160103, min_days: 7, max_days: 10 },
{ pincode: 160104, min_days: 7, max_days: 10 },
{ pincode: 160106, min_days: 7, max_days: 10 },
{ pincode: 160125, min_days: 7, max_days: 10 },
{ pincode: 160126, min_days: 7, max_days: 10 },
{ pincode: 160127, min_days: 7, max_days: 10 },
{ pincode: 160128, min_days: 7, max_days: 10 },
{ pincode: 160129, min_days: 7, max_days: 10 },
{ pincode: 160130, min_days: 7, max_days: 10 },
{ pincode: 160131, min_days: 7, max_days: 10 },
{ pincode: 160132, min_days: 7, max_days: 10 },
{ pincode: 160133, min_days: 7, max_days: 10 },
{ pincode: 160134, min_days: 7, max_days: 10 },
{ pincode: 160135, min_days: 7, max_days: 10 },
{ pincode: 160136, min_days: 7, max_days: 10 },
{ pincode: 161101, min_days: 7, max_days: 10 },
{ pincode: 166031, min_days: 7, max_days: 10 },
{ pincode: 171001, min_days: 7, max_days: 10 },
{ pincode: 171002, min_days: 7, max_days: 10 },
{ pincode: 171003, min_days: 7, max_days: 10 },
{ pincode: 171004, min_days: 7, max_days: 10 },
{ pincode: 171009, min_days: 7, max_days: 10 },
{ pincode: 171013, min_days: 7, max_days: 10 },
{ pincode: 173200, min_days: 7, max_days: 10 },
{ pincode: 173201, min_days: 7, max_days: 10 },
{ pincode: 173203, min_days: 7, max_days: 10 },
{ pincode: 173205, min_days: 7, max_days: 10 },
{ pincode: 173211, min_days: 7, max_days: 10 },
{ pincode: 173212, min_days: 7, max_days: 10 },
{ pincode: 173213, min_days: 7, max_days: 10 },
{ pincode: 173214, min_days: 7, max_days: 10 },
{ pincode: 173216, min_days: 7, max_days: 10 },
{ pincode: 173220, min_days: 7, max_days: 10 },
{ pincode: 173224, min_days: 7, max_days: 10 },
{ pincode: 173226, min_days: 7, max_days: 10 },
{ pincode: 173227, min_days: 7, max_days: 10 },
{ pincode: 173228, min_days: 7, max_days: 10 },
{ pincode: 174101, min_days: 7, max_days: 10 },
{ pincode: 174102, min_days: 7, max_days: 10 },
{ pincode: 174103, min_days: 7, max_days: 10 },
{ pincode: 174303, min_days: 7, max_days: 10 },
{ pincode: 174306, min_days: 7, max_days: 10 },
{ pincode: 174315, min_days: 7, max_days: 10 },
{ pincode: 175001, min_days: 7, max_days: 10 },
{ pincode: 175008, min_days: 7, max_days: 10 },
{ pincode: 175021, min_days: 7, max_days: 10 },
{ pincode: 176047, min_days: 7, max_days: 10 },
{ pincode: 176058, min_days: 7, max_days: 10 },
{ pincode: 176059, min_days: 7, max_days: 10 },
{ pincode: 176061, min_days: 7, max_days: 10 },
{ pincode: 176062, min_days: 7, max_days: 10 },
{ pincode: 176063, min_days: 7, max_days: 10 },
{ pincode: 176064, min_days: 7, max_days: 10 },
{ pincode: 176067, min_days: 7, max_days: 10 },
{ pincode: 176076, min_days: 7, max_days: 10 },
{ pincode: 176081, min_days: 7, max_days: 10 },
{ pincode: 176083, min_days: 7, max_days: 10 },
{ pincode: 176085, min_days: 7, max_days: 10 },
{ pincode: 176087, min_days: 7, max_days: 10 },
{ pincode: 176092, min_days: 7, max_days: 10 },
{ pincode: 176101, min_days: 7, max_days: 10 },
{ pincode: 176102, min_days: 7, max_days: 10 },
{ pincode: 176103, min_days: 7, max_days: 10 },
{ pincode: 176115, min_days: 7, max_days: 10 },
{ pincode: 176125, min_days: 7, max_days: 10 },
{ pincode: 180000, min_days: 7, max_days: 10 },
{ pincode: 180001, min_days: 7, max_days: 10 },
{ pincode: 180002, min_days: 7, max_days: 10 },
{ pincode: 180003, min_days: 7, max_days: 10 },
{ pincode: 180004, min_days: 7, max_days: 10 },
{ pincode: 180005, min_days: 7, max_days: 10 },
{ pincode: 180006, min_days: 7, max_days: 10 },
{ pincode: 180007, min_days: 7, max_days: 10 },
{ pincode: 180008, min_days: 7, max_days: 10 },
{ pincode: 180009, min_days: 7, max_days: 10 },
{ pincode: 180010, min_days: 7, max_days: 10 },
{ pincode: 180011, min_days: 7, max_days: 10 },
{ pincode: 180012, min_days: 7, max_days: 10 },
{ pincode: 180013, min_days: 7, max_days: 10 },
{ pincode: 180014, min_days: 7, max_days: 10 },
{ pincode: 180015, min_days: 7, max_days: 10 },
{ pincode: 180016, min_days: 7, max_days: 10 },
{ pincode: 180017, min_days: 7, max_days: 10 },
{ pincode: 180018, min_days: 7, max_days: 10 },
{ pincode: 180019, min_days: 7, max_days: 10 },
{ pincode: 180020, min_days: 7, max_days: 10 },
{ pincode: 181008, min_days: 7, max_days: 10 },
{ pincode: 181101, min_days: 7, max_days: 10 },
{ pincode: 181102, min_days: 7, max_days: 10 },
{ pincode: 181103, min_days: 7, max_days: 10 },
{ pincode: 181104, min_days: 7, max_days: 10 },
{ pincode: 181105, min_days: 7, max_days: 10 },
{ pincode: 181111, min_days: 7, max_days: 10 },
{ pincode: 181112, min_days: 7, max_days: 10 },
{ pincode: 181113, min_days: 7, max_days: 10 },
{ pincode: 181114, min_days: 7, max_days: 10 },
{ pincode: 181121, min_days: 7, max_days: 10 },
{ pincode: 181122, min_days: 7, max_days: 10 },
{ pincode: 181123, min_days: 7, max_days: 10 },
{ pincode: 181124, min_days: 7, max_days: 10 },
{ pincode: 181131, min_days: 7, max_days: 10 },
{ pincode: 181132, min_days: 7, max_days: 10 },
{ pincode: 181133, min_days: 7, max_days: 10 },
{ pincode: 181134, min_days: 7, max_days: 10 },
{ pincode: 181141, min_days: 7, max_days: 10 },
{ pincode: 181142, min_days: 7, max_days: 10 },
{ pincode: 181143, min_days: 7, max_days: 10 },
{ pincode: 181144, min_days: 7, max_days: 10 },
{ pincode: 181145, min_days: 7, max_days: 10 },
{ pincode: 181151, min_days: 7, max_days: 10 },
{ pincode: 181152, min_days: 7, max_days: 10 },
{ pincode: 181201, min_days: 7, max_days: 10 },
{ pincode: 181202, min_days: 7, max_days: 10 },
{ pincode: 181205, min_days: 7, max_days: 10 },
{ pincode: 181206, min_days: 7, max_days: 10 },
{ pincode: 181207, min_days: 7, max_days: 10 },
{ pincode: 181208, min_days: 7, max_days: 10 },
{ pincode: 181209, min_days: 7, max_days: 10 },
{ pincode: 181212, min_days: 7, max_days: 10 },
{ pincode: 181221, min_days: 7, max_days: 10 },
{ pincode: 181223, min_days: 7, max_days: 10 },
{ pincode: 181224, min_days: 7, max_days: 10 },
{ pincode: 182127, min_days: 7, max_days: 10 },
{ pincode: 182320, min_days: 7, max_days: 10 },
{ pincode: 184101, min_days: 7, max_days: 10 },
{ pincode: 184102, min_days: 7, max_days: 10 },
{ pincode: 184104, min_days: 7, max_days: 10 },
{ pincode: 184120, min_days: 7, max_days: 10 },
{ pincode: 184121, min_days: 7, max_days: 10 },
{ pincode: 184141, min_days: 7, max_days: 10 },
{ pincode: 184143, min_days: 7, max_days: 10 },
{ pincode: 184151, min_days: 7, max_days: 10 },
{ pincode: 184210, min_days: 7, max_days: 10 },
{ pincode: 185154, min_days: 7, max_days: 10 },
{ pincode: 190001, min_days: 7, max_days: 10 },
{ pincode: 190002, min_days: 7, max_days: 10 },
{ pincode: 190003, min_days: 7, max_days: 10 },
{ pincode: 190004, min_days: 7, max_days: 10 },
{ pincode: 190005, min_days: 7, max_days: 10 },
{ pincode: 190006, min_days: 7, max_days: 10 },
{ pincode: 190007, min_days: 7, max_days: 10 },
{ pincode: 190008, min_days: 7, max_days: 10 },
{ pincode: 190009, min_days: 7, max_days: 10 },
{ pincode: 190010, min_days: 7, max_days: 10 },
{ pincode: 190011, min_days: 7, max_days: 10 },
{ pincode: 190012, min_days: 7, max_days: 10 },
{ pincode: 190014, min_days: 7, max_days: 10 },
{ pincode: 190015, min_days: 7, max_days: 10 },
{ pincode: 190017, min_days: 7, max_days: 10 },
{ pincode: 190018, min_days: 7, max_days: 10 },
{ pincode: 190019, min_days: 7, max_days: 10 },
{ pincode: 190020, min_days: 7, max_days: 10 },
{ pincode: 190021, min_days: 7, max_days: 10 },
{ pincode: 190023, min_days: 7, max_days: 10 },
{ pincode: 190024, min_days: 7, max_days: 10 },
{ pincode: 190025, min_days: 7, max_days: 10 },
{ pincode: 191101, min_days: 7, max_days: 10 },
{ pincode: 191111, min_days: 7, max_days: 10 },
{ pincode: 191114, min_days: 7, max_days: 10 },
{ pincode: 191115, min_days: 7, max_days: 10 },
{ pincode: 191116, min_days: 7, max_days: 10 },
{ pincode: 191132, min_days: 7, max_days: 10 },
{ pincode: 191515, min_days: 7, max_days: 10 },
{ pincode: 200201, min_days: 7, max_days: 10 },
{ pincode: 201000, min_days: 7, max_days: 10 },
{ pincode: 201003, min_days: 7, max_days: 10 },
{ pincode: 201004, min_days: 7, max_days: 10 },
{ pincode: 201005, min_days: 7, max_days: 10 },
{ pincode: 201006, min_days: 7, max_days: 10 },
{ pincode: 201007, min_days: 7, max_days: 10 },
{ pincode: 201008, min_days: 7, max_days: 10 },
{ pincode: 201013, min_days: 7, max_days: 10 },
{ pincode: 201015, min_days: 7, max_days: 10 },
{ pincode: 201018, min_days: 7, max_days: 10 },
{ pincode: 201019, min_days: 7, max_days: 10 },
{ pincode: 201020, min_days: 7, max_days: 10 },
{ pincode: 201021, min_days: 7, max_days: 10 },
{ pincode: 201026, min_days: 7, max_days: 10 },
{ pincode: 201101, min_days: 7, max_days: 10 },
{ pincode: 201102, min_days: 7, max_days: 10 },
{ pincode: 201103, min_days: 7, max_days: 10 },
{ pincode: 201106, min_days: 7, max_days: 10 },
{ pincode: 201201, min_days: 7, max_days: 10 },
{ pincode: 201203, min_days: 7, max_days: 10 },
{ pincode: 201204, min_days: 7, max_days: 10 },
{ pincode: 201300, min_days: 7, max_days: 10 },
{ pincode: 201303, min_days: 7, max_days: 10 },
{ pincode: 201304, min_days: 7, max_days: 10 },
{ pincode: 201308, min_days: 7, max_days: 10 },
{ pincode: 201311, min_days: 7, max_days: 10 },
{ pincode: 201312, min_days: 7, max_days: 10 },
{ pincode: 201313, min_days: 7, max_days: 10 },
{ pincode: 201315, min_days: 7, max_days: 10 },
{ pincode: 202001, min_days: 7, max_days: 10 },
{ pincode: 202002, min_days: 7, max_days: 10 },
{ pincode: 202004, min_days: 7, max_days: 10 },
{ pincode: 202121, min_days: 7, max_days: 10 },
{ pincode: 202122, min_days: 7, max_days: 10 },
{ pincode: 202123, min_days: 7, max_days: 10 },
{ pincode: 202124, min_days: 7, max_days: 10 },
{ pincode: 202125, min_days: 7, max_days: 10 },
{ pincode: 202126, min_days: 7, max_days: 10 },
{ pincode: 202127, min_days: 7, max_days: 10 },
{ pincode: 202128, min_days: 7, max_days: 10 },
{ pincode: 202136, min_days: 7, max_days: 10 },
{ pincode: 202138, min_days: 7, max_days: 10 },
{ pincode: 202139, min_days: 7, max_days: 10 },
{ pincode: 202140, min_days: 7, max_days: 10 },
{ pincode: 202143, min_days: 7, max_days: 10 },
{ pincode: 202144, min_days: 7, max_days: 10 },
{ pincode: 202150, min_days: 7, max_days: 10 },
{ pincode: 202151, min_days: 7, max_days: 10 },
{ pincode: 202410, min_days: 7, max_days: 10 },
{ pincode: 202411, min_days: 7, max_days: 10 },
{ pincode: 202412, min_days: 7, max_days: 10 },
{ pincode: 202413, min_days: 7, max_days: 10 },
{ pincode: 202414, min_days: 7, max_days: 10 },
{ pincode: 202415, min_days: 7, max_days: 10 },
{ pincode: 202416, min_days: 7, max_days: 10 },
{ pincode: 202417, min_days: 7, max_days: 10 },
{ pincode: 202418, min_days: 7, max_days: 10 },
{ pincode: 202419, min_days: 7, max_days: 10 },
{ pincode: 202420, min_days: 7, max_days: 10 },
{ pincode: 202440, min_days: 7, max_days: 10 },
{ pincode: 203133, min_days: 7, max_days: 10 },
{ pincode: 203135, min_days: 7, max_days: 10 },
{ pincode: 203145, min_days: 7, max_days: 10 },
{ pincode: 203200, min_days: 7, max_days: 10 },
{ pincode: 203201, min_days: 7, max_days: 10 },
{ pincode: 203202, min_days: 7, max_days: 10 },
{ pincode: 203203, min_days: 7, max_days: 10 },
{ pincode: 203205, min_days: 7, max_days: 10 },
{ pincode: 203206, min_days: 7, max_days: 10 },
{ pincode: 203207, min_days: 7, max_days: 10 },
{ pincode: 203209, min_days: 7, max_days: 10 },
{ pincode: 204101, min_days: 7, max_days: 10 },
{ pincode: 204102, min_days: 7, max_days: 10 },
{ pincode: 204212, min_days: 7, max_days: 10 },
{ pincode: 204213, min_days: 7, max_days: 10 },
{ pincode: 204214, min_days: 7, max_days: 10 },
{ pincode: 204216, min_days: 7, max_days: 10 },
{ pincode: 205135, min_days: 7, max_days: 10 },
{ pincode: 207301, min_days: 7, max_days: 10 },
{ pincode: 207302, min_days: 7, max_days: 10 },
{ pincode: 208001, min_days: 7, max_days: 10 },
{ pincode: 208002, min_days: 7, max_days: 10 },
{ pincode: 208003, min_days: 7, max_days: 10 },
{ pincode: 208004, min_days: 7, max_days: 10 },
{ pincode: 208005, min_days: 7, max_days: 10 },
{ pincode: 208006, min_days: 7, max_days: 10 },
{ pincode: 208007, min_days: 7, max_days: 10 },
{ pincode: 208008, min_days: 7, max_days: 10 },
{ pincode: 208009, min_days: 7, max_days: 10 },
{ pincode: 208010, min_days: 7, max_days: 10 },
{ pincode: 208011, min_days: 7, max_days: 10 },
{ pincode: 208012, min_days: 7, max_days: 10 },
{ pincode: 208013, min_days: 7, max_days: 10 },
{ pincode: 208014, min_days: 7, max_days: 10 },
{ pincode: 208015, min_days: 7, max_days: 10 },
{ pincode: 208016, min_days: 7, max_days: 10 },
{ pincode: 208017, min_days: 7, max_days: 10 },
{ pincode: 208018, min_days: 7, max_days: 10 },
{ pincode: 208019, min_days: 7, max_days: 10 },
{ pincode: 208020, min_days: 7, max_days: 10 },
{ pincode: 208021, min_days: 7, max_days: 10 },
{ pincode: 208022, min_days: 7, max_days: 10 },
{ pincode: 208023, min_days: 7, max_days: 10 },
{ pincode: 208024, min_days: 7, max_days: 10 },
{ pincode: 208025, min_days: 7, max_days: 10 },
{ pincode: 208026, min_days: 7, max_days: 10 },
{ pincode: 208027, min_days: 7, max_days: 10 },
{ pincode: 208028, min_days: 7, max_days: 10 },
{ pincode: 208029, min_days: 7, max_days: 10 },
{ pincode: 208039, min_days: 7, max_days: 10 },
{ pincode: 209101, min_days: 7, max_days: 10 },
{ pincode: 209111, min_days: 7, max_days: 10 },
{ pincode: 209112, min_days: 7, max_days: 10 },
{ pincode: 209115, min_days: 7, max_days: 10 },
{ pincode: 209121, min_days: 7, max_days: 10 },
{ pincode: 209125, min_days: 7, max_days: 10 },
{ pincode: 209201, min_days: 7, max_days: 10 },
{ pincode: 209203, min_days: 7, max_days: 10 },
{ pincode: 209204, min_days: 7, max_days: 10 },
{ pincode: 209205, min_days: 7, max_days: 10 },
{ pincode: 209206, min_days: 7, max_days: 10 },
{ pincode: 209208, min_days: 7, max_days: 10 },
{ pincode: 209209, min_days: 7, max_days: 10 },
{ pincode: 209210, min_days: 7, max_days: 10 },
{ pincode: 209211, min_days: 7, max_days: 10 },
{ pincode: 209214, min_days: 7, max_days: 10 },
{ pincode: 209217, min_days: 7, max_days: 10 },
{ pincode: 209291, min_days: 7, max_days: 10 },
{ pincode: 209292, min_days: 7, max_days: 10 },
{ pincode: 209293, min_days: 7, max_days: 10 },
{ pincode: 209301, min_days: 7, max_days: 10 },
{ pincode: 209302, min_days: 7, max_days: 10 },
{ pincode: 209303, min_days: 7, max_days: 10 },
{ pincode: 209304, min_days: 7, max_days: 10 },
{ pincode: 209305, min_days: 7, max_days: 10 },
{ pincode: 209306, min_days: 7, max_days: 10 },
{ pincode: 209307, min_days: 7, max_days: 10 },
{ pincode: 209308, min_days: 7, max_days: 10 },
{ pincode: 209309, min_days: 7, max_days: 10 },
{ pincode: 209311, min_days: 7, max_days: 10 },
{ pincode: 209312, min_days: 7, max_days: 10 },
{ pincode: 209401, min_days: 7, max_days: 10 },
{ pincode: 209402, min_days: 7, max_days: 10 },
{ pincode: 209407, min_days: 7, max_days: 10 },
{ pincode: 209801, min_days: 7, max_days: 10 },
{ pincode: 209821, min_days: 7, max_days: 10 },
{ pincode: 209825, min_days: 7, max_days: 10 },
{ pincode: 209827, min_days: 7, max_days: 10 },
{ pincode: 209831, min_days: 7, max_days: 10 },
{ pincode: 209841, min_days: 7, max_days: 10 },
{ pincode: 209859, min_days: 7, max_days: 10 },
{ pincode: 209861, min_days: 7, max_days: 10 },
{ pincode: 209862, min_days: 7, max_days: 10 },
{ pincode: 209863, min_days: 7, max_days: 10 },
{ pincode: 209864, min_days: 7, max_days: 10 },
{ pincode: 209865, min_days: 7, max_days: 10 },
{ pincode: 209866, min_days: 7, max_days: 10 },
{ pincode: 209867, min_days: 7, max_days: 10 },
{ pincode: 209868, min_days: 7, max_days: 10 },
{ pincode: 209870, min_days: 7, max_days: 10 },
{ pincode: 209871, min_days: 7, max_days: 10 },
{ pincode: 209881, min_days: 7, max_days: 10 },
{ pincode: 211001, min_days: 7, max_days: 10 },
{ pincode: 211002, min_days: 7, max_days: 10 },
{ pincode: 211003, min_days: 7, max_days: 10 },
{ pincode: 211004, min_days: 7, max_days: 10 },
{ pincode: 211005, min_days: 7, max_days: 10 },
{ pincode: 211006, min_days: 7, max_days: 10 },
{ pincode: 211007, min_days: 7, max_days: 10 },
{ pincode: 211008, min_days: 7, max_days: 10 },
{ pincode: 211009, min_days: 7, max_days: 10 },
{ pincode: 211010, min_days: 7, max_days: 10 },
{ pincode: 211011, min_days: 7, max_days: 10 },
{ pincode: 211012, min_days: 7, max_days: 10 },
{ pincode: 211013, min_days: 7, max_days: 10 },
{ pincode: 211014, min_days: 7, max_days: 10 },
{ pincode: 211015, min_days: 7, max_days: 10 },
{ pincode: 211016, min_days: 7, max_days: 10 },
{ pincode: 211017, min_days: 7, max_days: 10 },
{ pincode: 211018, min_days: 7, max_days: 10 },
{ pincode: 211019, min_days: 7, max_days: 10 },
{ pincode: 211020, min_days: 7, max_days: 10 },
{ pincode: 211021, min_days: 7, max_days: 10 },
{ pincode: 211022, min_days: 7, max_days: 10 },
{ pincode: 212011, min_days: 7, max_days: 10 },
{ pincode: 212103, min_days: 7, max_days: 10 },
{ pincode: 212105, min_days: 7, max_days: 10 },
{ pincode: 212106, min_days: 7, max_days: 10 },
{ pincode: 212107, min_days: 7, max_days: 10 },
{ pincode: 212108, min_days: 7, max_days: 10 },
{ pincode: 212109, min_days: 7, max_days: 10 },
{ pincode: 212110, min_days: 7, max_days: 10 },
{ pincode: 212111, min_days: 7, max_days: 10 },
{ pincode: 212112, min_days: 7, max_days: 10 },
{ pincode: 212128, min_days: 7, max_days: 10 },
{ pincode: 212201, min_days: 7, max_days: 10 },
{ pincode: 212202, min_days: 7, max_days: 10 },
{ pincode: 212203, min_days: 7, max_days: 10 },
{ pincode: 212204, min_days: 7, max_days: 10 },
{ pincode: 212206, min_days: 7, max_days: 10 },
{ pincode: 212207, min_days: 7, max_days: 10 },
{ pincode: 212208, min_days: 7, max_days: 10 },
{ pincode: 212210, min_days: 7, max_days: 10 },
{ pincode: 212211, min_days: 7, max_days: 10 },
{ pincode: 212212, min_days: 7, max_days: 10 },
{ pincode: 212213, min_days: 7, max_days: 10 },
{ pincode: 212214, min_days: 7, max_days: 10 },
{ pincode: 212215, min_days: 7, max_days: 10 },
{ pincode: 212216, min_days: 7, max_days: 10 },
{ pincode: 212218, min_days: 7, max_days: 10 },
{ pincode: 212300, min_days: 7, max_days: 10 },
{ pincode: 212301, min_days: 7, max_days: 10 },
{ pincode: 212302, min_days: 7, max_days: 10 },
{ pincode: 212303, min_days: 7, max_days: 10 },
{ pincode: 212305, min_days: 7, max_days: 10 },
{ pincode: 212307, min_days: 7, max_days: 10 },
{ pincode: 212309, min_days: 7, max_days: 10 },
{ pincode: 212310, min_days: 7, max_days: 10 },
{ pincode: 212401, min_days: 7, max_days: 10 },
{ pincode: 212402, min_days: 7, max_days: 10 },
{ pincode: 212403, min_days: 7, max_days: 10 },
{ pincode: 212404, min_days: 7, max_days: 10 },
{ pincode: 212405, min_days: 7, max_days: 10 },
{ pincode: 212410, min_days: 7, max_days: 10 },
{ pincode: 212501, min_days: 7, max_days: 10 },
{ pincode: 212502, min_days: 7, max_days: 10 },
{ pincode: 212503, min_days: 7, max_days: 10 },
{ pincode: 212504, min_days: 7, max_days: 10 },
{ pincode: 212505, min_days: 7, max_days: 10 },
{ pincode: 212506, min_days: 7, max_days: 10 },
{ pincode: 212507, min_days: 7, max_days: 10 },
{ pincode: 212508, min_days: 7, max_days: 10 },
{ pincode: 212662, min_days: 7, max_days: 10 },
{ pincode: 220000, min_days: 7, max_days: 10 },
{ pincode: 220001, min_days: 7, max_days: 10 },
{ pincode: 221001, min_days: 7, max_days: 10 },
{ pincode: 221002, min_days: 7, max_days: 10 },
{ pincode: 221003, min_days: 7, max_days: 10 },
{ pincode: 221004, min_days: 7, max_days: 10 },
{ pincode: 221005, min_days: 7, max_days: 10 },
{ pincode: 221006, min_days: 7, max_days: 10 },
{ pincode: 221007, min_days: 7, max_days: 10 },
{ pincode: 221008, min_days: 7, max_days: 10 },
{ pincode: 221009, min_days: 7, max_days: 10 },
{ pincode: 221010, min_days: 7, max_days: 10 },
{ pincode: 221011, min_days: 7, max_days: 10 },
{ pincode: 221012, min_days: 7, max_days: 10 },
{ pincode: 221013, min_days: 7, max_days: 10 },
{ pincode: 221100, min_days: 7, max_days: 10 },
{ pincode: 221101, min_days: 7, max_days: 10 },
{ pincode: 221102, min_days: 7, max_days: 10 },
{ pincode: 221103, min_days: 7, max_days: 10 },
{ pincode: 221104, min_days: 7, max_days: 10 },
{ pincode: 221105, min_days: 7, max_days: 10 },
{ pincode: 221106, min_days: 7, max_days: 10 },
{ pincode: 221107, min_days: 7, max_days: 10 },
{ pincode: 221108, min_days: 7, max_days: 10 },
{ pincode: 221109, min_days: 7, max_days: 10 },
{ pincode: 221110, min_days: 7, max_days: 10 },
{ pincode: 221111, min_days: 7, max_days: 10 },
{ pincode: 221112, min_days: 7, max_days: 10 },
{ pincode: 221113, min_days: 7, max_days: 10 },
{ pincode: 221115, min_days: 7, max_days: 10 },
{ pincode: 221116, min_days: 7, max_days: 10 },
{ pincode: 221201, min_days: 7, max_days: 10 },
{ pincode: 221202, min_days: 7, max_days: 10 },
{ pincode: 221204, min_days: 7, max_days: 10 },
{ pincode: 221206, min_days: 7, max_days: 10 },
{ pincode: 221207, min_days: 7, max_days: 10 },
{ pincode: 221208, min_days: 7, max_days: 10 },
{ pincode: 221209, min_days: 7, max_days: 10 },
{ pincode: 221211, min_days: 7, max_days: 10 },
{ pincode: 221212, min_days: 7, max_days: 10 },
{ pincode: 221213, min_days: 7, max_days: 10 },
{ pincode: 221301, min_days: 7, max_days: 10 },
{ pincode: 221302, min_days: 7, max_days: 10 },
{ pincode: 221303, min_days: 7, max_days: 10 },
{ pincode: 221304, min_days: 7, max_days: 10 },
{ pincode: 221305, min_days: 7, max_days: 10 },
{ pincode: 221306, min_days: 7, max_days: 10 },
{ pincode: 221307, min_days: 7, max_days: 10 },
{ pincode: 221308, min_days: 7, max_days: 10 },
{ pincode: 221309, min_days: 7, max_days: 10 },
{ pincode: 221310, min_days: 7, max_days: 10 },
{ pincode: 221311, min_days: 7, max_days: 10 },
{ pincode: 221313, min_days: 7, max_days: 10 },
{ pincode: 221314, min_days: 7, max_days: 10 },
{ pincode: 221401, min_days: 7, max_days: 10 },
{ pincode: 221402, min_days: 7, max_days: 10 },
{ pincode: 221403, min_days: 7, max_days: 10 },
{ pincode: 221404, min_days: 7, max_days: 10 },
{ pincode: 221405, min_days: 7, max_days: 10 },
{ pincode: 221406, min_days: 7, max_days: 10 },
{ pincode: 221409, min_days: 7, max_days: 10 },
{ pincode: 221501, min_days: 7, max_days: 10 },
{ pincode: 221502, min_days: 7, max_days: 10 },
{ pincode: 221503, min_days: 7, max_days: 10 },
{ pincode: 221504, min_days: 7, max_days: 10 },
{ pincode: 221505, min_days: 7, max_days: 10 },
{ pincode: 221506, min_days: 7, max_days: 10 },
{ pincode: 221507, min_days: 7, max_days: 10 },
{ pincode: 221508, min_days: 7, max_days: 10 },
{ pincode: 222128, min_days: 7, max_days: 10 },
{ pincode: 222129, min_days: 7, max_days: 10 },
{ pincode: 222136, min_days: 7, max_days: 10 },
{ pincode: 222137, min_days: 7, max_days: 10 },
{ pincode: 222138, min_days: 7, max_days: 10 },
{ pincode: 222142, min_days: 7, max_days: 10 },
{ pincode: 222146, min_days: 7, max_days: 10 },
{ pincode: 222148, min_days: 7, max_days: 10 },
{ pincode: 222149, min_days: 7, max_days: 10 },
{ pincode: 222161, min_days: 7, max_days: 10 },
{ pincode: 222162, min_days: 7, max_days: 10 },
{ pincode: 222180, min_days: 7, max_days: 10 },
{ pincode: 222181, min_days: 7, max_days: 10 },
{ pincode: 222202, min_days: 7, max_days: 10 },
{ pincode: 222203, min_days: 7, max_days: 10 },
{ pincode: 222204, min_days: 7, max_days: 10 },
{ pincode: 222228, min_days: 7, max_days: 10 },
{ pincode: 224001, min_days: 7, max_days: 10 },
{ pincode: 224133, min_days: 7, max_days: 10 },
{ pincode: 224188, min_days: 7, max_days: 10 },
{ pincode: 224201, min_days: 7, max_days: 10 },
{ pincode: 225001, min_days: 7, max_days: 10 },
{ pincode: 225002, min_days: 7, max_days: 10 },
{ pincode: 225003, min_days: 7, max_days: 10 },
{ pincode: 225121, min_days: 7, max_days: 10 },
{ pincode: 225122, min_days: 7, max_days: 10 },
{ pincode: 225123, min_days: 7, max_days: 10 },
{ pincode: 225126, min_days: 7, max_days: 10 },
{ pincode: 225203, min_days: 7, max_days: 10 },
{ pincode: 225204, min_days: 7, max_days: 10 },
{ pincode: 225301, min_days: 7, max_days: 10 },
{ pincode: 225302, min_days: 7, max_days: 10 },
{ pincode: 225303, min_days: 7, max_days: 10 },
{ pincode: 225412, min_days: 7, max_days: 10 },
{ pincode: 226000, min_days: 7, max_days: 10 },
{ pincode: 226001, min_days: 7, max_days: 10 },
{ pincode: 226002, min_days: 7, max_days: 10 },
{ pincode: 226003, min_days: 7, max_days: 10 },
{ pincode: 226004, min_days: 7, max_days: 10 },
{ pincode: 226005, min_days: 7, max_days: 10 },
{ pincode: 226006, min_days: 7, max_days: 10 },
{ pincode: 226007, min_days: 7, max_days: 10 },
{ pincode: 226008, min_days: 7, max_days: 10 },
{ pincode: 226009, min_days: 7, max_days: 10 },
{ pincode: 226010, min_days: 7, max_days: 10 },
{ pincode: 226011, min_days: 7, max_days: 10 },
{ pincode: 226012, min_days: 7, max_days: 10 },
{ pincode: 226013, min_days: 7, max_days: 10 },
{ pincode: 226014, min_days: 7, max_days: 10 },
{ pincode: 226015, min_days: 7, max_days: 10 },
{ pincode: 226016, min_days: 7, max_days: 10 },
{ pincode: 226017, min_days: 7, max_days: 10 },
{ pincode: 226018, min_days: 7, max_days: 10 },
{ pincode: 226019, min_days: 7, max_days: 10 },
{ pincode: 226020, min_days: 7, max_days: 10 },
{ pincode: 226021, min_days: 7, max_days: 10 },
{ pincode: 226022, min_days: 7, max_days: 10 },
{ pincode: 226023, min_days: 7, max_days: 10 },
{ pincode: 226024, min_days: 7, max_days: 10 },
{ pincode: 226025, min_days: 7, max_days: 10 },
{ pincode: 226026, min_days: 7, max_days: 10 },
{ pincode: 226027, min_days: 7, max_days: 10 },
{ pincode: 226028, min_days: 7, max_days: 10 },
{ pincode: 226029, min_days: 7, max_days: 10 },
{ pincode: 226030, min_days: 7, max_days: 10 },
{ pincode: 226031, min_days: 7, max_days: 10 },
{ pincode: 226101, min_days: 7, max_days: 10 },
{ pincode: 226102, min_days: 7, max_days: 10 },
{ pincode: 226103, min_days: 7, max_days: 10 },
{ pincode: 226104, min_days: 7, max_days: 10 },
{ pincode: 226106, min_days: 7, max_days: 10 },
{ pincode: 226201, min_days: 7, max_days: 10 },
{ pincode: 226202, min_days: 7, max_days: 10 },
{ pincode: 226203, min_days: 7, max_days: 10 },
{ pincode: 226301, min_days: 7, max_days: 10 },
{ pincode: 226302, min_days: 7, max_days: 10 },
{ pincode: 226303, min_days: 7, max_days: 10 },
{ pincode: 226401, min_days: 7, max_days: 10 },
{ pincode: 226501, min_days: 7, max_days: 10 },
{ pincode: 227001, min_days: 7, max_days: 10 },
{ pincode: 227005, min_days: 7, max_days: 10 },
{ pincode: 227007, min_days: 7, max_days: 10 },
{ pincode: 227101, min_days: 7, max_days: 10 },
{ pincode: 227105, min_days: 7, max_days: 10 },
{ pincode: 227106, min_days: 7, max_days: 10 },
{ pincode: 227107, min_days: 7, max_days: 10 },
{ pincode: 227111, min_days: 7, max_days: 10 },
{ pincode: 227112, min_days: 7, max_days: 10 },
{ pincode: 227113, min_days: 7, max_days: 10 },
{ pincode: 227115, min_days: 7, max_days: 10 },
{ pincode: 227116, min_days: 7, max_days: 10 },
{ pincode: 227118, min_days: 7, max_days: 10 },
{ pincode: 227119, min_days: 7, max_days: 10 },
{ pincode: 227120, min_days: 7, max_days: 10 },
{ pincode: 227121, min_days: 7, max_days: 10 },
{ pincode: 227122, min_days: 7, max_days: 10 },
{ pincode: 227131, min_days: 7, max_days: 10 },
{ pincode: 227132, min_days: 7, max_days: 10 },
{ pincode: 227202, min_days: 7, max_days: 10 },
{ pincode: 227205, min_days: 7, max_days: 10 },
{ pincode: 227207, min_days: 7, max_days: 10 },
{ pincode: 227208, min_days: 7, max_days: 10 },
{ pincode: 227305, min_days: 7, max_days: 10 },
{ pincode: 227308, min_days: 7, max_days: 10 },
{ pincode: 227309, min_days: 7, max_days: 10 },
{ pincode: 228411, min_days: 7, max_days: 10 },
{ pincode: 229001, min_days: 7, max_days: 10 },
{ pincode: 229010, min_days: 7, max_days: 10 },
{ pincode: 229125, min_days: 7, max_days: 10 },
{ pincode: 229209, min_days: 7, max_days: 10 },
{ pincode: 229210, min_days: 7, max_days: 10 },
{ pincode: 229301, min_days: 7, max_days: 10 },
{ pincode: 229302, min_days: 7, max_days: 10 },
{ pincode: 229303, min_days: 7, max_days: 10 },
{ pincode: 229310, min_days: 7, max_days: 10 },
{ pincode: 229311, min_days: 7, max_days: 10 },
{ pincode: 229316, min_days: 7, max_days: 10 },
{ pincode: 229402, min_days: 7, max_days: 10 },
{ pincode: 229405, min_days: 7, max_days: 10 },
{ pincode: 229411, min_days: 7, max_days: 10 },
{ pincode: 229412, min_days: 7, max_days: 10 },
{ pincode: 229413, min_days: 7, max_days: 10 },
{ pincode: 229841, min_days: 7, max_days: 10 },
{ pincode: 229881, min_days: 7, max_days: 10 },
{ pincode: 230001, min_days: 7, max_days: 10 },
{ pincode: 230002, min_days: 7, max_days: 10 },
{ pincode: 230126, min_days: 7, max_days: 10 },
{ pincode: 230127, min_days: 7, max_days: 10 },
{ pincode: 230128, min_days: 7, max_days: 10 },
{ pincode: 230129, min_days: 7, max_days: 10 },
{ pincode: 230131, min_days: 7, max_days: 10 },
{ pincode: 230143, min_days: 7, max_days: 10 },
{ pincode: 230201, min_days: 7, max_days: 10 },
{ pincode: 230204, min_days: 7, max_days: 10 },
{ pincode: 230301, min_days: 7, max_days: 10 },
{ pincode: 230302, min_days: 7, max_days: 10 },
{ pincode: 230304, min_days: 7, max_days: 10 },
{ pincode: 230306, min_days: 7, max_days: 10 },
{ pincode: 230402, min_days: 7, max_days: 10 },
{ pincode: 230403, min_days: 7, max_days: 10 },
{ pincode: 230404, min_days: 7, max_days: 10 },
{ pincode: 231001, min_days: 7, max_days: 10 },
{ pincode: 231302, min_days: 7, max_days: 10 },
{ pincode: 231303, min_days: 7, max_days: 10 },
{ pincode: 231304, min_days: 7, max_days: 10 },
{ pincode: 231305, min_days: 7, max_days: 10 },
{ pincode: 231306, min_days: 7, max_days: 10 },
{ pincode: 231307, min_days: 7, max_days: 10 },
{ pincode: 231311, min_days: 7, max_days: 10 },
{ pincode: 231312, min_days: 7, max_days: 10 },
{ pincode: 231313, min_days: 7, max_days: 10 },
{ pincode: 231314, min_days: 7, max_days: 10 },
{ pincode: 231501, min_days: 7, max_days: 10 },
{ pincode: 232100, min_days: 7, max_days: 10 },
{ pincode: 232101, min_days: 7, max_days: 10 },
{ pincode: 232102, min_days: 7, max_days: 10 },
{ pincode: 232103, min_days: 7, max_days: 10 },
{ pincode: 232104, min_days: 7, max_days: 10 },
{ pincode: 232107, min_days: 7, max_days: 10 },
{ pincode: 232108, min_days: 7, max_days: 10 },
{ pincode: 232109, min_days: 7, max_days: 10 },
{ pincode: 232110, min_days: 7, max_days: 10 },
{ pincode: 232118, min_days: 7, max_days: 10 },
{ pincode: 232120, min_days: 7, max_days: 10 },
{ pincode: 233221, min_days: 7, max_days: 10 },
{ pincode: 233223, min_days: 7, max_days: 10 },
{ pincode: 240405, min_days: 7, max_days: 10 },
{ pincode: 241503, min_days: 7, max_days: 10 },
{ pincode: 241504, min_days: 7, max_days: 10 },
{ pincode: 243001, min_days: 7, max_days: 10 },
{ pincode: 243002, min_days: 7, max_days: 10 },
{ pincode: 243003, min_days: 7, max_days: 10 },
{ pincode: 243004, min_days: 7, max_days: 10 },
{ pincode: 243005, min_days: 7, max_days: 10 },
{ pincode: 243006, min_days: 7, max_days: 10 },
{ pincode: 243122, min_days: 7, max_days: 10 },
{ pincode: 243123, min_days: 7, max_days: 10 },
{ pincode: 243124, min_days: 7, max_days: 10 },
{ pincode: 243125, min_days: 7, max_days: 10 },
{ pincode: 243127, min_days: 7, max_days: 10 },
{ pincode: 243202, min_days: 7, max_days: 10 },
{ pincode: 243204, min_days: 7, max_days: 10 },
{ pincode: 243205, min_days: 7, max_days: 10 },
{ pincode: 243206, min_days: 7, max_days: 10 },
{ pincode: 243208, min_days: 7, max_days: 10 },
{ pincode: 243215, min_days: 7, max_days: 10 },
{ pincode: 243501, min_days: 7, max_days: 10 },
{ pincode: 243502, min_days: 7, max_days: 10 },
{ pincode: 243509, min_days: 7, max_days: 10 },
{ pincode: 243701, min_days: 7, max_days: 10 },
{ pincode: 244001, min_days: 7, max_days: 10 },
{ pincode: 244002, min_days: 7, max_days: 10 },
{ pincode: 244003, min_days: 7, max_days: 10 },
{ pincode: 244004, min_days: 7, max_days: 10 },
{ pincode: 244005, min_days: 7, max_days: 10 },
{ pincode: 244006, min_days: 7, max_days: 10 },
{ pincode: 244007, min_days: 7, max_days: 10 },
{ pincode: 244008, min_days: 7, max_days: 10 },
{ pincode: 244009, min_days: 7, max_days: 10 },
{ pincode: 244013, min_days: 7, max_days: 10 },
{ pincode: 244102, min_days: 7, max_days: 10 },
{ pincode: 244103, min_days: 7, max_days: 10 },
{ pincode: 244104, min_days: 7, max_days: 10 },
{ pincode: 244105, min_days: 7, max_days: 10 },
{ pincode: 244221, min_days: 7, max_days: 10 },
{ pincode: 244222, min_days: 7, max_days: 10 },
{ pincode: 244231, min_days: 7, max_days: 10 },
{ pincode: 244235, min_days: 7, max_days: 10 },
{ pincode: 244236, min_days: 7, max_days: 10 },
{ pincode: 244242, min_days: 7, max_days: 10 },
{ pincode: 244245, min_days: 7, max_days: 10 },
{ pincode: 244251, min_days: 7, max_days: 10 },
{ pincode: 244301, min_days: 7, max_days: 10 },
{ pincode: 244302, min_days: 7, max_days: 10 },
{ pincode: 244303, min_days: 7, max_days: 10 },
{ pincode: 244304, min_days: 7, max_days: 10 },
{ pincode: 244401, min_days: 7, max_days: 10 },
{ pincode: 244402, min_days: 7, max_days: 10 },
{ pincode: 244410, min_days: 7, max_days: 10 },
{ pincode: 244411, min_days: 7, max_days: 10 },
{ pincode: 244412, min_days: 7, max_days: 10 },
{ pincode: 244413, min_days: 7, max_days: 10 },
{ pincode: 244414, min_days: 7, max_days: 10 },
{ pincode: 244415, min_days: 7, max_days: 10 },
{ pincode: 244443, min_days: 7, max_days: 10 },
{ pincode: 244501, min_days: 7, max_days: 10 },
{ pincode: 244502, min_days: 7, max_days: 10 },
{ pincode: 244504, min_days: 7, max_days: 10 },
{ pincode: 244601, min_days: 7, max_days: 10 },
{ pincode: 244602, min_days: 7, max_days: 10 },
{ pincode: 244713, min_days: 7, max_days: 10 },
{ pincode: 244714, min_days: 7, max_days: 10 },
{ pincode: 244715, min_days: 7, max_days: 10 },
{ pincode: 244901, min_days: 7, max_days: 10 },
{ pincode: 244921, min_days: 7, max_days: 10 },
{ pincode: 244922, min_days: 7, max_days: 10 },
{ pincode: 244923, min_days: 7, max_days: 10 },
{ pincode: 244925, min_days: 7, max_days: 10 },
{ pincode: 244926, min_days: 7, max_days: 10 },
{ pincode: 244927, min_days: 7, max_days: 10 },
{ pincode: 244928, min_days: 7, max_days: 10 },
{ pincode: 245101, min_days: 7, max_days: 10 },
{ pincode: 245201, min_days: 7, max_days: 10 },
{ pincode: 245206, min_days: 7, max_days: 10 },
{ pincode: 245301, min_days: 7, max_days: 10 },
{ pincode: 245304, min_days: 7, max_days: 10 },
{ pincode: 245305, min_days: 7, max_days: 10 },
{ pincode: 245306, min_days: 7, max_days: 10 },
{ pincode: 246727, min_days: 7, max_days: 10 },
{ pincode: 246729, min_days: 7, max_days: 10 },
{ pincode: 246734, min_days: 7, max_days: 10 },
{ pincode: 246735, min_days: 7, max_days: 10 },
{ pincode: 246737, min_days: 7, max_days: 10 },
{ pincode: 246745, min_days: 7, max_days: 10 },
{ pincode: 246746, min_days: 7, max_days: 10 },
{ pincode: 246761, min_days: 7, max_days: 10 },
{ pincode: 247001, min_days: 7, max_days: 10 },
{ pincode: 247002, min_days: 7, max_days: 10 },
{ pincode: 247003, min_days: 7, max_days: 10 },
{ pincode: 247005, min_days: 7, max_days: 10 },
{ pincode: 247006, min_days: 7, max_days: 10 },
{ pincode: 247007, min_days: 7, max_days: 10 },
{ pincode: 247008, min_days: 7, max_days: 10 },
{ pincode: 247009, min_days: 7, max_days: 10 },
{ pincode: 247120, min_days: 7, max_days: 10 },
{ pincode: 247122, min_days: 7, max_days: 10 },
{ pincode: 247232, min_days: 7, max_days: 10 },
{ pincode: 247451, min_days: 7, max_days: 10 },
{ pincode: 247607, min_days: 7, max_days: 10 },
{ pincode: 247656, min_days: 7, max_days: 10 },
{ pincode: 247661, min_days: 7, max_days: 10 },
{ pincode: 247663, min_days: 7, max_days: 10 },
{ pincode: 247664, min_days: 7, max_days: 10 },
{ pincode: 247665, min_days: 7, max_days: 10 },
{ pincode: 247666, min_days: 7, max_days: 10 },
{ pincode: 247667, min_days: 7, max_days: 10 },
{ pincode: 247668, min_days: 7, max_days: 10 },
{ pincode: 247669, min_days: 7, max_days: 10 },
{ pincode: 247670, min_days: 7, max_days: 10 },
{ pincode: 247671, min_days: 7, max_days: 10 },
{ pincode: 247672, min_days: 7, max_days: 10 },
{ pincode: 247673, min_days: 7, max_days: 10 },
{ pincode: 248000, min_days: 7, max_days: 10 },
{ pincode: 248001, min_days: 7, max_days: 10 },
{ pincode: 248002, min_days: 7, max_days: 10 },
{ pincode: 248003, min_days: 7, max_days: 10 },
{ pincode: 248004, min_days: 7, max_days: 10 },
{ pincode: 248005, min_days: 7, max_days: 10 },
{ pincode: 248006, min_days: 7, max_days: 10 },
{ pincode: 248007, min_days: 7, max_days: 10 },
{ pincode: 248008, min_days: 7, max_days: 10 },
{ pincode: 248009, min_days: 7, max_days: 10 },
{ pincode: 248010, min_days: 7, max_days: 10 },
{ pincode: 248011, min_days: 7, max_days: 10 },
{ pincode: 248012, min_days: 7, max_days: 10 },
{ pincode: 248013, min_days: 7, max_days: 10 },
{ pincode: 248014, min_days: 7, max_days: 10 },
{ pincode: 248015, min_days: 7, max_days: 10 },
{ pincode: 248016, min_days: 7, max_days: 10 },
{ pincode: 248017, min_days: 7, max_days: 10 },
{ pincode: 248018, min_days: 7, max_days: 10 },
{ pincode: 248101, min_days: 7, max_days: 10 },
{ pincode: 248102, min_days: 7, max_days: 10 },
{ pincode: 248110, min_days: 7, max_days: 10 },
{ pincode: 248115, min_days: 7, max_days: 10 },
{ pincode: 248116, min_days: 7, max_days: 10 },
{ pincode: 248121, min_days: 7, max_days: 10 },
{ pincode: 248122, min_days: 7, max_days: 10 },
{ pincode: 248125, min_days: 7, max_days: 10 },
{ pincode: 248126, min_days: 7, max_days: 10 },
{ pincode: 248140, min_days: 7, max_days: 10 },
{ pincode: 248141, min_days: 7, max_days: 10 },
{ pincode: 248142, min_days: 7, max_days: 10 },
{ pincode: 248143, min_days: 7, max_days: 10 },
{ pincode: 248144, min_days: 7, max_days: 10 },
{ pincode: 248145, min_days: 7, max_days: 10 },
{ pincode: 248146, min_days: 7, max_days: 10 },
{ pincode: 248147, min_days: 7, max_days: 10 },
{ pincode: 248148, min_days: 7, max_days: 10 },
{ pincode: 248159, min_days: 7, max_days: 10 },
{ pincode: 248160, min_days: 7, max_days: 10 },
{ pincode: 248161, min_days: 7, max_days: 10 },
{ pincode: 248167, min_days: 7, max_days: 10 },
{ pincode: 248171, min_days: 7, max_days: 10 },
{ pincode: 248179, min_days: 7, max_days: 10 },
{ pincode: 248191, min_days: 7, max_days: 10 },
{ pincode: 248195, min_days: 7, max_days: 10 },
{ pincode: 248196, min_days: 7, max_days: 10 },
{ pincode: 248197, min_days: 7, max_days: 10 },
{ pincode: 248198, min_days: 7, max_days: 10 },
{ pincode: 248201, min_days: 7, max_days: 10 },
{ pincode: 248202, min_days: 7, max_days: 10 },
{ pincode: 248203, min_days: 7, max_days: 10 },
{ pincode: 249137, min_days: 7, max_days: 10 },
{ pincode: 249175, min_days: 7, max_days: 10 },
{ pincode: 249201, min_days: 7, max_days: 10 },
{ pincode: 249202, min_days: 7, max_days: 10 },
{ pincode: 249203, min_days: 7, max_days: 10 },
{ pincode: 249204, min_days: 7, max_days: 10 },
{ pincode: 249205, min_days: 7, max_days: 10 },
{ pincode: 249206, min_days: 7, max_days: 10 },
{ pincode: 249302, min_days: 7, max_days: 10 },
{ pincode: 249304, min_days: 7, max_days: 10 },
{ pincode: 249306, min_days: 7, max_days: 10 },
{ pincode: 249401, min_days: 7, max_days: 10 },
{ pincode: 249402, min_days: 7, max_days: 10 },
{ pincode: 249403, min_days: 7, max_days: 10 },
{ pincode: 249404, min_days: 7, max_days: 10 },
{ pincode: 249405, min_days: 7, max_days: 10 },
{ pincode: 249406, min_days: 7, max_days: 10 },
{ pincode: 249407, min_days: 7, max_days: 10 },
{ pincode: 249408, min_days: 7, max_days: 10 },
{ pincode: 249409, min_days: 7, max_days: 10 },
{ pincode: 249410, min_days: 7, max_days: 10 },
{ pincode: 249411, min_days: 7, max_days: 10 },
{ pincode: 249413, min_days: 7, max_days: 10 },
{ pincode: 250000, min_days: 7, max_days: 10 },
{ pincode: 250001, min_days: 7, max_days: 10 },
{ pincode: 250002, min_days: 7, max_days: 10 },
{ pincode: 250003, min_days: 7, max_days: 10 },
{ pincode: 250004, min_days: 7, max_days: 10 },
{ pincode: 250005, min_days: 7, max_days: 10 },
{ pincode: 250006, min_days: 7, max_days: 10 },
{ pincode: 250007, min_days: 7, max_days: 10 },
{ pincode: 250101, min_days: 7, max_days: 10 },
{ pincode: 250102, min_days: 7, max_days: 10 },
{ pincode: 250103, min_days: 7, max_days: 10 },
{ pincode: 250104, min_days: 7, max_days: 10 },
{ pincode: 250105, min_days: 7, max_days: 10 },
{ pincode: 250106, min_days: 7, max_days: 10 },
{ pincode: 250110, min_days: 7, max_days: 10 },
{ pincode: 250117, min_days: 7, max_days: 10 },
{ pincode: 250205, min_days: 7, max_days: 10 },
{ pincode: 250211, min_days: 7, max_days: 10 },
{ pincode: 250221, min_days: 7, max_days: 10 },
{ pincode: 250222, min_days: 7, max_days: 10 },
{ pincode: 250223, min_days: 7, max_days: 10 },
{ pincode: 250233, min_days: 7, max_days: 10 },
{ pincode: 250341, min_days: 7, max_days: 10 },
{ pincode: 250342, min_days: 7, max_days: 10 },
{ pincode: 250344, min_days: 7, max_days: 10 },
{ pincode: 250345, min_days: 7, max_days: 10 },
{ pincode: 250401, min_days: 7, max_days: 10 },
{ pincode: 250402, min_days: 7, max_days: 10 },
{ pincode: 250403, min_days: 7, max_days: 10 },
{ pincode: 250404, min_days: 7, max_days: 10 },
{ pincode: 250406, min_days: 7, max_days: 10 },
{ pincode: 250501, min_days: 7, max_days: 10 },
{ pincode: 250502, min_days: 7, max_days: 10 },
{ pincode: 250601, min_days: 7, max_days: 10 },
{ pincode: 250602, min_days: 7, max_days: 10 },
{ pincode: 250606, min_days: 7, max_days: 10 },
{ pincode: 250609, min_days: 7, max_days: 10 },
{ pincode: 250611, min_days: 7, max_days: 10 },
{ pincode: 250615, min_days: 7, max_days: 10 },
{ pincode: 250619, min_days: 7, max_days: 10 },
{ pincode: 250620, min_days: 7, max_days: 10 },
{ pincode: 250621, min_days: 7, max_days: 10 },
{ pincode: 250622, min_days: 7, max_days: 10 },
{ pincode: 250623, min_days: 7, max_days: 10 },
{ pincode: 250625, min_days: 7, max_days: 10 },
{ pincode: 250626, min_days: 7, max_days: 10 },
{ pincode: 251001, min_days: 7, max_days: 10 },
{ pincode: 251002, min_days: 7, max_days: 10 },
{ pincode: 251003, min_days: 7, max_days: 10 },
{ pincode: 251201, min_days: 7, max_days: 10 },
{ pincode: 251202, min_days: 7, max_days: 10 },
{ pincode: 251203, min_days: 7, max_days: 10 },
{ pincode: 251301, min_days: 7, max_days: 10 },
{ pincode: 251308, min_days: 7, max_days: 10 },
{ pincode: 251309, min_days: 7, max_days: 10 },
{ pincode: 251317, min_days: 7, max_days: 10 },
{ pincode: 251320, min_days: 7, max_days: 10 },
{ pincode: 262311, min_days: 7, max_days: 10 },
{ pincode: 262401, min_days: 7, max_days: 10 },
{ pincode: 262402, min_days: 7, max_days: 10 },
{ pincode: 262405, min_days: 7, max_days: 10 },
{ pincode: 262408, min_days: 7, max_days: 10 },
{ pincode: 263126, min_days: 7, max_days: 10 },
{ pincode: 263127, min_days: 7, max_days: 10 },
{ pincode: 263128, min_days: 7, max_days: 10 },
{ pincode: 263139, min_days: 7, max_days: 10 },
{ pincode: 263140, min_days: 7, max_days: 10 },
{ pincode: 263142, min_days: 7, max_days: 10 },
{ pincode: 263145, min_days: 7, max_days: 10 },
{ pincode: 263146, min_days: 7, max_days: 10 },
{ pincode: 263148, min_days: 7, max_days: 10 },
{ pincode: 263149, min_days: 7, max_days: 10 },
{ pincode: 263150, min_days: 7, max_days: 10 },
{ pincode: 263151, min_days: 7, max_days: 10 },
{ pincode: 263152, min_days: 7, max_days: 10 },
{ pincode: 263153, min_days: 7, max_days: 10 },
{ pincode: 263160, min_days: 7, max_days: 10 },
{ pincode: 263161, min_days: 7, max_days: 10 },
{ pincode: 263165, min_days: 7, max_days: 10 },
{ pincode: 263401, min_days: 7, max_days: 10 },
{ pincode: 272001, min_days: 7, max_days: 10 },
{ pincode: 272002, min_days: 7, max_days: 10 },
{ pincode: 272123, min_days: 7, max_days: 10 },
{ pincode: 272124, min_days: 7, max_days: 10 },
{ pincode: 272125, min_days: 7, max_days: 10 },
{ pincode: 272126, min_days: 7, max_days: 10 },
{ pincode: 272148, min_days: 7, max_days: 10 },
{ pincode: 272150, min_days: 7, max_days: 10 },
{ pincode: 272152, min_days: 7, max_days: 10 },
{ pincode: 272162, min_days: 7, max_days: 10 },
{ pincode: 272164, min_days: 7, max_days: 10 },
{ pincode: 272165, min_days: 7, max_days: 10 },
{ pincode: 272170, min_days: 7, max_days: 10 },
{ pincode: 272171, min_days: 7, max_days: 10 },
{ pincode: 272172, min_days: 7, max_days: 10 },
{ pincode: 272173, min_days: 7, max_days: 10 },
{ pincode: 272175, min_days: 7, max_days: 10 },
{ pincode: 272176, min_days: 7, max_days: 10 },
{ pincode: 272177, min_days: 7, max_days: 10 },
{ pincode: 272178, min_days: 7, max_days: 10 },
{ pincode: 272182, min_days: 7, max_days: 10 },
{ pincode: 272199, min_days: 7, max_days: 10 },
{ pincode: 272270, min_days: 7, max_days: 10 },
{ pincode: 272271, min_days: 7, max_days: 10 },
{ pincode: 273001, min_days: 7, max_days: 10 },
{ pincode: 273002, min_days: 7, max_days: 10 },
{ pincode: 273003, min_days: 7, max_days: 10 },
{ pincode: 273004, min_days: 7, max_days: 10 },
{ pincode: 273005, min_days: 7, max_days: 10 },
{ pincode: 273006, min_days: 7, max_days: 10 },
{ pincode: 273007, min_days: 7, max_days: 10 },
{ pincode: 273008, min_days: 7, max_days: 10 },
{ pincode: 273009, min_days: 7, max_days: 10 },
{ pincode: 273010, min_days: 7, max_days: 10 },
{ pincode: 273011, min_days: 7, max_days: 10 },
{ pincode: 273012, min_days: 7, max_days: 10 },
{ pincode: 273013, min_days: 7, max_days: 10 },
{ pincode: 273014, min_days: 7, max_days: 10 },
{ pincode: 273015, min_days: 7, max_days: 10 },
{ pincode: 273016, min_days: 7, max_days: 10 },
{ pincode: 273017, min_days: 7, max_days: 10 },
{ pincode: 273151, min_days: 7, max_days: 10 },
{ pincode: 273152, min_days: 7, max_days: 10 },
{ pincode: 273153, min_days: 7, max_days: 10 },
{ pincode: 273155, min_days: 7, max_days: 10 },
{ pincode: 273157, min_days: 7, max_days: 10 },
{ pincode: 273158, min_days: 7, max_days: 10 },
{ pincode: 273161, min_days: 7, max_days: 10 },
{ pincode: 273165, min_days: 7, max_days: 10 },
{ pincode: 273201, min_days: 7, max_days: 10 },
{ pincode: 273202, min_days: 7, max_days: 10 },
{ pincode: 273203, min_days: 7, max_days: 10 },
{ pincode: 273209, min_days: 7, max_days: 10 },
{ pincode: 273211, min_days: 7, max_days: 10 },
{ pincode: 273212, min_days: 7, max_days: 10 },
{ pincode: 273213, min_days: 7, max_days: 10 },
{ pincode: 273301, min_days: 7, max_days: 10 },
{ pincode: 273302, min_days: 7, max_days: 10 },
{ pincode: 273306, min_days: 7, max_days: 10 },
{ pincode: 273310, min_days: 7, max_days: 10 },
{ pincode: 273401, min_days: 7, max_days: 10 },
{ pincode: 273403, min_days: 7, max_days: 10 },
{ pincode: 273404, min_days: 7, max_days: 10 },
{ pincode: 273405, min_days: 7, max_days: 10 },
{ pincode: 273406, min_days: 7, max_days: 10 },
{ pincode: 273407, min_days: 7, max_days: 10 },
{ pincode: 273408, min_days: 7, max_days: 10 },
{ pincode: 273409, min_days: 7, max_days: 10 },
{ pincode: 273411, min_days: 7, max_days: 10 },
{ pincode: 273412, min_days: 7, max_days: 10 },
{ pincode: 273413, min_days: 7, max_days: 10 },
{ pincode: 273414, min_days: 7, max_days: 10 },
{ pincode: 273415, min_days: 7, max_days: 10 },
{ pincode: 273416, min_days: 7, max_days: 10 },
{ pincode: 273417, min_days: 7, max_days: 10 },
{ pincode: 274149, min_days: 7, max_days: 10 },
{ pincode: 274202, min_days: 7, max_days: 10 },
{ pincode: 274203, min_days: 7, max_days: 10 },
{ pincode: 274206, min_days: 7, max_days: 10 },
{ pincode: 274207, min_days: 7, max_days: 10 },
{ pincode: 274208, min_days: 7, max_days: 10 },
{ pincode: 274249, min_days: 7, max_days: 10 },
{ pincode: 274307, min_days: 7, max_days: 10 },
{ pincode: 274309, min_days: 7, max_days: 10 },
{ pincode: 274805, min_days: 7, max_days: 10 },
{ pincode: 275100, min_days: 7, max_days: 10 },
{ pincode: 281001, min_days: 7, max_days: 10 },
{ pincode: 281003, min_days: 7, max_days: 10 },
{ pincode: 281004, min_days: 7, max_days: 10 },
{ pincode: 281005, min_days: 7, max_days: 10 },
{ pincode: 281006, min_days: 7, max_days: 10 },
{ pincode: 281010, min_days: 7, max_days: 10 },
{ pincode: 281104, min_days: 7, max_days: 10 },
{ pincode: 281121, min_days: 7, max_days: 10 },
{ pincode: 281122, min_days: 7, max_days: 10 },
{ pincode: 281301, min_days: 7, max_days: 10 },
{ pincode: 281302, min_days: 7, max_days: 10 },
{ pincode: 281303, min_days: 7, max_days: 10 },
{ pincode: 281304, min_days: 7, max_days: 10 },
{ pincode: 281305, min_days: 7, max_days: 10 },
{ pincode: 281306, min_days: 7, max_days: 10 },
{ pincode: 281307, min_days: 7, max_days: 10 },
{ pincode: 281308, min_days: 7, max_days: 10 },
{ pincode: 281503, min_days: 7, max_days: 10 },
{ pincode: 282000, min_days: 7, max_days: 10 },
{ pincode: 282001, min_days: 7, max_days: 10 },
{ pincode: 282002, min_days: 7, max_days: 10 },
{ pincode: 282003, min_days: 7, max_days: 10 },
{ pincode: 282004, min_days: 7, max_days: 10 },
{ pincode: 282005, min_days: 7, max_days: 10 },
{ pincode: 282006, min_days: 7, max_days: 10 },
{ pincode: 282007, min_days: 7, max_days: 10 },
{ pincode: 282008, min_days: 7, max_days: 10 },
{ pincode: 282009, min_days: 7, max_days: 10 },
{ pincode: 282010, min_days: 7, max_days: 10 },
{ pincode: 282011, min_days: 7, max_days: 10 },
{ pincode: 283101, min_days: 7, max_days: 10 },
{ pincode: 283102, min_days: 7, max_days: 10 },
{ pincode: 283103, min_days: 7, max_days: 10 },
{ pincode: 283105, min_days: 7, max_days: 10 },
{ pincode: 283107, min_days: 7, max_days: 10 },
{ pincode: 283110, min_days: 7, max_days: 10 },
{ pincode: 283111, min_days: 7, max_days: 10 },
{ pincode: 283112, min_days: 7, max_days: 10 },
{ pincode: 283115, min_days: 7, max_days: 10 },
{ pincode: 283119, min_days: 7, max_days: 10 },
{ pincode: 283121, min_days: 7, max_days: 10 },
{ pincode: 283122, min_days: 7, max_days: 10 },
{ pincode: 283123, min_days: 7, max_days: 10 },
{ pincode: 283124, min_days: 7, max_days: 10 },
{ pincode: 283125, min_days: 7, max_days: 10 },
{ pincode: 283126, min_days: 7, max_days: 10 },
{ pincode: 283135, min_days: 7, max_days: 10 },
{ pincode: 283145, min_days: 7, max_days: 10 },
{ pincode: 283152, min_days: 7, max_days: 10 },
{ pincode: 283201, min_days: 7, max_days: 10 },
{ pincode: 283202, min_days: 7, max_days: 10 },
{ pincode: 283203, min_days: 7, max_days: 10 },
{ pincode: 283204, min_days: 7, max_days: 10 },
{ pincode: 283205, min_days: 7, max_days: 10 },
{ pincode: 283206, min_days: 7, max_days: 10 },
{ pincode: 283207, min_days: 7, max_days: 10 },
{ pincode: 284001, min_days: 7, max_days: 10 },
{ pincode: 284002, min_days: 7, max_days: 10 },
{ pincode: 284003, min_days: 7, max_days: 10 },
{ pincode: 284006, min_days: 7, max_days: 10 },
{ pincode: 284120, min_days: 7, max_days: 10 },
{ pincode: 284127, min_days: 7, max_days: 10 },
{ pincode: 284128, min_days: 7, max_days: 10 },
{ pincode: 284135, min_days: 7, max_days: 10 },
{ pincode: 284407, min_days: 7, max_days: 10 },
{ pincode: 284419, min_days: 7, max_days: 10 },
{ pincode: 301001, min_days: 7, max_days: 10 },
{ pincode: 301002, min_days: 7, max_days: 10 },
{ pincode: 301018, min_days: 7, max_days: 10 },
{ pincode: 301019, min_days: 7, max_days: 10 },
{ pincode: 301023, min_days: 7, max_days: 10 },
{ pincode: 301028, min_days: 7, max_days: 10 },
{ pincode: 301030, min_days: 7, max_days: 10 },
{ pincode: 301031, min_days: 7, max_days: 10 },
{ pincode: 301032, min_days: 7, max_days: 10 },
{ pincode: 301033, min_days: 7, max_days: 10 },
{ pincode: 301034, min_days: 7, max_days: 10 },
{ pincode: 301037, min_days: 7, max_days: 10 },
{ pincode: 301401, min_days: 7, max_days: 10 },
{ pincode: 301411, min_days: 7, max_days: 10 },
{ pincode: 301416, min_days: 7, max_days: 10 },
{ pincode: 301702, min_days: 7, max_days: 10 },
{ pincode: 301704, min_days: 7, max_days: 10 },
{ pincode: 301707, min_days: 7, max_days: 10 },
{ pincode: 302000, min_days: 7, max_days: 10 },
{ pincode: 302001, min_days: 7, max_days: 10 },
{ pincode: 302002, min_days: 7, max_days: 10 },
{ pincode: 302003, min_days: 7, max_days: 10 },
{ pincode: 302004, min_days: 7, max_days: 10 },
{ pincode: 302005, min_days: 7, max_days: 10 },
{ pincode: 302006, min_days: 7, max_days: 10 },
{ pincode: 302007, min_days: 7, max_days: 10 },
{ pincode: 302008, min_days: 7, max_days: 10 },
{ pincode: 302009, min_days: 7, max_days: 10 },
{ pincode: 302010, min_days: 7, max_days: 10 },
{ pincode: 302011, min_days: 7, max_days: 10 },
{ pincode: 302012, min_days: 7, max_days: 10 },
{ pincode: 302013, min_days: 7, max_days: 10 },
{ pincode: 302014, min_days: 7, max_days: 10 },
{ pincode: 302015, min_days: 7, max_days: 10 },
{ pincode: 302016, min_days: 7, max_days: 10 },
{ pincode: 302017, min_days: 7, max_days: 10 },
{ pincode: 302018, min_days: 7, max_days: 10 },
{ pincode: 302019, min_days: 7, max_days: 10 },
{ pincode: 302020, min_days: 7, max_days: 10 },
{ pincode: 302021, min_days: 7, max_days: 10 },
{ pincode: 302022, min_days: 7, max_days: 10 },
{ pincode: 302023, min_days: 7, max_days: 10 },
{ pincode: 302024, min_days: 7, max_days: 10 },
{ pincode: 302025, min_days: 7, max_days: 10 },
{ pincode: 302026, min_days: 7, max_days: 10 },
{ pincode: 302027, min_days: 7, max_days: 10 },
{ pincode: 302028, min_days: 7, max_days: 10 },
{ pincode: 302029, min_days: 7, max_days: 10 },
{ pincode: 302030, min_days: 7, max_days: 10 },
{ pincode: 302031, min_days: 7, max_days: 10 },
{ pincode: 302032, min_days: 7, max_days: 10 },
{ pincode: 302033, min_days: 7, max_days: 10 },
{ pincode: 302034, min_days: 7, max_days: 10 },
{ pincode: 302035, min_days: 7, max_days: 10 },
{ pincode: 302036, min_days: 7, max_days: 10 },
{ pincode: 302037, min_days: 7, max_days: 10 },
{ pincode: 302039, min_days: 7, max_days: 10 },
{ pincode: 302040, min_days: 7, max_days: 10 },
{ pincode: 302041, min_days: 7, max_days: 10 },
{ pincode: 302042, min_days: 7, max_days: 10 },
{ pincode: 302043, min_days: 7, max_days: 10 },
{ pincode: 302044, min_days: 7, max_days: 10 },
{ pincode: 302045, min_days: 7, max_days: 10 },
{ pincode: 302046, min_days: 7, max_days: 10 },
{ pincode: 302100, min_days: 7, max_days: 10 },
{ pincode: 302902, min_days: 7, max_days: 10 },
{ pincode: 303002, min_days: 7, max_days: 10 },
{ pincode: 303003, min_days: 7, max_days: 10 },
{ pincode: 303004, min_days: 7, max_days: 10 },
{ pincode: 303005, min_days: 7, max_days: 10 },
{ pincode: 303006, min_days: 7, max_days: 10 },
{ pincode: 303007, min_days: 7, max_days: 10 },
{ pincode: 303008, min_days: 7, max_days: 10 },
{ pincode: 303009, min_days: 7, max_days: 10 },
{ pincode: 303010, min_days: 7, max_days: 10 },
{ pincode: 303011, min_days: 7, max_days: 10 },
{ pincode: 303012, min_days: 7, max_days: 10 },
{ pincode: 303017, min_days: 7, max_days: 10 },
{ pincode: 303101, min_days: 7, max_days: 10 },
{ pincode: 303103, min_days: 7, max_days: 10 },
{ pincode: 303104, min_days: 7, max_days: 10 },
{ pincode: 303120, min_days: 7, max_days: 10 },
{ pincode: 303121, min_days: 7, max_days: 10 },
{ pincode: 303122, min_days: 7, max_days: 10 },
{ pincode: 303123, min_days: 7, max_days: 10 },
{ pincode: 303124, min_days: 7, max_days: 10 },
{ pincode: 303301, min_days: 7, max_days: 10 },
{ pincode: 303303, min_days: 7, max_days: 10 },
{ pincode: 303305, min_days: 7, max_days: 10 },
{ pincode: 303328, min_days: 7, max_days: 10 },
{ pincode: 303329, min_days: 7, max_days: 10 },
{ pincode: 303330, min_days: 7, max_days: 10 },
{ pincode: 303338, min_days: 7, max_days: 10 },
{ pincode: 303601, min_days: 7, max_days: 10 },
{ pincode: 303602, min_days: 7, max_days: 10 },
{ pincode: 303603, min_days: 7, max_days: 10 },
{ pincode: 303701, min_days: 7, max_days: 10 },
{ pincode: 303702, min_days: 7, max_days: 10 },
{ pincode: 303704, min_days: 7, max_days: 10 },
{ pincode: 303706, min_days: 7, max_days: 10 },
{ pincode: 303712, min_days: 7, max_days: 10 },
{ pincode: 303801, min_days: 7, max_days: 10 },
{ pincode: 303803, min_days: 7, max_days: 10 },
{ pincode: 303804, min_days: 7, max_days: 10 },
{ pincode: 303805, min_days: 7, max_days: 10 },
{ pincode: 303806, min_days: 7, max_days: 10 },
{ pincode: 303807, min_days: 7, max_days: 10 },
{ pincode: 303901, min_days: 7, max_days: 10 },
{ pincode: 303902, min_days: 7, max_days: 10 },
{ pincode: 303903, min_days: 7, max_days: 10 },
{ pincode: 303904, min_days: 7, max_days: 10 },
{ pincode: 303905, min_days: 7, max_days: 10 },
{ pincode: 303906, min_days: 7, max_days: 10 },
{ pincode: 305001, min_days: 7, max_days: 10 },
{ pincode: 305002, min_days: 7, max_days: 10 },
{ pincode: 305003, min_days: 7, max_days: 10 },
{ pincode: 305004, min_days: 7, max_days: 10 },
{ pincode: 305007, min_days: 7, max_days: 10 },
{ pincode: 305008, min_days: 7, max_days: 10 },
{ pincode: 305009, min_days: 7, max_days: 10 },
{ pincode: 305012, min_days: 7, max_days: 10 },
{ pincode: 305014, min_days: 7, max_days: 10 },
{ pincode: 305024, min_days: 7, max_days: 10 },
{ pincode: 305025, min_days: 7, max_days: 10 },
{ pincode: 305205, min_days: 7, max_days: 10 },
{ pincode: 305206, min_days: 7, max_days: 10 },
{ pincode: 305601, min_days: 7, max_days: 10 },
{ pincode: 306104, min_days: 7, max_days: 10 },
{ pincode: 306401, min_days: 7, max_days: 10 },
{ pincode: 306421, min_days: 7, max_days: 10 },
{ pincode: 311001, min_days: 7, max_days: 10 },
{ pincode: 311012, min_days: 7, max_days: 10 },
{ pincode: 311013, min_days: 7, max_days: 10 },
{ pincode: 311031, min_days: 7, max_days: 10 },
{ pincode: 311032, min_days: 7, max_days: 10 },
{ pincode: 311802, min_days: 7, max_days: 10 },
{ pincode: 313001, min_days: 7, max_days: 10 },
{ pincode: 313002, min_days: 7, max_days: 10 },
{ pincode: 313003, min_days: 7, max_days: 10 },
{ pincode: 313004, min_days: 7, max_days: 10 },
{ pincode: 313005, min_days: 7, max_days: 10 },
{ pincode: 313006, min_days: 7, max_days: 10 },
{ pincode: 313007, min_days: 7, max_days: 10 },
{ pincode: 313008, min_days: 7, max_days: 10 },
{ pincode: 313009, min_days: 7, max_days: 10 },
{ pincode: 313010, min_days: 7, max_days: 10 },
{ pincode: 313011, min_days: 7, max_days: 10 },
{ pincode: 313012, min_days: 7, max_days: 10 },
{ pincode: 313013, min_days: 7, max_days: 10 },
{ pincode: 313014, min_days: 7, max_days: 10 },
{ pincode: 313015, min_days: 7, max_days: 10 },
{ pincode: 313016, min_days: 7, max_days: 10 },
{ pincode: 313017, min_days: 7, max_days: 10 },
{ pincode: 313018, min_days: 7, max_days: 10 },
{ pincode: 313019, min_days: 7, max_days: 10 },
{ pincode: 313020, min_days: 7, max_days: 10 },
{ pincode: 313021, min_days: 7, max_days: 10 },
{ pincode: 313022, min_days: 7, max_days: 10 },
{ pincode: 313023, min_days: 7, max_days: 10 },
{ pincode: 313024, min_days: 7, max_days: 10 },
{ pincode: 313025, min_days: 7, max_days: 10 },
{ pincode: 313029, min_days: 7, max_days: 10 },
{ pincode: 313031, min_days: 7, max_days: 10 },
{ pincode: 313032, min_days: 7, max_days: 10 },
{ pincode: 313033, min_days: 7, max_days: 10 },
{ pincode: 313034, min_days: 7, max_days: 10 },
{ pincode: 313201, min_days: 7, max_days: 10 },
{ pincode: 313202, min_days: 7, max_days: 10 },
{ pincode: 313203, min_days: 7, max_days: 10 },
{ pincode: 313204, min_days: 7, max_days: 10 },
{ pincode: 313205, min_days: 7, max_days: 10 },
{ pincode: 313206, min_days: 7, max_days: 10 },
{ pincode: 313301, min_days: 7, max_days: 10 },
{ pincode: 313322, min_days: 7, max_days: 10 },
{ pincode: 313323, min_days: 7, max_days: 10 },
{ pincode: 313601, min_days: 7, max_days: 10 },
{ pincode: 313602, min_days: 7, max_days: 10 },
{ pincode: 313603, min_days: 7, max_days: 10 },
{ pincode: 313606, min_days: 7, max_days: 10 },
{ pincode: 313607, min_days: 7, max_days: 10 },
{ pincode: 313608, min_days: 7, max_days: 10 },
{ pincode: 313609, min_days: 7, max_days: 10 },
{ pincode: 313702, min_days: 7, max_days: 10 },
{ pincode: 313703, min_days: 7, max_days: 10 },
{ pincode: 313705, min_days: 7, max_days: 10 },
{ pincode: 313706, min_days: 7, max_days: 10 },
{ pincode: 313707, min_days: 7, max_days: 10 },
{ pincode: 313709, min_days: 7, max_days: 10 },
{ pincode: 313710, min_days: 7, max_days: 10 },
{ pincode: 313801, min_days: 7, max_days: 10 },
{ pincode: 313802, min_days: 7, max_days: 10 },
{ pincode: 313901, min_days: 7, max_days: 10 },
{ pincode: 313902, min_days: 7, max_days: 10 },
{ pincode: 313904, min_days: 7, max_days: 10 },
{ pincode: 313905, min_days: 7, max_days: 10 },
{ pincode: 313907, min_days: 7, max_days: 10 },
{ pincode: 321001, min_days: 7, max_days: 10 },
{ pincode: 321006, min_days: 7, max_days: 10 },
{ pincode: 321021, min_days: 7, max_days: 10 },
{ pincode: 321025, min_days: 7, max_days: 10 },
{ pincode: 321026, min_days: 7, max_days: 10 },
{ pincode: 321202, min_days: 7, max_days: 10 },
{ pincode: 321303, min_days: 7, max_days: 10 },
{ pincode: 321305, min_days: 7, max_days: 10 },
{ pincode: 321603, min_days: 7, max_days: 10 },
{ pincode: 321604, min_days: 7, max_days: 10 },
{ pincode: 321641, min_days: 7, max_days: 10 },
{ pincode: 324001, min_days: 7, max_days: 10 },
{ pincode: 324002, min_days: 7, max_days: 10 },
{ pincode: 324003, min_days: 7, max_days: 10 },
{ pincode: 324004, min_days: 7, max_days: 10 },
{ pincode: 324005, min_days: 7, max_days: 10 },
{ pincode: 324006, min_days: 7, max_days: 10 },
{ pincode: 324007, min_days: 7, max_days: 10 },
{ pincode: 324008, min_days: 7, max_days: 10 },
{ pincode: 324009, min_days: 7, max_days: 10 },
{ pincode: 324010, min_days: 7, max_days: 10 },
{ pincode: 326510, min_days: 7, max_days: 10 },
{ pincode: 332001, min_days: 7, max_days: 10 },
{ pincode: 332402, min_days: 7, max_days: 10 },
{ pincode: 332403, min_days: 7, max_days: 10 },
{ pincode: 333337, min_days: 7, max_days: 10 },
{ pincode: 333338, min_days: 7, max_days: 10 },
{ pincode: 334001, min_days: 7, max_days: 10 },
{ pincode: 334002, min_days: 7, max_days: 10 },
{ pincode: 334003, min_days: 7, max_days: 10 },
{ pincode: 334004, min_days: 7, max_days: 10 },
{ pincode: 334005, min_days: 7, max_days: 10 },
{ pincode: 334006, min_days: 7, max_days: 10 },
{ pincode: 334007, min_days: 7, max_days: 10 },
{ pincode: 334401, min_days: 7, max_days: 10 },
{ pincode: 334403, min_days: 7, max_days: 10 },
{ pincode: 334404, min_days: 7, max_days: 10 },
{ pincode: 335001, min_days: 7, max_days: 10 },
{ pincode: 335009, min_days: 7, max_days: 10 },
{ pincode: 335026, min_days: 7, max_days: 10 },
{ pincode: 335042, min_days: 7, max_days: 10 },
{ pincode: 335043, min_days: 7, max_days: 10 },
{ pincode: 335902, min_days: 7, max_days: 10 },
{ pincode: 342001, min_days: 7, max_days: 10 },
{ pincode: 342002, min_days: 7, max_days: 10 },
{ pincode: 342003, min_days: 7, max_days: 10 },
{ pincode: 342004, min_days: 7, max_days: 10 },
{ pincode: 342005, min_days: 7, max_days: 10 },
{ pincode: 342006, min_days: 7, max_days: 10 },
{ pincode: 342007, min_days: 7, max_days: 10 },
{ pincode: 342008, min_days: 7, max_days: 10 },
{ pincode: 342009, min_days: 7, max_days: 10 },
{ pincode: 342010, min_days: 7, max_days: 10 },
{ pincode: 342011, min_days: 7, max_days: 10 },
{ pincode: 342012, min_days: 7, max_days: 10 },
{ pincode: 342013, min_days: 7, max_days: 10 },
{ pincode: 342014, min_days: 7, max_days: 10 },
{ pincode: 342015, min_days: 7, max_days: 10 },
{ pincode: 342016, min_days: 7, max_days: 10 },
{ pincode: 342018, min_days: 7, max_days: 10 },
{ pincode: 342019, min_days: 7, max_days: 10 },
{ pincode: 342023, min_days: 7, max_days: 10 },
{ pincode: 342024, min_days: 7, max_days: 10 },
{ pincode: 342027, min_days: 7, max_days: 10 },
{ pincode: 342031, min_days: 7, max_days: 10 },
{ pincode: 342032, min_days: 7, max_days: 10 },
{ pincode: 342033, min_days: 7, max_days: 10 },
{ pincode: 342034, min_days: 7, max_days: 10 },
{ pincode: 342037, min_days: 7, max_days: 10 },
{ pincode: 342303, min_days: 7, max_days: 10 },
{ pincode: 342304, min_days: 7, max_days: 10 },
{ pincode: 342305, min_days: 7, max_days: 10 },
{ pincode: 342306, min_days: 7, max_days: 10 },
{ pincode: 342605, min_days: 7, max_days: 10 },
{ pincode: 342606, min_days: 7, max_days: 10 },
{ pincode: 342607, min_days: 7, max_days: 10 },
{ pincode: 342608, min_days: 7, max_days: 10 },
{ pincode: 342609, min_days: 7, max_days: 10 },
{ pincode: 342801, min_days: 7, max_days: 10 },
{ pincode: 342802, min_days: 7, max_days: 10 },
{ pincode: 342803, min_days: 7, max_days: 10 },
{ pincode: 342804, min_days: 7, max_days: 10 },
{ pincode: 360000, min_days: 7, max_days: 10 },
{ pincode: 360001, min_days: 7, max_days: 10 },
{ pincode: 360002, min_days: 7, max_days: 10 },
{ pincode: 360003, min_days: 7, max_days: 10 },
{ pincode: 360004, min_days: 7, max_days: 10 },
{ pincode: 360005, min_days: 7, max_days: 10 },
{ pincode: 360006, min_days: 7, max_days: 10 },
{ pincode: 360007, min_days: 7, max_days: 10 },
{ pincode: 360008, min_days: 7, max_days: 10 },
{ pincode: 360009, min_days: 7, max_days: 10 },
{ pincode: 360020, min_days: 7, max_days: 10 },
{ pincode: 360021, min_days: 7, max_days: 10 },
{ pincode: 360022, min_days: 7, max_days: 10 },
{ pincode: 360023, min_days: 7, max_days: 10 },
{ pincode: 360024, min_days: 7, max_days: 10 },
{ pincode: 360025, min_days: 7, max_days: 10 },
{ pincode: 360028, min_days: 7, max_days: 10 },
{ pincode: 360029, min_days: 7, max_days: 10 },
{ pincode: 360030, min_days: 7, max_days: 10 },
{ pincode: 360031, min_days: 7, max_days: 10 },
{ pincode: 360032, min_days: 7, max_days: 10 },
{ pincode: 360034, min_days: 7, max_days: 10 },
{ pincode: 360035, min_days: 7, max_days: 10 },
{ pincode: 360037, min_days: 7, max_days: 10 },
{ pincode: 360045, min_days: 7, max_days: 10 },
{ pincode: 360050, min_days: 7, max_days: 10 },
{ pincode: 360060, min_days: 7, max_days: 10 },
{ pincode: 360070, min_days: 7, max_days: 10 },
{ pincode: 360075, min_days: 7, max_days: 10 },
{ pincode: 360080, min_days: 7, max_days: 10 },
{ pincode: 360110, min_days: 7, max_days: 10 },
{ pincode: 360150, min_days: 7, max_days: 10 },
{ pincode: 360311, min_days: 7, max_days: 10 },
{ pincode: 360320, min_days: 7, max_days: 10 },
{ pincode: 360325, min_days: 7, max_days: 10 },
{ pincode: 360330, min_days: 7, max_days: 10 },
{ pincode: 360380, min_days: 7, max_days: 10 },
{ pincode: 360520, min_days: 7, max_days: 10 },
{ pincode: 360540, min_days: 7, max_days: 10 },
{ pincode: 361001, min_days: 7, max_days: 10 },
{ pincode: 361002, min_days: 7, max_days: 10 },
{ pincode: 361003, min_days: 7, max_days: 10 },
{ pincode: 361004, min_days: 7, max_days: 10 },
{ pincode: 361005, min_days: 7, max_days: 10 },
{ pincode: 361006, min_days: 7, max_days: 10 },
{ pincode: 361007, min_days: 7, max_days: 10 },
{ pincode: 361008, min_days: 7, max_days: 10 },
{ pincode: 361009, min_days: 7, max_days: 10 },
{ pincode: 361010, min_days: 7, max_days: 10 },
{ pincode: 361011, min_days: 7, max_days: 10 },
{ pincode: 361012, min_days: 7, max_days: 10 },
{ pincode: 361013, min_days: 7, max_days: 10 },
{ pincode: 361110, min_days: 7, max_days: 10 },
{ pincode: 361120, min_days: 7, max_days: 10 },
{ pincode: 361130, min_days: 7, max_days: 10 },
{ pincode: 361135, min_days: 7, max_days: 10 },
{ pincode: 361140, min_days: 7, max_days: 10 },
{ pincode: 361141, min_days: 7, max_days: 10 },
{ pincode: 361142, min_days: 7, max_days: 10 },
{ pincode: 361150, min_days: 7, max_days: 10 },
{ pincode: 361160, min_days: 7, max_days: 10 },
{ pincode: 361162, min_days: 7, max_days: 10 },
{ pincode: 361170, min_days: 7, max_days: 10 },
{ pincode: 361210, min_days: 7, max_days: 10 },
{ pincode: 361220, min_days: 7, max_days: 10 },
{ pincode: 361230, min_days: 7, max_days: 10 },
{ pincode: 361250, min_days: 7, max_days: 10 },
{ pincode: 361280, min_days: 7, max_days: 10 },
{ pincode: 361290, min_days: 7, max_days: 10 },
{ pincode: 361295, min_days: 7, max_days: 10 },
{ pincode: 361305, min_days: 7, max_days: 10 },
{ pincode: 361312, min_days: 7, max_days: 10 },
{ pincode: 361316, min_days: 7, max_days: 10 },
{ pincode: 361321, min_days: 7, max_days: 10 },
{ pincode: 361322, min_days: 7, max_days: 10 },
{ pincode: 361336, min_days: 7, max_days: 10 },
{ pincode: 362001, min_days: 7, max_days: 10 },
{ pincode: 362002, min_days: 7, max_days: 10 },
{ pincode: 362004, min_days: 7, max_days: 10 },
{ pincode: 362011, min_days: 7, max_days: 10 },
{ pincode: 362015, min_days: 7, max_days: 10 },
{ pincode: 362037, min_days: 7, max_days: 10 },
{ pincode: 362205, min_days: 7, max_days: 10 },
{ pincode: 362263, min_days: 7, max_days: 10 },
{ pincode: 362310, min_days: 7, max_days: 10 },
{ pincode: 362610, min_days: 7, max_days: 10 },
{ pincode: 363001, min_days: 7, max_days: 10 },
{ pincode: 363002, min_days: 7, max_days: 10 },
{ pincode: 363020, min_days: 7, max_days: 10 },
{ pincode: 363030, min_days: 7, max_days: 10 },
{ pincode: 363034, min_days: 7, max_days: 10 },
{ pincode: 363035, min_days: 7, max_days: 10 },
{ pincode: 363040, min_days: 7, max_days: 10 },
{ pincode: 363110, min_days: 7, max_days: 10 },
{ pincode: 363520, min_days: 7, max_days: 10 },
{ pincode: 363621, min_days: 7, max_days: 10 },
{ pincode: 363623, min_days: 7, max_days: 10 },
{ pincode: 363626, min_days: 7, max_days: 10 },
{ pincode: 363641, min_days: 7, max_days: 10 },
{ pincode: 363642, min_days: 7, max_days: 10 },
{ pincode: 363650, min_days: 7, max_days: 10 },
{ pincode: 363667, min_days: 7, max_days: 10 },
{ pincode: 363669, min_days: 7, max_days: 10 },
{ pincode: 364001, min_days: 7, max_days: 10 },
{ pincode: 364002, min_days: 7, max_days: 10 },
{ pincode: 364003, min_days: 7, max_days: 10 },
{ pincode: 364004, min_days: 7, max_days: 10 },
{ pincode: 364005, min_days: 7, max_days: 10 },
{ pincode: 364006, min_days: 7, max_days: 10 },
{ pincode: 364060, min_days: 7, max_days: 10 },
{ pincode: 364110, min_days: 7, max_days: 10 },
{ pincode: 370001, min_days: 7, max_days: 10 },
{ pincode: 370003, min_days: 7, max_days: 10 },
{ pincode: 370004, min_days: 7, max_days: 10 },
{ pincode: 370005, min_days: 7, max_days: 10 },
{ pincode: 370006, min_days: 7, max_days: 10 },
{ pincode: 370007, min_days: 7, max_days: 10 },
{ pincode: 370008, min_days: 7, max_days: 10 },
{ pincode: 370009, min_days: 7, max_days: 10 },
{ pincode: 370020, min_days: 7, max_days: 10 },
{ pincode: 370040, min_days: 7, max_days: 10 },
{ pincode: 370104, min_days: 7, max_days: 10 },
{ pincode: 370105, min_days: 7, max_days: 10 },
{ pincode: 370201, min_days: 7, max_days: 10 },
{ pincode: 370203, min_days: 7, max_days: 10 },
{ pincode: 370205, min_days: 7, max_days: 10 },
{ pincode: 370210, min_days: 7, max_days: 10 },
{ pincode: 370230, min_days: 7, max_days: 10 },
{ pincode: 370231, min_days: 7, max_days: 10 },
{ pincode: 370232, min_days: 7, max_days: 10 },
{ pincode: 370233, min_days: 7, max_days: 10 },
{ pincode: 370234, min_days: 7, max_days: 10 },
{ pincode: 370235, min_days: 7, max_days: 10 },
{ pincode: 370236, min_days: 7, max_days: 10 },
{ pincode: 370237, min_days: 7, max_days: 10 },
{ pincode: 370238, min_days: 7, max_days: 10 },
{ pincode: 370239, min_days: 7, max_days: 10 },
{ pincode: 370240, min_days: 7, max_days: 10 },
{ pincode: 370427, min_days: 7, max_days: 10 },
{ pincode: 380000, min_days: 7, max_days: 10 },
{ pincode: 380001, min_days: 7, max_days: 10 },
{ pincode: 380002, min_days: 7, max_days: 10 },
{ pincode: 380003, min_days: 7, max_days: 10 },
{ pincode: 380004, min_days: 7, max_days: 10 },
{ pincode: 380005, min_days: 7, max_days: 10 },
{ pincode: 380006, min_days: 7, max_days: 10 },
{ pincode: 380007, min_days: 7, max_days: 10 },
{ pincode: 380008, min_days: 7, max_days: 10 },
{ pincode: 380009, min_days: 7, max_days: 10 },
{ pincode: 380010, min_days: 7, max_days: 10 },
{ pincode: 380011, min_days: 7, max_days: 10 },
{ pincode: 380012, min_days: 7, max_days: 10 },
{ pincode: 380013, min_days: 7, max_days: 10 },
{ pincode: 380014, min_days: 7, max_days: 10 },
{ pincode: 380015, min_days: 7, max_days: 10 },
{ pincode: 380016, min_days: 7, max_days: 10 },
{ pincode: 380017, min_days: 7, max_days: 10 },
{ pincode: 380018, min_days: 7, max_days: 10 },
{ pincode: 380019, min_days: 7, max_days: 10 },
{ pincode: 380020, min_days: 7, max_days: 10 },
{ pincode: 380021, min_days: 7, max_days: 10 },
{ pincode: 380022, min_days: 7, max_days: 10 },
{ pincode: 380023, min_days: 7, max_days: 10 },
{ pincode: 380024, min_days: 7, max_days: 10 },
{ pincode: 380025, min_days: 7, max_days: 10 },
{ pincode: 380026, min_days: 7, max_days: 10 },
{ pincode: 380027, min_days: 7, max_days: 10 },
{ pincode: 380028, min_days: 7, max_days: 10 },
{ pincode: 380029, min_days: 7, max_days: 10 },
{ pincode: 380030, min_days: 7, max_days: 10 },
{ pincode: 380038, min_days: 7, max_days: 10 },
{ pincode: 380043, min_days: 7, max_days: 10 },
{ pincode: 380045, min_days: 7, max_days: 10 },
{ pincode: 380049, min_days: 7, max_days: 10 },
{ pincode: 380050, min_days: 7, max_days: 10 },
{ pincode: 380051, min_days: 7, max_days: 10 },
{ pincode: 380052, min_days: 7, max_days: 10 },
{ pincode: 380053, min_days: 7, max_days: 10 },
{ pincode: 380054, min_days: 7, max_days: 10 },
{ pincode: 380055, min_days: 7, max_days: 10 },
{ pincode: 380057, min_days: 7, max_days: 10 },
{ pincode: 380058, min_days: 7, max_days: 10 },
{ pincode: 380059, min_days: 7, max_days: 10 },
{ pincode: 380060, min_days: 7, max_days: 10 },
{ pincode: 380061, min_days: 7, max_days: 10 },
{ pincode: 380062, min_days: 7, max_days: 10 },
{ pincode: 380063, min_days: 7, max_days: 10 },
{ pincode: 380075, min_days: 7, max_days: 10 },
{ pincode: 382000, min_days: 7, max_days: 10 },
{ pincode: 382001, min_days: 7, max_days: 10 },
{ pincode: 382002, min_days: 7, max_days: 10 },
{ pincode: 382003, min_days: 7, max_days: 10 },
{ pincode: 382004, min_days: 7, max_days: 10 },
{ pincode: 382005, min_days: 7, max_days: 10 },
{ pincode: 382006, min_days: 7, max_days: 10 },
{ pincode: 382007, min_days: 7, max_days: 10 },
{ pincode: 382008, min_days: 7, max_days: 10 },
{ pincode: 382009, min_days: 7, max_days: 10 },
{ pincode: 382010, min_days: 7, max_days: 10 },
{ pincode: 382011, min_days: 7, max_days: 10 },
{ pincode: 382012, min_days: 7, max_days: 10 },
{ pincode: 382013, min_days: 7, max_days: 10 },
{ pincode: 382014, min_days: 7, max_days: 10 },
{ pincode: 382015, min_days: 7, max_days: 10 },
{ pincode: 382016, min_days: 7, max_days: 10 },
{ pincode: 382017, min_days: 7, max_days: 10 },
{ pincode: 382018, min_days: 7, max_days: 10 },
{ pincode: 382019, min_days: 7, max_days: 10 },
{ pincode: 382020, min_days: 7, max_days: 10 },
{ pincode: 382021, min_days: 7, max_days: 10 },
{ pincode: 382022, min_days: 7, max_days: 10 },
{ pincode: 382023, min_days: 7, max_days: 10 },
{ pincode: 382024, min_days: 7, max_days: 10 },
{ pincode: 382025, min_days: 7, max_days: 10 },
{ pincode: 382026, min_days: 7, max_days: 10 },
{ pincode: 382027, min_days: 7, max_days: 10 },
{ pincode: 382028, min_days: 7, max_days: 10 },
{ pincode: 382029, min_days: 7, max_days: 10 },
{ pincode: 382030, min_days: 7, max_days: 10 },
{ pincode: 382032, min_days: 7, max_days: 10 },
{ pincode: 382041, min_days: 7, max_days: 10 },
{ pincode: 382042, min_days: 7, max_days: 10 },
{ pincode: 382043, min_days: 7, max_days: 10 },
{ pincode: 382044, min_days: 7, max_days: 10 },
{ pincode: 382045, min_days: 7, max_days: 10 },
{ pincode: 382051, min_days: 7, max_days: 10 },
{ pincode: 382110, min_days: 7, max_days: 10 },
{ pincode: 382115, min_days: 7, max_days: 10 },
{ pincode: 382117, min_days: 7, max_days: 10 },
{ pincode: 382120, min_days: 7, max_days: 10 },
{ pincode: 382165, min_days: 7, max_days: 10 },
{ pincode: 382170, min_days: 7, max_days: 10 },
{ pincode: 382210, min_days: 7, max_days: 10 },
{ pincode: 382211, min_days: 7, max_days: 10 },
{ pincode: 382212, min_days: 7, max_days: 10 },
{ pincode: 382213, min_days: 7, max_days: 10 },
{ pincode: 382214, min_days: 7, max_days: 10 },
{ pincode: 382215, min_days: 7, max_days: 10 },
{ pincode: 382220, min_days: 7, max_days: 10 },
{ pincode: 382225, min_days: 7, max_days: 10 },
{ pincode: 382230, min_days: 7, max_days: 10 },
{ pincode: 382240, min_days: 7, max_days: 10 },
{ pincode: 382260, min_days: 7, max_days: 10 },
{ pincode: 382265, min_days: 7, max_days: 10 },
{ pincode: 382276, min_days: 7, max_days: 10 },
{ pincode: 382305, min_days: 7, max_days: 10 },
{ pincode: 382308, min_days: 7, max_days: 10 },
{ pincode: 382310, min_days: 7, max_days: 10 },
{ pincode: 382315, min_days: 7, max_days: 10 },
{ pincode: 382316, min_days: 7, max_days: 10 },
{ pincode: 382320, min_days: 7, max_days: 10 },
{ pincode: 382321, min_days: 7, max_days: 10 },
{ pincode: 382324, min_days: 7, max_days: 10 },
{ pincode: 382325, min_days: 7, max_days: 10 },
{ pincode: 382327, min_days: 7, max_days: 10 },
{ pincode: 382330, min_days: 7, max_days: 10 },
{ pincode: 382333, min_days: 7, max_days: 10 },
{ pincode: 382334, min_days: 7, max_days: 10 },
{ pincode: 382340, min_days: 7, max_days: 10 },
{ pincode: 382345, min_days: 7, max_days: 10 },
{ pincode: 382346, min_days: 7, max_days: 10 },
{ pincode: 382350, min_days: 7, max_days: 10 },
{ pincode: 382352, min_days: 7, max_days: 10 },
{ pincode: 382355, min_days: 7, max_days: 10 },
{ pincode: 382360, min_days: 7, max_days: 10 },
{ pincode: 382404, min_days: 7, max_days: 10 },
{ pincode: 382405, min_days: 7, max_days: 10 },
{ pincode: 382410, min_days: 7, max_days: 10 },
{ pincode: 382415, min_days: 7, max_days: 10 },
{ pincode: 382418, min_days: 7, max_days: 10 },
{ pincode: 382420, min_days: 7, max_days: 10 },
{ pincode: 382421, min_days: 7, max_days: 10 },
{ pincode: 382422, min_days: 7, max_days: 10 },
{ pincode: 382423, min_days: 7, max_days: 10 },
{ pincode: 382424, min_days: 7, max_days: 10 },
{ pincode: 382425, min_days: 7, max_days: 10 },
{ pincode: 382426, min_days: 7, max_days: 10 },
{ pincode: 382427, min_days: 7, max_days: 10 },
{ pincode: 382428, min_days: 7, max_days: 10 },
{ pincode: 382430, min_days: 7, max_days: 10 },
{ pincode: 382431, min_days: 7, max_days: 10 },
{ pincode: 382433, min_days: 7, max_days: 10 },
{ pincode: 382434, min_days: 7, max_days: 10 },
{ pincode: 382435, min_days: 7, max_days: 10 },
{ pincode: 382440, min_days: 7, max_days: 10 },
{ pincode: 382442, min_days: 7, max_days: 10 },
{ pincode: 382443, min_days: 7, max_days: 10 },
{ pincode: 382445, min_days: 7, max_days: 10 },
{ pincode: 382449, min_days: 7, max_days: 10 },
{ pincode: 382451, min_days: 7, max_days: 10 },
{ pincode: 382470, min_days: 7, max_days: 10 },
{ pincode: 382475, min_days: 7, max_days: 10 },
{ pincode: 382480, min_days: 7, max_days: 10 },
{ pincode: 382481, min_days: 7, max_days: 10 },
{ pincode: 382610, min_days: 7, max_days: 10 },
{ pincode: 382620, min_days: 7, max_days: 10 },
{ pincode: 382625, min_days: 7, max_days: 10 },
{ pincode: 382630, min_days: 7, max_days: 10 },
{ pincode: 382640, min_days: 7, max_days: 10 },
{ pincode: 382644, min_days: 7, max_days: 10 },
{ pincode: 382650, min_days: 7, max_days: 10 },
{ pincode: 382655, min_days: 7, max_days: 10 },
{ pincode: 382705, min_days: 7, max_days: 10 },
{ pincode: 382715, min_days: 7, max_days: 10 },
{ pincode: 382721, min_days: 7, max_days: 10 },
{ pincode: 382722, min_days: 7, max_days: 10 },
{ pincode: 382723, min_days: 7, max_days: 10 },
{ pincode: 382724, min_days: 7, max_days: 10 },
{ pincode: 382725, min_days: 7, max_days: 10 },
{ pincode: 382727, min_days: 7, max_days: 10 },
{ pincode: 382728, min_days: 7, max_days: 10 },
{ pincode: 382729, min_days: 7, max_days: 10 },
{ pincode: 382730, min_days: 7, max_days: 10 },
{ pincode: 382732, min_days: 7, max_days: 10 },
{ pincode: 382735, min_days: 7, max_days: 10 },
{ pincode: 382740, min_days: 7, max_days: 10 },
{ pincode: 382805, min_days: 7, max_days: 10 },
{ pincode: 382806, min_days: 7, max_days: 10 },
{ pincode: 382812, min_days: 7, max_days: 10 },
{ pincode: 382816, min_days: 7, max_days: 10 },
{ pincode: 382823, min_days: 7, max_days: 10 },
{ pincode: 382825, min_days: 7, max_days: 10 },
{ pincode: 382826, min_days: 7, max_days: 10 },
{ pincode: 382832, min_days: 7, max_days: 10 },
{ pincode: 382833, min_days: 7, max_days: 10 },
{ pincode: 382835, min_days: 7, max_days: 10 },
{ pincode: 382836, min_days: 7, max_days: 10 },
{ pincode: 382845, min_days: 7, max_days: 10 },
{ pincode: 382851, min_days: 7, max_days: 10 },
{ pincode: 382856, min_days: 7, max_days: 10 },
{ pincode: 382857, min_days: 7, max_days: 10 },
{ pincode: 382862, min_days: 7, max_days: 10 },
{ pincode: 382863, min_days: 7, max_days: 10 },
{ pincode: 382865, min_days: 7, max_days: 10 },
{ pincode: 382868, min_days: 7, max_days: 10 },
{ pincode: 382870, min_days: 7, max_days: 10 },
{ pincode: 383001, min_days: 7, max_days: 10 },
{ pincode: 383415, min_days: 7, max_days: 10 },
{ pincode: 383430, min_days: 7, max_days: 10 },
{ pincode: 384001, min_days: 7, max_days: 10 },
{ pincode: 384002, min_days: 7, max_days: 10 },
{ pincode: 384003, min_days: 7, max_days: 10 },
{ pincode: 384151, min_days: 7, max_days: 10 },
{ pincode: 384170, min_days: 7, max_days: 10 },
{ pincode: 384215, min_days: 7, max_days: 10 },
{ pincode: 384435, min_days: 7, max_days: 10 },
{ pincode: 385001, min_days: 7, max_days: 10 },
{ pincode: 385210, min_days: 7, max_days: 10 },
{ pincode: 385520, min_days: 7, max_days: 10 },
{ pincode: 387001, min_days: 7, max_days: 10 },
{ pincode: 387002, min_days: 7, max_days: 10 },
{ pincode: 387100, min_days: 7, max_days: 10 },
{ pincode: 387110, min_days: 7, max_days: 10 },
{ pincode: 387113, min_days: 7, max_days: 10 },
{ pincode: 387120, min_days: 7, max_days: 10 },
{ pincode: 387130, min_days: 7, max_days: 10 },
{ pincode: 387135, min_days: 7, max_days: 10 },
{ pincode: 387140, min_days: 7, max_days: 10 },
{ pincode: 387220, min_days: 7, max_days: 10 },
{ pincode: 387230, min_days: 7, max_days: 10 },
{ pincode: 387310, min_days: 7, max_days: 10 },
{ pincode: 387315, min_days: 7, max_days: 10 },
{ pincode: 387320, min_days: 7, max_days: 10 },
{ pincode: 387325, min_days: 7, max_days: 10 },
{ pincode: 387331, min_days: 7, max_days: 10 },
{ pincode: 387345, min_days: 7, max_days: 10 },
{ pincode: 387350, min_days: 7, max_days: 10 },
{ pincode: 387360, min_days: 7, max_days: 10 },
{ pincode: 387370, min_days: 7, max_days: 10 },
{ pincode: 387375, min_days: 7, max_days: 10 },
{ pincode: 387380, min_days: 7, max_days: 10 },
{ pincode: 387382, min_days: 7, max_days: 10 },
{ pincode: 387385, min_days: 7, max_days: 10 },
{ pincode: 387411, min_days: 7, max_days: 10 },
{ pincode: 387420, min_days: 7, max_days: 10 },
{ pincode: 387421, min_days: 7, max_days: 10 },
{ pincode: 387430, min_days: 7, max_days: 10 },
{ pincode: 387435, min_days: 7, max_days: 10 },
{ pincode: 387450, min_days: 7, max_days: 10 },
{ pincode: 387510, min_days: 7, max_days: 10 },
{ pincode: 387520, min_days: 7, max_days: 10 },
{ pincode: 387530, min_days: 7, max_days: 10 },
{ pincode: 387531, min_days: 7, max_days: 10 },
{ pincode: 387540, min_days: 7, max_days: 10 },
{ pincode: 387550, min_days: 7, max_days: 10 },
{ pincode: 387560, min_days: 7, max_days: 10 },
{ pincode: 387570, min_days: 7, max_days: 10 },
{ pincode: 387710, min_days: 7, max_days: 10 },
{ pincode: 387810, min_days: 7, max_days: 10 },
{ pincode: 388000, min_days: 7, max_days: 10 },
{ pincode: 388001, min_days: 7, max_days: 10 },
{ pincode: 388002, min_days: 7, max_days: 10 },
{ pincode: 388003, min_days: 7, max_days: 10 },
{ pincode: 388005, min_days: 7, max_days: 10 },
{ pincode: 388006, min_days: 7, max_days: 10 },
{ pincode: 388007, min_days: 7, max_days: 10 },
{ pincode: 388008, min_days: 7, max_days: 10 },
{ pincode: 388009, min_days: 7, max_days: 10 },
{ pincode: 388110, min_days: 7, max_days: 10 },
{ pincode: 388120, min_days: 7, max_days: 10 },
{ pincode: 388121, min_days: 7, max_days: 10 },
{ pincode: 388122, min_days: 7, max_days: 10 },
{ pincode: 388124, min_days: 7, max_days: 10 },
{ pincode: 388130, min_days: 7, max_days: 10 },
{ pincode: 388131, min_days: 7, max_days: 10 },
{ pincode: 388132, min_days: 7, max_days: 10 },
{ pincode: 388140, min_days: 7, max_days: 10 },
{ pincode: 388201, min_days: 7, max_days: 10 },
{ pincode: 388205, min_days: 7, max_days: 10 },
{ pincode: 388210, min_days: 7, max_days: 10 },
{ pincode: 388225, min_days: 7, max_days: 10 },
{ pincode: 388305, min_days: 7, max_days: 10 },
{ pincode: 388306, min_days: 7, max_days: 10 },
{ pincode: 388307, min_days: 7, max_days: 10 },
{ pincode: 388308, min_days: 7, max_days: 10 },
{ pincode: 388310, min_days: 7, max_days: 10 },
{ pincode: 388315, min_days: 7, max_days: 10 },
{ pincode: 388320, min_days: 7, max_days: 10 },
{ pincode: 388325, min_days: 7, max_days: 10 },
{ pincode: 388330, min_days: 7, max_days: 10 },
{ pincode: 388335, min_days: 7, max_days: 10 },
{ pincode: 388336, min_days: 7, max_days: 10 },
{ pincode: 388340, min_days: 7, max_days: 10 },
{ pincode: 388345, min_days: 7, max_days: 10 },
{ pincode: 388350, min_days: 7, max_days: 10 },
{ pincode: 388355, min_days: 7, max_days: 10 },
{ pincode: 388360, min_days: 7, max_days: 10 },
{ pincode: 388361, min_days: 7, max_days: 10 },
{ pincode: 388365, min_days: 7, max_days: 10 },
{ pincode: 388370, min_days: 7, max_days: 10 },
{ pincode: 388421, min_days: 7, max_days: 10 },
{ pincode: 388440, min_days: 7, max_days: 10 },
{ pincode: 388450, min_days: 7, max_days: 10 },
{ pincode: 388470, min_days: 7, max_days: 10 },
{ pincode: 388480, min_days: 7, max_days: 10 },
{ pincode: 388510, min_days: 7, max_days: 10 },
{ pincode: 388520, min_days: 7, max_days: 10 },
{ pincode: 388530, min_days: 7, max_days: 10 },
{ pincode: 388540, min_days: 7, max_days: 10 },
{ pincode: 388543, min_days: 7, max_days: 10 },
{ pincode: 388545, min_days: 7, max_days: 10 },
{ pincode: 388560, min_days: 7, max_days: 10 },
{ pincode: 388570, min_days: 7, max_days: 10 },
{ pincode: 388590, min_days: 7, max_days: 10 },
{ pincode: 389310, min_days: 7, max_days: 10 },
{ pincode: 389320, min_days: 7, max_days: 10 },
{ pincode: 389330, min_days: 7, max_days: 10 },
{ pincode: 389340, min_days: 7, max_days: 10 },
{ pincode: 389350, min_days: 7, max_days: 10 },
{ pincode: 389360, min_days: 7, max_days: 10 },
{ pincode: 389365, min_days: 7, max_days: 10 },
{ pincode: 389370, min_days: 7, max_days: 10 },
{ pincode: 389390, min_days: 7, max_days: 10 },
{ pincode: 390000, min_days: 7, max_days: 10 },
{ pincode: 390001, min_days: 7, max_days: 10 },
{ pincode: 390002, min_days: 7, max_days: 10 },
{ pincode: 390003, min_days: 7, max_days: 10 },
{ pincode: 390004, min_days: 7, max_days: 10 },
{ pincode: 390005, min_days: 7, max_days: 10 },
{ pincode: 390006, min_days: 7, max_days: 10 },
{ pincode: 390007, min_days: 7, max_days: 10 },
{ pincode: 390008, min_days: 7, max_days: 10 },
{ pincode: 390009, min_days: 7, max_days: 10 },
{ pincode: 390010, min_days: 7, max_days: 10 },
{ pincode: 390011, min_days: 7, max_days: 10 },
{ pincode: 390012, min_days: 7, max_days: 10 },
{ pincode: 390013, min_days: 7, max_days: 10 },
{ pincode: 390014, min_days: 7, max_days: 10 },
{ pincode: 390015, min_days: 7, max_days: 10 },
{ pincode: 390016, min_days: 7, max_days: 10 },
{ pincode: 390017, min_days: 7, max_days: 10 },
{ pincode: 390018, min_days: 7, max_days: 10 },
{ pincode: 390019, min_days: 7, max_days: 10 },
{ pincode: 390020, min_days: 7, max_days: 10 },
{ pincode: 390021, min_days: 7, max_days: 10 },
{ pincode: 390022, min_days: 7, max_days: 10 },
{ pincode: 390023, min_days: 7, max_days: 10 },
{ pincode: 390024, min_days: 7, max_days: 10 },
{ pincode: 390025, min_days: 7, max_days: 10 },
{ pincode: 390026, min_days: 7, max_days: 10 },
{ pincode: 391101, min_days: 7, max_days: 10 },
{ pincode: 391105, min_days: 7, max_days: 10 },
{ pincode: 391107, min_days: 7, max_days: 10 },
{ pincode: 391110, min_days: 7, max_days: 10 },
{ pincode: 391111, min_days: 7, max_days: 10 },
{ pincode: 391112, min_days: 7, max_days: 10 },
{ pincode: 391115, min_days: 7, max_days: 10 },
{ pincode: 391120, min_days: 7, max_days: 10 },
{ pincode: 391125, min_days: 7, max_days: 10 },
{ pincode: 391126, min_days: 7, max_days: 10 },
{ pincode: 391130, min_days: 7, max_days: 10 },
{ pincode: 391134, min_days: 7, max_days: 10 },
{ pincode: 391145, min_days: 7, max_days: 10 },
{ pincode: 391151, min_days: 7, max_days: 10 },
{ pincode: 391210, min_days: 7, max_days: 10 },
{ pincode: 391220, min_days: 7, max_days: 10 },
{ pincode: 391230, min_days: 7, max_days: 10 },
{ pincode: 391240, min_days: 7, max_days: 10 },
{ pincode: 391243, min_days: 7, max_days: 10 },
{ pincode: 391244, min_days: 7, max_days: 10 },
{ pincode: 391250, min_days: 7, max_days: 10 },
{ pincode: 391310, min_days: 7, max_days: 10 },
{ pincode: 391320, min_days: 7, max_days: 10 },
{ pincode: 391330, min_days: 7, max_days: 10 },
{ pincode: 391340, min_days: 7, max_days: 10 },
{ pincode: 391345, min_days: 7, max_days: 10 },
{ pincode: 391346, min_days: 7, max_days: 10 },
{ pincode: 391347, min_days: 7, max_days: 10 },
{ pincode: 391350, min_days: 7, max_days: 10 },
{ pincode: 391351, min_days: 7, max_days: 10 },
{ pincode: 391352, min_days: 7, max_days: 10 },
{ pincode: 391353, min_days: 7, max_days: 10 },
{ pincode: 391354, min_days: 7, max_days: 10 },
{ pincode: 391410, min_days: 7, max_days: 10 },
{ pincode: 391411, min_days: 7, max_days: 10 },
{ pincode: 391421, min_days: 7, max_days: 10 },
{ pincode: 391430, min_days: 7, max_days: 10 },
{ pincode: 391431, min_days: 7, max_days: 10 },
{ pincode: 391440, min_days: 7, max_days: 10 },
{ pincode: 391445, min_days: 7, max_days: 10 },
{ pincode: 391450, min_days: 7, max_days: 10 },
{ pincode: 391460, min_days: 7, max_days: 10 },
{ pincode: 391461, min_days: 7, max_days: 10 },
{ pincode: 391510, min_days: 7, max_days: 10 },
{ pincode: 391520, min_days: 7, max_days: 10 },
{ pincode: 391530, min_days: 7, max_days: 10 },
{ pincode: 391535, min_days: 7, max_days: 10 },
{ pincode: 391740, min_days: 7, max_days: 10 },
{ pincode: 391742, min_days: 7, max_days: 10 },
{ pincode: 391745, min_days: 7, max_days: 10 },
{ pincode: 391750, min_days: 7, max_days: 10 },
{ pincode: 391759, min_days: 7, max_days: 10 },
{ pincode: 391760, min_days: 7, max_days: 10 },
{ pincode: 391761, min_days: 7, max_days: 10 },
{ pincode: 391765, min_days: 7, max_days: 10 },
{ pincode: 391766, min_days: 7, max_days: 10 },
{ pincode: 391770, min_days: 7, max_days: 10 },
{ pincode: 391774, min_days: 7, max_days: 10 },
{ pincode: 391775, min_days: 7, max_days: 10 },
{ pincode: 391780, min_days: 7, max_days: 10 },
{ pincode: 392001, min_days: 7, max_days: 10 },
{ pincode: 392002, min_days: 7, max_days: 10 },
{ pincode: 392011, min_days: 7, max_days: 10 },
{ pincode: 392012, min_days: 7, max_days: 10 },
{ pincode: 392014, min_days: 7, max_days: 10 },
{ pincode: 392015, min_days: 7, max_days: 10 },
{ pincode: 392020, min_days: 7, max_days: 10 },
{ pincode: 392021, min_days: 7, max_days: 10 },
{ pincode: 392025, min_days: 7, max_days: 10 },
{ pincode: 392027, min_days: 7, max_days: 10 },
{ pincode: 392030, min_days: 7, max_days: 10 },
{ pincode: 392031, min_days: 7, max_days: 10 },
{ pincode: 392035, min_days: 7, max_days: 10 },
{ pincode: 392110, min_days: 7, max_days: 10 },
{ pincode: 392130, min_days: 7, max_days: 10 },
{ pincode: 392140, min_days: 7, max_days: 10 },
{ pincode: 392150, min_days: 7, max_days: 10 },
{ pincode: 392160, min_days: 7, max_days: 10 },
{ pincode: 392161, min_days: 7, max_days: 10 },
{ pincode: 392162, min_days: 7, max_days: 10 },
{ pincode: 392165, min_days: 7, max_days: 10 },
{ pincode: 392210, min_days: 7, max_days: 10 },
{ pincode: 392218, min_days: 7, max_days: 10 },
{ pincode: 392220, min_days: 7, max_days: 10 },
{ pincode: 392221, min_days: 7, max_days: 10 },
{ pincode: 392230, min_days: 7, max_days: 10 },
{ pincode: 392240, min_days: 7, max_days: 10 },
{ pincode: 392243, min_days: 7, max_days: 10 },
{ pincode: 392310, min_days: 7, max_days: 10 },
{ pincode: 393001, min_days: 7, max_days: 10 },
{ pincode: 393002, min_days: 7, max_days: 10 },
{ pincode: 393003, min_days: 7, max_days: 10 },
{ pincode: 393004, min_days: 7, max_days: 10 },
{ pincode: 393005, min_days: 7, max_days: 10 },
{ pincode: 393006, min_days: 7, max_days: 10 },
{ pincode: 393008, min_days: 7, max_days: 10 },
{ pincode: 393010, min_days: 7, max_days: 10 },
{ pincode: 393016, min_days: 7, max_days: 10 },
{ pincode: 393017, min_days: 7, max_days: 10 },
{ pincode: 393020, min_days: 7, max_days: 10 },
{ pincode: 393028, min_days: 7, max_days: 10 },
{ pincode: 393030, min_days: 7, max_days: 10 },
{ pincode: 393035, min_days: 7, max_days: 10 },
{ pincode: 393105, min_days: 7, max_days: 10 },
{ pincode: 393110, min_days: 7, max_days: 10 },
{ pincode: 393111, min_days: 7, max_days: 10 },
{ pincode: 393115, min_days: 7, max_days: 10 },
{ pincode: 393120, min_days: 7, max_days: 10 },
{ pincode: 393125, min_days: 7, max_days: 10 },
{ pincode: 393130, min_days: 7, max_days: 10 },
{ pincode: 393131, min_days: 7, max_days: 10 },
{ pincode: 393133, min_days: 7, max_days: 10 },
{ pincode: 393135, min_days: 7, max_days: 10 },
{ pincode: 393140, min_days: 7, max_days: 10 },
{ pincode: 393145, min_days: 7, max_days: 10 },
{ pincode: 394010, min_days: 7, max_days: 10 },
{ pincode: 394101, min_days: 7, max_days: 10 },
{ pincode: 394104, min_days: 7, max_days: 10 },
{ pincode: 394105, min_days: 7, max_days: 10 },
{ pincode: 394107, min_days: 7, max_days: 10 },
{ pincode: 394110, min_days: 7, max_days: 10 },
{ pincode: 394111, min_days: 7, max_days: 10 },
{ pincode: 394112, min_days: 7, max_days: 10 },
{ pincode: 394115, min_days: 7, max_days: 10 },
{ pincode: 394116, min_days: 7, max_days: 10 },
{ pincode: 394120, min_days: 7, max_days: 10 },
{ pincode: 394125, min_days: 7, max_days: 10 },
{ pincode: 394130, min_days: 7, max_days: 10 },
{ pincode: 394140, min_days: 7, max_days: 10 },
{ pincode: 394145, min_days: 7, max_days: 10 },
{ pincode: 394150, min_days: 7, max_days: 10 },
{ pincode: 394155, min_days: 7, max_days: 10 },
{ pincode: 394163, min_days: 7, max_days: 10 },
{ pincode: 394170, min_days: 7, max_days: 10 },
{ pincode: 394180, min_days: 7, max_days: 10 },
{ pincode: 394181, min_days: 7, max_days: 10 },
{ pincode: 394183, min_days: 7, max_days: 10 },
{ pincode: 394184, min_days: 7, max_days: 10 },
{ pincode: 394185, min_days: 7, max_days: 10 },
{ pincode: 394190, min_days: 7, max_days: 10 },
{ pincode: 394210, min_days: 7, max_days: 10 },
{ pincode: 394211, min_days: 7, max_days: 10 },
{ pincode: 394212, min_days: 7, max_days: 10 },
{ pincode: 394220, min_days: 7, max_days: 10 },
{ pincode: 394221, min_days: 7, max_days: 10 },
{ pincode: 394229, min_days: 7, max_days: 10 },
{ pincode: 394230, min_days: 7, max_days: 10 },
{ pincode: 394235, min_days: 7, max_days: 10 },
{ pincode: 394238, min_days: 7, max_days: 10 },
{ pincode: 394240, min_days: 7, max_days: 10 },
{ pincode: 394243, min_days: 7, max_days: 10 },
{ pincode: 394244, min_days: 7, max_days: 10 },
{ pincode: 394245, min_days: 7, max_days: 10 },
{ pincode: 394246, min_days: 7, max_days: 10 },
{ pincode: 394248, min_days: 7, max_days: 10 },
{ pincode: 394250, min_days: 7, max_days: 10 },
{ pincode: 394270, min_days: 7, max_days: 10 },
{ pincode: 394305, min_days: 7, max_days: 10 },
{ pincode: 394306, min_days: 7, max_days: 10 },
{ pincode: 394310, min_days: 7, max_days: 10 },
{ pincode: 394315, min_days: 7, max_days: 10 },
{ pincode: 394317, min_days: 7, max_days: 10 },
{ pincode: 394320, min_days: 7, max_days: 10 },
{ pincode: 394324, min_days: 7, max_days: 10 },
{ pincode: 394325, min_days: 7, max_days: 10 },
{ pincode: 394326, min_days: 7, max_days: 10 },
{ pincode: 394327, min_days: 7, max_days: 10 },
{ pincode: 394330, min_days: 7, max_days: 10 },
{ pincode: 394335, min_days: 7, max_days: 10 },
{ pincode: 394340, min_days: 7, max_days: 10 },
{ pincode: 394345, min_days: 7, max_days: 10 },
{ pincode: 394350, min_days: 7, max_days: 10 },
{ pincode: 394352, min_days: 7, max_days: 10 },
{ pincode: 394355, min_days: 7, max_days: 10 },
{ pincode: 394405, min_days: 7, max_days: 10 },
{ pincode: 394410, min_days: 7, max_days: 10 },
{ pincode: 394421, min_days: 7, max_days: 10 },
{ pincode: 394430, min_days: 7, max_days: 10 },
{ pincode: 394510, min_days: 7, max_days: 10 },
{ pincode: 394515, min_days: 7, max_days: 10 },
{ pincode: 394516, min_days: 7, max_days: 10 },
{ pincode: 394517, min_days: 7, max_days: 10 },
{ pincode: 394518, min_days: 7, max_days: 10 },
{ pincode: 394520, min_days: 7, max_days: 10 },
{ pincode: 394530, min_days: 7, max_days: 10 },
{ pincode: 394540, min_days: 7, max_days: 10 },
{ pincode: 394550, min_days: 7, max_days: 10 },
{ pincode: 394601, min_days: 7, max_days: 10 },
{ pincode: 394608, min_days: 7, max_days: 10 },
{ pincode: 394620, min_days: 7, max_days: 10 },
{ pincode: 394630, min_days: 7, max_days: 10 },
{ pincode: 394633, min_days: 7, max_days: 10 },
{ pincode: 394640, min_days: 7, max_days: 10 },
{ pincode: 394641, min_days: 7, max_days: 10 },
{ pincode: 394650, min_days: 7, max_days: 10 },
{ pincode: 394651, min_days: 7, max_days: 10 },
{ pincode: 394690, min_days: 7, max_days: 10 },
{ pincode: 394810, min_days: 7, max_days: 10 },
{ pincode: 395000, min_days: 7, max_days: 10 },
{ pincode: 395001, min_days: 7, max_days: 10 },
{ pincode: 395002, min_days: 7, max_days: 10 },
{ pincode: 395003, min_days: 7, max_days: 10 },
{ pincode: 395004, min_days: 7, max_days: 10 },
{ pincode: 395005, min_days: 7, max_days: 10 },
{ pincode: 395006, min_days: 7, max_days: 10 },
{ pincode: 395007, min_days: 7, max_days: 10 },
{ pincode: 395008, min_days: 7, max_days: 10 },
{ pincode: 395009, min_days: 7, max_days: 10 },
{ pincode: 395010, min_days: 7, max_days: 10 },
{ pincode: 395011, min_days: 7, max_days: 10 },
{ pincode: 395012, min_days: 7, max_days: 10 },
{ pincode: 395013, min_days: 7, max_days: 10 },
{ pincode: 395017, min_days: 7, max_days: 10 },
{ pincode: 395021, min_days: 7, max_days: 10 },
{ pincode: 395023, min_days: 7, max_days: 10 },
{ pincode: 395163, min_days: 7, max_days: 10 },
{ pincode: 395210, min_days: 7, max_days: 10 },
{ pincode: 395345, min_days: 7, max_days: 10 },
{ pincode: 395375, min_days: 7, max_days: 10 },
{ pincode: 395620, min_days: 7, max_days: 10 },
{ pincode: 395650, min_days: 7, max_days: 10 },
{ pincode: 396001, min_days: 7, max_days: 10 },
{ pincode: 396002, min_days: 7, max_days: 10 },
{ pincode: 396003, min_days: 7, max_days: 10 },
{ pincode: 396005, min_days: 7, max_days: 10 },
{ pincode: 396006, min_days: 7, max_days: 10 },
{ pincode: 396007, min_days: 7, max_days: 10 },
{ pincode: 396008, min_days: 7, max_days: 10 },
{ pincode: 396009, min_days: 7, max_days: 10 },
{ pincode: 396020, min_days: 7, max_days: 10 },
{ pincode: 396023, min_days: 7, max_days: 10 },
{ pincode: 396025, min_days: 7, max_days: 10 },
{ pincode: 396030, min_days: 7, max_days: 10 },
{ pincode: 396031, min_days: 7, max_days: 10 },
{ pincode: 396035, min_days: 7, max_days: 10 },
{ pincode: 396040, min_days: 7, max_days: 10 },
{ pincode: 396041, min_days: 7, max_days: 10 },
{ pincode: 396042, min_days: 7, max_days: 10 },
{ pincode: 396045, min_days: 7, max_days: 10 },
{ pincode: 396050, min_days: 7, max_days: 10 },
{ pincode: 396051, min_days: 7, max_days: 10 },
{ pincode: 396055, min_days: 7, max_days: 10 },
{ pincode: 396065, min_days: 7, max_days: 10 },
{ pincode: 396105, min_days: 7, max_days: 10 },
{ pincode: 396106, min_days: 7, max_days: 10 },
{ pincode: 396107, min_days: 7, max_days: 10 },
{ pincode: 396108, min_days: 7, max_days: 10 },
{ pincode: 396110, min_days: 7, max_days: 10 },
{ pincode: 396112, min_days: 7, max_days: 10 },
{ pincode: 396115, min_days: 7, max_days: 10 },
{ pincode: 396120, min_days: 7, max_days: 10 },
{ pincode: 396121, min_days: 7, max_days: 10 },
{ pincode: 396125, min_days: 7, max_days: 10 },
{ pincode: 396126, min_days: 7, max_days: 10 },
{ pincode: 396130, min_days: 7, max_days: 10 },
{ pincode: 396135, min_days: 7, max_days: 10 },
{ pincode: 396140, min_days: 7, max_days: 10 },
{ pincode: 396142, min_days: 7, max_days: 10 },
{ pincode: 396145, min_days: 7, max_days: 10 },
{ pincode: 396150, min_days: 7, max_days: 10 },
{ pincode: 396152, min_days: 7, max_days: 10 },
{ pincode: 396155, min_days: 7, max_days: 10 },
{ pincode: 396156, min_days: 7, max_days: 10 },
{ pincode: 396165, min_days: 7, max_days: 10 },
{ pincode: 396170, min_days: 7, max_days: 10 },
{ pincode: 396171, min_days: 7, max_days: 10 },
{ pincode: 396172, min_days: 7, max_days: 10 },
{ pincode: 396175, min_days: 7, max_days: 10 },
{ pincode: 396180, min_days: 7, max_days: 10 },
{ pincode: 396185, min_days: 7, max_days: 10 },
{ pincode: 396191, min_days: 7, max_days: 10 },
{ pincode: 396193, min_days: 7, max_days: 10 },
{ pincode: 396194, min_days: 7, max_days: 10 },
{ pincode: 396195, min_days: 7, max_days: 10 },
{ pincode: 396196, min_days: 7, max_days: 10 },
{ pincode: 396197, min_days: 7, max_days: 10 },
{ pincode: 396200, min_days: 7, max_days: 10 },
{ pincode: 396201, min_days: 7, max_days: 10 },
{ pincode: 396202, min_days: 7, max_days: 10 },
{ pincode: 396209, min_days: 7, max_days: 10 },
{ pincode: 396210, min_days: 7, max_days: 10 },
{ pincode: 396211, min_days: 7, max_days: 10 },
{ pincode: 396215, min_days: 7, max_days: 10 },
{ pincode: 396217, min_days: 7, max_days: 10 },
{ pincode: 396220, min_days: 7, max_days: 10 },
{ pincode: 396223, min_days: 7, max_days: 10 },
{ pincode: 396230, min_days: 7, max_days: 10 },
{ pincode: 396231, min_days: 7, max_days: 10 },
{ pincode: 396235, min_days: 7, max_days: 10 },
{ pincode: 396236, min_days: 7, max_days: 10 },
{ pincode: 396238, min_days: 7, max_days: 10 },
{ pincode: 396240, min_days: 7, max_days: 10 },
{ pincode: 396245, min_days: 7, max_days: 10 },
{ pincode: 396310, min_days: 7, max_days: 10 },
{ pincode: 396321, min_days: 7, max_days: 10 },
{ pincode: 396325, min_days: 7, max_days: 10 },
{ pincode: 396350, min_days: 7, max_days: 10 },
{ pincode: 396360, min_days: 7, max_days: 10 },
{ pincode: 396370, min_days: 7, max_days: 10 },
{ pincode: 396375, min_days: 7, max_days: 10 },
{ pincode: 396380, min_days: 7, max_days: 10 },
{ pincode: 396385, min_days: 7, max_days: 10 },
{ pincode: 396403, min_days: 7, max_days: 10 },
{ pincode: 396406, min_days: 7, max_days: 10 },
{ pincode: 396409, min_days: 7, max_days: 10 },
{ pincode: 396412, min_days: 7, max_days: 10 },
{ pincode: 396415, min_days: 7, max_days: 10 },
{ pincode: 396418, min_days: 7, max_days: 10 },
{ pincode: 396421, min_days: 7, max_days: 10 },
{ pincode: 396424, min_days: 7, max_days: 10 },
{ pincode: 396427, min_days: 7, max_days: 10 },
{ pincode: 396430, min_days: 7, max_days: 10 },
{ pincode: 396433, min_days: 7, max_days: 10 },
{ pincode: 396436, min_days: 7, max_days: 10 },
{ pincode: 396439, min_days: 7, max_days: 10 },
{ pincode: 396440, min_days: 7, max_days: 10 },
{ pincode: 396445, min_days: 7, max_days: 10 },
{ pincode: 396450, min_days: 7, max_days: 10 },
{ pincode: 396460, min_days: 7, max_days: 10 },
{ pincode: 396463, min_days: 7, max_days: 10 },
{ pincode: 396466, min_days: 7, max_days: 10 },
{ pincode: 396469, min_days: 7, max_days: 10 },
{ pincode: 396472, min_days: 7, max_days: 10 },
{ pincode: 396475, min_days: 7, max_days: 10 },
{ pincode: 396521, min_days: 7, max_days: 10 },
{ pincode: 396530, min_days: 7, max_days: 10 },
{ pincode: 396560, min_days: 7, max_days: 10 },
{ pincode: 396570, min_days: 7, max_days: 10 },
{ pincode: 398350, min_days: 7, max_days: 10 },
{ pincode: 400000, min_days: 7, max_days: 10 },
{ pincode: 400100, min_days: 7, max_days: 10 },
{ pincode: 400105, min_days: 7, max_days: 10 },
{ pincode: 400107, min_days: 7, max_days: 10 },
{ pincode: 400109, min_days: 7, max_days: 10 },
{ pincode: 400125, min_days: 7, max_days: 10 },
{ pincode: 400202, min_days: 7, max_days: 10 },
{ pincode: 400206, min_days: 7, max_days: 10 },
{ pincode: 400208, min_days: 7, max_days: 10 },
{ pincode: 400218, min_days: 7, max_days: 10 },
{ pincode: 400301, min_days: 7, max_days: 10 },
{ pincode: 400547, min_days: 7, max_days: 10 },
{ pincode: 400611, min_days: 7, max_days: 10 },
{ pincode: 400612, min_days: 7, max_days: 10 },
{ pincode: 400613, min_days: 7, max_days: 10 },
{ pincode: 400700, min_days: 7, max_days: 10 },
{ pincode: 400702, min_days: 7, max_days: 10 },
{ pincode: 400704, min_days: 7, max_days: 10 },
{ pincode: 400707, min_days: 7, max_days: 10 },
{ pincode: 400713, min_days: 7, max_days: 10 },
{ pincode: 400716, min_days: 7, max_days: 10 },
{ pincode: 400901, min_days: 7, max_days: 10 },
{ pincode: 401101, min_days: 7, max_days: 10 },
{ pincode: 401102, min_days: 7, max_days: 10 },
{ pincode: 401105, min_days: 7, max_days: 10 },
{ pincode: 401106, min_days: 7, max_days: 10 },
{ pincode: 401200, min_days: 7, max_days: 10 },
{ pincode: 401201, min_days: 7, max_days: 10 },
{ pincode: 401202, min_days: 7, max_days: 10 },
{ pincode: 401203, min_days: 7, max_days: 10 },
{ pincode: 401204, min_days: 7, max_days: 10 },
{ pincode: 401205, min_days: 7, max_days: 10 },
{ pincode: 401206, min_days: 7, max_days: 10 },
{ pincode: 401207, min_days: 7, max_days: 10 },
{ pincode: 401208, min_days: 7, max_days: 10 },
{ pincode: 401209, min_days: 7, max_days: 10 },
{ pincode: 401210, min_days: 7, max_days: 10 },
{ pincode: 401211, min_days: 7, max_days: 10 },
{ pincode: 401212, min_days: 7, max_days: 10 },
{ pincode: 401214, min_days: 7, max_days: 10 },
{ pincode: 401301, min_days: 7, max_days: 10 },
{ pincode: 401302, min_days: 7, max_days: 10 },
{ pincode: 401303, min_days: 7, max_days: 10 },
{ pincode: 401304, min_days: 7, max_days: 10 },
{ pincode: 401305, min_days: 7, max_days: 10 },
{ pincode: 401401, min_days: 7, max_days: 10 },
{ pincode: 401402, min_days: 7, max_days: 10 },
{ pincode: 401403, min_days: 7, max_days: 10 },
{ pincode: 401404, min_days: 7, max_days: 10 },
{ pincode: 401405, min_days: 7, max_days: 10 },
{ pincode: 401501, min_days: 7, max_days: 10 },
{ pincode: 401502, min_days: 7, max_days: 10 },
{ pincode: 401504, min_days: 7, max_days: 10 },
{ pincode: 401505, min_days: 7, max_days: 10 },
{ pincode: 401506, min_days: 7, max_days: 10 },
{ pincode: 401601, min_days: 7, max_days: 10 },
{ pincode: 401604, min_days: 7, max_days: 10 },
{ pincode: 401605, min_days: 7, max_days: 10 },
{ pincode: 401606, min_days: 7, max_days: 10 },
{ pincode: 401616, min_days: 7, max_days: 10 },
{ pincode: 401706, min_days: 7, max_days: 10 },
{ pincode: 401709, min_days: 7, max_days: 10 },
{ pincode: 402107, min_days: 7, max_days: 10 },
{ pincode: 402120, min_days: 7, max_days: 10 },
{ pincode: 402201, min_days: 7, max_days: 10 },
{ pincode: 402207, min_days: 7, max_days: 10 },
{ pincode: 402208, min_days: 7, max_days: 10 },
{ pincode: 402209, min_days: 7, max_days: 10 },
{ pincode: 402308, min_days: 7, max_days: 10 },
{ pincode: 403000, min_days: 7, max_days: 10 },
{ pincode: 403001, min_days: 7, max_days: 10 },
{ pincode: 403002, min_days: 7, max_days: 10 },
{ pincode: 403003, min_days: 7, max_days: 10 },
{ pincode: 403004, min_days: 7, max_days: 10 },
{ pincode: 403005, min_days: 7, max_days: 10 },
{ pincode: 403006, min_days: 7, max_days: 10 },
{ pincode: 403007, min_days: 7, max_days: 10 },
{ pincode: 403008, min_days: 7, max_days: 10 },
{ pincode: 403100, min_days: 7, max_days: 10 },
{ pincode: 403101, min_days: 7, max_days: 10 },
{ pincode: 403102, min_days: 7, max_days: 10 },
{ pincode: 403103, min_days: 7, max_days: 10 },
{ pincode: 403104, min_days: 7, max_days: 10 },
{ pincode: 403105, min_days: 7, max_days: 10 },
{ pincode: 403106, min_days: 7, max_days: 10 },
{ pincode: 403107, min_days: 7, max_days: 10 },
{ pincode: 403108, min_days: 7, max_days: 10 },
{ pincode: 403109, min_days: 7, max_days: 10 },
{ pincode: 403110, min_days: 7, max_days: 10 },
{ pincode: 403111, min_days: 7, max_days: 10 },
{ pincode: 403112, min_days: 7, max_days: 10 },
{ pincode: 403113, min_days: 7, max_days: 10 },
{ pincode: 403114, min_days: 7, max_days: 10 },
{ pincode: 403115, min_days: 7, max_days: 10 },
{ pincode: 403201, min_days: 7, max_days: 10 },
{ pincode: 403202, min_days: 7, max_days: 10 },
{ pincode: 403203, min_days: 7, max_days: 10 },
{ pincode: 403204, min_days: 7, max_days: 10 },
{ pincode: 403206, min_days: 7, max_days: 10 },
{ pincode: 403401, min_days: 7, max_days: 10 },
{ pincode: 403402, min_days: 7, max_days: 10 },
{ pincode: 403403, min_days: 7, max_days: 10 },
{ pincode: 403404, min_days: 7, max_days: 10 },
{ pincode: 403405, min_days: 7, max_days: 10 },
{ pincode: 403406, min_days: 7, max_days: 10 },
{ pincode: 403407, min_days: 7, max_days: 10 },
{ pincode: 403409, min_days: 7, max_days: 10 },
{ pincode: 403410, min_days: 7, max_days: 10 },
{ pincode: 403412, min_days: 7, max_days: 10 },
{ pincode: 403501, min_days: 7, max_days: 10 },
{ pincode: 403502, min_days: 7, max_days: 10 },
{ pincode: 403503, min_days: 7, max_days: 10 },
{ pincode: 403504, min_days: 7, max_days: 10 },
{ pincode: 403505, min_days: 7, max_days: 10 },
{ pincode: 403506, min_days: 7, max_days: 10 },
{ pincode: 403507, min_days: 7, max_days: 10 },
{ pincode: 403508, min_days: 7, max_days: 10 },
{ pincode: 403509, min_days: 7, max_days: 10 },
{ pincode: 403510, min_days: 7, max_days: 10 },
{ pincode: 403511, min_days: 7, max_days: 10 },
{ pincode: 403512, min_days: 7, max_days: 10 },
{ pincode: 403513, min_days: 7, max_days: 10 },
{ pincode: 403515, min_days: 7, max_days: 10 },
{ pincode: 403516, min_days: 7, max_days: 10 },
{ pincode: 403517, min_days: 7, max_days: 10 },
{ pincode: 403518, min_days: 7, max_days: 10 },
{ pincode: 403519, min_days: 7, max_days: 10 },
{ pincode: 403520, min_days: 7, max_days: 10 },
{ pincode: 403521, min_days: 7, max_days: 10 },
{ pincode: 403523, min_days: 7, max_days: 10 },
{ pincode: 403524, min_days: 7, max_days: 10 },
{ pincode: 403525, min_days: 7, max_days: 10 },
{ pincode: 403526, min_days: 7, max_days: 10 },
{ pincode: 403527, min_days: 7, max_days: 10 },
{ pincode: 403529, min_days: 7, max_days: 10 },
{ pincode: 403530, min_days: 7, max_days: 10 },
{ pincode: 403531, min_days: 7, max_days: 10 },
{ pincode: 403601, min_days: 7, max_days: 10 },
{ pincode: 403602, min_days: 7, max_days: 10 },
{ pincode: 403603, min_days: 7, max_days: 10 },
{ pincode: 403604, min_days: 7, max_days: 10 },
{ pincode: 403605, min_days: 7, max_days: 10 },
{ pincode: 403701, min_days: 7, max_days: 10 },
{ pincode: 403702, min_days: 7, max_days: 10 },
{ pincode: 403703, min_days: 7, max_days: 10 },
{ pincode: 403704, min_days: 7, max_days: 10 },
{ pincode: 403705, min_days: 7, max_days: 10 },
{ pincode: 403706, min_days: 7, max_days: 10 },
{ pincode: 403707, min_days: 7, max_days: 10 },
{ pincode: 403708, min_days: 7, max_days: 10 },
{ pincode: 403709, min_days: 7, max_days: 10 },
{ pincode: 403710, min_days: 7, max_days: 10 },
{ pincode: 403711, min_days: 7, max_days: 10 },
{ pincode: 403712, min_days: 7, max_days: 10 },
{ pincode: 403713, min_days: 7, max_days: 10 },
{ pincode: 403714, min_days: 7, max_days: 10 },
{ pincode: 403715, min_days: 7, max_days: 10 },
{ pincode: 403716, min_days: 7, max_days: 10 },
{ pincode: 403717, min_days: 7, max_days: 10 },
{ pincode: 403718, min_days: 7, max_days: 10 },
{ pincode: 403719, min_days: 7, max_days: 10 },
{ pincode: 403720, min_days: 7, max_days: 10 },
{ pincode: 403721, min_days: 7, max_days: 10 },
{ pincode: 403722, min_days: 7, max_days: 10 },
{ pincode: 403723, min_days: 7, max_days: 10 },
{ pincode: 403724, min_days: 7, max_days: 10 },
{ pincode: 403725, min_days: 7, max_days: 10 },
{ pincode: 403726, min_days: 7, max_days: 10 },
{ pincode: 403727, min_days: 7, max_days: 10 },
{ pincode: 403728, min_days: 7, max_days: 10 },
{ pincode: 403729, min_days: 7, max_days: 10 },
{ pincode: 403730, min_days: 7, max_days: 10 },
{ pincode: 403731, min_days: 7, max_days: 10 },
{ pincode: 403801, min_days: 7, max_days: 10 },
{ pincode: 403802, min_days: 7, max_days: 10 },
{ pincode: 403803, min_days: 7, max_days: 10 },
{ pincode: 403804, min_days: 7, max_days: 10 },
{ pincode: 403806, min_days: 7, max_days: 10 },
{ pincode: 403807, min_days: 7, max_days: 10 },
{ pincode: 403808, min_days: 7, max_days: 10 },
{ pincode: 410038, min_days: 7, max_days: 10 },
{ pincode: 410101, min_days: 7, max_days: 10 },
{ pincode: 410102, min_days: 7, max_days: 10 },
{ pincode: 410201, min_days: 7, max_days: 10 },
{ pincode: 410202, min_days: 7, max_days: 10 },
{ pincode: 410203, min_days: 7, max_days: 10 },
{ pincode: 410204, min_days: 7, max_days: 10 },
{ pincode: 410206, min_days: 7, max_days: 10 },
{ pincode: 410207, min_days: 7, max_days: 10 },
{ pincode: 410208, min_days: 7, max_days: 10 },
{ pincode: 410209, min_days: 7, max_days: 10 },
{ pincode: 410210, min_days: 7, max_days: 10 },
{ pincode: 410211, min_days: 7, max_days: 10 },
{ pincode: 410212, min_days: 7, max_days: 10 },
{ pincode: 410216, min_days: 7, max_days: 10 },
{ pincode: 410217, min_days: 7, max_days: 10 },
{ pincode: 410218, min_days: 7, max_days: 10 },
{ pincode: 410220, min_days: 7, max_days: 10 },
{ pincode: 410221, min_days: 7, max_days: 10 },
{ pincode: 410222, min_days: 7, max_days: 10 },
{ pincode: 410302, min_days: 7, max_days: 10 },
{ pincode: 410318, min_days: 7, max_days: 10 },
{ pincode: 410401, min_days: 7, max_days: 10 },
{ pincode: 410402, min_days: 7, max_days: 10 },
{ pincode: 410403, min_days: 7, max_days: 10 },
{ pincode: 410405, min_days: 7, max_days: 10 },
{ pincode: 410406, min_days: 7, max_days: 10 },
{ pincode: 410407, min_days: 7, max_days: 10 },
{ pincode: 410500, min_days: 7, max_days: 10 },
{ pincode: 410501, min_days: 7, max_days: 10 },
{ pincode: 410503, min_days: 7, max_days: 10 },
{ pincode: 410504, min_days: 7, max_days: 10 },
{ pincode: 410505, min_days: 7, max_days: 10 },
{ pincode: 410506, min_days: 7, max_days: 10 },
{ pincode: 410507, min_days: 7, max_days: 10 },
{ pincode: 410508, min_days: 7, max_days: 10 },
{ pincode: 410510, min_days: 7, max_days: 10 },
{ pincode: 410512, min_days: 7, max_days: 10 },
{ pincode: 410513, min_days: 7, max_days: 10 },
{ pincode: 410515, min_days: 7, max_days: 10 },
{ pincode: 410516, min_days: 7, max_days: 10 },
{ pincode: 410613, min_days: 7, max_days: 10 },
{ pincode: 411000, min_days: 7, max_days: 10 },
{ pincode: 411001, min_days: 7, max_days: 10 },
{ pincode: 411002, min_days: 7, max_days: 10 },
{ pincode: 411003, min_days: 7, max_days: 10 },
{ pincode: 411004, min_days: 7, max_days: 10 },
{ pincode: 411005, min_days: 7, max_days: 10 },
{ pincode: 411006, min_days: 7, max_days: 10 },
{ pincode: 411007, min_days: 7, max_days: 10 },
{ pincode: 411008, min_days: 7, max_days: 10 },
{ pincode: 411009, min_days: 7, max_days: 10 },
{ pincode: 411010, min_days: 7, max_days: 10 },
{ pincode: 411011, min_days: 7, max_days: 10 },
{ pincode: 411012, min_days: 7, max_days: 10 },
{ pincode: 411013, min_days: 7, max_days: 10 },
{ pincode: 411014, min_days: 7, max_days: 10 },
{ pincode: 411015, min_days: 7, max_days: 10 },
{ pincode: 411016, min_days: 7, max_days: 10 },
{ pincode: 411017, min_days: 7, max_days: 10 },
{ pincode: 411018, min_days: 7, max_days: 10 },
{ pincode: 411019, min_days: 7, max_days: 10 },
{ pincode: 411020, min_days: 7, max_days: 10 },
{ pincode: 411021, min_days: 7, max_days: 10 },
{ pincode: 411022, min_days: 7, max_days: 10 },
{ pincode: 411023, min_days: 7, max_days: 10 },
{ pincode: 411024, min_days: 7, max_days: 10 },
{ pincode: 411025, min_days: 7, max_days: 10 },
{ pincode: 411026, min_days: 7, max_days: 10 },
{ pincode: 411027, min_days: 7, max_days: 10 },
{ pincode: 411028, min_days: 7, max_days: 10 },
{ pincode: 411029, min_days: 7, max_days: 10 },
{ pincode: 411030, min_days: 7, max_days: 10 },
{ pincode: 411031, min_days: 7, max_days: 10 },
{ pincode: 411032, min_days: 7, max_days: 10 },
{ pincode: 411033, min_days: 7, max_days: 10 },
{ pincode: 411034, min_days: 7, max_days: 10 },
{ pincode: 411035, min_days: 7, max_days: 10 },
{ pincode: 411036, min_days: 7, max_days: 10 },
{ pincode: 411037, min_days: 7, max_days: 10 },
{ pincode: 411038, min_days: 7, max_days: 10 },
{ pincode: 411039, min_days: 7, max_days: 10 },
{ pincode: 411040, min_days: 7, max_days: 10 },
{ pincode: 411041, min_days: 7, max_days: 10 },
{ pincode: 411042, min_days: 7, max_days: 10 },
{ pincode: 411043, min_days: 7, max_days: 10 },
{ pincode: 411044, min_days: 7, max_days: 10 },
{ pincode: 411045, min_days: 7, max_days: 10 },
{ pincode: 411046, min_days: 7, max_days: 10 },
{ pincode: 411047, min_days: 7, max_days: 10 },
{ pincode: 411048, min_days: 7, max_days: 10 },
{ pincode: 411049, min_days: 7, max_days: 10 },
{ pincode: 411050, min_days: 7, max_days: 10 },
{ pincode: 411051, min_days: 7, max_days: 10 },
{ pincode: 411052, min_days: 7, max_days: 10 },
{ pincode: 411053, min_days: 7, max_days: 10 },
{ pincode: 411054, min_days: 7, max_days: 10 },
{ pincode: 411055, min_days: 7, max_days: 10 },
{ pincode: 411057, min_days: 7, max_days: 10 },
{ pincode: 411058, min_days: 7, max_days: 10 },
{ pincode: 411059, min_days: 7, max_days: 10 },
{ pincode: 411060, min_days: 7, max_days: 10 },
{ pincode: 411061, min_days: 7, max_days: 10 },
{ pincode: 411062, min_days: 7, max_days: 10 },
{ pincode: 411067, min_days: 7, max_days: 10 },
{ pincode: 411068, min_days: 7, max_days: 10 },
{ pincode: 411111, min_days: 7, max_days: 10 },
{ pincode: 411134, min_days: 7, max_days: 10 },
{ pincode: 411230, min_days: 7, max_days: 10 },
{ pincode: 411307, min_days: 7, max_days: 10 },
{ pincode: 411501, min_days: 7, max_days: 10 },
{ pincode: 411505, min_days: 7, max_days: 10 },
{ pincode: 411507, min_days: 7, max_days: 10 },
{ pincode: 412101, min_days: 7, max_days: 10 },
{ pincode: 412102, min_days: 7, max_days: 10 },
{ pincode: 412104, min_days: 7, max_days: 10 },
{ pincode: 412105, min_days: 7, max_days: 10 },
{ pincode: 412106, min_days: 7, max_days: 10 },
{ pincode: 412107, min_days: 7, max_days: 10 },
{ pincode: 412108, min_days: 7, max_days: 10 },
{ pincode: 412109, min_days: 7, max_days: 10 },
{ pincode: 412110, min_days: 7, max_days: 10 },
{ pincode: 412111, min_days: 7, max_days: 10 },
{ pincode: 412112, min_days: 7, max_days: 10 },
{ pincode: 412113, min_days: 7, max_days: 10 },
{ pincode: 412114, min_days: 7, max_days: 10 },
{ pincode: 412115, min_days: 7, max_days: 10 },
{ pincode: 412200, min_days: 7, max_days: 10 },
{ pincode: 412201, min_days: 7, max_days: 10 },
{ pincode: 412202, min_days: 7, max_days: 10 },
{ pincode: 412203, min_days: 7, max_days: 10 },
{ pincode: 412205, min_days: 7, max_days: 10 },
{ pincode: 412206, min_days: 7, max_days: 10 },
{ pincode: 412207, min_days: 7, max_days: 10 },
{ pincode: 412208, min_days: 7, max_days: 10 },
{ pincode: 412209, min_days: 7, max_days: 10 },
{ pincode: 412210, min_days: 7, max_days: 10 },
{ pincode: 412211, min_days: 7, max_days: 10 },
{ pincode: 412212, min_days: 7, max_days: 10 },
{ pincode: 412213, min_days: 7, max_days: 10 },
{ pincode: 412214, min_days: 7, max_days: 10 },
{ pincode: 412216, min_days: 7, max_days: 10 },
{ pincode: 412218, min_days: 7, max_days: 10 },
{ pincode: 412220, min_days: 7, max_days: 10 },
{ pincode: 412221, min_days: 7, max_days: 10 },
{ pincode: 412223, min_days: 7, max_days: 10 },
{ pincode: 412224, min_days: 7, max_days: 10 },
{ pincode: 412225, min_days: 7, max_days: 10 },
{ pincode: 412301, min_days: 7, max_days: 10 },
{ pincode: 412303, min_days: 7, max_days: 10 },
{ pincode: 412307, min_days: 7, max_days: 10 },
{ pincode: 412308, min_days: 7, max_days: 10 },
{ pincode: 412311, min_days: 7, max_days: 10 },
{ pincode: 412402, min_days: 7, max_days: 10 },
{ pincode: 412403, min_days: 7, max_days: 10 },
{ pincode: 412404, min_days: 7, max_days: 10 },
{ pincode: 412405, min_days: 7, max_days: 10 },
{ pincode: 412406, min_days: 7, max_days: 10 },
{ pincode: 412408, min_days: 7, max_days: 10 },
{ pincode: 412801, min_days: 7, max_days: 10 },
{ pincode: 412802, min_days: 7, max_days: 10 },
{ pincode: 413001, min_days: 7, max_days: 10 },
{ pincode: 413002, min_days: 7, max_days: 10 },
{ pincode: 413003, min_days: 7, max_days: 10 },
{ pincode: 413004, min_days: 7, max_days: 10 },
{ pincode: 413005, min_days: 7, max_days: 10 },
{ pincode: 413006, min_days: 7, max_days: 10 },
{ pincode: 413007, min_days: 7, max_days: 10 },
{ pincode: 413008, min_days: 7, max_days: 10 },
{ pincode: 413009, min_days: 7, max_days: 10 },
{ pincode: 413215, min_days: 7, max_days: 10 },
{ pincode: 413224, min_days: 7, max_days: 10 },
{ pincode: 413225, min_days: 7, max_days: 10 },
{ pincode: 413254, min_days: 7, max_days: 10 },
{ pincode: 413255, min_days: 7, max_days: 10 },
{ pincode: 413512, min_days: 7, max_days: 10 },
{ pincode: 413531, min_days: 7, max_days: 10 },
{ pincode: 413802, min_days: 7, max_days: 10 },
{ pincode: 414001, min_days: 7, max_days: 10 },
{ pincode: 414002, min_days: 7, max_days: 10 },
{ pincode: 414003, min_days: 7, max_days: 10 },
{ pincode: 414004, min_days: 7, max_days: 10 },
{ pincode: 414005, min_days: 7, max_days: 10 },
{ pincode: 414006, min_days: 7, max_days: 10 },
{ pincode: 414110, min_days: 7, max_days: 10 },
{ pincode: 414111, min_days: 7, max_days: 10 },
{ pincode: 414112, min_days: 7, max_days: 10 },
{ pincode: 414207, min_days: 7, max_days: 10 },
{ pincode: 414601, min_days: 7, max_days: 10 },
{ pincode: 414603, min_days: 7, max_days: 10 },
{ pincode: 414605, min_days: 7, max_days: 10 },
{ pincode: 414608, min_days: 7, max_days: 10 },
{ pincode: 414609, min_days: 7, max_days: 10 },
{ pincode: 415101, min_days: 7, max_days: 10 },
{ pincode: 415104, min_days: 7, max_days: 10 },
{ pincode: 415302, min_days: 7, max_days: 10 },
{ pincode: 415303, min_days: 7, max_days: 10 },
{ pincode: 415313, min_days: 7, max_days: 10 },
{ pincode: 415401, min_days: 7, max_days: 10 },
{ pincode: 415402, min_days: 7, max_days: 10 },
{ pincode: 415403, min_days: 7, max_days: 10 },
{ pincode: 415404, min_days: 7, max_days: 10 },
{ pincode: 415405, min_days: 7, max_days: 10 },
{ pincode: 415406, min_days: 7, max_days: 10 },
{ pincode: 415407, min_days: 7, max_days: 10 },
{ pincode: 415408, min_days: 7, max_days: 10 },
{ pincode: 415409, min_days: 7, max_days: 10 },
{ pincode: 415410, min_days: 7, max_days: 10 },
{ pincode: 415411, min_days: 7, max_days: 10 },
{ pincode: 415412, min_days: 7, max_days: 10 },
{ pincode: 415413, min_days: 7, max_days: 10 },
{ pincode: 415414, min_days: 7, max_days: 10 },
{ pincode: 415539, min_days: 7, max_days: 10 },
{ pincode: 416001, min_days: 7, max_days: 10 },
{ pincode: 416002, min_days: 7, max_days: 10 },
{ pincode: 416003, min_days: 7, max_days: 10 },
{ pincode: 416004, min_days: 7, max_days: 10 },
{ pincode: 416005, min_days: 7, max_days: 10 },
{ pincode: 416006, min_days: 7, max_days: 10 },
{ pincode: 416007, min_days: 7, max_days: 10 },
{ pincode: 416008, min_days: 7, max_days: 10 },
{ pincode: 416009, min_days: 7, max_days: 10 },
{ pincode: 416010, min_days: 7, max_days: 10 },
{ pincode: 416011, min_days: 7, max_days: 10 },
{ pincode: 416012, min_days: 7, max_days: 10 },
{ pincode: 416013, min_days: 7, max_days: 10 },
{ pincode: 416014, min_days: 7, max_days: 10 },
{ pincode: 416015, min_days: 7, max_days: 10 },
{ pincode: 416016, min_days: 7, max_days: 10 },
{ pincode: 416017, min_days: 7, max_days: 10 },
{ pincode: 416019, min_days: 7, max_days: 10 },
{ pincode: 416101, min_days: 7, max_days: 10 },
{ pincode: 416102, min_days: 7, max_days: 10 },
{ pincode: 416103, min_days: 7, max_days: 10 },
{ pincode: 416104, min_days: 7, max_days: 10 },
{ pincode: 416105, min_days: 7, max_days: 10 },
{ pincode: 416106, min_days: 7, max_days: 10 },
{ pincode: 416107, min_days: 7, max_days: 10 },
{ pincode: 416108, min_days: 7, max_days: 10 },
{ pincode: 416109, min_days: 7, max_days: 10 },
{ pincode: 416110, min_days: 7, max_days: 10 },
{ pincode: 416111, min_days: 7, max_days: 10 },
{ pincode: 416112, min_days: 7, max_days: 10 },
{ pincode: 416113, min_days: 7, max_days: 10 },
{ pincode: 416114, min_days: 7, max_days: 10 },
{ pincode: 416115, min_days: 7, max_days: 10 },
{ pincode: 416116, min_days: 7, max_days: 10 },
{ pincode: 416117, min_days: 7, max_days: 10 },
{ pincode: 416118, min_days: 7, max_days: 10 },
{ pincode: 416119, min_days: 7, max_days: 10 },
{ pincode: 416120, min_days: 7, max_days: 10 },
{ pincode: 416121, min_days: 7, max_days: 10 },
{ pincode: 416122, min_days: 7, max_days: 10 },
{ pincode: 416129, min_days: 7, max_days: 10 },
{ pincode: 416138, min_days: 7, max_days: 10 },
{ pincode: 416143, min_days: 7, max_days: 10 },
{ pincode: 416144, min_days: 7, max_days: 10 },
{ pincode: 416145, min_days: 7, max_days: 10 },
{ pincode: 416146, min_days: 7, max_days: 10 },
{ pincode: 416201, min_days: 7, max_days: 10 },
{ pincode: 416202, min_days: 7, max_days: 10 },
{ pincode: 416203, min_days: 7, max_days: 10 },
{ pincode: 416204, min_days: 7, max_days: 10 },
{ pincode: 416205, min_days: 7, max_days: 10 },
{ pincode: 416206, min_days: 7, max_days: 10 },
{ pincode: 416207, min_days: 7, max_days: 10 },
{ pincode: 416208, min_days: 7, max_days: 10 },
{ pincode: 416209, min_days: 7, max_days: 10 },
{ pincode: 416211, min_days: 7, max_days: 10 },
{ pincode: 416212, min_days: 7, max_days: 10 },
{ pincode: 416213, min_days: 7, max_days: 10 },
{ pincode: 416215, min_days: 7, max_days: 10 },
{ pincode: 416216, min_days: 7, max_days: 10 },
{ pincode: 416217, min_days: 7, max_days: 10 },
{ pincode: 416218, min_days: 7, max_days: 10 },
{ pincode: 416219, min_days: 7, max_days: 10 },
{ pincode: 416221, min_days: 7, max_days: 10 },
{ pincode: 416222, min_days: 7, max_days: 10 },
{ pincode: 416224, min_days: 7, max_days: 10 },
{ pincode: 416228, min_days: 7, max_days: 10 },
{ pincode: 416229, min_days: 7, max_days: 10 },
{ pincode: 416230, min_days: 7, max_days: 10 },
{ pincode: 416231, min_days: 7, max_days: 10 },
{ pincode: 416232, min_days: 7, max_days: 10 },
{ pincode: 416234, min_days: 7, max_days: 10 },
{ pincode: 416235, min_days: 7, max_days: 10 },
{ pincode: 416236, min_days: 7, max_days: 10 },
{ pincode: 416301, min_days: 7, max_days: 10 },
{ pincode: 416302, min_days: 7, max_days: 10 },
{ pincode: 416303, min_days: 7, max_days: 10 },
{ pincode: 416304, min_days: 7, max_days: 10 },
{ pincode: 416305, min_days: 7, max_days: 10 },
{ pincode: 416306, min_days: 7, max_days: 10 },
{ pincode: 416307, min_days: 7, max_days: 10 },
{ pincode: 416308, min_days: 7, max_days: 10 },
{ pincode: 416309, min_days: 7, max_days: 10 },
{ pincode: 416310, min_days: 7, max_days: 10 },
{ pincode: 416312, min_days: 7, max_days: 10 },
{ pincode: 416313, min_days: 7, max_days: 10 },
{ pincode: 416315, min_days: 7, max_days: 10 },
{ pincode: 416316, min_days: 7, max_days: 10 },
{ pincode: 416401, min_days: 7, max_days: 10 },
{ pincode: 416406, min_days: 7, max_days: 10 },
{ pincode: 416407, min_days: 7, max_days: 10 },
{ pincode: 416409, min_days: 7, max_days: 10 },
{ pincode: 416410, min_days: 7, max_days: 10 },
{ pincode: 416414, min_days: 7, max_days: 10 },
{ pincode: 416415, min_days: 7, max_days: 10 },
{ pincode: 416416, min_days: 7, max_days: 10 },
{ pincode: 416417, min_days: 7, max_days: 10 },
{ pincode: 416421, min_days: 7, max_days: 10 },
{ pincode: 416425, min_days: 7, max_days: 10 },
{ pincode: 416436, min_days: 7, max_days: 10 },
{ pincode: 416437, min_days: 7, max_days: 10 },
{ pincode: 416501, min_days: 7, max_days: 10 },
{ pincode: 421000, min_days: 7, max_days: 10 },
{ pincode: 421001, min_days: 7, max_days: 10 },
{ pincode: 421002, min_days: 7, max_days: 10 },
{ pincode: 421003, min_days: 7, max_days: 10 },
{ pincode: 421004, min_days: 7, max_days: 10 },
{ pincode: 421005, min_days: 7, max_days: 10 },
{ pincode: 421100, min_days: 7, max_days: 10 },
{ pincode: 421101, min_days: 7, max_days: 10 },
{ pincode: 421102, min_days: 7, max_days: 10 },
{ pincode: 421103, min_days: 7, max_days: 10 },
{ pincode: 421200, min_days: 7, max_days: 10 },
{ pincode: 421201, min_days: 7, max_days: 10 },
{ pincode: 421202, min_days: 7, max_days: 10 },
{ pincode: 421203, min_days: 7, max_days: 10 },
{ pincode: 421204, min_days: 7, max_days: 10 },
{ pincode: 421205, min_days: 7, max_days: 10 },
{ pincode: 421206, min_days: 7, max_days: 10 },
{ pincode: 421208, min_days: 7, max_days: 10 },
{ pincode: 421300, min_days: 7, max_days: 10 },
{ pincode: 421301, min_days: 7, max_days: 10 },
{ pincode: 421302, min_days: 7, max_days: 10 },
{ pincode: 421303, min_days: 7, max_days: 10 },
{ pincode: 421304, min_days: 7, max_days: 10 },
{ pincode: 421305, min_days: 7, max_days: 10 },
{ pincode: 421306, min_days: 7, max_days: 10 },
{ pincode: 421307, min_days: 7, max_days: 10 },
{ pincode: 421308, min_days: 7, max_days: 10 },
{ pincode: 421309, min_days: 7, max_days: 10 },
{ pincode: 421311, min_days: 7, max_days: 10 },
{ pincode: 421312, min_days: 7, max_days: 10 },
{ pincode: 421401, min_days: 7, max_days: 10 },
{ pincode: 421402, min_days: 7, max_days: 10 },
{ pincode: 421403, min_days: 7, max_days: 10 },
{ pincode: 421501, min_days: 7, max_days: 10 },
{ pincode: 421502, min_days: 7, max_days: 10 },
{ pincode: 421503, min_days: 7, max_days: 10 },
{ pincode: 421504, min_days: 7, max_days: 10 },
{ pincode: 421505, min_days: 7, max_days: 10 },
{ pincode: 421506, min_days: 7, max_days: 10 },
{ pincode: 421507, min_days: 7, max_days: 10 },
{ pincode: 421508, min_days: 7, max_days: 10 },
{ pincode: 421601, min_days: 7, max_days: 10 },
{ pincode: 421602, min_days: 7, max_days: 10 },
{ pincode: 421603, min_days: 7, max_days: 10 },
{ pincode: 421604, min_days: 7, max_days: 10 },
{ pincode: 421605, min_days: 7, max_days: 10 },
{ pincode: 421607, min_days: 7, max_days: 10 },
{ pincode: 422001, min_days: 7, max_days: 10 },
{ pincode: 422002, min_days: 7, max_days: 10 },
{ pincode: 422003, min_days: 7, max_days: 10 },
{ pincode: 422004, min_days: 7, max_days: 10 },
{ pincode: 422005, min_days: 7, max_days: 10 },
{ pincode: 422006, min_days: 7, max_days: 10 },
{ pincode: 422007, min_days: 7, max_days: 10 },
{ pincode: 422008, min_days: 7, max_days: 10 },
{ pincode: 422009, min_days: 7, max_days: 10 },
{ pincode: 422010, min_days: 7, max_days: 10 },
{ pincode: 422011, min_days: 7, max_days: 10 },
{ pincode: 422012, min_days: 7, max_days: 10 },
{ pincode: 422013, min_days: 7, max_days: 10 },
{ pincode: 422014, min_days: 7, max_days: 10 },
{ pincode: 422015, min_days: 7, max_days: 10 },
{ pincode: 422016, min_days: 7, max_days: 10 },
{ pincode: 422017, min_days: 7, max_days: 10 },
{ pincode: 422101, min_days: 7, max_days: 10 },
{ pincode: 422102, min_days: 7, max_days: 10 },
{ pincode: 422103, min_days: 7, max_days: 10 },
{ pincode: 422104, min_days: 7, max_days: 10 },
{ pincode: 422105, min_days: 7, max_days: 10 },
{ pincode: 422106, min_days: 7, max_days: 10 },
{ pincode: 422107, min_days: 7, max_days: 10 },
{ pincode: 422108, min_days: 7, max_days: 10 },
{ pincode: 422109, min_days: 7, max_days: 10 },
{ pincode: 422111, min_days: 7, max_days: 10 },
{ pincode: 422112, min_days: 7, max_days: 10 },
{ pincode: 422113, min_days: 7, max_days: 10 },
{ pincode: 422200, min_days: 7, max_days: 10 },
{ pincode: 422201, min_days: 7, max_days: 10 },
{ pincode: 422202, min_days: 7, max_days: 10 },
{ pincode: 422203, min_days: 7, max_days: 10 },
{ pincode: 422204, min_days: 7, max_days: 10 },
{ pincode: 422205, min_days: 7, max_days: 10 },
{ pincode: 422206, min_days: 7, max_days: 10 },
{ pincode: 422207, min_days: 7, max_days: 10 },
{ pincode: 422208, min_days: 7, max_days: 10 },
{ pincode: 422209, min_days: 7, max_days: 10 },
{ pincode: 422210, min_days: 7, max_days: 10 },
{ pincode: 422212, min_days: 7, max_days: 10 },
{ pincode: 422213, min_days: 7, max_days: 10 },
{ pincode: 422214, min_days: 7, max_days: 10 },
{ pincode: 422215, min_days: 7, max_days: 10 },
{ pincode: 422216, min_days: 7, max_days: 10 },
{ pincode: 422217, min_days: 7, max_days: 10 },
{ pincode: 422218, min_days: 7, max_days: 10 },
{ pincode: 422219, min_days: 7, max_days: 10 },
{ pincode: 422220, min_days: 7, max_days: 10 },
{ pincode: 422221, min_days: 7, max_days: 10 },
{ pincode: 422222, min_days: 7, max_days: 10 },
{ pincode: 422223, min_days: 7, max_days: 10 },
{ pincode: 422301, min_days: 7, max_days: 10 },
{ pincode: 422302, min_days: 7, max_days: 10 },
{ pincode: 422303, min_days: 7, max_days: 10 },
{ pincode: 422304, min_days: 7, max_days: 10 },
{ pincode: 422305, min_days: 7, max_days: 10 },
{ pincode: 422306, min_days: 7, max_days: 10 },
{ pincode: 422308, min_days: 7, max_days: 10 },
{ pincode: 422401, min_days: 7, max_days: 10 },
{ pincode: 422402, min_days: 7, max_days: 10 },
{ pincode: 422403, min_days: 7, max_days: 10 },
{ pincode: 422404, min_days: 7, max_days: 10 },
{ pincode: 422405, min_days: 7, max_days: 10 },
{ pincode: 422406, min_days: 7, max_days: 10 },
{ pincode: 422407, min_days: 7, max_days: 10 },
{ pincode: 422408, min_days: 7, max_days: 10 },
{ pincode: 422409, min_days: 7, max_days: 10 },
{ pincode: 422501, min_days: 7, max_days: 10 },
{ pincode: 422502, min_days: 7, max_days: 10 },
{ pincode: 422503, min_days: 7, max_days: 10 },
{ pincode: 422601, min_days: 7, max_days: 10 },
{ pincode: 422606, min_days: 7, max_days: 10 },
{ pincode: 422607, min_days: 7, max_days: 10 },
{ pincode: 423101, min_days: 7, max_days: 10 },
{ pincode: 423102, min_days: 7, max_days: 10 },
{ pincode: 423111, min_days: 7, max_days: 10 },
{ pincode: 423113, min_days: 7, max_days: 10 },
{ pincode: 423117, min_days: 7, max_days: 10 },
{ pincode: 423203, min_days: 7, max_days: 10 },
{ pincode: 423601, min_days: 7, max_days: 10 },
{ pincode: 423602, min_days: 7, max_days: 10 },
{ pincode: 423604, min_days: 7, max_days: 10 },
{ pincode: 423702, min_days: 7, max_days: 10 },
{ pincode: 423703, min_days: 7, max_days: 10 },
{ pincode: 425001, min_days: 7, max_days: 10 },
{ pincode: 425002, min_days: 7, max_days: 10 },
{ pincode: 425004, min_days: 7, max_days: 10 },
{ pincode: 425118, min_days: 7, max_days: 10 },
{ pincode: 425119, min_days: 7, max_days: 10 },
{ pincode: 425120, min_days: 7, max_days: 10 },
{ pincode: 425121, min_days: 7, max_days: 10 },
{ pincode: 425122, min_days: 7, max_days: 10 },
{ pincode: 425123, min_days: 7, max_days: 10 },
{ pincode: 425124, min_days: 7, max_days: 10 },
{ pincode: 425125, min_days: 7, max_days: 10 },
{ pincode: 425127, min_days: 7, max_days: 10 },
{ pincode: 425128, min_days: 7, max_days: 10 },
{ pincode: 425129, min_days: 7, max_days: 10 },
{ pincode: 425130, min_days: 7, max_days: 10 },
{ pincode: 425131, min_days: 7, max_days: 10 },
{ pincode: 425133, min_days: 7, max_days: 10 },
{ pincode: 425134, min_days: 7, max_days: 10 },
{ pincode: 425136, min_days: 7, max_days: 10 },
{ pincode: 431001, min_days: 7, max_days: 10 },
{ pincode: 431002, min_days: 7, max_days: 10 },
{ pincode: 431003, min_days: 7, max_days: 10 },
{ pincode: 431004, min_days: 7, max_days: 10 },
{ pincode: 431005, min_days: 7, max_days: 10 },
{ pincode: 431006, min_days: 7, max_days: 10 },
{ pincode: 431007, min_days: 7, max_days: 10 },
{ pincode: 431008, min_days: 7, max_days: 10 },
{ pincode: 431009, min_days: 7, max_days: 10 },
{ pincode: 431010, min_days: 7, max_days: 10 },
{ pincode: 431012, min_days: 7, max_days: 10 },
{ pincode: 431013, min_days: 7, max_days: 10 },
{ pincode: 431014, min_days: 7, max_days: 10 },
{ pincode: 431015, min_days: 7, max_days: 10 },
{ pincode: 431016, min_days: 7, max_days: 10 },
{ pincode: 431100, min_days: 7, max_days: 10 },
{ pincode: 431101, min_days: 7, max_days: 10 },
{ pincode: 431102, min_days: 7, max_days: 10 },
{ pincode: 431103, min_days: 7, max_days: 10 },
{ pincode: 431105, min_days: 7, max_days: 10 },
{ pincode: 431107, min_days: 7, max_days: 10 },
{ pincode: 431108, min_days: 7, max_days: 10 },
{ pincode: 431109, min_days: 7, max_days: 10 },
{ pincode: 431110, min_days: 7, max_days: 10 },
{ pincode: 431111, min_days: 7, max_days: 10 },
{ pincode: 431115, min_days: 7, max_days: 10 },
{ pincode: 431116, min_days: 7, max_days: 10 },
{ pincode: 431121, min_days: 7, max_days: 10 },
{ pincode: 431133, min_days: 7, max_days: 10 },
{ pincode: 431134, min_days: 7, max_days: 10 },
{ pincode: 431135, min_days: 7, max_days: 10 },
{ pincode: 431136, min_days: 7, max_days: 10 },
{ pincode: 431141, min_days: 7, max_days: 10 },
{ pincode: 431148, min_days: 7, max_days: 10 },
{ pincode: 431151, min_days: 7, max_days: 10 },
{ pincode: 431154, min_days: 7, max_days: 10 },
{ pincode: 431201, min_days: 7, max_days: 10 },
{ pincode: 431210, min_days: 7, max_days: 10 },
{ pincode: 431302, min_days: 7, max_days: 10 },
{ pincode: 431601, min_days: 7, max_days: 10 },
{ pincode: 431602, min_days: 7, max_days: 10 },
{ pincode: 431603, min_days: 7, max_days: 10 },
{ pincode: 431605, min_days: 7, max_days: 10 },
{ pincode: 431606, min_days: 7, max_days: 10 },
{ pincode: 431706, min_days: 7, max_days: 10 },
{ pincode: 440000, min_days: 7, max_days: 10 },
{ pincode: 440001, min_days: 7, max_days: 10 },
{ pincode: 440002, min_days: 7, max_days: 10 },
{ pincode: 440003, min_days: 7, max_days: 10 },
{ pincode: 440004, min_days: 7, max_days: 10 },
{ pincode: 440005, min_days: 7, max_days: 10 },
{ pincode: 440006, min_days: 7, max_days: 10 },
{ pincode: 440007, min_days: 7, max_days: 10 },
{ pincode: 440008, min_days: 7, max_days: 10 },
{ pincode: 440009, min_days: 7, max_days: 10 },
{ pincode: 440010, min_days: 7, max_days: 10 },
{ pincode: 440011, min_days: 7, max_days: 10 },
{ pincode: 440012, min_days: 7, max_days: 10 },
{ pincode: 440013, min_days: 7, max_days: 10 },
{ pincode: 440014, min_days: 7, max_days: 10 },
{ pincode: 440015, min_days: 7, max_days: 10 },
{ pincode: 440016, min_days: 7, max_days: 10 },
{ pincode: 440017, min_days: 7, max_days: 10 },
{ pincode: 440018, min_days: 7, max_days: 10 },
{ pincode: 440019, min_days: 7, max_days: 10 },
{ pincode: 440020, min_days: 7, max_days: 10 },
{ pincode: 440021, min_days: 7, max_days: 10 },
{ pincode: 440022, min_days: 7, max_days: 10 },
{ pincode: 440023, min_days: 7, max_days: 10 },
{ pincode: 440024, min_days: 7, max_days: 10 },
{ pincode: 440025, min_days: 7, max_days: 10 },
{ pincode: 440026, min_days: 7, max_days: 10 },
{ pincode: 440027, min_days: 7, max_days: 10 },
{ pincode: 440028, min_days: 7, max_days: 10 },
{ pincode: 440029, min_days: 7, max_days: 10 },
{ pincode: 440030, min_days: 7, max_days: 10 },
{ pincode: 440031, min_days: 7, max_days: 10 },
{ pincode: 440032, min_days: 7, max_days: 10 },
{ pincode: 440033, min_days: 7, max_days: 10 },
{ pincode: 440034, min_days: 7, max_days: 10 },
{ pincode: 440035, min_days: 7, max_days: 10 },
{ pincode: 440036, min_days: 7, max_days: 10 },
{ pincode: 440037, min_days: 7, max_days: 10 },
{ pincode: 440038, min_days: 7, max_days: 10 },
{ pincode: 441001, min_days: 7, max_days: 10 },
{ pincode: 441002, min_days: 7, max_days: 10 },
{ pincode: 441004, min_days: 7, max_days: 10 },
{ pincode: 441101, min_days: 7, max_days: 10 },
{ pincode: 441102, min_days: 7, max_days: 10 },
{ pincode: 441103, min_days: 7, max_days: 10 },
{ pincode: 441104, min_days: 7, max_days: 10 },
{ pincode: 441105, min_days: 7, max_days: 10 },
{ pincode: 441106, min_days: 7, max_days: 10 },
{ pincode: 441107, min_days: 7, max_days: 10 },
{ pincode: 441108, min_days: 7, max_days: 10 },
{ pincode: 441109, min_days: 7, max_days: 10 },
{ pincode: 441110, min_days: 7, max_days: 10 },
{ pincode: 441111, min_days: 7, max_days: 10 },
{ pincode: 441112, min_days: 7, max_days: 10 },
{ pincode: 441113, min_days: 7, max_days: 10 },
{ pincode: 441116, min_days: 7, max_days: 10 },
{ pincode: 441117, min_days: 7, max_days: 10 },
{ pincode: 441118, min_days: 7, max_days: 10 },
{ pincode: 441122, min_days: 7, max_days: 10 },
{ pincode: 441123, min_days: 7, max_days: 10 },
{ pincode: 441204, min_days: 7, max_days: 10 },
{ pincode: 441302, min_days: 7, max_days: 10 },
{ pincode: 441304, min_days: 7, max_days: 10 },
{ pincode: 441305, min_days: 7, max_days: 10 },
{ pincode: 441306, min_days: 7, max_days: 10 },
{ pincode: 441402, min_days: 7, max_days: 10 },
{ pincode: 441403, min_days: 7, max_days: 10 },
{ pincode: 441404, min_days: 7, max_days: 10 },
{ pincode: 441405, min_days: 7, max_days: 10 },
{ pincode: 441458, min_days: 7, max_days: 10 },
{ pincode: 441500, min_days: 7, max_days: 10 },
{ pincode: 441501, min_days: 7, max_days: 10 },
{ pincode: 441502, min_days: 7, max_days: 10 },
{ pincode: 441503, min_days: 7, max_days: 10 },
{ pincode: 441504, min_days: 7, max_days: 10 },
{ pincode: 442001, min_days: 7, max_days: 10 },
{ pincode: 442003, min_days: 7, max_days: 10 },
{ pincode: 442004, min_days: 7, max_days: 10 },
{ pincode: 442102, min_days: 7, max_days: 10 },
{ pincode: 442103, min_days: 7, max_days: 10 },
{ pincode: 442104, min_days: 7, max_days: 10 },
{ pincode: 442105, min_days: 7, max_days: 10 },
{ pincode: 442108, min_days: 7, max_days: 10 },
{ pincode: 442111, min_days: 7, max_days: 10 },
{ pincode: 444001, min_days: 7, max_days: 10 },
{ pincode: 444002, min_days: 7, max_days: 10 },
{ pincode: 444003, min_days: 7, max_days: 10 },
{ pincode: 444004, min_days: 7, max_days: 10 },
{ pincode: 444005, min_days: 7, max_days: 10 },
{ pincode: 444104, min_days: 7, max_days: 10 },
{ pincode: 444447, min_days: 7, max_days: 10 },
{ pincode: 444601, min_days: 7, max_days: 10 },
{ pincode: 444602, min_days: 7, max_days: 10 },
{ pincode: 444603, min_days: 7, max_days: 10 },
{ pincode: 444604, min_days: 7, max_days: 10 },
{ pincode: 444605, min_days: 7, max_days: 10 },
{ pincode: 444608, min_days: 7, max_days: 10 },
{ pincode: 444609, min_days: 7, max_days: 10 },
{ pincode: 444900, min_days: 7, max_days: 10 },
{ pincode: 451010, min_days: 7, max_days: 10 },
{ pincode: 451115, min_days: 7, max_days: 10 },
{ pincode: 451220, min_days: 7, max_days: 10 },
{ pincode: 451221, min_days: 7, max_days: 10 },
{ pincode: 451224, min_days: 7, max_days: 10 },
{ pincode: 451660, min_days: 7, max_days: 10 },
{ pincode: 452000, min_days: 7, max_days: 10 },
{ pincode: 452001, min_days: 7, max_days: 10 },
{ pincode: 452002, min_days: 7, max_days: 10 },
{ pincode: 452003, min_days: 7, max_days: 10 },
{ pincode: 452004, min_days: 7, max_days: 10 },
{ pincode: 452005, min_days: 7, max_days: 10 },
{ pincode: 452006, min_days: 7, max_days: 10 },
{ pincode: 452007, min_days: 7, max_days: 10 },
{ pincode: 452008, min_days: 7, max_days: 10 },
{ pincode: 452009, min_days: 7, max_days: 10 },
{ pincode: 452010, min_days: 7, max_days: 10 },
{ pincode: 452011, min_days: 7, max_days: 10 },
{ pincode: 452012, min_days: 7, max_days: 10 },
{ pincode: 452013, min_days: 7, max_days: 10 },
{ pincode: 452014, min_days: 7, max_days: 10 },
{ pincode: 452015, min_days: 7, max_days: 10 },
{ pincode: 452016, min_days: 7, max_days: 10 },
{ pincode: 452017, min_days: 7, max_days: 10 },
{ pincode: 452018, min_days: 7, max_days: 10 },
{ pincode: 452019, min_days: 7, max_days: 10 },
{ pincode: 452020, min_days: 7, max_days: 10 },
{ pincode: 452023, min_days: 7, max_days: 10 },
{ pincode: 452056, min_days: 7, max_days: 10 },
{ pincode: 453001, min_days: 7, max_days: 10 },
{ pincode: 453111, min_days: 7, max_days: 10 },
{ pincode: 453112, min_days: 7, max_days: 10 },
{ pincode: 453115, min_days: 7, max_days: 10 },
{ pincode: 453236, min_days: 7, max_days: 10 },
{ pincode: 453331, min_days: 7, max_days: 10 },
{ pincode: 453332, min_days: 7, max_days: 10 },
{ pincode: 453440, min_days: 7, max_days: 10 },
{ pincode: 453441, min_days: 7, max_days: 10 },
{ pincode: 453442, min_days: 7, max_days: 10 },
{ pincode: 453443, min_days: 7, max_days: 10 },
{ pincode: 453446, min_days: 7, max_days: 10 },
{ pincode: 453551, min_days: 7, max_days: 10 },
{ pincode: 453555, min_days: 7, max_days: 10 },
{ pincode: 453556, min_days: 7, max_days: 10 },
{ pincode: 453562, min_days: 7, max_days: 10 },
{ pincode: 453661, min_days: 7, max_days: 10 },
{ pincode: 453771, min_days: 7, max_days: 10 },
{ pincode: 453772, min_days: 7, max_days: 10 },
{ pincode: 453773, min_days: 7, max_days: 10 },
{ pincode: 454010, min_days: 7, max_days: 10 },
{ pincode: 454552, min_days: 7, max_days: 10 },
{ pincode: 454772, min_days: 7, max_days: 10 },
{ pincode: 454773, min_days: 7, max_days: 10 },
{ pincode: 454774, min_days: 7, max_days: 10 },
{ pincode: 454775, min_days: 7, max_days: 10 },
{ pincode: 454776, min_days: 7, max_days: 10 },
{ pincode: 455001, min_days: 7, max_days: 10 },
{ pincode: 455003, min_days: 7, max_days: 10 },
{ pincode: 455111, min_days: 7, max_days: 10 },
{ pincode: 455112, min_days: 7, max_days: 10 },
{ pincode: 455115, min_days: 7, max_days: 10 },
{ pincode: 455116, min_days: 7, max_days: 10 },
{ pincode: 455118, min_days: 7, max_days: 10 },
{ pincode: 455221, min_days: 7, max_days: 10 },
{ pincode: 455223, min_days: 7, max_days: 10 },
{ pincode: 455227, min_days: 7, max_days: 10 },
{ pincode: 455435, min_days: 7, max_days: 10 },
{ pincode: 455552, min_days: 7, max_days: 10 },
{ pincode: 456000, min_days: 7, max_days: 10 },
{ pincode: 456001, min_days: 7, max_days: 10 },
{ pincode: 456002, min_days: 7, max_days: 10 },
{ pincode: 456003, min_days: 7, max_days: 10 },
{ pincode: 456004, min_days: 7, max_days: 10 },
{ pincode: 456005, min_days: 7, max_days: 10 },
{ pincode: 456006, min_days: 7, max_days: 10 },
{ pincode: 456007, min_days: 7, max_days: 10 },
{ pincode: 456008, min_days: 7, max_days: 10 },
{ pincode: 456009, min_days: 7, max_days: 10 },
{ pincode: 456010, min_days: 7, max_days: 10 },
{ pincode: 456661, min_days: 7, max_days: 10 },
{ pincode: 456664, min_days: 7, max_days: 10 },
{ pincode: 456770, min_days: 7, max_days: 10 },
{ pincode: 462000, min_days: 7, max_days: 10 },
{ pincode: 462001, min_days: 7, max_days: 10 },
{ pincode: 462002, min_days: 7, max_days: 10 },
{ pincode: 462003, min_days: 7, max_days: 10 },
{ pincode: 462004, min_days: 7, max_days: 10 },
{ pincode: 462005, min_days: 7, max_days: 10 },
{ pincode: 462006, min_days: 7, max_days: 10 },
{ pincode: 462007, min_days: 7, max_days: 10 },
{ pincode: 462008, min_days: 7, max_days: 10 },
{ pincode: 462009, min_days: 7, max_days: 10 },
{ pincode: 462010, min_days: 7, max_days: 10 },
{ pincode: 462011, min_days: 7, max_days: 10 },
{ pincode: 462012, min_days: 7, max_days: 10 },
{ pincode: 462013, min_days: 7, max_days: 10 },
{ pincode: 462014, min_days: 7, max_days: 10 },
{ pincode: 462015, min_days: 7, max_days: 10 },
{ pincode: 462016, min_days: 7, max_days: 10 },
{ pincode: 462017, min_days: 7, max_days: 10 },
{ pincode: 462018, min_days: 7, max_days: 10 },
{ pincode: 462019, min_days: 7, max_days: 10 },
{ pincode: 462020, min_days: 7, max_days: 10 },
{ pincode: 462021, min_days: 7, max_days: 10 },
{ pincode: 462022, min_days: 7, max_days: 10 },
{ pincode: 462023, min_days: 7, max_days: 10 },
{ pincode: 462024, min_days: 7, max_days: 10 },
{ pincode: 462025, min_days: 7, max_days: 10 },
{ pincode: 462026, min_days: 7, max_days: 10 },
{ pincode: 462027, min_days: 7, max_days: 10 },
{ pincode: 462028, min_days: 7, max_days: 10 },
{ pincode: 462029, min_days: 7, max_days: 10 },
{ pincode: 462030, min_days: 7, max_days: 10 },
{ pincode: 462031, min_days: 7, max_days: 10 },
{ pincode: 462032, min_days: 7, max_days: 10 },
{ pincode: 462033, min_days: 7, max_days: 10 },
{ pincode: 462034, min_days: 7, max_days: 10 },
{ pincode: 462035, min_days: 7, max_days: 10 },
{ pincode: 462036, min_days: 7, max_days: 10 },
{ pincode: 462037, min_days: 7, max_days: 10 },
{ pincode: 462038, min_days: 7, max_days: 10 },
{ pincode: 462039, min_days: 7, max_days: 10 },
{ pincode: 462040, min_days: 7, max_days: 10 },
{ pincode: 462041, min_days: 7, max_days: 10 },
{ pincode: 462042, min_days: 7, max_days: 10 },
{ pincode: 462043, min_days: 7, max_days: 10 },
{ pincode: 462044, min_days: 7, max_days: 10 },
{ pincode: 462045, min_days: 7, max_days: 10 },
{ pincode: 462046, min_days: 7, max_days: 10 },
{ pincode: 462047, min_days: 7, max_days: 10 },
{ pincode: 462048, min_days: 7, max_days: 10 },
{ pincode: 462049, min_days: 7, max_days: 10 },
{ pincode: 462050, min_days: 7, max_days: 10 },
{ pincode: 462051, min_days: 7, max_days: 10 },
{ pincode: 462052, min_days: 7, max_days: 10 },
{ pincode: 462053, min_days: 7, max_days: 10 },
{ pincode: 462054, min_days: 7, max_days: 10 },
{ pincode: 462055, min_days: 7, max_days: 10 },
{ pincode: 462056, min_days: 7, max_days: 10 },
{ pincode: 462057, min_days: 7, max_days: 10 },
{ pincode: 462058, min_days: 7, max_days: 10 },
{ pincode: 462059, min_days: 7, max_days: 10 },
{ pincode: 462060, min_days: 7, max_days: 10 },
{ pincode: 462061, min_days: 7, max_days: 10 },
{ pincode: 462062, min_days: 7, max_days: 10 },
{ pincode: 462063, min_days: 7, max_days: 10 },
{ pincode: 462064, min_days: 7, max_days: 10 },
{ pincode: 462065, min_days: 7, max_days: 10 },
{ pincode: 462066, min_days: 7, max_days: 10 },
{ pincode: 462100, min_days: 7, max_days: 10 },
{ pincode: 462101, min_days: 7, max_days: 10 },
{ pincode: 462420, min_days: 7, max_days: 10 },
{ pincode: 462421, min_days: 7, max_days: 10 },
{ pincode: 462464, min_days: 7, max_days: 10 },
{ pincode: 463105, min_days: 7, max_days: 10 },
{ pincode: 463106, min_days: 7, max_days: 10 },
{ pincode: 463113, min_days: 7, max_days: 10 },
{ pincode: 464112, min_days: 7, max_days: 10 },
{ pincode: 464113, min_days: 7, max_days: 10 },
{ pincode: 464226, min_days: 7, max_days: 10 },
{ pincode: 464551, min_days: 7, max_days: 10 },
{ pincode: 464552, min_days: 7, max_days: 10 },
{ pincode: 464553, min_days: 7, max_days: 10 },
{ pincode: 464554, min_days: 7, max_days: 10 },
{ pincode: 464555, min_days: 7, max_days: 10 },
{ pincode: 464556, min_days: 7, max_days: 10 },
{ pincode: 464651, min_days: 7, max_days: 10 },
{ pincode: 464661, min_days: 7, max_days: 10 },
{ pincode: 464670, min_days: 7, max_days: 10 },
{ pincode: 464676, min_days: 7, max_days: 10 },
{ pincode: 464887, min_days: 7, max_days: 10 },
{ pincode: 464990, min_days: 7, max_days: 10 },
{ pincode: 464993, min_days: 7, max_days: 10 },
{ pincode: 465106, min_days: 7, max_days: 10 },
{ pincode: 465670, min_days: 7, max_days: 10 },
{ pincode: 465671, min_days: 7, max_days: 10 },
{ pincode: 465672, min_days: 7, max_days: 10 },
{ pincode: 466000, min_days: 7, max_days: 10 },
{ pincode: 466001, min_days: 7, max_days: 10 },
{ pincode: 466002, min_days: 7, max_days: 10 },
{ pincode: 466003, min_days: 7, max_days: 10 },
{ pincode: 466011, min_days: 7, max_days: 10 },
{ pincode: 466111, min_days: 7, max_days: 10 },
{ pincode: 466112, min_days: 7, max_days: 10 },
{ pincode: 466119, min_days: 7, max_days: 10 },
{ pincode: 466166, min_days: 7, max_days: 10 },
{ pincode: 466441, min_days: 7, max_days: 10 },
{ pincode: 466445, min_days: 7, max_days: 10 },
{ pincode: 466651, min_days: 7, max_days: 10 },
{ pincode: 466661, min_days: 7, max_days: 10 },
{ pincode: 466665, min_days: 7, max_days: 10 },
{ pincode: 470880, min_days: 7, max_days: 10 },
{ pincode: 470881, min_days: 7, max_days: 10 },
{ pincode: 473557, min_days: 7, max_days: 10 },
{ pincode: 474000, min_days: 7, max_days: 10 },
{ pincode: 474001, min_days: 7, max_days: 10 },
{ pincode: 474002, min_days: 7, max_days: 10 },
{ pincode: 474003, min_days: 7, max_days: 10 },
{ pincode: 474004, min_days: 7, max_days: 10 },
{ pincode: 474005, min_days: 7, max_days: 10 },
{ pincode: 474006, min_days: 7, max_days: 10 },
{ pincode: 474007, min_days: 7, max_days: 10 },
{ pincode: 474008, min_days: 7, max_days: 10 },
{ pincode: 474009, min_days: 7, max_days: 10 },
{ pincode: 474010, min_days: 7, max_days: 10 },
{ pincode: 474011, min_days: 7, max_days: 10 },
{ pincode: 474012, min_days: 7, max_days: 10 },
{ pincode: 474015, min_days: 7, max_days: 10 },
{ pincode: 474017, min_days: 7, max_days: 10 },
{ pincode: 474020, min_days: 7, max_days: 10 },
{ pincode: 475001, min_days: 7, max_days: 10 },
{ pincode: 475002, min_days: 7, max_days: 10 },
{ pincode: 475005, min_days: 7, max_days: 10 },
{ pincode: 475006, min_days: 7, max_days: 10 },
{ pincode: 475110, min_days: 7, max_days: 10 },
{ pincode: 475330, min_days: 7, max_days: 10 },
{ pincode: 475351, min_days: 7, max_days: 10 },
{ pincode: 476001, min_days: 7, max_days: 10 },
{ pincode: 476111, min_days: 7, max_days: 10 },
{ pincode: 476134, min_days: 7, max_days: 10 },
{ pincode: 476219, min_days: 7, max_days: 10 },
{ pincode: 476221, min_days: 7, max_days: 10 },
{ pincode: 476444, min_days: 7, max_days: 10 },
{ pincode: 476554, min_days: 7, max_days: 10 },
{ pincode: 477116, min_days: 7, max_days: 10 },
{ pincode: 477117, min_days: 7, max_days: 10 },
{ pincode: 477222, min_days: 7, max_days: 10 },
{ pincode: 481666, min_days: 7, max_days: 10 },
{ pincode: 481885, min_days: 7, max_days: 10 },
{ pincode: 482000, min_days: 7, max_days: 10 },
{ pincode: 482001, min_days: 7, max_days: 10 },
{ pincode: 482002, min_days: 7, max_days: 10 },
{ pincode: 482003, min_days: 7, max_days: 10 },
{ pincode: 482004, min_days: 7, max_days: 10 },
{ pincode: 482005, min_days: 7, max_days: 10 },
{ pincode: 482006, min_days: 7, max_days: 10 },
{ pincode: 482007, min_days: 7, max_days: 10 },
{ pincode: 482008, min_days: 7, max_days: 10 },
{ pincode: 482009, min_days: 7, max_days: 10 },
{ pincode: 482010, min_days: 7, max_days: 10 },
{ pincode: 482011, min_days: 7, max_days: 10 },
{ pincode: 482012, min_days: 7, max_days: 10 },
{ pincode: 482013, min_days: 7, max_days: 10 },
{ pincode: 482014, min_days: 7, max_days: 10 },
{ pincode: 482015, min_days: 7, max_days: 10 },
{ pincode: 482016, min_days: 7, max_days: 10 },
{ pincode: 482017, min_days: 7, max_days: 10 },
{ pincode: 482018, min_days: 7, max_days: 10 },
{ pincode: 482019, min_days: 7, max_days: 10 },
{ pincode: 482020, min_days: 7, max_days: 10 },
{ pincode: 482021, min_days: 7, max_days: 10 },
{ pincode: 482022, min_days: 7, max_days: 10 },
{ pincode: 482023, min_days: 7, max_days: 10 },
{ pincode: 482024, min_days: 7, max_days: 10 },
{ pincode: 482025, min_days: 7, max_days: 10 },
{ pincode: 482026, min_days: 7, max_days: 10 },
{ pincode: 482027, min_days: 7, max_days: 10 },
{ pincode: 482028, min_days: 7, max_days: 10 },
{ pincode: 482029, min_days: 7, max_days: 10 },
{ pincode: 482050, min_days: 7, max_days: 10 },
{ pincode: 482051, min_days: 7, max_days: 10 },
{ pincode: 482052, min_days: 7, max_days: 10 },
{ pincode: 482053, min_days: 7, max_days: 10 },
{ pincode: 482054, min_days: 7, max_days: 10 },
{ pincode: 482055, min_days: 7, max_days: 10 },
{ pincode: 482056, min_days: 7, max_days: 10 },
{ pincode: 483001, min_days: 7, max_days: 10 },
{ pincode: 483050, min_days: 7, max_days: 10 },
{ pincode: 483053, min_days: 7, max_days: 10 },
{ pincode: 483105, min_days: 7, max_days: 10 },
{ pincode: 483110, min_days: 7, max_days: 10 },
{ pincode: 483113, min_days: 7, max_days: 10 },
{ pincode: 483119, min_days: 7, max_days: 10 },
{ pincode: 483220, min_days: 7, max_days: 10 },
{ pincode: 483222, min_days: 7, max_days: 10 },
{ pincode: 483225, min_days: 7, max_days: 10 },
{ pincode: 483333, min_days: 7, max_days: 10 },
{ pincode: 483334, min_days: 7, max_days: 10 },
{ pincode: 483336, min_days: 7, max_days: 10 },
{ pincode: 483440, min_days: 7, max_days: 10 },
{ pincode: 483445, min_days: 7, max_days: 10 },
{ pincode: 483446, min_days: 7, max_days: 10 },
{ pincode: 486001, min_days: 7, max_days: 10 },
{ pincode: 486004, min_days: 7, max_days: 10 },
{ pincode: 486006, min_days: 7, max_days: 10 },
{ pincode: 486007, min_days: 7, max_days: 10 },
{ pincode: 486008, min_days: 7, max_days: 10 },
{ pincode: 486010, min_days: 7, max_days: 10 },
{ pincode: 487118, min_days: 7, max_days: 10 },
{ pincode: 487231, min_days: 7, max_days: 10 },
{ pincode: 490000, min_days: 7, max_days: 10 },
{ pincode: 490001, min_days: 7, max_days: 10 },
{ pincode: 490006, min_days: 7, max_days: 10 },
{ pincode: 490008, min_days: 7, max_days: 10 },
{ pincode: 490009, min_days: 7, max_days: 10 },
{ pincode: 490010, min_days: 7, max_days: 10 },
{ pincode: 490011, min_days: 7, max_days: 10 },
{ pincode: 490013, min_days: 7, max_days: 10 },
{ pincode: 490019, min_days: 7, max_days: 10 },
{ pincode: 490020, min_days: 7, max_days: 10 },
{ pincode: 490021, min_days: 7, max_days: 10 },
{ pincode: 490022, min_days: 7, max_days: 10 },
{ pincode: 490023, min_days: 7, max_days: 10 },
{ pincode: 490024, min_days: 7, max_days: 10 },
{ pincode: 490025, min_days: 7, max_days: 10 },
{ pincode: 490026, min_days: 7, max_days: 10 },
{ pincode: 490027, min_days: 7, max_days: 10 },
{ pincode: 490028, min_days: 7, max_days: 10 },
{ pincode: 490029, min_days: 7, max_days: 10 },
{ pincode: 490030, min_days: 7, max_days: 10 },
{ pincode: 490031, min_days: 7, max_days: 10 },
{ pincode: 490032, min_days: 7, max_days: 10 },
{ pincode: 490033, min_days: 7, max_days: 10 },
{ pincode: 490034, min_days: 7, max_days: 10 },
{ pincode: 490035, min_days: 7, max_days: 10 },
{ pincode: 490036, min_days: 7, max_days: 10 },
{ pincode: 490037, min_days: 7, max_days: 10 },
{ pincode: 490038, min_days: 7, max_days: 10 },
{ pincode: 490039, min_days: 7, max_days: 10 },
{ pincode: 490040, min_days: 7, max_days: 10 },
{ pincode: 490041, min_days: 7, max_days: 10 },
{ pincode: 490042, min_days: 7, max_days: 10 },
{ pincode: 490044, min_days: 7, max_days: 10 },
{ pincode: 491001, min_days: 7, max_days: 10 },
{ pincode: 491002, min_days: 7, max_days: 10 },
{ pincode: 491003, min_days: 7, max_days: 10 },
{ pincode: 491004, min_days: 7, max_days: 10 },
{ pincode: 491006, min_days: 7, max_days: 10 },
{ pincode: 491009, min_days: 7, max_days: 10 },
{ pincode: 491107, min_days: 7, max_days: 10 },
{ pincode: 491111, min_days: 7, max_days: 10 },
{ pincode: 491113, min_days: 7, max_days: 10 },
{ pincode: 491221, min_days: 7, max_days: 10 },
{ pincode: 491223, min_days: 7, max_days: 10 },
{ pincode: 491224, min_days: 7, max_days: 10 },
{ pincode: 491230, min_days: 7, max_days: 10 },
{ pincode: 491331, min_days: 7, max_days: 10 },
{ pincode: 491332, min_days: 7, max_days: 10 },
{ pincode: 491333, min_days: 7, max_days: 10 },
{ pincode: 491339, min_days: 7, max_days: 10 },
{ pincode: 492000, min_days: 7, max_days: 10 },
{ pincode: 492001, min_days: 7, max_days: 10 },
{ pincode: 492002, min_days: 7, max_days: 10 },
{ pincode: 492003, min_days: 7, max_days: 10 },
{ pincode: 492004, min_days: 7, max_days: 10 },
{ pincode: 492005, min_days: 7, max_days: 10 },
{ pincode: 492006, min_days: 7, max_days: 10 },
{ pincode: 492007, min_days: 7, max_days: 10 },
{ pincode: 492008, min_days: 7, max_days: 10 },
{ pincode: 492009, min_days: 7, max_days: 10 },
{ pincode: 492010, min_days: 7, max_days: 10 },
{ pincode: 492011, min_days: 7, max_days: 10 },
{ pincode: 492012, min_days: 7, max_days: 10 },
{ pincode: 492013, min_days: 7, max_days: 10 },
{ pincode: 492014, min_days: 7, max_days: 10 },
{ pincode: 492015, min_days: 7, max_days: 10 },
{ pincode: 492016, min_days: 7, max_days: 10 },
{ pincode: 492017, min_days: 7, max_days: 10 },
{ pincode: 492018, min_days: 7, max_days: 10 },
{ pincode: 492019, min_days: 7, max_days: 10 },
{ pincode: 492021, min_days: 7, max_days: 10 },
{ pincode: 492099, min_days: 7, max_days: 10 },
{ pincode: 492100, min_days: 7, max_days: 10 },
{ pincode: 492101, min_days: 7, max_days: 10 },
{ pincode: 492102, min_days: 7, max_days: 10 },
{ pincode: 492104, min_days: 7, max_days: 10 },
{ pincode: 492108, min_days: 7, max_days: 10 },
{ pincode: 492109, min_days: 7, max_days: 10 },
{ pincode: 493101, min_days: 7, max_days: 10 },
{ pincode: 493110, min_days: 7, max_days: 10 },
{ pincode: 493111, min_days: 7, max_days: 10 },
{ pincode: 493114, min_days: 7, max_days: 10 },
{ pincode: 493116, min_days: 7, max_days: 10 },
{ pincode: 493195, min_days: 7, max_days: 10 },
{ pincode: 493211, min_days: 7, max_days: 10 },
{ pincode: 493221, min_days: 7, max_days: 10 },
{ pincode: 493225, min_days: 7, max_days: 10 },
{ pincode: 493441, min_days: 7, max_days: 10 },
{ pincode: 493562, min_days: 7, max_days: 10 },
{ pincode: 493661, min_days: 7, max_days: 10 },
{ pincode: 493663, min_days: 7, max_days: 10 },
{ pincode: 493770, min_days: 7, max_days: 10 },
{ pincode: 493881, min_days: 7, max_days: 10 },
{ pincode: 493885, min_days: 7, max_days: 10 },
{ pincode: 495001, min_days: 7, max_days: 10 },
{ pincode: 495002, min_days: 7, max_days: 10 },
{ pincode: 495003, min_days: 7, max_days: 10 },
{ pincode: 495004, min_days: 7, max_days: 10 },
{ pincode: 495005, min_days: 7, max_days: 10 },
{ pincode: 495006, min_days: 7, max_days: 10 },
{ pincode: 495007, min_days: 7, max_days: 10 },
{ pincode: 495008, min_days: 7, max_days: 10 },
{ pincode: 495009, min_days: 7, max_days: 10 },
{ pincode: 495111, min_days: 7, max_days: 10 },
{ pincode: 495114, min_days: 7, max_days: 10 },
{ pincode: 495220, min_days: 7, max_days: 10 },
{ pincode: 495221, min_days: 7, max_days: 10 },
{ pincode: 495223, min_days: 7, max_days: 10 },
{ pincode: 495225, min_days: 7, max_days: 10 },
{ pincode: 495331, min_days: 7, max_days: 10 },
{ pincode: 495336, min_days: 7, max_days: 10 },
{ pincode: 495338, min_days: 7, max_days: 10 },
{ pincode: 495422, min_days: 7, max_days: 10 },
{ pincode: 495542, min_days: 7, max_days: 10 },
{ pincode: 495550, min_days: 7, max_days: 10 },
{ pincode: 495677, min_days: 7, max_days: 10 },
{ pincode: 495684, min_days: 7, max_days: 10 },
{ pincode: 500000, min_days: 7, max_days: 10 },
{ pincode: 500100, min_days: 7, max_days: 10 },
{ pincode: 500101, min_days: 7, max_days: 10 },
{ pincode: 500102, min_days: 7, max_days: 10 },
{ pincode: 500103, min_days: 7, max_days: 10 },
{ pincode: 500104, min_days: 7, max_days: 10 },
{ pincode: 500105, min_days: 7, max_days: 10 },
{ pincode: 500107, min_days: 7, max_days: 10 },
{ pincode: 500108, min_days: 7, max_days: 10 },
{ pincode: 500109, min_days: 7, max_days: 10 },
{ pincode: 500110, min_days: 7, max_days: 10 },
{ pincode: 500111, min_days: 7, max_days: 10 },
{ pincode: 500112, min_days: 7, max_days: 10 },
{ pincode: 500114, min_days: 7, max_days: 10 },
{ pincode: 500115, min_days: 7, max_days: 10 },
{ pincode: 500133, min_days: 7, max_days: 10 },
{ pincode: 500138, min_days: 7, max_days: 10 },
{ pincode: 500171, min_days: 7, max_days: 10 },
{ pincode: 500175, min_days: 7, max_days: 10 },
{ pincode: 500195, min_days: 7, max_days: 10 },
{ pincode: 500252, min_days: 7, max_days: 10 },
{ pincode: 500253, min_days: 7, max_days: 10 },
{ pincode: 500258, min_days: 7, max_days: 10 },
{ pincode: 500264, min_days: 7, max_days: 10 },
{ pincode: 500265, min_days: 7, max_days: 10 },
{ pincode: 500266, min_days: 7, max_days: 10 },
{ pincode: 500267, min_days: 7, max_days: 10 },
{ pincode: 500361, min_days: 7, max_days: 10 },
{ pincode: 500380, min_days: 7, max_days: 10 },
{ pincode: 500409, min_days: 7, max_days: 10 },
{ pincode: 500457, min_days: 7, max_days: 10 },
{ pincode: 500463, min_days: 7, max_days: 10 },
{ pincode: 500482, min_days: 7, max_days: 10 },
{ pincode: 500484, min_days: 7, max_days: 10 },
{ pincode: 500485, min_days: 7, max_days: 10 },
{ pincode: 500486, min_days: 7, max_days: 10 },
{ pincode: 500488, min_days: 7, max_days: 10 },
{ pincode: 500556, min_days: 7, max_days: 10 },
{ pincode: 500587, min_days: 7, max_days: 10 },
{ pincode: 500593, min_days: 7, max_days: 10 },
{ pincode: 500594, min_days: 7, max_days: 10 },
{ pincode: 500605, min_days: 7, max_days: 10 },
{ pincode: 500658, min_days: 7, max_days: 10 },
{ pincode: 500659, min_days: 7, max_days: 10 },
{ pincode: 500660, min_days: 7, max_days: 10 },
{ pincode: 500661, min_days: 7, max_days: 10 },
{ pincode: 500762, min_days: 7, max_days: 10 },
{ pincode: 500768, min_days: 7, max_days: 10 },
{ pincode: 500855, min_days: 7, max_days: 10 },
{ pincode: 500872, min_days: 7, max_days: 10 },
{ pincode: 500873, min_days: 7, max_days: 10 },
{ pincode: 500890, min_days: 7, max_days: 10 },
{ pincode: 500960, min_days: 7, max_days: 10 },
{ pincode: 500963, min_days: 7, max_days: 10 },
{ pincode: 501111, min_days: 7, max_days: 10 },
{ pincode: 501114, min_days: 7, max_days: 10 },
{ pincode: 501203, min_days: 7, max_days: 10 },
{ pincode: 501218, min_days: 7, max_days: 10 },
{ pincode: 501301, min_days: 7, max_days: 10 },
{ pincode: 501323, min_days: 7, max_days: 10 },
{ pincode: 501359, min_days: 7, max_days: 10 },
{ pincode: 501401, min_days: 7, max_days: 10 },
{ pincode: 501403, min_days: 7, max_days: 10 },
{ pincode: 501404, min_days: 7, max_days: 10 },
{ pincode: 501405, min_days: 7, max_days: 10 },
{ pincode: 501503, min_days: 7, max_days: 10 },
{ pincode: 501504, min_days: 7, max_days: 10 },
{ pincode: 501505, min_days: 7, max_days: 10 },
{ pincode: 501506, min_days: 7, max_days: 10 },
{ pincode: 501510, min_days: 7, max_days: 10 },
{ pincode: 501511, min_days: 7, max_days: 10 },
{ pincode: 501512, min_days: 7, max_days: 10 },
{ pincode: 502001, min_days: 7, max_days: 10 },
{ pincode: 502002, min_days: 7, max_days: 10 },
{ pincode: 502032, min_days: 7, max_days: 10 },
{ pincode: 502101, min_days: 7, max_days: 10 },
{ pincode: 502109, min_days: 7, max_days: 10 },
{ pincode: 502117, min_days: 7, max_days: 10 },
{ pincode: 502205, min_days: 7, max_days: 10 },
{ pincode: 502213, min_days: 7, max_days: 10 },
{ pincode: 502247, min_days: 7, max_days: 10 },
{ pincode: 502248, min_days: 7, max_days: 10 },
{ pincode: 502255, min_days: 7, max_days: 10 },
{ pincode: 502273, min_days: 7, max_days: 10 },
{ pincode: 502278, min_days: 7, max_days: 10 },
{ pincode: 502279, min_days: 7, max_days: 10 },
{ pincode: 502281, min_days: 7, max_days: 10 },
{ pincode: 502285, min_days: 7, max_days: 10 },
{ pincode: 502288, min_days: 7, max_days: 10 },
{ pincode: 502289, min_days: 7, max_days: 10 },
{ pincode: 502291, min_days: 7, max_days: 10 },
{ pincode: 502292, min_days: 7, max_days: 10 },
{ pincode: 502294, min_days: 7, max_days: 10 },
{ pincode: 502295, min_days: 7, max_days: 10 },
{ pincode: 502296, min_days: 7, max_days: 10 },
{ pincode: 502297, min_days: 7, max_days: 10 },
{ pincode: 502299, min_days: 7, max_days: 10 },
{ pincode: 502300, min_days: 7, max_days: 10 },
{ pincode: 502302, min_days: 7, max_days: 10 },
{ pincode: 502304, min_days: 7, max_days: 10 },
{ pincode: 502305, min_days: 7, max_days: 10 },
{ pincode: 502306, min_days: 7, max_days: 10 },
{ pincode: 502307, min_days: 7, max_days: 10 },
{ pincode: 502308, min_days: 7, max_days: 10 },
{ pincode: 502311, min_days: 7, max_days: 10 },
{ pincode: 502312, min_days: 7, max_days: 10 },
{ pincode: 502313, min_days: 7, max_days: 10 },
{ pincode: 502314, min_days: 7, max_days: 10 },
{ pincode: 502316, min_days: 7, max_days: 10 },
{ pincode: 502319, min_days: 7, max_days: 10 },
{ pincode: 502320, min_days: 7, max_days: 10 },
{ pincode: 502324, min_days: 7, max_days: 10 },
{ pincode: 502325, min_days: 7, max_days: 10 },
{ pincode: 502329, min_days: 7, max_days: 10 },
{ pincode: 502330, min_days: 7, max_days: 10 },
{ pincode: 502334, min_days: 7, max_days: 10 },
{ pincode: 502335, min_days: 7, max_days: 10 },
{ pincode: 502336, min_days: 7, max_days: 10 },
{ pincode: 502374, min_days: 7, max_days: 10 },
{ pincode: 502381, min_days: 7, max_days: 10 },
{ pincode: 503001, min_days: 7, max_days: 10 },
{ pincode: 503002, min_days: 7, max_days: 10 },
{ pincode: 503003, min_days: 7, max_days: 10 },
{ pincode: 505001, min_days: 7, max_days: 10 },
{ pincode: 506001, min_days: 7, max_days: 10 },
{ pincode: 506002, min_days: 7, max_days: 10 },
{ pincode: 507001, min_days: 7, max_days: 10 },
{ pincode: 507002, min_days: 7, max_days: 10 },
{ pincode: 507003, min_days: 7, max_days: 10 },
{ pincode: 507004, min_days: 7, max_days: 10 },
{ pincode: 507163, min_days: 7, max_days: 10 },
{ pincode: 507170, min_days: 7, max_days: 10 },
{ pincode: 507318, min_days: 7, max_days: 10 },
{ pincode: 508001, min_days: 7, max_days: 10 },
{ pincode: 508002, min_days: 7, max_days: 10 },
{ pincode: 508004, min_days: 7, max_days: 10 },
{ pincode: 508112, min_days: 7, max_days: 10 },
{ pincode: 508115, min_days: 7, max_days: 10 },
{ pincode: 508116, min_days: 7, max_days: 10 },
{ pincode: 508126, min_days: 7, max_days: 10 },
{ pincode: 508207, min_days: 7, max_days: 10 },
{ pincode: 508208, min_days: 7, max_days: 10 },
{ pincode: 508217, min_days: 7, max_days: 10 },
{ pincode: 508218, min_days: 7, max_days: 10 },
{ pincode: 508252, min_days: 7, max_days: 10 },
{ pincode: 508284, min_days: 7, max_days: 10 },
{ pincode: 508285, min_days: 7, max_days: 10 },
{ pincode: 508355, min_days: 7, max_days: 10 },
{ pincode: 509001, min_days: 7, max_days: 10 },
{ pincode: 509002, min_days: 7, max_days: 10 },
{ pincode: 509207, min_days: 7, max_days: 10 },
{ pincode: 509216, min_days: 7, max_days: 10 },
{ pincode: 509217, min_days: 7, max_days: 10 },
{ pincode: 509218, min_days: 7, max_days: 10 },
{ pincode: 509228, min_days: 7, max_days: 10 },
{ pincode: 509325, min_days: 7, max_days: 10 },
{ pincode: 509358, min_days: 7, max_days: 10 },
{ pincode: 509408, min_days: 7, max_days: 10 },
{ pincode: 509410, min_days: 7, max_days: 10 },
{ pincode: 510000, min_days: 7, max_days: 10 },
{ pincode: 510051, min_days: 7, max_days: 10 },
{ pincode: 511100, min_days: 7, max_days: 10 },
{ pincode: 515001, min_days: 7, max_days: 10 },
{ pincode: 515002, min_days: 7, max_days: 10 },
{ pincode: 515004, min_days: 7, max_days: 10 },
{ pincode: 515005, min_days: 7, max_days: 10 },
{ pincode: 515731, min_days: 7, max_days: 10 },
{ pincode: 516001, min_days: 7, max_days: 10 },
{ pincode: 516002, min_days: 7, max_days: 10 },
{ pincode: 516003, min_days: 7, max_days: 10 },
{ pincode: 516004, min_days: 7, max_days: 10 },
{ pincode: 516101, min_days: 7, max_days: 10 },
{ pincode: 516114, min_days: 7, max_days: 10 },
{ pincode: 516162, min_days: 7, max_days: 10 },
{ pincode: 516293, min_days: 7, max_days: 10 },
{ pincode: 516312, min_days: 7, max_days: 10 },
{ pincode: 516360, min_days: 7, max_days: 10 },
{ pincode: 516361, min_days: 7, max_days: 10 },
{ pincode: 516366, min_days: 7, max_days: 10 },
{ pincode: 517001, min_days: 7, max_days: 10 },
{ pincode: 517002, min_days: 7, max_days: 10 },
{ pincode: 517003, min_days: 7, max_days: 10 },
{ pincode: 517004, min_days: 7, max_days: 10 },
{ pincode: 517101, min_days: 7, max_days: 10 },
{ pincode: 517102, min_days: 7, max_days: 10 },
{ pincode: 517192, min_days: 7, max_days: 10 },
{ pincode: 517216, min_days: 7, max_days: 10 },
{ pincode: 517217, min_days: 7, max_days: 10 },
{ pincode: 517218, min_days: 7, max_days: 10 },
{ pincode: 517231, min_days: 7, max_days: 10 },
{ pincode: 517238, min_days: 7, max_days: 10 },
{ pincode: 517239, min_days: 7, max_days: 10 },
{ pincode: 517240, min_days: 7, max_days: 10 },
{ pincode: 517241, min_days: 7, max_days: 10 },
{ pincode: 517242, min_days: 7, max_days: 10 },
{ pincode: 517278, min_days: 7, max_days: 10 },
{ pincode: 517292, min_days: 7, max_days: 10 },
{ pincode: 517298, min_days: 7, max_days: 10 },
{ pincode: 517301, min_days: 7, max_days: 10 },
{ pincode: 517302, min_days: 7, max_days: 10 },
{ pincode: 517501, min_days: 7, max_days: 10 },
{ pincode: 517502, min_days: 7, max_days: 10 },
{ pincode: 517503, min_days: 7, max_days: 10 },
{ pincode: 517504, min_days: 7, max_days: 10 },
{ pincode: 517505, min_days: 7, max_days: 10 },
{ pincode: 517506, min_days: 7, max_days: 10 },
{ pincode: 517507, min_days: 7, max_days: 10 },
{ pincode: 517508, min_days: 7, max_days: 10 },
{ pincode: 517509, min_days: 7, max_days: 10 },
{ pincode: 517510, min_days: 7, max_days: 10 },
{ pincode: 517511, min_days: 7, max_days: 10 },
{ pincode: 517512, min_days: 7, max_days: 10 },
{ pincode: 517513, min_days: 7, max_days: 10 },
{ pincode: 517514, min_days: 7, max_days: 10 },
{ pincode: 517515, min_days: 7, max_days: 10 },
{ pincode: 517516, min_days: 7, max_days: 10 },
{ pincode: 517517, min_days: 7, max_days: 10 },
{ pincode: 517518, min_days: 7, max_days: 10 },
{ pincode: 517519, min_days: 7, max_days: 10 },
{ pincode: 517520, min_days: 7, max_days: 10 },
{ pincode: 517521, min_days: 7, max_days: 10 },
{ pincode: 517526, min_days: 7, max_days: 10 },
{ pincode: 517527, min_days: 7, max_days: 10 },
{ pincode: 517551, min_days: 7, max_days: 10 },
{ pincode: 517561, min_days: 7, max_days: 10 },
{ pincode: 517562, min_days: 7, max_days: 10 },
{ pincode: 517564, min_days: 7, max_days: 10 },
{ pincode: 517565, min_days: 7, max_days: 10 },
{ pincode: 517566, min_days: 7, max_days: 10 },
{ pincode: 517567, min_days: 7, max_days: 10 },
{ pincode: 517569, min_days: 7, max_days: 10 },
{ pincode: 517570, min_days: 7, max_days: 10 },
{ pincode: 517571, min_days: 7, max_days: 10 },
{ pincode: 517581, min_days: 7, max_days: 10 },
{ pincode: 517582, min_days: 7, max_days: 10 },
{ pincode: 517583, min_days: 7, max_days: 10 },
{ pincode: 517584, min_days: 7, max_days: 10 },
{ pincode: 517587, min_days: 7, max_days: 10 },
{ pincode: 517596, min_days: 7, max_days: 10 },
{ pincode: 517604, min_days: 7, max_days: 10 },
{ pincode: 517619, min_days: 7, max_days: 10 },
{ pincode: 517621, min_days: 7, max_days: 10 },
{ pincode: 517640, min_days: 7, max_days: 10 },
{ pincode: 517641, min_days: 7, max_days: 10 },
{ pincode: 517644, min_days: 7, max_days: 10 },
{ pincode: 517646, min_days: 7, max_days: 10 },
{ pincode: 517650, min_days: 7, max_days: 10 },
{ pincode: 517655, min_days: 7, max_days: 10 },
{ pincode: 518001, min_days: 7, max_days: 10 },
{ pincode: 518002, min_days: 7, max_days: 10 },
{ pincode: 518003, min_days: 7, max_days: 10 },
{ pincode: 518004, min_days: 7, max_days: 10 },
{ pincode: 518005, min_days: 7, max_days: 10 },
{ pincode: 518006, min_days: 7, max_days: 10 },
{ pincode: 518007, min_days: 7, max_days: 10 },
{ pincode: 520000, min_days: 7, max_days: 10 },
{ pincode: 520001, min_days: 7, max_days: 10 },
{ pincode: 520002, min_days: 7, max_days: 10 },
{ pincode: 520003, min_days: 7, max_days: 10 },
{ pincode: 520004, min_days: 7, max_days: 10 },
{ pincode: 520005, min_days: 7, max_days: 10 },
{ pincode: 520006, min_days: 7, max_days: 10 },
{ pincode: 520007, min_days: 7, max_days: 10 },
{ pincode: 520008, min_days: 7, max_days: 10 },
{ pincode: 520009, min_days: 7, max_days: 10 },
{ pincode: 520010, min_days: 7, max_days: 10 },
{ pincode: 520011, min_days: 7, max_days: 10 },
{ pincode: 520012, min_days: 7, max_days: 10 },
{ pincode: 520013, min_days: 7, max_days: 10 },
{ pincode: 520014, min_days: 7, max_days: 10 },
{ pincode: 520015, min_days: 7, max_days: 10 },
{ pincode: 520016, min_days: 7, max_days: 10 },
{ pincode: 520017, min_days: 7, max_days: 10 },
{ pincode: 520050, min_days: 7, max_days: 10 },
{ pincode: 521001, min_days: 7, max_days: 10 },
{ pincode: 521006, min_days: 7, max_days: 10 },
{ pincode: 521010, min_days: 7, max_days: 10 },
{ pincode: 521011, min_days: 7, max_days: 10 },
{ pincode: 521014, min_days: 7, max_days: 10 },
{ pincode: 521101, min_days: 7, max_days: 10 },
{ pincode: 521102, min_days: 7, max_days: 10 },
{ pincode: 521103, min_days: 7, max_days: 10 },
{ pincode: 521104, min_days: 7, max_days: 10 },
{ pincode: 521105, min_days: 7, max_days: 10 },
{ pincode: 521106, min_days: 7, max_days: 10 },
{ pincode: 521107, min_days: 7, max_days: 10 },
{ pincode: 521108, min_days: 7, max_days: 10 },
{ pincode: 521109, min_days: 7, max_days: 10 },
{ pincode: 521110, min_days: 7, max_days: 10 },
{ pincode: 521111, min_days: 7, max_days: 10 },
{ pincode: 521112, min_days: 7, max_days: 10 },
{ pincode: 521113, min_days: 7, max_days: 10 },
{ pincode: 521114, min_days: 7, max_days: 10 },
{ pincode: 521115, min_days: 7, max_days: 10 },
{ pincode: 521116, min_days: 7, max_days: 10 },
{ pincode: 521117, min_days: 7, max_days: 10 },
{ pincode: 521118, min_days: 7, max_days: 10 },
{ pincode: 521123, min_days: 7, max_days: 10 },
{ pincode: 521124, min_days: 7, max_days: 10 },
{ pincode: 521125, min_days: 7, max_days: 10 },
{ pincode: 521126, min_days: 7, max_days: 10 },
{ pincode: 521128, min_days: 7, max_days: 10 },
{ pincode: 521129, min_days: 7, max_days: 10 },
{ pincode: 521132, min_days: 7, max_days: 10 },
{ pincode: 521133, min_days: 7, max_days: 10 },
{ pincode: 521134, min_days: 7, max_days: 10 },
{ pincode: 521135, min_days: 7, max_days: 10 },
{ pincode: 521136, min_days: 7, max_days: 10 },
{ pincode: 521137, min_days: 7, max_days: 10 },
{ pincode: 521138, min_days: 7, max_days: 10 },
{ pincode: 521139, min_days: 7, max_days: 10 },
{ pincode: 521140, min_days: 7, max_days: 10 },
{ pincode: 521144, min_days: 7, max_days: 10 },
{ pincode: 521148, min_days: 7, max_days: 10 },
{ pincode: 521149, min_days: 7, max_days: 10 },
{ pincode: 521150, min_days: 7, max_days: 10 },
{ pincode: 521151, min_days: 7, max_days: 10 },
{ pincode: 521152, min_days: 7, max_days: 10 },
{ pincode: 521153, min_days: 7, max_days: 10 },
{ pincode: 521155, min_days: 7, max_days: 10 },
{ pincode: 521156, min_days: 7, max_days: 10 },
{ pincode: 521157, min_days: 7, max_days: 10 },
{ pincode: 521158, min_days: 7, max_days: 10 },
{ pincode: 521160, min_days: 7, max_days: 10 },
{ pincode: 521162, min_days: 7, max_days: 10 },
{ pincode: 521163, min_days: 7, max_days: 10 },
{ pincode: 521164, min_days: 7, max_days: 10 },
{ pincode: 521165, min_days: 7, max_days: 10 },
{ pincode: 521167, min_days: 7, max_days: 10 },
{ pincode: 521168, min_days: 7, max_days: 10 },
{ pincode: 521169, min_days: 7, max_days: 10 },
{ pincode: 521171, min_days: 7, max_days: 10 },
{ pincode: 521176, min_days: 7, max_days: 10 },
{ pincode: 521177, min_days: 7, max_days: 10 },
{ pincode: 521179, min_days: 7, max_days: 10 },
{ pincode: 521180, min_days: 7, max_days: 10 },
{ pincode: 521181, min_days: 7, max_days: 10 },
{ pincode: 521184, min_days: 7, max_days: 10 },
{ pincode: 521186, min_days: 7, max_days: 10 },
{ pincode: 521201, min_days: 7, max_days: 10 },
{ pincode: 521202, min_days: 7, max_days: 10 },
{ pincode: 521204, min_days: 7, max_days: 10 },
{ pincode: 521205, min_days: 7, max_days: 10 },
{ pincode: 521206, min_days: 7, max_days: 10 },
{ pincode: 521207, min_days: 7, max_days: 10 },
{ pincode: 521208, min_days: 7, max_days: 10 },
{ pincode: 521211, min_days: 7, max_days: 10 },
{ pincode: 521212, min_days: 7, max_days: 10 },
{ pincode: 521215, min_days: 7, max_days: 10 },
{ pincode: 521216, min_days: 7, max_days: 10 },
{ pincode: 521217, min_days: 7, max_days: 10 },
{ pincode: 521218, min_days: 7, max_days: 10 },
{ pincode: 521219, min_days: 7, max_days: 10 },
{ pincode: 521221, min_days: 7, max_days: 10 },
{ pincode: 521225, min_days: 7, max_days: 10 },
{ pincode: 521228, min_days: 7, max_days: 10 },
{ pincode: 521229, min_days: 7, max_days: 10 },
{ pincode: 521230, min_days: 7, max_days: 10 },
{ pincode: 521231, min_days: 7, max_days: 10 },
{ pincode: 521236, min_days: 7, max_days: 10 },
{ pincode: 521240, min_days: 7, max_days: 10 },
{ pincode: 521241, min_days: 7, max_days: 10 },
{ pincode: 521242, min_days: 7, max_days: 10 },
{ pincode: 521245, min_days: 7, max_days: 10 },
{ pincode: 521246, min_days: 7, max_days: 10 },
{ pincode: 521247, min_days: 7, max_days: 10 },
{ pincode: 521250, min_days: 7, max_days: 10 },
{ pincode: 521251, min_days: 7, max_days: 10 },
{ pincode: 521253, min_days: 7, max_days: 10 },
{ pincode: 521255, min_days: 7, max_days: 10 },
{ pincode: 521256, min_days: 7, max_days: 10 },
{ pincode: 521260, min_days: 7, max_days: 10 },
{ pincode: 521261, min_days: 7, max_days: 10 },
{ pincode: 521263, min_days: 7, max_days: 10 },
{ pincode: 521265, min_days: 7, max_days: 10 },
{ pincode: 521281, min_days: 7, max_days: 10 },
{ pincode: 521285, min_days: 7, max_days: 10 },
{ pincode: 521286, min_days: 7, max_days: 10 },
{ pincode: 521288, min_days: 7, max_days: 10 },
{ pincode: 521301, min_days: 7, max_days: 10 },
{ pincode: 521311, min_days: 7, max_days: 10 },
{ pincode: 521312, min_days: 7, max_days: 10 },
{ pincode: 521315, min_days: 7, max_days: 10 },
{ pincode: 521319, min_days: 7, max_days: 10 },
{ pincode: 521321, min_days: 7, max_days: 10 },
{ pincode: 521322, min_days: 7, max_days: 10 },
{ pincode: 521323, min_days: 7, max_days: 10 },
{ pincode: 521325, min_days: 7, max_days: 10 },
{ pincode: 521326, min_days: 7, max_days: 10 },
{ pincode: 521327, min_days: 7, max_days: 10 },
{ pincode: 521329, min_days: 7, max_days: 10 },
{ pincode: 521330, min_days: 7, max_days: 10 },
{ pincode: 521331, min_days: 7, max_days: 10 },
{ pincode: 521332, min_days: 7, max_days: 10 },
{ pincode: 521334, min_days: 7, max_days: 10 },
{ pincode: 521338, min_days: 7, max_days: 10 },
{ pincode: 521343, min_days: 7, max_days: 10 },
{ pincode: 521345, min_days: 7, max_days: 10 },
{ pincode: 521356, min_days: 7, max_days: 10 },
{ pincode: 521358, min_days: 7, max_days: 10 },
{ pincode: 521366, min_days: 7, max_days: 10 },
{ pincode: 521370, min_days: 7, max_days: 10 },
{ pincode: 521372, min_days: 7, max_days: 10 },
{ pincode: 521375, min_days: 7, max_days: 10 },
{ pincode: 521379, min_days: 7, max_days: 10 },
{ pincode: 521384, min_days: 7, max_days: 10 },
{ pincode: 521390, min_days: 7, max_days: 10 },
{ pincode: 521391, min_days: 7, max_days: 10 },
{ pincode: 521397, min_days: 7, max_days: 10 },
{ pincode: 521399, min_days: 7, max_days: 10 },
{ pincode: 521404, min_days: 7, max_days: 10 },
{ pincode: 521411, min_days: 7, max_days: 10 },
{ pincode: 521424, min_days: 7, max_days: 10 },
{ pincode: 521429, min_days: 7, max_days: 10 },
{ pincode: 521436, min_days: 7, max_days: 10 },
{ pincode: 521444, min_days: 7, max_days: 10 },
{ pincode: 521452, min_days: 7, max_days: 10 },
{ pincode: 521456, min_days: 7, max_days: 10 },
{ pincode: 522001, min_days: 7, max_days: 10 },
{ pincode: 522002, min_days: 7, max_days: 10 },
{ pincode: 522003, min_days: 7, max_days: 10 },
{ pincode: 522004, min_days: 7, max_days: 10 },
{ pincode: 522005, min_days: 7, max_days: 10 },
{ pincode: 522006, min_days: 7, max_days: 10 },
{ pincode: 522007, min_days: 7, max_days: 10 },
{ pincode: 522008, min_days: 7, max_days: 10 },
{ pincode: 522009, min_days: 7, max_days: 10 },
{ pincode: 522010, min_days: 7, max_days: 10 },
{ pincode: 522013, min_days: 7, max_days: 10 },
{ pincode: 522014, min_days: 7, max_days: 10 },
{ pincode: 522016, min_days: 7, max_days: 10 },
{ pincode: 522017, min_days: 7, max_days: 10 },
{ pincode: 522018, min_days: 7, max_days: 10 },
{ pincode: 522019, min_days: 7, max_days: 10 },
{ pincode: 522020, min_days: 7, max_days: 10 },
{ pincode: 522021, min_days: 7, max_days: 10 },
{ pincode: 522023, min_days: 7, max_days: 10 },
{ pincode: 522024, min_days: 7, max_days: 10 },
{ pincode: 522025, min_days: 7, max_days: 10 },
{ pincode: 522026, min_days: 7, max_days: 10 },
{ pincode: 522027, min_days: 7, max_days: 10 },
{ pincode: 522028, min_days: 7, max_days: 10 },
{ pincode: 522034, min_days: 7, max_days: 10 },
{ pincode: 522035, min_days: 7, max_days: 10 },
{ pincode: 522036, min_days: 7, max_days: 10 },
{ pincode: 522050, min_days: 7, max_days: 10 },
{ pincode: 522201, min_days: 7, max_days: 10 },
{ pincode: 522202, min_days: 7, max_days: 10 },
{ pincode: 522203, min_days: 7, max_days: 10 },
{ pincode: 522208, min_days: 7, max_days: 10 },
{ pincode: 522213, min_days: 7, max_days: 10 },
{ pincode: 522233, min_days: 7, max_days: 10 },
{ pincode: 522236, min_days: 7, max_days: 10 },
{ pincode: 522237, min_days: 7, max_days: 10 },
{ pincode: 522238, min_days: 7, max_days: 10 },
{ pincode: 522261, min_days: 7, max_days: 10 },
{ pincode: 522301, min_days: 7, max_days: 10 },
{ pincode: 522302, min_days: 7, max_days: 10 },
{ pincode: 522303, min_days: 7, max_days: 10 },
{ pincode: 522304, min_days: 7, max_days: 10 },
{ pincode: 522305, min_days: 7, max_days: 10 },
{ pincode: 522306, min_days: 7, max_days: 10 },
{ pincode: 522307, min_days: 7, max_days: 10 },
{ pincode: 522308, min_days: 7, max_days: 10 },
{ pincode: 522312, min_days: 7, max_days: 10 },
{ pincode: 522313, min_days: 7, max_days: 10 },
{ pincode: 522325, min_days: 7, max_days: 10 },
{ pincode: 522330, min_days: 7, max_days: 10 },
{ pincode: 522501, min_days: 7, max_days: 10 },
{ pincode: 522502, min_days: 7, max_days: 10 },
{ pincode: 522503, min_days: 7, max_days: 10 },
{ pincode: 522504, min_days: 7, max_days: 10 },
{ pincode: 522508, min_days: 7, max_days: 10 },
{ pincode: 522509, min_days: 7, max_days: 10 },
{ pincode: 522510, min_days: 7, max_days: 10 },
{ pincode: 522516, min_days: 7, max_days: 10 },
{ pincode: 523001, min_days: 7, max_days: 10 },
{ pincode: 523002, min_days: 7, max_days: 10 },
{ pincode: 523182, min_days: 7, max_days: 10 },
{ pincode: 523211, min_days: 7, max_days: 10 },
{ pincode: 523225, min_days: 7, max_days: 10 },
{ pincode: 523262, min_days: 7, max_days: 10 },
{ pincode: 523272, min_days: 7, max_days: 10 },
{ pincode: 524003, min_days: 7, max_days: 10 },
{ pincode: 524004, min_days: 7, max_days: 10 },
{ pincode: 530000, min_days: 7, max_days: 10 },
{ pincode: 530001, min_days: 7, max_days: 10 },
{ pincode: 530002, min_days: 7, max_days: 10 },
{ pincode: 530003, min_days: 7, max_days: 10 },
{ pincode: 530004, min_days: 7, max_days: 10 },
{ pincode: 530005, min_days: 7, max_days: 10 },
{ pincode: 530006, min_days: 7, max_days: 10 },
{ pincode: 530007, min_days: 7, max_days: 10 },
{ pincode: 530008, min_days: 7, max_days: 10 },
{ pincode: 530009, min_days: 7, max_days: 10 },
{ pincode: 530010, min_days: 7, max_days: 10 },
{ pincode: 530011, min_days: 7, max_days: 10 },
{ pincode: 530012, min_days: 7, max_days: 10 },
{ pincode: 530013, min_days: 7, max_days: 10 },
{ pincode: 530014, min_days: 7, max_days: 10 },
{ pincode: 530015, min_days: 7, max_days: 10 },
{ pincode: 530016, min_days: 7, max_days: 10 },
{ pincode: 530017, min_days: 7, max_days: 10 },
{ pincode: 530018, min_days: 7, max_days: 10 },
{ pincode: 530019, min_days: 7, max_days: 10 },
{ pincode: 530020, min_days: 7, max_days: 10 },
{ pincode: 530021, min_days: 7, max_days: 10 },
{ pincode: 530022, min_days: 7, max_days: 10 },
{ pincode: 530023, min_days: 7, max_days: 10 },
{ pincode: 530024, min_days: 7, max_days: 10 },
{ pincode: 530025, min_days: 7, max_days: 10 },
{ pincode: 530026, min_days: 7, max_days: 10 },
{ pincode: 530027, min_days: 7, max_days: 10 },
{ pincode: 530028, min_days: 7, max_days: 10 },
{ pincode: 530029, min_days: 7, max_days: 10 },
{ pincode: 530030, min_days: 7, max_days: 10 },
{ pincode: 530031, min_days: 7, max_days: 10 },
{ pincode: 530032, min_days: 7, max_days: 10 },
{ pincode: 530033, min_days: 7, max_days: 10 },
{ pincode: 530034, min_days: 7, max_days: 10 },
{ pincode: 530035, min_days: 7, max_days: 10 },
{ pincode: 530036, min_days: 7, max_days: 10 },
{ pincode: 530037, min_days: 7, max_days: 10 },
{ pincode: 530038, min_days: 7, max_days: 10 },
{ pincode: 530039, min_days: 7, max_days: 10 },
{ pincode: 530040, min_days: 7, max_days: 10 },
{ pincode: 530041, min_days: 7, max_days: 10 },
{ pincode: 530042, min_days: 7, max_days: 10 },
{ pincode: 530043, min_days: 7, max_days: 10 },
{ pincode: 530044, min_days: 7, max_days: 10 },
{ pincode: 530045, min_days: 7, max_days: 10 },
{ pincode: 530046, min_days: 7, max_days: 10 },
{ pincode: 530047, min_days: 7, max_days: 10 },
{ pincode: 530048, min_days: 7, max_days: 10 },
{ pincode: 530049, min_days: 7, max_days: 10 },
{ pincode: 530051, min_days: 7, max_days: 10 },
{ pincode: 530052, min_days: 7, max_days: 10 },
{ pincode: 530053, min_days: 7, max_days: 10 },
{ pincode: 531001, min_days: 7, max_days: 10 },
{ pincode: 531002, min_days: 7, max_days: 10 },
{ pincode: 531011, min_days: 7, max_days: 10 },
{ pincode: 531019, min_days: 7, max_days: 10 },
{ pincode: 531020, min_days: 7, max_days: 10 },
{ pincode: 531021, min_days: 7, max_days: 10 },
{ pincode: 531022, min_days: 7, max_days: 10 },
{ pincode: 531023, min_days: 7, max_days: 10 },
{ pincode: 531025, min_days: 7, max_days: 10 },
{ pincode: 531026, min_days: 7, max_days: 10 },
{ pincode: 531028, min_days: 7, max_days: 10 },
{ pincode: 531031, min_days: 7, max_days: 10 },
{ pincode: 531032, min_days: 7, max_days: 10 },
{ pincode: 531033, min_days: 7, max_days: 10 },
{ pincode: 531034, min_days: 7, max_days: 10 },
{ pincode: 531035, min_days: 7, max_days: 10 },
{ pincode: 531036, min_days: 7, max_days: 10 },
{ pincode: 531039, min_days: 7, max_days: 10 },
{ pincode: 531041, min_days: 7, max_days: 10 },
{ pincode: 531043, min_days: 7, max_days: 10 },
{ pincode: 531046, min_days: 7, max_days: 10 },
{ pincode: 531047, min_days: 7, max_days: 10 },
{ pincode: 531049, min_days: 7, max_days: 10 },
{ pincode: 531051, min_days: 7, max_days: 10 },
{ pincode: 531054, min_days: 7, max_days: 10 },
{ pincode: 531055, min_days: 7, max_days: 10 },
{ pincode: 531057, min_days: 7, max_days: 10 },
{ pincode: 531060, min_days: 7, max_days: 10 },
{ pincode: 531061, min_days: 7, max_days: 10 },
{ pincode: 531062, min_days: 7, max_days: 10 },
{ pincode: 531064, min_days: 7, max_days: 10 },
{ pincode: 531072, min_days: 7, max_days: 10 },
{ pincode: 531075, min_days: 7, max_days: 10 },
{ pincode: 531078, min_days: 7, max_days: 10 },
{ pincode: 531079, min_days: 7, max_days: 10 },
{ pincode: 531082, min_days: 7, max_days: 10 },
{ pincode: 531086, min_days: 7, max_days: 10 },
{ pincode: 531101, min_days: 7, max_days: 10 },
{ pincode: 531108, min_days: 7, max_days: 10 },
{ pincode: 531110, min_days: 7, max_days: 10 },
{ pincode: 531112, min_days: 7, max_days: 10 },
{ pincode: 531113, min_days: 7, max_days: 10 },
{ pincode: 531120, min_days: 7, max_days: 10 },
{ pincode: 531131, min_days: 7, max_days: 10 },
{ pincode: 531135, min_days: 7, max_days: 10 },
{ pincode: 531145, min_days: 7, max_days: 10 },
{ pincode: 531148, min_days: 7, max_days: 10 },
{ pincode: 531162, min_days: 7, max_days: 10 },
{ pincode: 531163, min_days: 7, max_days: 10 },
{ pincode: 531172, min_days: 7, max_days: 10 },
{ pincode: 531173, min_days: 7, max_days: 10 },
{ pincode: 531183, min_days: 7, max_days: 10 },
{ pincode: 531210, min_days: 7, max_days: 10 },
{ pincode: 531212, min_days: 7, max_days: 10 },
{ pincode: 531219, min_days: 7, max_days: 10 },
{ pincode: 532001, min_days: 7, max_days: 10 },
{ pincode: 532005, min_days: 7, max_days: 10 },
{ pincode: 532185, min_days: 7, max_days: 10 },
{ pincode: 532401, min_days: 7, max_days: 10 },
{ pincode: 532402, min_days: 7, max_days: 10 },
{ pincode: 532403, min_days: 7, max_days: 10 },
{ pincode: 532404, min_days: 7, max_days: 10 },
{ pincode: 532408, min_days: 7, max_days: 10 },
{ pincode: 532410, min_days: 7, max_days: 10 },
{ pincode: 532484, min_days: 7, max_days: 10 },
{ pincode: 533000, min_days: 7, max_days: 10 },
{ pincode: 533001, min_days: 7, max_days: 10 },
{ pincode: 533002, min_days: 7, max_days: 10 },
{ pincode: 533003, min_days: 7, max_days: 10 },
{ pincode: 533004, min_days: 7, max_days: 10 },
{ pincode: 533005, min_days: 7, max_days: 10 },
{ pincode: 533006, min_days: 7, max_days: 10 },
{ pincode: 533007, min_days: 7, max_days: 10 },
{ pincode: 533009, min_days: 7, max_days: 10 },
{ pincode: 533014, min_days: 7, max_days: 10 },
{ pincode: 533016, min_days: 7, max_days: 10 },
{ pincode: 533101, min_days: 7, max_days: 10 },
{ pincode: 533102, min_days: 7, max_days: 10 },
{ pincode: 533103, min_days: 7, max_days: 10 },
{ pincode: 533104, min_days: 7, max_days: 10 },
{ pincode: 533105, min_days: 7, max_days: 10 },
{ pincode: 533106, min_days: 7, max_days: 10 },
{ pincode: 533107, min_days: 7, max_days: 10 },
{ pincode: 533108, min_days: 7, max_days: 10 },
{ pincode: 533109, min_days: 7, max_days: 10 },
{ pincode: 533121, min_days: 7, max_days: 10 },
{ pincode: 533122, min_days: 7, max_days: 10 },
{ pincode: 533124, min_days: 7, max_days: 10 },
{ pincode: 533125, min_days: 7, max_days: 10 },
{ pincode: 533126, min_days: 7, max_days: 10 },
{ pincode: 533133, min_days: 7, max_days: 10 },
{ pincode: 533137, min_days: 7, max_days: 10 },
{ pincode: 533201, min_days: 7, max_days: 10 },
{ pincode: 533211, min_days: 7, max_days: 10 },
{ pincode: 533213, min_days: 7, max_days: 10 },
{ pincode: 533214, min_days: 7, max_days: 10 },
{ pincode: 533215, min_days: 7, max_days: 10 },
{ pincode: 533216, min_days: 7, max_days: 10 },
{ pincode: 533217, min_days: 7, max_days: 10 },
{ pincode: 533218, min_days: 7, max_days: 10 },
{ pincode: 533221, min_days: 7, max_days: 10 },
{ pincode: 533222, min_days: 7, max_days: 10 },
{ pincode: 533223, min_days: 7, max_days: 10 },
{ pincode: 533228, min_days: 7, max_days: 10 },
{ pincode: 533229, min_days: 7, max_days: 10 },
{ pincode: 533232, min_days: 7, max_days: 10 },
{ pincode: 533233, min_days: 7, max_days: 10 },
{ pincode: 533234, min_days: 7, max_days: 10 },
{ pincode: 533235, min_days: 7, max_days: 10 },
{ pincode: 533236, min_days: 7, max_days: 10 },
{ pincode: 533237, min_days: 7, max_days: 10 },
{ pincode: 533238, min_days: 7, max_days: 10 },
{ pincode: 533239, min_days: 7, max_days: 10 },
{ pincode: 533240, min_days: 7, max_days: 10 },
{ pincode: 533241, min_days: 7, max_days: 10 },
{ pincode: 533242, min_days: 7, max_days: 10 },
{ pincode: 533244, min_days: 7, max_days: 10 },
{ pincode: 533247, min_days: 7, max_days: 10 },
{ pincode: 533248, min_days: 7, max_days: 10 },
{ pincode: 533249, min_days: 7, max_days: 10 },
{ pincode: 533253, min_days: 7, max_days: 10 },
{ pincode: 533255, min_days: 7, max_days: 10 },
{ pincode: 533260, min_days: 7, max_days: 10 },
{ pincode: 533261, min_days: 7, max_days: 10 },
{ pincode: 533262, min_days: 7, max_days: 10 },
{ pincode: 533263, min_days: 7, max_days: 10 },
{ pincode: 533264, min_days: 7, max_days: 10 },
{ pincode: 533274, min_days: 7, max_days: 10 },
{ pincode: 533284, min_days: 7, max_days: 10 },
{ pincode: 533285, min_days: 7, max_days: 10 },
{ pincode: 533286, min_days: 7, max_days: 10 },
{ pincode: 533287, min_days: 7, max_days: 10 },
{ pincode: 533289, min_days: 7, max_days: 10 },
{ pincode: 533290, min_days: 7, max_days: 10 },
{ pincode: 533291, min_days: 7, max_days: 10 },
{ pincode: 533292, min_days: 7, max_days: 10 },
{ pincode: 533293, min_days: 7, max_days: 10 },
{ pincode: 533294, min_days: 7, max_days: 10 },
{ pincode: 533296, min_days: 7, max_days: 10 },
{ pincode: 533297, min_days: 7, max_days: 10 },
{ pincode: 533305, min_days: 7, max_days: 10 },
{ pincode: 533306, min_days: 7, max_days: 10 },
{ pincode: 533307, min_days: 7, max_days: 10 },
{ pincode: 533308, min_days: 7, max_days: 10 },
{ pincode: 533309, min_days: 7, max_days: 10 },
{ pincode: 533340, min_days: 7, max_days: 10 },
{ pincode: 533341, min_days: 7, max_days: 10 },
{ pincode: 533342, min_days: 7, max_days: 10 },
{ pincode: 533343, min_days: 7, max_days: 10 },
{ pincode: 533344, min_days: 7, max_days: 10 },
{ pincode: 533345, min_days: 7, max_days: 10 },
{ pincode: 533346, min_days: 7, max_days: 10 },
{ pincode: 533429, min_days: 7, max_days: 10 },
{ pincode: 533431, min_days: 7, max_days: 10 },
{ pincode: 533432, min_days: 7, max_days: 10 },
{ pincode: 533433, min_days: 7, max_days: 10 },
{ pincode: 533434, min_days: 7, max_days: 10 },
{ pincode: 533435, min_days: 7, max_days: 10 },
{ pincode: 533437, min_days: 7, max_days: 10 },
{ pincode: 533440, min_days: 7, max_days: 10 },
{ pincode: 533441, min_days: 7, max_days: 10 },
{ pincode: 533450, min_days: 7, max_days: 10 },
{ pincode: 533461, min_days: 7, max_days: 10 },
{ pincode: 533462, min_days: 7, max_days: 10 },
{ pincode: 533465, min_days: 7, max_days: 10 },
{ pincode: 533466, min_days: 7, max_days: 10 },
{ pincode: 533468, min_days: 7, max_days: 10 },
{ pincode: 533577, min_days: 7, max_days: 10 },
{ pincode: 534001, min_days: 7, max_days: 10 },
{ pincode: 534002, min_days: 7, max_days: 10 },
{ pincode: 534003, min_days: 7, max_days: 10 },
{ pincode: 534005, min_days: 7, max_days: 10 },
{ pincode: 534006, min_days: 7, max_days: 10 },
{ pincode: 534007, min_days: 7, max_days: 10 },
{ pincode: 534101, min_days: 7, max_days: 10 },
{ pincode: 534102, min_days: 7, max_days: 10 },
{ pincode: 534111, min_days: 7, max_days: 10 },
{ pincode: 534122, min_days: 7, max_days: 10 },
{ pincode: 534123, min_days: 7, max_days: 10 },
{ pincode: 534124, min_days: 7, max_days: 10 },
{ pincode: 534126, min_days: 7, max_days: 10 },
{ pincode: 534134, min_days: 7, max_days: 10 },
{ pincode: 534145, min_days: 7, max_days: 10 },
{ pincode: 534146, min_days: 7, max_days: 10 },
{ pincode: 534156, min_days: 7, max_days: 10 },
{ pincode: 534165, min_days: 7, max_days: 10 },
{ pincode: 534166, min_days: 7, max_days: 10 },
{ pincode: 534186, min_days: 7, max_days: 10 },
{ pincode: 534196, min_days: 7, max_days: 10 },
{ pincode: 534197, min_days: 7, max_days: 10 },
{ pincode: 534198, min_days: 7, max_days: 10 },
{ pincode: 534199, min_days: 7, max_days: 10 },
{ pincode: 534201, min_days: 7, max_days: 10 },
{ pincode: 534202, min_days: 7, max_days: 10 },
{ pincode: 534203, min_days: 7, max_days: 10 },
{ pincode: 534204, min_days: 7, max_days: 10 },
{ pincode: 534207, min_days: 7, max_days: 10 },
{ pincode: 534208, min_days: 7, max_days: 10 },
{ pincode: 534209, min_days: 7, max_days: 10 },
{ pincode: 534210, min_days: 7, max_days: 10 },
{ pincode: 534211, min_days: 7, max_days: 10 },
{ pincode: 534215, min_days: 7, max_days: 10 },
{ pincode: 534216, min_days: 7, max_days: 10 },
{ pincode: 534217, min_days: 7, max_days: 10 },
{ pincode: 534218, min_days: 7, max_days: 10 },
{ pincode: 534222, min_days: 7, max_days: 10 },
{ pincode: 534225, min_days: 7, max_days: 10 },
{ pincode: 534227, min_days: 7, max_days: 10 },
{ pincode: 534238, min_days: 7, max_days: 10 },
{ pincode: 534239, min_days: 7, max_days: 10 },
{ pincode: 534240, min_days: 7, max_days: 10 },
{ pincode: 534243, min_days: 7, max_days: 10 },
{ pincode: 534244, min_days: 7, max_days: 10 },
{ pincode: 534245, min_days: 7, max_days: 10 },
{ pincode: 534247, min_days: 7, max_days: 10 },
{ pincode: 534250, min_days: 7, max_days: 10 },
{ pincode: 534260, min_days: 7, max_days: 10 },
{ pincode: 534265, min_days: 7, max_days: 10 },
{ pincode: 534266, min_days: 7, max_days: 10 },
{ pincode: 534267, min_days: 7, max_days: 10 },
{ pincode: 534268, min_days: 7, max_days: 10 },
{ pincode: 534269, min_days: 7, max_days: 10 },
{ pincode: 534275, min_days: 7, max_days: 10 },
{ pincode: 534280, min_days: 7, max_days: 10 },
{ pincode: 534281, min_days: 7, max_days: 10 },
{ pincode: 534301, min_days: 7, max_days: 10 },
{ pincode: 534302, min_days: 7, max_days: 10 },
{ pincode: 534305, min_days: 7, max_days: 10 },
{ pincode: 534311, min_days: 7, max_days: 10 },
{ pincode: 534312, min_days: 7, max_days: 10 },
{ pincode: 534313, min_days: 7, max_days: 10 },
{ pincode: 534314, min_days: 7, max_days: 10 },
{ pincode: 534316, min_days: 7, max_days: 10 },
{ pincode: 534318, min_days: 7, max_days: 10 },
{ pincode: 534319, min_days: 7, max_days: 10 },
{ pincode: 534320, min_days: 7, max_days: 10 },
{ pincode: 534324, min_days: 7, max_days: 10 },
{ pincode: 534326, min_days: 7, max_days: 10 },
{ pincode: 534327, min_days: 7, max_days: 10 },
{ pincode: 534328, min_days: 7, max_days: 10 },
{ pincode: 534329, min_days: 7, max_days: 10 },
{ pincode: 534330, min_days: 7, max_days: 10 },
{ pincode: 534331, min_days: 7, max_days: 10 },
{ pincode: 534338, min_days: 7, max_days: 10 },
{ pincode: 534340, min_days: 7, max_days: 10 },
{ pincode: 534341, min_days: 7, max_days: 10 },
{ pincode: 534342, min_days: 7, max_days: 10 },
{ pincode: 534343, min_days: 7, max_days: 10 },
{ pincode: 534347, min_days: 7, max_days: 10 },
{ pincode: 534350, min_days: 7, max_days: 10 },
{ pincode: 534351, min_days: 7, max_days: 10 },
{ pincode: 534352, min_days: 7, max_days: 10 },
{ pincode: 534353, min_days: 7, max_days: 10 },
{ pincode: 534355, min_days: 7, max_days: 10 },
{ pincode: 534357, min_days: 7, max_days: 10 },
{ pincode: 534437, min_days: 7, max_days: 10 },
{ pincode: 534450, min_days: 7, max_days: 10 },
{ pincode: 535001, min_days: 7, max_days: 10 },
{ pincode: 535002, min_days: 7, max_days: 10 },
{ pincode: 535003, min_days: 7, max_days: 10 },
{ pincode: 535004, min_days: 7, max_days: 10 },
{ pincode: 535005, min_days: 7, max_days: 10 },
{ pincode: 535148, min_days: 7, max_days: 10 },
{ pincode: 535160, min_days: 7, max_days: 10 },
{ pincode: 535161, min_days: 7, max_days: 10 },
{ pincode: 535183, min_days: 7, max_days: 10 },
{ pincode: 535214, min_days: 7, max_days: 10 },
{ pincode: 535215, min_days: 7, max_days: 10 },
{ pincode: 535240, min_days: 7, max_days: 10 },
{ pincode: 535250, min_days: 7, max_days: 10 },
{ pincode: 535281, min_days: 7, max_days: 10 },
{ pincode: 555557, min_days: 7, max_days: 10 },
{ pincode: 560000, min_days: 7, max_days: 10 },
{ pincode: 560101, min_days: 7, max_days: 10 },
{ pincode: 560106, min_days: 7, max_days: 10 },
{ pincode: 560107, min_days: 7, max_days: 10 },
{ pincode: 560110, min_days: 7, max_days: 10 },
{ pincode: 560111, min_days: 7, max_days: 10 },
{ pincode: 560112, min_days: 7, max_days: 10 },
{ pincode: 560113, min_days: 7, max_days: 10 },
{ pincode: 560114, min_days: 7, max_days: 10 },
{ pincode: 560115, min_days: 7, max_days: 10 },
{ pincode: 560116, min_days: 7, max_days: 10 },
{ pincode: 560117, min_days: 7, max_days: 10 },
{ pincode: 560119, min_days: 7, max_days: 10 },
{ pincode: 560231, min_days: 7, max_days: 10 },
{ pincode: 560300, min_days: 7, max_days: 10 },
{ pincode: 560500, min_days: 7, max_days: 10 },
{ pincode: 561101, min_days: 7, max_days: 10 },
{ pincode: 561123, min_days: 7, max_days: 10 },
{ pincode: 561201, min_days: 7, max_days: 10 },
{ pincode: 561203, min_days: 7, max_days: 10 },
{ pincode: 561204, min_days: 7, max_days: 10 },
{ pincode: 561205, min_days: 7, max_days: 10 },
{ pincode: 561229, min_days: 7, max_days: 10 },
{ pincode: 562100, min_days: 7, max_days: 10 },
{ pincode: 562101, min_days: 7, max_days: 10 },
{ pincode: 562102, min_days: 7, max_days: 10 },
{ pincode: 562103, min_days: 7, max_days: 10 },
{ pincode: 562105, min_days: 7, max_days: 10 },
{ pincode: 562106, min_days: 7, max_days: 10 },
{ pincode: 562107, min_days: 7, max_days: 10 },
{ pincode: 562108, min_days: 7, max_days: 10 },
{ pincode: 562109, min_days: 7, max_days: 10 },
{ pincode: 562110, min_days: 7, max_days: 10 },
{ pincode: 562111, min_days: 7, max_days: 10 },
{ pincode: 562112, min_days: 7, max_days: 10 },
{ pincode: 562114, min_days: 7, max_days: 10 },
{ pincode: 562115, min_days: 7, max_days: 10 },
{ pincode: 562116, min_days: 7, max_days: 10 },
{ pincode: 562117, min_days: 7, max_days: 10 },
{ pincode: 562120, min_days: 7, max_days: 10 },
{ pincode: 562121, min_days: 7, max_days: 10 },
{ pincode: 562122, min_days: 7, max_days: 10 },
{ pincode: 562123, min_days: 7, max_days: 10 },
{ pincode: 562124, min_days: 7, max_days: 10 },
{ pincode: 562125, min_days: 7, max_days: 10 },
{ pincode: 562127, min_days: 7, max_days: 10 },
{ pincode: 562128, min_days: 7, max_days: 10 },
{ pincode: 562129, min_days: 7, max_days: 10 },
{ pincode: 562130, min_days: 7, max_days: 10 },
{ pincode: 562131, min_days: 7, max_days: 10 },
{ pincode: 562132, min_days: 7, max_days: 10 },
{ pincode: 562134, min_days: 7, max_days: 10 },
{ pincode: 562135, min_days: 7, max_days: 10 },
{ pincode: 562136, min_days: 7, max_days: 10 },
{ pincode: 562137, min_days: 7, max_days: 10 },
{ pincode: 562138, min_days: 7, max_days: 10 },
{ pincode: 562140, min_days: 7, max_days: 10 },
{ pincode: 562141, min_days: 7, max_days: 10 },
{ pincode: 562143, min_days: 7, max_days: 10 },
{ pincode: 562144, min_days: 7, max_days: 10 },
{ pincode: 562145, min_days: 7, max_days: 10 },
{ pincode: 562147, min_days: 7, max_days: 10 },
{ pincode: 562148, min_days: 7, max_days: 10 },
{ pincode: 562149, min_days: 7, max_days: 10 },
{ pincode: 562150, min_days: 7, max_days: 10 },
{ pincode: 562151, min_days: 7, max_days: 10 },
{ pincode: 562152, min_days: 7, max_days: 10 },
{ pincode: 562153, min_days: 7, max_days: 10 },
{ pincode: 562154, min_days: 7, max_days: 10 },
{ pincode: 562156, min_days: 7, max_days: 10 },
{ pincode: 562157, min_days: 7, max_days: 10 },
{ pincode: 562158, min_days: 7, max_days: 10 },
{ pincode: 562159, min_days: 7, max_days: 10 },
{ pincode: 562160, min_days: 7, max_days: 10 },
{ pincode: 562161, min_days: 7, max_days: 10 },
{ pincode: 562162, min_days: 7, max_days: 10 },
{ pincode: 562163, min_days: 7, max_days: 10 },
{ pincode: 562164, min_days: 7, max_days: 10 },
{ pincode: 563101, min_days: 7, max_days: 10 },
{ pincode: 563102, min_days: 7, max_days: 10 },
{ pincode: 563103, min_days: 7, max_days: 10 },
{ pincode: 563114, min_days: 7, max_days: 10 },
{ pincode: 563115, min_days: 7, max_days: 10 },
{ pincode: 563117, min_days: 7, max_days: 10 },
{ pincode: 563118, min_days: 7, max_days: 10 },
{ pincode: 563119, min_days: 7, max_days: 10 },
{ pincode: 563120, min_days: 7, max_days: 10 },
{ pincode: 563122, min_days: 7, max_days: 10 },
{ pincode: 563125, min_days: 7, max_days: 10 },
{ pincode: 563126, min_days: 7, max_days: 10 },
{ pincode: 563127, min_days: 7, max_days: 10 },
{ pincode: 563128, min_days: 7, max_days: 10 },
{ pincode: 563130, min_days: 7, max_days: 10 },
{ pincode: 563131, min_days: 7, max_days: 10 },
{ pincode: 563132, min_days: 7, max_days: 10 },
{ pincode: 563133, min_days: 7, max_days: 10 },
{ pincode: 563134, min_days: 7, max_days: 10 },
{ pincode: 563135, min_days: 7, max_days: 10 },
{ pincode: 563136, min_days: 7, max_days: 10 },
{ pincode: 563137, min_days: 7, max_days: 10 },
{ pincode: 563139, min_days: 7, max_days: 10 },
{ pincode: 563146, min_days: 7, max_days: 10 },
{ pincode: 563159, min_days: 7, max_days: 10 },
{ pincode: 563160, min_days: 7, max_days: 10 },
{ pincode: 563161, min_days: 7, max_days: 10 },
{ pincode: 563162, min_days: 7, max_days: 10 },
{ pincode: 570000, min_days: 7, max_days: 10 },
{ pincode: 570001, min_days: 7, max_days: 10 },
{ pincode: 570002, min_days: 7, max_days: 10 },
{ pincode: 570003, min_days: 7, max_days: 10 },
{ pincode: 570004, min_days: 7, max_days: 10 },
{ pincode: 570005, min_days: 7, max_days: 10 },
{ pincode: 570006, min_days: 7, max_days: 10 },
{ pincode: 570007, min_days: 7, max_days: 10 },
{ pincode: 570008, min_days: 7, max_days: 10 },
{ pincode: 570009, min_days: 7, max_days: 10 },
{ pincode: 570010, min_days: 7, max_days: 10 },
{ pincode: 570011, min_days: 7, max_days: 10 },
{ pincode: 570012, min_days: 7, max_days: 10 },
{ pincode: 570013, min_days: 7, max_days: 10 },
{ pincode: 570014, min_days: 7, max_days: 10 },
{ pincode: 570015, min_days: 7, max_days: 10 },
{ pincode: 570016, min_days: 7, max_days: 10 },
{ pincode: 570017, min_days: 7, max_days: 10 },
{ pincode: 570018, min_days: 7, max_days: 10 },
{ pincode: 570019, min_days: 7, max_days: 10 },
{ pincode: 570020, min_days: 7, max_days: 10 },
{ pincode: 570021, min_days: 7, max_days: 10 },
{ pincode: 570022, min_days: 7, max_days: 10 },
{ pincode: 570023, min_days: 7, max_days: 10 },
{ pincode: 570024, min_days: 7, max_days: 10 },
{ pincode: 570025, min_days: 7, max_days: 10 },
{ pincode: 570026, min_days: 7, max_days: 10 },
{ pincode: 570027, min_days: 7, max_days: 10 },
{ pincode: 570028, min_days: 7, max_days: 10 },
{ pincode: 570029, min_days: 7, max_days: 10 },
{ pincode: 570030, min_days: 7, max_days: 10 },
{ pincode: 570031, min_days: 7, max_days: 10 },
{ pincode: 570032, min_days: 7, max_days: 10 },
{ pincode: 570033, min_days: 7, max_days: 10 },
{ pincode: 570034, min_days: 7, max_days: 10 },
{ pincode: 571101, min_days: 7, max_days: 10 },
{ pincode: 571103, min_days: 7, max_days: 10 },
{ pincode: 571105, min_days: 7, max_days: 10 },
{ pincode: 571107, min_days: 7, max_days: 10 },
{ pincode: 571108, min_days: 7, max_days: 10 },
{ pincode: 571109, min_days: 7, max_days: 10 },
{ pincode: 571110, min_days: 7, max_days: 10 },
{ pincode: 571114, min_days: 7, max_days: 10 },
{ pincode: 571115, min_days: 7, max_days: 10 },
{ pincode: 571118, min_days: 7, max_days: 10 },
{ pincode: 571119, min_days: 7, max_days: 10 },
{ pincode: 571120, min_days: 7, max_days: 10 },
{ pincode: 571122, min_days: 7, max_days: 10 },
{ pincode: 571124, min_days: 7, max_days: 10 },
{ pincode: 571125, min_days: 7, max_days: 10 },
{ pincode: 571128, min_days: 7, max_days: 10 },
{ pincode: 571129, min_days: 7, max_days: 10 },
{ pincode: 571130, min_days: 7, max_days: 10 },
{ pincode: 571132, min_days: 7, max_days: 10 },
{ pincode: 571133, min_days: 7, max_days: 10 },
{ pincode: 571134, min_days: 7, max_days: 10 },
{ pincode: 571135, min_days: 7, max_days: 10 },
{ pincode: 571136, min_days: 7, max_days: 10 },
{ pincode: 571137, min_days: 7, max_days: 10 },
{ pincode: 571138, min_days: 7, max_days: 10 },
{ pincode: 571139, min_days: 7, max_days: 10 },
{ pincode: 571140, min_days: 7, max_days: 10 },
{ pincode: 571141, min_days: 7, max_days: 10 },
{ pincode: 571142, min_days: 7, max_days: 10 },
{ pincode: 571143, min_days: 7, max_days: 10 },
{ pincode: 571144, min_days: 7, max_days: 10 },
{ pincode: 571145, min_days: 7, max_days: 10 },
{ pincode: 571146, min_days: 7, max_days: 10 },
{ pincode: 571147, min_days: 7, max_days: 10 },
{ pincode: 571148, min_days: 7, max_days: 10 },
{ pincode: 571149, min_days: 7, max_days: 10 },
{ pincode: 571150, min_days: 7, max_days: 10 },
{ pincode: 571151, min_days: 7, max_days: 10 },
{ pincode: 571152, min_days: 7, max_days: 10 },
{ pincode: 571153, min_days: 7, max_days: 10 },
{ pincode: 571154, min_days: 7, max_days: 10 },
{ pincode: 571155, min_days: 7, max_days: 10 },
{ pincode: 571156, min_days: 7, max_days: 10 },
{ pincode: 571157, min_days: 7, max_days: 10 },
{ pincode: 571158, min_days: 7, max_days: 10 },
{ pincode: 571159, min_days: 7, max_days: 10 },
{ pincode: 571160, min_days: 7, max_days: 10 },
{ pincode: 571161, min_days: 7, max_days: 10 },
{ pincode: 571162, min_days: 7, max_days: 10 },
{ pincode: 571163, min_days: 7, max_days: 10 },
{ pincode: 571164, min_days: 7, max_days: 10 },
{ pincode: 571165, min_days: 7, max_days: 10 },
{ pincode: 571166, min_days: 7, max_days: 10 },
{ pincode: 571167, min_days: 7, max_days: 10 },
{ pincode: 571168, min_days: 7, max_days: 10 },
{ pincode: 571169, min_days: 7, max_days: 10 },
{ pincode: 571170, min_days: 7, max_days: 10 },
{ pincode: 571171, min_days: 7, max_days: 10 },
{ pincode: 571172, min_days: 7, max_days: 10 },
{ pincode: 571173, min_days: 7, max_days: 10 },
{ pincode: 571174, min_days: 7, max_days: 10 },
{ pincode: 571175, min_days: 7, max_days: 10 },
{ pincode: 571176, min_days: 7, max_days: 10 },
{ pincode: 571177, min_days: 7, max_days: 10 },
{ pincode: 571178, min_days: 7, max_days: 10 },
{ pincode: 571180, min_days: 7, max_days: 10 },
{ pincode: 571181, min_days: 7, max_days: 10 },
{ pincode: 571182, min_days: 7, max_days: 10 },
{ pincode: 571183, min_days: 7, max_days: 10 },
{ pincode: 571184, min_days: 7, max_days: 10 },
{ pincode: 571188, min_days: 7, max_days: 10 },
{ pincode: 571189, min_days: 7, max_days: 10 },
{ pincode: 571301, min_days: 7, max_days: 10 },
{ pincode: 571302, min_days: 7, max_days: 10 },
{ pincode: 571311, min_days: 7, max_days: 10 },
{ pincode: 571312, min_days: 7, max_days: 10 },
{ pincode: 571314, min_days: 7, max_days: 10 },
{ pincode: 571315, min_days: 7, max_days: 10 },
{ pincode: 571317, min_days: 7, max_days: 10 },
{ pincode: 571318, min_days: 7, max_days: 10 },
{ pincode: 571401, min_days: 7, max_days: 10 },
{ pincode: 571402, min_days: 7, max_days: 10 },
{ pincode: 571403, min_days: 7, max_days: 10 },
{ pincode: 571404, min_days: 7, max_days: 10 },
{ pincode: 571405, min_days: 7, max_days: 10 },
{ pincode: 571415, min_days: 7, max_days: 10 },
{ pincode: 571416, min_days: 7, max_days: 10 },
{ pincode: 571417, min_days: 7, max_days: 10 },
{ pincode: 571419, min_days: 7, max_days: 10 },
{ pincode: 571423, min_days: 7, max_days: 10 },
{ pincode: 571424, min_days: 7, max_days: 10 },
{ pincode: 571425, min_days: 7, max_days: 10 },
{ pincode: 571426, min_days: 7, max_days: 10 },
{ pincode: 571427, min_days: 7, max_days: 10 },
{ pincode: 571428, min_days: 7, max_days: 10 },
{ pincode: 571430, min_days: 7, max_days: 10 },
{ pincode: 571431, min_days: 7, max_days: 10 },
{ pincode: 571432, min_days: 7, max_days: 10 },
{ pincode: 571434, min_days: 7, max_days: 10 },
{ pincode: 571435, min_days: 7, max_days: 10 },
{ pincode: 571436, min_days: 7, max_days: 10 },
{ pincode: 571438, min_days: 7, max_days: 10 },
{ pincode: 571442, min_days: 7, max_days: 10 },
{ pincode: 571446, min_days: 7, max_days: 10 },
{ pincode: 571449, min_days: 7, max_days: 10 },
{ pincode: 571450, min_days: 7, max_days: 10 },
{ pincode: 571455, min_days: 7, max_days: 10 },
{ pincode: 571463, min_days: 7, max_days: 10 },
{ pincode: 571475, min_days: 7, max_days: 10 },
{ pincode: 571477, min_days: 7, max_days: 10 },
{ pincode: 571478, min_days: 7, max_days: 10 },
{ pincode: 571491, min_days: 7, max_days: 10 },
{ pincode: 571601, min_days: 7, max_days: 10 },
{ pincode: 571602, min_days: 7, max_days: 10 },
{ pincode: 571603, min_days: 7, max_days: 10 },
{ pincode: 571604, min_days: 7, max_days: 10 },
{ pincode: 571605, min_days: 7, max_days: 10 },
{ pincode: 571606, min_days: 7, max_days: 10 },
{ pincode: 571607, min_days: 7, max_days: 10 },
{ pincode: 571608, min_days: 7, max_days: 10 },
{ pincode: 571609, min_days: 7, max_days: 10 },
{ pincode: 571610, min_days: 7, max_days: 10 },
{ pincode: 571611, min_days: 7, max_days: 10 },
{ pincode: 571612, min_days: 7, max_days: 10 },
{ pincode: 571613, min_days: 7, max_days: 10 },
{ pincode: 571614, min_days: 7, max_days: 10 },
{ pincode: 571615, min_days: 7, max_days: 10 },
{ pincode: 571616, min_days: 7, max_days: 10 },
{ pincode: 571617, min_days: 7, max_days: 10 },
{ pincode: 571807, min_days: 7, max_days: 10 },
{ pincode: 571812, min_days: 7, max_days: 10 },
{ pincode: 572101, min_days: 7, max_days: 10 },
{ pincode: 572102, min_days: 7, max_days: 10 },
{ pincode: 572103, min_days: 7, max_days: 10 },
{ pincode: 572104, min_days: 7, max_days: 10 },
{ pincode: 572105, min_days: 7, max_days: 10 },
{ pincode: 572106, min_days: 7, max_days: 10 },
{ pincode: 572107, min_days: 7, max_days: 10 },
{ pincode: 572111, min_days: 7, max_days: 10 },
{ pincode: 572118, min_days: 7, max_days: 10 },
{ pincode: 572120, min_days: 7, max_days: 10 },
{ pincode: 572122, min_days: 7, max_days: 10 },
{ pincode: 572123, min_days: 7, max_days: 10 },
{ pincode: 572126, min_days: 7, max_days: 10 },
{ pincode: 572128, min_days: 7, max_days: 10 },
{ pincode: 572129, min_days: 7, max_days: 10 },
{ pincode: 572130, min_days: 7, max_days: 10 },
{ pincode: 572140, min_days: 7, max_days: 10 },
{ pincode: 572168, min_days: 7, max_days: 10 },
{ pincode: 573132, min_days: 7, max_days: 10 },
{ pincode: 573201, min_days: 7, max_days: 10 },
{ pincode: 574102, min_days: 7, max_days: 10 },
{ pincode: 574103, min_days: 7, max_days: 10 },
{ pincode: 574104, min_days: 7, max_days: 10 },
{ pincode: 574105, min_days: 7, max_days: 10 },
{ pincode: 574106, min_days: 7, max_days: 10 },
{ pincode: 574107, min_days: 7, max_days: 10 },
{ pincode: 574109, min_days: 7, max_days: 10 },
{ pincode: 574110, min_days: 7, max_days: 10 },
{ pincode: 574111, min_days: 7, max_days: 10 },
{ pincode: 574112, min_days: 7, max_days: 10 },
{ pincode: 574113, min_days: 7, max_days: 10 },
{ pincode: 574114, min_days: 7, max_days: 10 },
{ pincode: 574115, min_days: 7, max_days: 10 },
{ pincode: 574116, min_days: 7, max_days: 10 },
{ pincode: 574117, min_days: 7, max_days: 10 },
{ pincode: 574118, min_days: 7, max_days: 10 },
{ pincode: 574119, min_days: 7, max_days: 10 },
{ pincode: 574121, min_days: 7, max_days: 10 },
{ pincode: 574129, min_days: 7, max_days: 10 },
{ pincode: 574140, min_days: 7, max_days: 10 },
{ pincode: 574141, min_days: 7, max_days: 10 },
{ pincode: 574142, min_days: 7, max_days: 10 },
{ pincode: 574143, min_days: 7, max_days: 10 },
{ pincode: 574144, min_days: 7, max_days: 10 },
{ pincode: 574145, min_days: 7, max_days: 10 },
{ pincode: 574146, min_days: 7, max_days: 10 },
{ pincode: 574148, min_days: 7, max_days: 10 },
{ pincode: 574149, min_days: 7, max_days: 10 },
{ pincode: 574150, min_days: 7, max_days: 10 },
{ pincode: 574151, min_days: 7, max_days: 10 },
{ pincode: 574152, min_days: 7, max_days: 10 },
{ pincode: 574153, min_days: 7, max_days: 10 },
{ pincode: 574154, min_days: 7, max_days: 10 },
{ pincode: 574157, min_days: 7, max_days: 10 },
{ pincode: 574158, min_days: 7, max_days: 10 },
{ pincode: 574159, min_days: 7, max_days: 10 },
{ pincode: 574160, min_days: 7, max_days: 10 },
{ pincode: 574161, min_days: 7, max_days: 10 },
{ pincode: 574162, min_days: 7, max_days: 10 },
{ pincode: 574163, min_days: 7, max_days: 10 },
{ pincode: 574164, min_days: 7, max_days: 10 },
{ pincode: 574165, min_days: 7, max_days: 10 },
{ pincode: 574166, min_days: 7, max_days: 10 },
{ pincode: 574167, min_days: 7, max_days: 10 },
{ pincode: 574168, min_days: 7, max_days: 10 },
{ pincode: 574169, min_days: 7, max_days: 10 },
{ pincode: 574170, min_days: 7, max_days: 10 },
{ pincode: 574171, min_days: 7, max_days: 10 },
{ pincode: 574172, min_days: 7, max_days: 10 },
{ pincode: 574173, min_days: 7, max_days: 10 },
{ pincode: 574175, min_days: 7, max_days: 10 },
{ pincode: 574176, min_days: 7, max_days: 10 },
{ pincode: 574177, min_days: 7, max_days: 10 },
{ pincode: 574179, min_days: 7, max_days: 10 },
{ pincode: 574180, min_days: 7, max_days: 10 },
{ pincode: 574181, min_days: 7, max_days: 10 },
{ pincode: 574182, min_days: 7, max_days: 10 },
{ pincode: 574183, min_days: 7, max_days: 10 },
{ pincode: 574184, min_days: 7, max_days: 10 },
{ pincode: 574187, min_days: 7, max_days: 10 },
{ pincode: 574188, min_days: 7, max_days: 10 },
{ pincode: 574189, min_days: 7, max_days: 10 },
{ pincode: 574190, min_days: 7, max_days: 10 },
{ pincode: 574191, min_days: 7, max_days: 10 },
{ pincode: 574192, min_days: 7, max_days: 10 },
{ pincode: 574193, min_days: 7, max_days: 10 },
{ pincode: 574194, min_days: 7, max_days: 10 },
{ pincode: 574195, min_days: 7, max_days: 10 },
{ pincode: 574196, min_days: 7, max_days: 10 },
{ pincode: 574197, min_days: 7, max_days: 10 },
{ pincode: 574199, min_days: 7, max_days: 10 },
{ pincode: 574201, min_days: 7, max_days: 10 },
{ pincode: 574202, min_days: 7, max_days: 10 },
{ pincode: 574203, min_days: 7, max_days: 10 },
{ pincode: 574204, min_days: 7, max_days: 10 },
{ pincode: 574208, min_days: 7, max_days: 10 },
{ pincode: 574210, min_days: 7, max_days: 10 },
{ pincode: 574211, min_days: 7, max_days: 10 },
{ pincode: 574213, min_days: 7, max_days: 10 },
{ pincode: 574217, min_days: 7, max_days: 10 },
{ pincode: 574219, min_days: 7, max_days: 10 },
{ pincode: 574220, min_days: 7, max_days: 10 },
{ pincode: 574222, min_days: 7, max_days: 10 },
{ pincode: 574223, min_days: 7, max_days: 10 },
{ pincode: 574224, min_days: 7, max_days: 10 },
{ pincode: 574225, min_days: 7, max_days: 10 },
{ pincode: 574226, min_days: 7, max_days: 10 },
{ pincode: 574227, min_days: 7, max_days: 10 },
{ pincode: 574231, min_days: 7, max_days: 10 },
{ pincode: 574233, min_days: 7, max_days: 10 },
{ pincode: 574235, min_days: 7, max_days: 10 },
{ pincode: 574236, min_days: 7, max_days: 10 },
{ pincode: 574237, min_days: 7, max_days: 10 },
{ pincode: 574241, min_days: 7, max_days: 10 },
{ pincode: 574242, min_days: 7, max_days: 10 },
{ pincode: 574243, min_days: 7, max_days: 10 },
{ pincode: 574244, min_days: 7, max_days: 10 },
{ pincode: 574245, min_days: 7, max_days: 10 },
{ pincode: 574246, min_days: 7, max_days: 10 },
{ pincode: 574247, min_days: 7, max_days: 10 },
{ pincode: 574249, min_days: 7, max_days: 10 },
{ pincode: 574250, min_days: 7, max_days: 10 },
{ pincode: 574251, min_days: 7, max_days: 10 },
{ pincode: 574252, min_days: 7, max_days: 10 },
{ pincode: 574253, min_days: 7, max_days: 10 },
{ pincode: 574254, min_days: 7, max_days: 10 },
{ pincode: 574255, min_days: 7, max_days: 10 },
{ pincode: 574256, min_days: 7, max_days: 10 },
{ pincode: 574257, min_days: 7, max_days: 10 },
{ pincode: 574258, min_days: 7, max_days: 10 },
{ pincode: 574259, min_days: 7, max_days: 10 },
{ pincode: 574260, min_days: 7, max_days: 10 },
{ pincode: 574261, min_days: 7, max_days: 10 },
{ pincode: 574262, min_days: 7, max_days: 10 },
{ pincode: 574263, min_days: 7, max_days: 10 },
{ pincode: 574264, min_days: 7, max_days: 10 },
{ pincode: 574265, min_days: 7, max_days: 10 },
{ pincode: 574266, min_days: 7, max_days: 10 },
{ pincode: 574267, min_days: 7, max_days: 10 },
{ pincode: 574268, min_days: 7, max_days: 10 },
{ pincode: 574269, min_days: 7, max_days: 10 },
{ pincode: 574270, min_days: 7, max_days: 10 },
{ pincode: 574271, min_days: 7, max_days: 10 },
{ pincode: 574272, min_days: 7, max_days: 10 },
{ pincode: 574273, min_days: 7, max_days: 10 },
{ pincode: 574275, min_days: 7, max_days: 10 },
{ pincode: 574276, min_days: 7, max_days: 10 },
{ pincode: 574277, min_days: 7, max_days: 10 },
{ pincode: 574278, min_days: 7, max_days: 10 },
{ pincode: 574279, min_days: 7, max_days: 10 },
{ pincode: 574280, min_days: 7, max_days: 10 },
{ pincode: 574281, min_days: 7, max_days: 10 },
{ pincode: 574282, min_days: 7, max_days: 10 },
{ pincode: 574283, min_days: 7, max_days: 10 },
{ pincode: 574284, min_days: 7, max_days: 10 },
{ pincode: 574285, min_days: 7, max_days: 10 },
{ pincode: 574286, min_days: 7, max_days: 10 },
{ pincode: 574287, min_days: 7, max_days: 10 },
{ pincode: 574288, min_days: 7, max_days: 10 },
{ pincode: 574289, min_days: 7, max_days: 10 },
{ pincode: 574290, min_days: 7, max_days: 10 },
{ pincode: 574291, min_days: 7, max_days: 10 },
{ pincode: 574292, min_days: 7, max_days: 10 },
{ pincode: 574293, min_days: 7, max_days: 10 },
{ pincode: 574294, min_days: 7, max_days: 10 },
{ pincode: 574295, min_days: 7, max_days: 10 },
{ pincode: 574296, min_days: 7, max_days: 10 },
{ pincode: 574297, min_days: 7, max_days: 10 },
{ pincode: 574298, min_days: 7, max_days: 10 },
{ pincode: 574299, min_days: 7, max_days: 10 },
{ pincode: 574300, min_days: 7, max_days: 10 },
{ pincode: 574301, min_days: 7, max_days: 10 },
{ pincode: 574302, min_days: 7, max_days: 10 },
{ pincode: 574303, min_days: 7, max_days: 10 },
{ pincode: 574304, min_days: 7, max_days: 10 },
{ pincode: 574305, min_days: 7, max_days: 10 },
{ pincode: 574306, min_days: 7, max_days: 10 },
{ pincode: 574307, min_days: 7, max_days: 10 },
{ pincode: 574309, min_days: 7, max_days: 10 },
{ pincode: 574310, min_days: 7, max_days: 10 },
{ pincode: 574311, min_days: 7, max_days: 10 },
{ pincode: 574312, min_days: 7, max_days: 10 },
{ pincode: 574315, min_days: 7, max_days: 10 },
{ pincode: 574316, min_days: 7, max_days: 10 },
{ pincode: 574317, min_days: 7, max_days: 10 },
{ pincode: 574318, min_days: 7, max_days: 10 },
{ pincode: 574319, min_days: 7, max_days: 10 },
{ pincode: 574320, min_days: 7, max_days: 10 },
{ pincode: 574321, min_days: 7, max_days: 10 },
{ pincode: 574323, min_days: 7, max_days: 10 },
{ pincode: 574324, min_days: 7, max_days: 10 },
{ pincode: 574325, min_days: 7, max_days: 10 },
{ pincode: 574326, min_days: 7, max_days: 10 },
{ pincode: 574329, min_days: 7, max_days: 10 },
{ pincode: 574333, min_days: 7, max_days: 10 },
{ pincode: 574334, min_days: 7, max_days: 10 },
{ pincode: 574335, min_days: 7, max_days: 10 },
{ pincode: 574336, min_days: 7, max_days: 10 },
{ pincode: 574337, min_days: 7, max_days: 10 },
{ pincode: 574371, min_days: 7, max_days: 10 },
{ pincode: 574509, min_days: 7, max_days: 10 },
{ pincode: 575001, min_days: 7, max_days: 10 },
{ pincode: 575002, min_days: 7, max_days: 10 },
{ pincode: 575003, min_days: 7, max_days: 10 },
{ pincode: 575004, min_days: 7, max_days: 10 },
{ pincode: 575005, min_days: 7, max_days: 10 },
{ pincode: 575006, min_days: 7, max_days: 10 },
{ pincode: 575007, min_days: 7, max_days: 10 },
{ pincode: 575008, min_days: 7, max_days: 10 },
{ pincode: 575009, min_days: 7, max_days: 10 },
{ pincode: 575010, min_days: 7, max_days: 10 },
{ pincode: 575011, min_days: 7, max_days: 10 },
{ pincode: 575012, min_days: 7, max_days: 10 },
{ pincode: 575013, min_days: 7, max_days: 10 },
{ pincode: 575014, min_days: 7, max_days: 10 },
{ pincode: 575015, min_days: 7, max_days: 10 },
{ pincode: 575016, min_days: 7, max_days: 10 },
{ pincode: 575017, min_days: 7, max_days: 10 },
{ pincode: 575018, min_days: 7, max_days: 10 },
{ pincode: 575019, min_days: 7, max_days: 10 },
{ pincode: 575020, min_days: 7, max_days: 10 },
{ pincode: 575021, min_days: 7, max_days: 10 },
{ pincode: 575022, min_days: 7, max_days: 10 },
{ pincode: 575023, min_days: 7, max_days: 10 },
{ pincode: 575024, min_days: 7, max_days: 10 },
{ pincode: 575025, min_days: 7, max_days: 10 },
{ pincode: 575026, min_days: 7, max_days: 10 },
{ pincode: 575027, min_days: 7, max_days: 10 },
{ pincode: 575028, min_days: 7, max_days: 10 },
{ pincode: 575029, min_days: 7, max_days: 10 },
{ pincode: 575030, min_days: 7, max_days: 10 },
{ pincode: 575328, min_days: 7, max_days: 10 },
{ pincode: 576101, min_days: 7, max_days: 10 },
{ pincode: 576102, min_days: 7, max_days: 10 },
{ pincode: 576103, min_days: 7, max_days: 10 },
{ pincode: 576104, min_days: 7, max_days: 10 },
{ pincode: 576105, min_days: 7, max_days: 10 },
{ pincode: 576106, min_days: 7, max_days: 10 },
{ pincode: 576107, min_days: 7, max_days: 10 },
{ pincode: 576108, min_days: 7, max_days: 10 },
{ pincode: 576111, min_days: 7, max_days: 10 },
{ pincode: 576113, min_days: 7, max_days: 10 },
{ pincode: 576114, min_days: 7, max_days: 10 },
{ pincode: 576115, min_days: 7, max_days: 10 },
{ pincode: 576117, min_days: 7, max_days: 10 },
{ pincode: 576120, min_days: 7, max_days: 10 },
{ pincode: 576122, min_days: 7, max_days: 10 },
{ pincode: 576128, min_days: 7, max_days: 10 },
{ pincode: 576201, min_days: 7, max_days: 10 },
{ pincode: 576211, min_days: 7, max_days: 10 },
{ pincode: 576213, min_days: 7, max_days: 10 },
{ pincode: 576216, min_days: 7, max_days: 10 },
{ pincode: 576217, min_days: 7, max_days: 10 },
{ pincode: 576218, min_days: 7, max_days: 10 },
{ pincode: 576221, min_days: 7, max_days: 10 },
{ pincode: 576222, min_days: 7, max_days: 10 },
{ pincode: 576224, min_days: 7, max_days: 10 },
{ pincode: 576225, min_days: 7, max_days: 10 },
{ pincode: 576226, min_days: 7, max_days: 10 },
{ pincode: 576230, min_days: 7, max_days: 10 },
{ pincode: 576231, min_days: 7, max_days: 10 },
{ pincode: 576235, min_days: 7, max_days: 10 },
{ pincode: 576247, min_days: 7, max_days: 10 },
{ pincode: 576254, min_days: 7, max_days: 10 },
{ pincode: 576257, min_days: 7, max_days: 10 },
{ pincode: 576283, min_days: 7, max_days: 10 },
{ pincode: 577001, min_days: 7, max_days: 10 },
{ pincode: 577002, min_days: 7, max_days: 10 },
{ pincode: 577003, min_days: 7, max_days: 10 },
{ pincode: 577004, min_days: 7, max_days: 10 },
{ pincode: 577005, min_days: 7, max_days: 10 },
{ pincode: 577153, min_days: 7, max_days: 10 },
{ pincode: 577201, min_days: 7, max_days: 10 },
{ pincode: 577204, min_days: 7, max_days: 10 },
{ pincode: 577205, min_days: 7, max_days: 10 },
{ pincode: 577235, min_days: 7, max_days: 10 },
{ pincode: 577237, min_days: 7, max_days: 10 },
{ pincode: 580001, min_days: 7, max_days: 10 },
{ pincode: 580002, min_days: 7, max_days: 10 },
{ pincode: 580003, min_days: 7, max_days: 10 },
{ pincode: 580004, min_days: 7, max_days: 10 },
{ pincode: 580005, min_days: 7, max_days: 10 },
{ pincode: 580006, min_days: 7, max_days: 10 },
{ pincode: 580007, min_days: 7, max_days: 10 },
{ pincode: 580008, min_days: 7, max_days: 10 },
{ pincode: 580009, min_days: 7, max_days: 10 },
{ pincode: 580011, min_days: 7, max_days: 10 },
{ pincode: 580020, min_days: 7, max_days: 10 },
{ pincode: 580021, min_days: 7, max_days: 10 },
{ pincode: 580022, min_days: 7, max_days: 10 },
{ pincode: 580023, min_days: 7, max_days: 10 },
{ pincode: 580024, min_days: 7, max_days: 10 },
{ pincode: 580025, min_days: 7, max_days: 10 },
{ pincode: 580026, min_days: 7, max_days: 10 },
{ pincode: 580027, min_days: 7, max_days: 10 },
{ pincode: 580028, min_days: 7, max_days: 10 },
{ pincode: 580029, min_days: 7, max_days: 10 },
{ pincode: 580030, min_days: 7, max_days: 10 },
{ pincode: 580031, min_days: 7, max_days: 10 },
{ pincode: 580032, min_days: 7, max_days: 10 },
{ pincode: 580112, min_days: 7, max_days: 10 },
{ pincode: 580114, min_days: 7, max_days: 10 },
{ pincode: 580118, min_days: 7, max_days: 10 },
{ pincode: 580211, min_days: 7, max_days: 10 },
{ pincode: 580212, min_days: 7, max_days: 10 },
{ pincode: 580213, min_days: 7, max_days: 10 },
{ pincode: 580214, min_days: 7, max_days: 10 },
{ pincode: 580215, min_days: 7, max_days: 10 },
{ pincode: 580216, min_days: 7, max_days: 10 },
{ pincode: 581107, min_days: 7, max_days: 10 },
{ pincode: 581113, min_days: 7, max_days: 10 },
{ pincode: 581117, min_days: 7, max_days: 10 },
{ pincode: 581122, min_days: 7, max_days: 10 },
{ pincode: 581124, min_days: 7, max_days: 10 },
{ pincode: 581126, min_days: 7, max_days: 10 },
{ pincode: 581193, min_days: 7, max_days: 10 },
{ pincode: 581195, min_days: 7, max_days: 10 },
{ pincode: 581196, min_days: 7, max_days: 10 },
{ pincode: 581200, min_days: 7, max_days: 10 },
{ pincode: 581202, min_days: 7, max_days: 10 },
{ pincode: 581204, min_days: 7, max_days: 10 },
{ pincode: 581205, min_days: 7, max_days: 10 },
{ pincode: 581207, min_days: 7, max_days: 10 },
{ pincode: 581209, min_days: 7, max_days: 10 },
{ pincode: 581212, min_days: 7, max_days: 10 },
{ pincode: 581325, min_days: 7, max_days: 10 },
{ pincode: 582116, min_days: 7, max_days: 10 },
{ pincode: 582117, min_days: 7, max_days: 10 },
{ pincode: 582201, min_days: 7, max_days: 10 },
{ pincode: 582205, min_days: 7, max_days: 10 },
{ pincode: 582208, min_days: 7, max_days: 10 },
{ pincode: 582210, min_days: 7, max_days: 10 },
{ pincode: 585101, min_days: 7, max_days: 10 },
{ pincode: 585102, min_days: 7, max_days: 10 },
{ pincode: 585103, min_days: 7, max_days: 10 },
{ pincode: 585104, min_days: 7, max_days: 10 },
{ pincode: 585105, min_days: 7, max_days: 10 },
{ pincode: 585243, min_days: 7, max_days: 10 },
{ pincode: 585266, min_days: 7, max_days: 10 },
{ pincode: 585278, min_days: 7, max_days: 10 },
{ pincode: 585282, min_days: 7, max_days: 10 },
{ pincode: 585285, min_days: 7, max_days: 10 },
{ pincode: 585286, min_days: 7, max_days: 10 },
{ pincode: 585289, min_days: 7, max_days: 10 },
{ pincode: 585337, min_days: 7, max_days: 10 },
{ pincode: 590001, min_days: 7, max_days: 10 },
{ pincode: 590002, min_days: 7, max_days: 10 },
{ pincode: 590006, min_days: 7, max_days: 10 },
{ pincode: 590009, min_days: 7, max_days: 10 },
{ pincode: 591103, min_days: 7, max_days: 10 },
{ pincode: 591108, min_days: 7, max_days: 10 },
{ pincode: 591134, min_days: 7, max_days: 10 },
{ pincode: 591135, min_days: 7, max_days: 10 },
{ pincode: 591146, min_days: 7, max_days: 10 },
{ pincode: 591157, min_days: 7, max_days: 10 },
{ pincode: 591175, min_days: 7, max_days: 10 },
{ pincode: 591176, min_days: 7, max_days: 10 },
{ pincode: 591181, min_days: 7, max_days: 10 },
{ pincode: 600000, min_days: 7, max_days: 10 },
{ pincode: 600103, min_days: 7, max_days: 10 },
{ pincode: 600105, min_days: 7, max_days: 10 },
{ pincode: 600109, min_days: 7, max_days: 10 },
{ pincode: 600111, min_days: 7, max_days: 10 },
{ pincode: 600120, min_days: 7, max_days: 10 },
{ pincode: 600121, min_days: 7, max_days: 10 },
{ pincode: 600123, min_days: 7, max_days: 10 },
{ pincode: 600124, min_days: 7, max_days: 10 },
{ pincode: 600131, min_days: 7, max_days: 10 },
{ pincode: 600132, min_days: 7, max_days: 10 },
{ pincode: 601101, min_days: 7, max_days: 10 },
{ pincode: 601102, min_days: 7, max_days: 10 },
{ pincode: 601103, min_days: 7, max_days: 10 },
{ pincode: 601104, min_days: 7, max_days: 10 },
{ pincode: 601105, min_days: 7, max_days: 10 },
{ pincode: 601201, min_days: 7, max_days: 10 },
{ pincode: 601202, min_days: 7, max_days: 10 },
{ pincode: 601203, min_days: 7, max_days: 10 },
{ pincode: 601204, min_days: 7, max_days: 10 },
{ pincode: 601205, min_days: 7, max_days: 10 },
{ pincode: 601206, min_days: 7, max_days: 10 },
{ pincode: 601207, min_days: 7, max_days: 10 },
{ pincode: 601208, min_days: 7, max_days: 10 },
{ pincode: 601209, min_days: 7, max_days: 10 },
{ pincode: 601210, min_days: 7, max_days: 10 },
{ pincode: 601211, min_days: 7, max_days: 10 },
{ pincode: 601212, min_days: 7, max_days: 10 },
{ pincode: 601213, min_days: 7, max_days: 10 },
{ pincode: 601214, min_days: 7, max_days: 10 },
{ pincode: 601295, min_days: 7, max_days: 10 },
{ pincode: 601301, min_days: 7, max_days: 10 },
{ pincode: 601302, min_days: 7, max_days: 10 },
{ pincode: 601303, min_days: 7, max_days: 10 },
{ pincode: 601304, min_days: 7, max_days: 10 },
{ pincode: 602001, min_days: 7, max_days: 10 },
{ pincode: 602002, min_days: 7, max_days: 10 },
{ pincode: 602003, min_days: 7, max_days: 10 },
{ pincode: 602004, min_days: 7, max_days: 10 },
{ pincode: 602021, min_days: 7, max_days: 10 },
{ pincode: 602022, min_days: 7, max_days: 10 },
{ pincode: 602023, min_days: 7, max_days: 10 },
{ pincode: 602024, min_days: 7, max_days: 10 },
{ pincode: 602025, min_days: 7, max_days: 10 },
{ pincode: 602026, min_days: 7, max_days: 10 },
{ pincode: 602027, min_days: 7, max_days: 10 },
{ pincode: 602028, min_days: 7, max_days: 10 },
{ pincode: 602029, min_days: 7, max_days: 10 },
{ pincode: 602030, min_days: 7, max_days: 10 },
{ pincode: 602031, min_days: 7, max_days: 10 },
{ pincode: 602101, min_days: 7, max_days: 10 },
{ pincode: 602102, min_days: 7, max_days: 10 },
{ pincode: 602103, min_days: 7, max_days: 10 },
{ pincode: 602104, min_days: 7, max_days: 10 },
{ pincode: 602105, min_days: 7, max_days: 10 },
{ pincode: 602106, min_days: 7, max_days: 10 },
{ pincode: 602107, min_days: 7, max_days: 10 },
{ pincode: 602108, min_days: 7, max_days: 10 },
{ pincode: 602109, min_days: 7, max_days: 10 },
{ pincode: 602111, min_days: 7, max_days: 10 },
{ pincode: 602112, min_days: 7, max_days: 10 },
{ pincode: 602113, min_days: 7, max_days: 10 },
{ pincode: 602114, min_days: 7, max_days: 10 },
{ pincode: 602115, min_days: 7, max_days: 10 },
{ pincode: 602116, min_days: 7, max_days: 10 },
{ pincode: 602117, min_days: 7, max_days: 10 },
{ pincode: 603001, min_days: 7, max_days: 10 },
{ pincode: 603002, min_days: 7, max_days: 10 },
{ pincode: 603003, min_days: 7, max_days: 10 },
{ pincode: 603004, min_days: 7, max_days: 10 },
{ pincode: 603011, min_days: 7, max_days: 10 },
{ pincode: 603024, min_days: 7, max_days: 10 },
{ pincode: 603048, min_days: 7, max_days: 10 },
{ pincode: 603101, min_days: 7, max_days: 10 },
{ pincode: 603102, min_days: 7, max_days: 10 },
{ pincode: 603104, min_days: 7, max_days: 10 },
{ pincode: 603105, min_days: 7, max_days: 10 },
{ pincode: 603106, min_days: 7, max_days: 10 },
{ pincode: 603107, min_days: 7, max_days: 10 },
{ pincode: 603108, min_days: 7, max_days: 10 },
{ pincode: 603109, min_days: 7, max_days: 10 },
{ pincode: 603110, min_days: 7, max_days: 10 },
{ pincode: 603111, min_days: 7, max_days: 10 },
{ pincode: 603112, min_days: 7, max_days: 10 },
{ pincode: 603113, min_days: 7, max_days: 10 },
{ pincode: 603114, min_days: 7, max_days: 10 },
{ pincode: 603115, min_days: 7, max_days: 10 },
{ pincode: 603116, min_days: 7, max_days: 10 },
{ pincode: 603117, min_days: 7, max_days: 10 },
{ pincode: 603118, min_days: 7, max_days: 10 },
{ pincode: 603119, min_days: 7, max_days: 10 },
{ pincode: 603120, min_days: 7, max_days: 10 },
{ pincode: 603121, min_days: 7, max_days: 10 },
{ pincode: 603122, min_days: 7, max_days: 10 },
{ pincode: 603126, min_days: 7, max_days: 10 },
{ pincode: 603127, min_days: 7, max_days: 10 },
{ pincode: 603201, min_days: 7, max_days: 10 },
{ pincode: 603202, min_days: 7, max_days: 10 },
{ pincode: 603203, min_days: 7, max_days: 10 },
{ pincode: 603204, min_days: 7, max_days: 10 },
{ pincode: 603205, min_days: 7, max_days: 10 },
{ pincode: 603209, min_days: 7, max_days: 10 },
{ pincode: 603210, min_days: 7, max_days: 10 },
{ pincode: 603211, min_days: 7, max_days: 10 },
{ pincode: 603212, min_days: 7, max_days: 10 },
{ pincode: 603219, min_days: 7, max_days: 10 },
{ pincode: 603232, min_days: 7, max_days: 10 },
{ pincode: 603303, min_days: 7, max_days: 10 },
{ pincode: 603308, min_days: 7, max_days: 10 },
{ pincode: 603314, min_days: 7, max_days: 10 },
{ pincode: 603315, min_days: 7, max_days: 10 },
{ pincode: 603316, min_days: 7, max_days: 10 },
{ pincode: 603317, min_days: 7, max_days: 10 },
{ pincode: 603318, min_days: 7, max_days: 10 },
{ pincode: 603320, min_days: 7, max_days: 10 },
{ pincode: 603404, min_days: 7, max_days: 10 },
{ pincode: 603405, min_days: 7, max_days: 10 },
{ pincode: 603406, min_days: 7, max_days: 10 },
{ pincode: 603408, min_days: 7, max_days: 10 },
{ pincode: 604001, min_days: 7, max_days: 10 },
{ pincode: 604024, min_days: 7, max_days: 10 },
{ pincode: 604101, min_days: 7, max_days: 10 },
{ pincode: 604102, min_days: 7, max_days: 10 },
{ pincode: 604103, min_days: 7, max_days: 10 },
{ pincode: 604105, min_days: 7, max_days: 10 },
{ pincode: 604154, min_days: 7, max_days: 10 },
{ pincode: 604155, min_days: 7, max_days: 10 },
{ pincode: 604156, min_days: 7, max_days: 10 },
{ pincode: 604202, min_days: 7, max_days: 10 },
{ pincode: 604203, min_days: 7, max_days: 10 },
{ pincode: 604205, min_days: 7, max_days: 10 },
{ pincode: 604206, min_days: 7, max_days: 10 },
{ pincode: 604207, min_days: 7, max_days: 10 },
{ pincode: 604210, min_days: 7, max_days: 10 },
{ pincode: 604211, min_days: 7, max_days: 10 },
{ pincode: 604212, min_days: 7, max_days: 10 },
{ pincode: 604213, min_days: 7, max_days: 10 },
{ pincode: 604301, min_days: 7, max_days: 10 },
{ pincode: 604302, min_days: 7, max_days: 10 },
{ pincode: 604303, min_days: 7, max_days: 10 },
{ pincode: 604304, min_days: 7, max_days: 10 },
{ pincode: 604305, min_days: 7, max_days: 10 },
{ pincode: 604306, min_days: 7, max_days: 10 },
{ pincode: 604307, min_days: 7, max_days: 10 },
{ pincode: 604309, min_days: 7, max_days: 10 },
{ pincode: 604401, min_days: 7, max_days: 10 },
{ pincode: 604402, min_days: 7, max_days: 10 },
{ pincode: 604404, min_days: 7, max_days: 10 },
{ pincode: 604405, min_days: 7, max_days: 10 },
{ pincode: 604407, min_days: 7, max_days: 10 },
{ pincode: 604408, min_days: 7, max_days: 10 },
{ pincode: 604409, min_days: 7, max_days: 10 },
{ pincode: 604410, min_days: 7, max_days: 10 },
{ pincode: 604503, min_days: 7, max_days: 10 },
{ pincode: 604504, min_days: 7, max_days: 10 },
{ pincode: 604505, min_days: 7, max_days: 10 },
{ pincode: 604601, min_days: 7, max_days: 10 },
{ pincode: 605001, min_days: 7, max_days: 10 },
{ pincode: 605002, min_days: 7, max_days: 10 },
{ pincode: 605003, min_days: 7, max_days: 10 },
{ pincode: 605004, min_days: 7, max_days: 10 },
{ pincode: 605005, min_days: 7, max_days: 10 },
{ pincode: 605006, min_days: 7, max_days: 10 },
{ pincode: 605007, min_days: 7, max_days: 10 },
{ pincode: 605008, min_days: 7, max_days: 10 },
{ pincode: 605009, min_days: 7, max_days: 10 },
{ pincode: 605010, min_days: 7, max_days: 10 },
{ pincode: 605011, min_days: 7, max_days: 10 },
{ pincode: 605012, min_days: 7, max_days: 10 },
{ pincode: 605013, min_days: 7, max_days: 10 },
{ pincode: 605014, min_days: 7, max_days: 10 },
{ pincode: 605016, min_days: 7, max_days: 10 },
{ pincode: 605036, min_days: 7, max_days: 10 },
{ pincode: 605051, min_days: 7, max_days: 10 },
{ pincode: 605101, min_days: 7, max_days: 10 },
{ pincode: 605102, min_days: 7, max_days: 10 },
{ pincode: 605103, min_days: 7, max_days: 10 },
{ pincode: 605104, min_days: 7, max_days: 10 },
{ pincode: 605105, min_days: 7, max_days: 10 },
{ pincode: 605106, min_days: 7, max_days: 10 },
{ pincode: 605107, min_days: 7, max_days: 10 },
{ pincode: 605108, min_days: 7, max_days: 10 },
{ pincode: 605109, min_days: 7, max_days: 10 },
{ pincode: 605110, min_days: 7, max_days: 10 },
{ pincode: 605111, min_days: 7, max_days: 10 },
{ pincode: 605112, min_days: 7, max_days: 10 },
{ pincode: 605113, min_days: 7, max_days: 10 },
{ pincode: 605114, min_days: 7, max_days: 10 },
{ pincode: 605115, min_days: 7, max_days: 10 },
{ pincode: 605116, min_days: 7, max_days: 10 },
{ pincode: 605118, min_days: 7, max_days: 10 },
{ pincode: 605120, min_days: 7, max_days: 10 },
{ pincode: 605123, min_days: 7, max_days: 10 },
{ pincode: 605201, min_days: 7, max_days: 10 },
{ pincode: 605202, min_days: 7, max_days: 10 },
{ pincode: 605203, min_days: 7, max_days: 10 },
{ pincode: 605207, min_days: 7, max_days: 10 },
{ pincode: 605301, min_days: 7, max_days: 10 },
{ pincode: 605302, min_days: 7, max_days: 10 },
{ pincode: 605401, min_days: 7, max_days: 10 },
{ pincode: 605402, min_days: 7, max_days: 10 },
{ pincode: 605501, min_days: 7, max_days: 10 },
{ pincode: 605502, min_days: 7, max_days: 10 },
{ pincode: 605503, min_days: 7, max_days: 10 },
{ pincode: 605504, min_days: 7, max_days: 10 },
{ pincode: 605601, min_days: 7, max_days: 10 },
{ pincode: 605602, min_days: 7, max_days: 10 },
{ pincode: 605604, min_days: 7, max_days: 10 },
{ pincode: 605605, min_days: 7, max_days: 10 },
{ pincode: 605606, min_days: 7, max_days: 10 },
{ pincode: 605651, min_days: 7, max_days: 10 },
{ pincode: 605652, min_days: 7, max_days: 10 },
{ pincode: 605655, min_days: 7, max_days: 10 },
{ pincode: 605701, min_days: 7, max_days: 10 },
{ pincode: 605753, min_days: 7, max_days: 10 },
{ pincode: 605755, min_days: 7, max_days: 10 },
{ pincode: 605805, min_days: 7, max_days: 10 },
{ pincode: 605809, min_days: 7, max_days: 10 },
{ pincode: 606101, min_days: 7, max_days: 10 },
{ pincode: 606102, min_days: 7, max_days: 10 },
{ pincode: 606107, min_days: 7, max_days: 10 },
{ pincode: 606115, min_days: 7, max_days: 10 },
{ pincode: 606120, min_days: 7, max_days: 10 },
{ pincode: 606221, min_days: 7, max_days: 10 },
{ pincode: 606223, min_days: 7, max_days: 10 },
{ pincode: 606306, min_days: 7, max_days: 10 },
{ pincode: 606307, min_days: 7, max_days: 10 },
{ pincode: 606309, min_days: 7, max_days: 10 },
{ pincode: 606405, min_days: 7, max_days: 10 },
{ pincode: 606407, min_days: 7, max_days: 10 },
{ pincode: 606601, min_days: 7, max_days: 10 },
{ pincode: 606602, min_days: 7, max_days: 10 },
{ pincode: 606603, min_days: 7, max_days: 10 },
{ pincode: 606604, min_days: 7, max_days: 10 },
{ pincode: 606611, min_days: 7, max_days: 10 },
{ pincode: 606701, min_days: 7, max_days: 10 },
{ pincode: 606702, min_days: 7, max_days: 10 },
{ pincode: 606703, min_days: 7, max_days: 10 },
{ pincode: 606704, min_days: 7, max_days: 10 },
{ pincode: 606705, min_days: 7, max_days: 10 },
{ pincode: 606706, min_days: 7, max_days: 10 },
{ pincode: 606707, min_days: 7, max_days: 10 },
{ pincode: 606709, min_days: 7, max_days: 10 },
{ pincode: 606718, min_days: 7, max_days: 10 },
{ pincode: 606751, min_days: 7, max_days: 10 },
{ pincode: 606752, min_days: 7, max_days: 10 },
{ pincode: 606753, min_days: 7, max_days: 10 },
{ pincode: 606754, min_days: 7, max_days: 10 },
{ pincode: 606755, min_days: 7, max_days: 10 },
{ pincode: 606801, min_days: 7, max_days: 10 },
{ pincode: 606802, min_days: 7, max_days: 10 },
{ pincode: 606803, min_days: 7, max_days: 10 },
{ pincode: 606804, min_days: 7, max_days: 10 },
{ pincode: 606805, min_days: 7, max_days: 10 },
{ pincode: 606806, min_days: 7, max_days: 10 },
{ pincode: 606807, min_days: 7, max_days: 10 },
{ pincode: 606808, min_days: 7, max_days: 10 },
{ pincode: 606809, min_days: 7, max_days: 10 },
{ pincode: 606811, min_days: 7, max_days: 10 },
{ pincode: 606901, min_days: 7, max_days: 10 },
{ pincode: 606902, min_days: 7, max_days: 10 },
{ pincode: 606903, min_days: 7, max_days: 10 },
{ pincode: 606904, min_days: 7, max_days: 10 },
{ pincode: 606905, min_days: 7, max_days: 10 },
{ pincode: 606906, min_days: 7, max_days: 10 },
{ pincode: 606907, min_days: 7, max_days: 10 },
{ pincode: 606909, min_days: 7, max_days: 10 },
{ pincode: 606910, min_days: 7, max_days: 10 },
{ pincode: 606911, min_days: 7, max_days: 10 },
{ pincode: 606912, min_days: 7, max_days: 10 },
{ pincode: 606914, min_days: 7, max_days: 10 },
{ pincode: 606915, min_days: 7, max_days: 10 },
{ pincode: 607001, min_days: 7, max_days: 10 },
{ pincode: 607002, min_days: 7, max_days: 10 },
{ pincode: 607003, min_days: 7, max_days: 10 },
{ pincode: 607004, min_days: 7, max_days: 10 },
{ pincode: 607005, min_days: 7, max_days: 10 },
{ pincode: 607006, min_days: 7, max_days: 10 },
{ pincode: 607101, min_days: 7, max_days: 10 },
{ pincode: 607102, min_days: 7, max_days: 10 },
{ pincode: 607103, min_days: 7, max_days: 10 },
{ pincode: 607104, min_days: 7, max_days: 10 },
{ pincode: 607105, min_days: 7, max_days: 10 },
{ pincode: 607106, min_days: 7, max_days: 10 },
{ pincode: 607107, min_days: 7, max_days: 10 },
{ pincode: 607108, min_days: 7, max_days: 10 },
{ pincode: 607109, min_days: 7, max_days: 10 },
{ pincode: 607112, min_days: 7, max_days: 10 },
{ pincode: 607116, min_days: 7, max_days: 10 },
{ pincode: 607203, min_days: 7, max_days: 10 },
{ pincode: 607205, min_days: 7, max_days: 10 },
{ pincode: 607207, min_days: 7, max_days: 10 },
{ pincode: 607209, min_days: 7, max_days: 10 },
{ pincode: 607301, min_days: 7, max_days: 10 },
{ pincode: 607302, min_days: 7, max_days: 10 },
{ pincode: 607303, min_days: 7, max_days: 10 },
{ pincode: 607308, min_days: 7, max_days: 10 },
{ pincode: 607401, min_days: 7, max_days: 10 },
{ pincode: 607402, min_days: 7, max_days: 10 },
{ pincode: 607403, min_days: 7, max_days: 10 },
{ pincode: 608501, min_days: 7, max_days: 10 },
{ pincode: 608502, min_days: 7, max_days: 10 },
{ pincode: 608801, min_days: 7, max_days: 10 },
{ pincode: 610206, min_days: 7, max_days: 10 },
{ pincode: 613001, min_days: 7, max_days: 10 },
{ pincode: 613002, min_days: 7, max_days: 10 },
{ pincode: 613003, min_days: 7, max_days: 10 },
{ pincode: 613004, min_days: 7, max_days: 10 },
{ pincode: 613005, min_days: 7, max_days: 10 },
{ pincode: 613006, min_days: 7, max_days: 10 },
{ pincode: 613007, min_days: 7, max_days: 10 },
{ pincode: 613008, min_days: 7, max_days: 10 },
{ pincode: 613009, min_days: 7, max_days: 10 },
{ pincode: 613010, min_days: 7, max_days: 10 },
{ pincode: 613101, min_days: 7, max_days: 10 },
{ pincode: 613102, min_days: 7, max_days: 10 },
{ pincode: 613103, min_days: 7, max_days: 10 },
{ pincode: 613104, min_days: 7, max_days: 10 },
{ pincode: 613105, min_days: 7, max_days: 10 },
{ pincode: 613201, min_days: 7, max_days: 10 },
{ pincode: 613202, min_days: 7, max_days: 10 },
{ pincode: 613203, min_days: 7, max_days: 10 },
{ pincode: 613204, min_days: 7, max_days: 10 },
{ pincode: 613205, min_days: 7, max_days: 10 },
{ pincode: 613301, min_days: 7, max_days: 10 },
{ pincode: 613302, min_days: 7, max_days: 10 },
{ pincode: 613303, min_days: 7, max_days: 10 },
{ pincode: 613304, min_days: 7, max_days: 10 },
{ pincode: 613305, min_days: 7, max_days: 10 },
{ pincode: 613307, min_days: 7, max_days: 10 },
{ pincode: 613308, min_days: 7, max_days: 10 },
{ pincode: 613401, min_days: 7, max_days: 10 },
{ pincode: 613402, min_days: 7, max_days: 10 },
{ pincode: 613403, min_days: 7, max_days: 10 },
{ pincode: 613501, min_days: 7, max_days: 10 },
{ pincode: 613502, min_days: 7, max_days: 10 },
{ pincode: 613503, min_days: 7, max_days: 10 },
{ pincode: 613601, min_days: 7, max_days: 10 },
{ pincode: 613602, min_days: 7, max_days: 10 },
{ pincode: 614202, min_days: 7, max_days: 10 },
{ pincode: 614203, min_days: 7, max_days: 10 },
{ pincode: 614206, min_days: 7, max_days: 10 },
{ pincode: 614614, min_days: 7, max_days: 10 },
{ pincode: 614633, min_days: 7, max_days: 10 },
{ pincode: 614634, min_days: 7, max_days: 10 },
{ pincode: 614635, min_days: 7, max_days: 10 },
{ pincode: 614636, min_days: 7, max_days: 10 },
{ pincode: 614637, min_days: 7, max_days: 10 },
{ pincode: 614638, min_days: 7, max_days: 10 },
{ pincode: 614639, min_days: 7, max_days: 10 },
{ pincode: 614902, min_days: 7, max_days: 10 },
{ pincode: 614904, min_days: 7, max_days: 10 },
{ pincode: 620000, min_days: 7, max_days: 10 },
{ pincode: 620001, min_days: 7, max_days: 10 },
{ pincode: 620002, min_days: 7, max_days: 10 },
{ pincode: 620003, min_days: 7, max_days: 10 },
{ pincode: 620004, min_days: 7, max_days: 10 },
{ pincode: 620005, min_days: 7, max_days: 10 },
{ pincode: 620006, min_days: 7, max_days: 10 },
{ pincode: 620007, min_days: 7, max_days: 10 },
{ pincode: 620008, min_days: 7, max_days: 10 },
{ pincode: 620009, min_days: 7, max_days: 10 },
{ pincode: 620010, min_days: 7, max_days: 10 },
{ pincode: 620011, min_days: 7, max_days: 10 },
{ pincode: 620012, min_days: 7, max_days: 10 },
{ pincode: 620013, min_days: 7, max_days: 10 },
{ pincode: 620014, min_days: 7, max_days: 10 },
{ pincode: 620015, min_days: 7, max_days: 10 },
{ pincode: 620016, min_days: 7, max_days: 10 },
{ pincode: 620017, min_days: 7, max_days: 10 },
{ pincode: 620018, min_days: 7, max_days: 10 },
{ pincode: 620019, min_days: 7, max_days: 10 },
{ pincode: 620020, min_days: 7, max_days: 10 },
{ pincode: 620021, min_days: 7, max_days: 10 },
{ pincode: 620022, min_days: 7, max_days: 10 },
{ pincode: 620023, min_days: 7, max_days: 10 },
{ pincode: 620024, min_days: 7, max_days: 10 },
{ pincode: 620025, min_days: 7, max_days: 10 },
{ pincode: 620026, min_days: 7, max_days: 10 },
{ pincode: 620027, min_days: 7, max_days: 10 },
{ pincode: 620101, min_days: 7, max_days: 10 },
{ pincode: 620102, min_days: 7, max_days: 10 },
{ pincode: 621001, min_days: 7, max_days: 10 },
{ pincode: 621002, min_days: 7, max_days: 10 },
{ pincode: 621003, min_days: 7, max_days: 10 },
{ pincode: 621004, min_days: 7, max_days: 10 },
{ pincode: 621005, min_days: 7, max_days: 10 },
{ pincode: 621006, min_days: 7, max_days: 10 },
{ pincode: 621007, min_days: 7, max_days: 10 },
{ pincode: 621008, min_days: 7, max_days: 10 },
{ pincode: 621009, min_days: 7, max_days: 10 },
{ pincode: 621010, min_days: 7, max_days: 10 },
{ pincode: 621012, min_days: 7, max_days: 10 },
{ pincode: 621013, min_days: 7, max_days: 10 },
{ pincode: 621014, min_days: 7, max_days: 10 },
{ pincode: 621015, min_days: 7, max_days: 10 },
{ pincode: 621016, min_days: 7, max_days: 10 },
{ pincode: 621017, min_days: 7, max_days: 10 },
{ pincode: 621018, min_days: 7, max_days: 10 },
{ pincode: 621019, min_days: 7, max_days: 10 },
{ pincode: 621020, min_days: 7, max_days: 10 },
{ pincode: 621021, min_days: 7, max_days: 10 },
{ pincode: 621022, min_days: 7, max_days: 10 },
{ pincode: 621023, min_days: 7, max_days: 10 },
{ pincode: 621101, min_days: 7, max_days: 10 },
{ pincode: 621102, min_days: 7, max_days: 10 },
{ pincode: 621104, min_days: 7, max_days: 10 },
{ pincode: 621105, min_days: 7, max_days: 10 },
{ pincode: 621106, min_days: 7, max_days: 10 },
{ pincode: 621107, min_days: 7, max_days: 10 },
{ pincode: 621108, min_days: 7, max_days: 10 },
{ pincode: 621109, min_days: 7, max_days: 10 },
{ pincode: 621111, min_days: 7, max_days: 10 },
{ pincode: 621112, min_days: 7, max_days: 10 },
{ pincode: 621113, min_days: 7, max_days: 10 },
{ pincode: 621114, min_days: 7, max_days: 10 },
{ pincode: 621115, min_days: 7, max_days: 10 },
{ pincode: 621116, min_days: 7, max_days: 10 },
{ pincode: 621118, min_days: 7, max_days: 10 },
{ pincode: 621120, min_days: 7, max_days: 10 },
{ pincode: 621121, min_days: 7, max_days: 10 },
{ pincode: 621127, min_days: 7, max_days: 10 },
{ pincode: 621128, min_days: 7, max_days: 10 },
{ pincode: 621129, min_days: 7, max_days: 10 },
{ pincode: 621132, min_days: 7, max_days: 10 },
{ pincode: 621201, min_days: 7, max_days: 10 },
{ pincode: 621202, min_days: 7, max_days: 10 },
{ pincode: 621203, min_days: 7, max_days: 10 },
{ pincode: 621204, min_days: 7, max_days: 10 },
{ pincode: 621205, min_days: 7, max_days: 10 },
{ pincode: 621206, min_days: 7, max_days: 10 },
{ pincode: 621207, min_days: 7, max_days: 10 },
{ pincode: 621208, min_days: 7, max_days: 10 },
{ pincode: 621209, min_days: 7, max_days: 10 },
{ pincode: 621210, min_days: 7, max_days: 10 },
{ pincode: 621211, min_days: 7, max_days: 10 },
{ pincode: 621212, min_days: 7, max_days: 10 },
{ pincode: 621213, min_days: 7, max_days: 10 },
{ pincode: 621214, min_days: 7, max_days: 10 },
{ pincode: 621215, min_days: 7, max_days: 10 },
{ pincode: 621216, min_days: 7, max_days: 10 },
{ pincode: 621217, min_days: 7, max_days: 10 },
{ pincode: 621218, min_days: 7, max_days: 10 },
{ pincode: 621219, min_days: 7, max_days: 10 },
{ pincode: 621220, min_days: 7, max_days: 10 },
{ pincode: 621221, min_days: 7, max_days: 10 },
{ pincode: 621224, min_days: 7, max_days: 10 },
{ pincode: 621229, min_days: 7, max_days: 10 },
{ pincode: 621302, min_days: 7, max_days: 10 },
{ pincode: 621303, min_days: 7, max_days: 10 },
{ pincode: 621304, min_days: 7, max_days: 10 },
{ pincode: 621305, min_days: 7, max_days: 10 },
{ pincode: 621306, min_days: 7, max_days: 10 },
{ pincode: 621307, min_days: 7, max_days: 10 },
{ pincode: 621308, min_days: 7, max_days: 10 },
{ pincode: 621309, min_days: 7, max_days: 10 },
{ pincode: 621310, min_days: 7, max_days: 10 },
{ pincode: 621312, min_days: 7, max_days: 10 },
{ pincode: 621313, min_days: 7, max_days: 10 },
{ pincode: 621314, min_days: 7, max_days: 10 },
{ pincode: 621316, min_days: 7, max_days: 10 },
{ pincode: 621317, min_days: 7, max_days: 10 },
{ pincode: 621601, min_days: 7, max_days: 10 },
{ pincode: 621604, min_days: 7, max_days: 10 },
{ pincode: 621620, min_days: 7, max_days: 10 },
{ pincode: 621624, min_days: 7, max_days: 10 },
{ pincode: 621626, min_days: 7, max_days: 10 },
{ pincode: 621651, min_days: 7, max_days: 10 },
{ pincode: 621652, min_days: 7, max_days: 10 },
{ pincode: 621653, min_days: 7, max_days: 10 },
{ pincode: 621702, min_days: 7, max_days: 10 },
{ pincode: 621703, min_days: 7, max_days: 10 },
{ pincode: 621704, min_days: 7, max_days: 10 },
{ pincode: 621706, min_days: 7, max_days: 10 },
{ pincode: 621707, min_days: 7, max_days: 10 },
{ pincode: 621708, min_days: 7, max_days: 10 },
{ pincode: 621711, min_days: 7, max_days: 10 },
{ pincode: 621712, min_days: 7, max_days: 10 },
{ pincode: 621713, min_days: 7, max_days: 10 },
{ pincode: 621715, min_days: 7, max_days: 10 },
{ pincode: 621722, min_days: 7, max_days: 10 },
{ pincode: 621851, min_days: 7, max_days: 10 },
{ pincode: 622001, min_days: 7, max_days: 10 },
{ pincode: 622002, min_days: 7, max_days: 10 },
{ pincode: 622003, min_days: 7, max_days: 10 },
{ pincode: 622004, min_days: 7, max_days: 10 },
{ pincode: 622005, min_days: 7, max_days: 10 },
{ pincode: 622009, min_days: 7, max_days: 10 },
{ pincode: 622052, min_days: 7, max_days: 10 },
{ pincode: 622053, min_days: 7, max_days: 10 },
{ pincode: 622054, min_days: 7, max_days: 10 },
{ pincode: 622055, min_days: 7, max_days: 10 },
{ pincode: 622056, min_days: 7, max_days: 10 },
{ pincode: 622101, min_days: 7, max_days: 10 },
{ pincode: 622102, min_days: 7, max_days: 10 },
{ pincode: 622103, min_days: 7, max_days: 10 },
{ pincode: 622104, min_days: 7, max_days: 10 },
{ pincode: 622105, min_days: 7, max_days: 10 },
{ pincode: 622106, min_days: 7, max_days: 10 },
{ pincode: 622107, min_days: 7, max_days: 10 },
{ pincode: 622108, min_days: 7, max_days: 10 },
{ pincode: 622203, min_days: 7, max_days: 10 },
{ pincode: 622205, min_days: 7, max_days: 10 },
{ pincode: 622206, min_days: 7, max_days: 10 },
{ pincode: 622207, min_days: 7, max_days: 10 },
{ pincode: 622208, min_days: 7, max_days: 10 },
{ pincode: 622210, min_days: 7, max_days: 10 },
{ pincode: 622211, min_days: 7, max_days: 10 },
{ pincode: 622212, min_days: 7, max_days: 10 },
{ pincode: 622213, min_days: 7, max_days: 10 },
{ pincode: 622302, min_days: 7, max_days: 10 },
{ pincode: 622303, min_days: 7, max_days: 10 },
{ pincode: 622404, min_days: 7, max_days: 10 },
{ pincode: 622405, min_days: 7, max_days: 10 },
{ pincode: 622406, min_days: 7, max_days: 10 },
{ pincode: 622408, min_days: 7, max_days: 10 },
{ pincode: 622410, min_days: 7, max_days: 10 },
{ pincode: 622411, min_days: 7, max_days: 10 },
{ pincode: 622412, min_days: 7, max_days: 10 },
{ pincode: 622413, min_days: 7, max_days: 10 },
{ pincode: 622414, min_days: 7, max_days: 10 },
{ pincode: 622415, min_days: 7, max_days: 10 },
{ pincode: 622416, min_days: 7, max_days: 10 },
{ pincode: 622417, min_days: 7, max_days: 10 },
{ pincode: 622419, min_days: 7, max_days: 10 },
{ pincode: 622420, min_days: 7, max_days: 10 },
{ pincode: 622421, min_days: 7, max_days: 10 },
{ pincode: 622422, min_days: 7, max_days: 10 },
{ pincode: 622501, min_days: 7, max_days: 10 },
{ pincode: 622502, min_days: 7, max_days: 10 },
{ pincode: 622504, min_days: 7, max_days: 10 },
{ pincode: 622506, min_days: 7, max_days: 10 },
{ pincode: 622508, min_days: 7, max_days: 10 },
{ pincode: 622509, min_days: 7, max_days: 10 },
{ pincode: 622510, min_days: 7, max_days: 10 },
{ pincode: 622511, min_days: 7, max_days: 10 },
{ pincode: 622512, min_days: 7, max_days: 10 },
{ pincode: 622513, min_days: 7, max_days: 10 },
{ pincode: 622514, min_days: 7, max_days: 10 },
{ pincode: 622515, min_days: 7, max_days: 10 },
{ pincode: 622518, min_days: 7, max_days: 10 },
{ pincode: 622521, min_days: 7, max_days: 10 },
{ pincode: 622522, min_days: 7, max_days: 10 },
{ pincode: 624001, min_days: 7, max_days: 10 },
{ pincode: 624002, min_days: 7, max_days: 10 },
{ pincode: 624003, min_days: 7, max_days: 10 },
{ pincode: 624004, min_days: 7, max_days: 10 },
{ pincode: 624005, min_days: 7, max_days: 10 },
{ pincode: 624006, min_days: 7, max_days: 10 },
{ pincode: 624007, min_days: 7, max_days: 10 },
{ pincode: 624008, min_days: 7, max_days: 10 },
{ pincode: 624010, min_days: 7, max_days: 10 },
{ pincode: 624201, min_days: 7, max_days: 10 },
{ pincode: 624202, min_days: 7, max_days: 10 },
{ pincode: 624204, min_days: 7, max_days: 10 },
{ pincode: 624206, min_days: 7, max_days: 10 },
{ pincode: 624208, min_days: 7, max_days: 10 },
{ pincode: 624211, min_days: 7, max_days: 10 },
{ pincode: 624215, min_days: 7, max_days: 10 },
{ pincode: 624219, min_days: 7, max_days: 10 },
{ pincode: 624301, min_days: 7, max_days: 10 },
{ pincode: 624302, min_days: 7, max_days: 10 },
{ pincode: 624303, min_days: 7, max_days: 10 },
{ pincode: 624306, min_days: 7, max_days: 10 },
{ pincode: 624307, min_days: 7, max_days: 10 },
{ pincode: 624308, min_days: 7, max_days: 10 },
{ pincode: 624401, min_days: 7, max_days: 10 },
{ pincode: 624402, min_days: 7, max_days: 10 },
{ pincode: 624403, min_days: 7, max_days: 10 },
{ pincode: 624701, min_days: 7, max_days: 10 },
{ pincode: 624705, min_days: 7, max_days: 10 },
{ pincode: 624707, min_days: 7, max_days: 10 },
{ pincode: 624708, min_days: 7, max_days: 10 },
{ pincode: 625001, min_days: 7, max_days: 10 },
{ pincode: 625002, min_days: 7, max_days: 10 },
{ pincode: 625003, min_days: 7, max_days: 10 },
{ pincode: 625004, min_days: 7, max_days: 10 },
{ pincode: 625005, min_days: 7, max_days: 10 },
{ pincode: 625006, min_days: 7, max_days: 10 },
{ pincode: 625007, min_days: 7, max_days: 10 },
{ pincode: 625008, min_days: 7, max_days: 10 },
{ pincode: 625009, min_days: 7, max_days: 10 },
{ pincode: 625010, min_days: 7, max_days: 10 },
{ pincode: 625011, min_days: 7, max_days: 10 },
{ pincode: 625012, min_days: 7, max_days: 10 },
{ pincode: 625013, min_days: 7, max_days: 10 },
{ pincode: 625014, min_days: 7, max_days: 10 },
{ pincode: 625015, min_days: 7, max_days: 10 },
{ pincode: 625016, min_days: 7, max_days: 10 },
{ pincode: 625017, min_days: 7, max_days: 10 },
{ pincode: 625018, min_days: 7, max_days: 10 },
{ pincode: 625019, min_days: 7, max_days: 10 },
{ pincode: 625020, min_days: 7, max_days: 10 },
{ pincode: 625021, min_days: 7, max_days: 10 },
{ pincode: 625022, min_days: 7, max_days: 10 },
{ pincode: 625023, min_days: 7, max_days: 10 },
{ pincode: 625025, min_days: 7, max_days: 10 },
{ pincode: 625101, min_days: 7, max_days: 10 },
{ pincode: 625102, min_days: 7, max_days: 10 },
{ pincode: 625103, min_days: 7, max_days: 10 },
{ pincode: 625104, min_days: 7, max_days: 10 },
{ pincode: 625105, min_days: 7, max_days: 10 },
{ pincode: 625106, min_days: 7, max_days: 10 },
{ pincode: 625107, min_days: 7, max_days: 10 },
{ pincode: 625108, min_days: 7, max_days: 10 },
{ pincode: 625109, min_days: 7, max_days: 10 },
{ pincode: 625110, min_days: 7, max_days: 10 },
{ pincode: 625111, min_days: 7, max_days: 10 },
{ pincode: 625112, min_days: 7, max_days: 10 },
{ pincode: 625113, min_days: 7, max_days: 10 },
{ pincode: 625114, min_days: 7, max_days: 10 },
{ pincode: 625115, min_days: 7, max_days: 10 },
{ pincode: 625116, min_days: 7, max_days: 10 },
{ pincode: 625117, min_days: 7, max_days: 10 },
{ pincode: 625118, min_days: 7, max_days: 10 },
{ pincode: 625119, min_days: 7, max_days: 10 },
{ pincode: 625120, min_days: 7, max_days: 10 },
{ pincode: 625121, min_days: 7, max_days: 10 },
{ pincode: 625122, min_days: 7, max_days: 10 },
{ pincode: 625123, min_days: 7, max_days: 10 },
{ pincode: 625124, min_days: 7, max_days: 10 },
{ pincode: 625125, min_days: 7, max_days: 10 },
{ pincode: 625126, min_days: 7, max_days: 10 },
{ pincode: 625127, min_days: 7, max_days: 10 },
{ pincode: 625151, min_days: 7, max_days: 10 },
{ pincode: 625152, min_days: 7, max_days: 10 },
{ pincode: 625201, min_days: 7, max_days: 10 },
{ pincode: 625203, min_days: 7, max_days: 10 },
{ pincode: 625205, min_days: 7, max_days: 10 },
{ pincode: 625206, min_days: 7, max_days: 10 },
{ pincode: 625207, min_days: 7, max_days: 10 },
{ pincode: 625209, min_days: 7, max_days: 10 },
{ pincode: 625214, min_days: 7, max_days: 10 },
{ pincode: 625217, min_days: 7, max_days: 10 },
{ pincode: 625218, min_days: 7, max_days: 10 },
{ pincode: 625221, min_days: 7, max_days: 10 },
{ pincode: 625234, min_days: 7, max_days: 10 },
{ pincode: 625301, min_days: 7, max_days: 10 },
{ pincode: 625303, min_days: 7, max_days: 10 },
{ pincode: 625304, min_days: 7, max_days: 10 },
{ pincode: 625401, min_days: 7, max_days: 10 },
{ pincode: 625402, min_days: 7, max_days: 10 },
{ pincode: 625403, min_days: 7, max_days: 10 },
{ pincode: 625501, min_days: 7, max_days: 10 },
{ pincode: 625502, min_days: 7, max_days: 10 },
{ pincode: 625503, min_days: 7, max_days: 10 },
{ pincode: 625504, min_days: 7, max_days: 10 },
{ pincode: 625506, min_days: 7, max_days: 10 },
{ pincode: 625514, min_days: 7, max_days: 10 },
{ pincode: 625527, min_days: 7, max_days: 10 },
{ pincode: 625529, min_days: 7, max_days: 10 },
{ pincode: 625532, min_days: 7, max_days: 10 },
{ pincode: 625537, min_days: 7, max_days: 10 },
{ pincode: 625566, min_days: 7, max_days: 10 },
{ pincode: 625701, min_days: 7, max_days: 10 },
{ pincode: 625702, min_days: 7, max_days: 10 },
{ pincode: 625704, min_days: 7, max_days: 10 },
{ pincode: 625706, min_days: 7, max_days: 10 },
{ pincode: 625707, min_days: 7, max_days: 10 },
{ pincode: 625708, min_days: 7, max_days: 10 },
{ pincode: 625709, min_days: 7, max_days: 10 },
{ pincode: 625712, min_days: 7, max_days: 10 },
{ pincode: 626001, min_days: 7, max_days: 10 },
{ pincode: 626002, min_days: 7, max_days: 10 },
{ pincode: 626003, min_days: 7, max_days: 10 },
{ pincode: 626005, min_days: 7, max_days: 10 },
{ pincode: 626101, min_days: 7, max_days: 10 },
{ pincode: 626104, min_days: 7, max_days: 10 },
{ pincode: 626105, min_days: 7, max_days: 10 },
{ pincode: 626106, min_days: 7, max_days: 10 },
{ pincode: 626107, min_days: 7, max_days: 10 },
{ pincode: 626109, min_days: 7, max_days: 10 },
{ pincode: 626112, min_days: 7, max_days: 10 },
{ pincode: 626115, min_days: 7, max_days: 10 },
{ pincode: 626123, min_days: 7, max_days: 10 },
{ pincode: 626607, min_days: 7, max_days: 10 },
{ pincode: 626612, min_days: 7, max_days: 10 },
{ pincode: 627001, min_days: 7, max_days: 10 },
{ pincode: 630211, min_days: 7, max_days: 10 },
{ pincode: 630501, min_days: 7, max_days: 10 },
{ pincode: 630502, min_days: 7, max_days: 10 },
{ pincode: 630552, min_days: 7, max_days: 10 },
{ pincode: 630553, min_days: 7, max_days: 10 },
{ pincode: 630556, min_days: 7, max_days: 10 },
{ pincode: 630557, min_days: 7, max_days: 10 },
{ pincode: 630558, min_days: 7, max_days: 10 },
{ pincode: 630559, min_days: 7, max_days: 10 },
{ pincode: 630560, min_days: 7, max_days: 10 },
{ pincode: 630561, min_days: 7, max_days: 10 },
{ pincode: 630562, min_days: 7, max_days: 10 },
{ pincode: 630565, min_days: 7, max_days: 10 },
{ pincode: 630566, min_days: 7, max_days: 10 },
{ pincode: 630601, min_days: 7, max_days: 10 },
{ pincode: 630602, min_days: 7, max_days: 10 },
{ pincode: 630603, min_days: 7, max_days: 10 },
{ pincode: 630604, min_days: 7, max_days: 10 },
{ pincode: 630605, min_days: 7, max_days: 10 },
{ pincode: 630606, min_days: 7, max_days: 10 },
{ pincode: 630607, min_days: 7, max_days: 10 },
{ pincode: 630608, min_days: 7, max_days: 10 },
{ pincode: 630609, min_days: 7, max_days: 10 },
{ pincode: 630610, min_days: 7, max_days: 10 },
{ pincode: 630611, min_days: 7, max_days: 10 },
{ pincode: 630613, min_days: 7, max_days: 10 },
{ pincode: 630615, min_days: 7, max_days: 10 },
{ pincode: 630617, min_days: 7, max_days: 10 },
{ pincode: 630654, min_days: 7, max_days: 10 },
{ pincode: 631001, min_days: 7, max_days: 10 },
{ pincode: 631002, min_days: 7, max_days: 10 },
{ pincode: 631003, min_days: 7, max_days: 10 },
{ pincode: 631004, min_days: 7, max_days: 10 },
{ pincode: 631005, min_days: 7, max_days: 10 },
{ pincode: 631006, min_days: 7, max_days: 10 },
{ pincode: 631051, min_days: 7, max_days: 10 },
{ pincode: 631052, min_days: 7, max_days: 10 },
{ pincode: 631101, min_days: 7, max_days: 10 },
{ pincode: 631102, min_days: 7, max_days: 10 },
{ pincode: 631103, min_days: 7, max_days: 10 },
{ pincode: 631104, min_days: 7, max_days: 10 },
{ pincode: 631105, min_days: 7, max_days: 10 },
{ pincode: 631118, min_days: 7, max_days: 10 },
{ pincode: 631122, min_days: 7, max_days: 10 },
{ pincode: 631151, min_days: 7, max_days: 10 },
{ pincode: 631152, min_days: 7, max_days: 10 },
{ pincode: 631201, min_days: 7, max_days: 10 },
{ pincode: 631202, min_days: 7, max_days: 10 },
{ pincode: 631203, min_days: 7, max_days: 10 },
{ pincode: 631205, min_days: 7, max_days: 10 },
{ pincode: 631206, min_days: 7, max_days: 10 },
{ pincode: 631207, min_days: 7, max_days: 10 },
{ pincode: 631208, min_days: 7, max_days: 10 },
{ pincode: 631209, min_days: 7, max_days: 10 },
{ pincode: 631210, min_days: 7, max_days: 10 },
{ pincode: 631211, min_days: 7, max_days: 10 },
{ pincode: 631212, min_days: 7, max_days: 10 },
{ pincode: 631213, min_days: 7, max_days: 10 },
{ pincode: 631301, min_days: 7, max_days: 10 },
{ pincode: 631302, min_days: 7, max_days: 10 },
{ pincode: 631303, min_days: 7, max_days: 10 },
{ pincode: 631304, min_days: 7, max_days: 10 },
{ pincode: 631402, min_days: 7, max_days: 10 },
{ pincode: 631404, min_days: 7, max_days: 10 },
{ pincode: 631501, min_days: 7, max_days: 10 },
{ pincode: 631502, min_days: 7, max_days: 10 },
{ pincode: 631503, min_days: 7, max_days: 10 },
{ pincode: 631551, min_days: 7, max_days: 10 },
{ pincode: 631552, min_days: 7, max_days: 10 },
{ pincode: 631553, min_days: 7, max_days: 10 },
{ pincode: 631561, min_days: 7, max_days: 10 },
{ pincode: 631601, min_days: 7, max_days: 10 },
{ pincode: 631603, min_days: 7, max_days: 10 },
{ pincode: 631604, min_days: 7, max_days: 10 },
{ pincode: 631605, min_days: 7, max_days: 10 },
{ pincode: 631606, min_days: 7, max_days: 10 },
{ pincode: 631701, min_days: 7, max_days: 10 },
{ pincode: 631702, min_days: 7, max_days: 10 },
{ pincode: 632001, min_days: 7, max_days: 10 },
{ pincode: 632002, min_days: 7, max_days: 10 },
{ pincode: 632003, min_days: 7, max_days: 10 },
{ pincode: 632004, min_days: 7, max_days: 10 },
{ pincode: 632005, min_days: 7, max_days: 10 },
{ pincode: 632006, min_days: 7, max_days: 10 },
{ pincode: 632007, min_days: 7, max_days: 10 },
{ pincode: 632008, min_days: 7, max_days: 10 },
{ pincode: 632009, min_days: 7, max_days: 10 },
{ pincode: 632010, min_days: 7, max_days: 10 },
{ pincode: 632011, min_days: 7, max_days: 10 },
{ pincode: 632012, min_days: 7, max_days: 10 },
{ pincode: 632013, min_days: 7, max_days: 10 },
{ pincode: 632014, min_days: 7, max_days: 10 },
{ pincode: 632052, min_days: 7, max_days: 10 },
{ pincode: 632053, min_days: 7, max_days: 10 },
{ pincode: 632054, min_days: 7, max_days: 10 },
{ pincode: 632055, min_days: 7, max_days: 10 },
{ pincode: 632057, min_days: 7, max_days: 10 },
{ pincode: 632058, min_days: 7, max_days: 10 },
{ pincode: 632059, min_days: 7, max_days: 10 },
{ pincode: 632101, min_days: 7, max_days: 10 },
{ pincode: 632102, min_days: 7, max_days: 10 },
{ pincode: 632103, min_days: 7, max_days: 10 },
{ pincode: 632104, min_days: 7, max_days: 10 },
{ pincode: 632105, min_days: 7, max_days: 10 },
{ pincode: 632106, min_days: 7, max_days: 10 },
{ pincode: 632107, min_days: 7, max_days: 10 },
{ pincode: 632108, min_days: 7, max_days: 10 },
{ pincode: 632109, min_days: 7, max_days: 10 },
{ pincode: 632110, min_days: 7, max_days: 10 },
{ pincode: 632113, min_days: 7, max_days: 10 },
{ pincode: 632114, min_days: 7, max_days: 10 },
{ pincode: 632115, min_days: 7, max_days: 10 },
{ pincode: 632201, min_days: 7, max_days: 10 },
{ pincode: 632202, min_days: 7, max_days: 10 },
{ pincode: 632203, min_days: 7, max_days: 10 },
{ pincode: 632204, min_days: 7, max_days: 10 },
{ pincode: 632209, min_days: 7, max_days: 10 },
{ pincode: 632211, min_days: 7, max_days: 10 },
{ pincode: 632301, min_days: 7, max_days: 10 },
{ pincode: 632311, min_days: 7, max_days: 10 },
{ pincode: 632312, min_days: 7, max_days: 10 },
{ pincode: 632313, min_days: 7, max_days: 10 },
{ pincode: 632314, min_days: 7, max_days: 10 },
{ pincode: 632315, min_days: 7, max_days: 10 },
{ pincode: 632316, min_days: 7, max_days: 10 },
{ pincode: 632317, min_days: 7, max_days: 10 },
{ pincode: 632318, min_days: 7, max_days: 10 },
{ pincode: 632319, min_days: 7, max_days: 10 },
{ pincode: 632320, min_days: 7, max_days: 10 },
{ pincode: 632321, min_days: 7, max_days: 10 },
{ pincode: 632322, min_days: 7, max_days: 10 },
{ pincode: 632323, min_days: 7, max_days: 10 },
{ pincode: 632324, min_days: 7, max_days: 10 },
{ pincode: 632325, min_days: 7, max_days: 10 },
{ pincode: 632326, min_days: 7, max_days: 10 },
{ pincode: 632401, min_days: 7, max_days: 10 },
{ pincode: 632402, min_days: 7, max_days: 10 },
{ pincode: 632403, min_days: 7, max_days: 10 },
{ pincode: 632404, min_days: 7, max_days: 10 },
{ pincode: 632405, min_days: 7, max_days: 10 },
{ pincode: 632406, min_days: 7, max_days: 10 },
{ pincode: 632408, min_days: 7, max_days: 10 },
{ pincode: 632501, min_days: 7, max_days: 10 },
{ pincode: 632502, min_days: 7, max_days: 10 },
{ pincode: 632503, min_days: 7, max_days: 10 },
{ pincode: 632504, min_days: 7, max_days: 10 },
{ pincode: 632505, min_days: 7, max_days: 10 },
{ pincode: 632506, min_days: 7, max_days: 10 },
{ pincode: 632507, min_days: 7, max_days: 10 },
{ pincode: 632508, min_days: 7, max_days: 10 },
{ pincode: 632509, min_days: 7, max_days: 10 },
{ pincode: 632510, min_days: 7, max_days: 10 },
{ pincode: 632511, min_days: 7, max_days: 10 },
{ pincode: 632512, min_days: 7, max_days: 10 },
{ pincode: 632513, min_days: 7, max_days: 10 },
{ pincode: 632514, min_days: 7, max_days: 10 },
{ pincode: 632515, min_days: 7, max_days: 10 },
{ pincode: 632516, min_days: 7, max_days: 10 },
{ pincode: 632517, min_days: 7, max_days: 10 },
{ pincode: 632518, min_days: 7, max_days: 10 },
{ pincode: 632519, min_days: 7, max_days: 10 },
{ pincode: 632520, min_days: 7, max_days: 10 },
{ pincode: 632521, min_days: 7, max_days: 10 },
{ pincode: 632522, min_days: 7, max_days: 10 },
{ pincode: 632523, min_days: 7, max_days: 10 },
{ pincode: 632524, min_days: 7, max_days: 10 },
{ pincode: 632525, min_days: 7, max_days: 10 },
{ pincode: 632526, min_days: 7, max_days: 10 },
{ pincode: 632527, min_days: 7, max_days: 10 },
{ pincode: 632528, min_days: 7, max_days: 10 },
{ pincode: 632529, min_days: 7, max_days: 10 },
{ pincode: 632530, min_days: 7, max_days: 10 },
{ pincode: 632531, min_days: 7, max_days: 10 },
{ pincode: 632602, min_days: 7, max_days: 10 },
{ pincode: 632603, min_days: 7, max_days: 10 },
{ pincode: 635103, min_days: 7, max_days: 10 },
{ pincode: 635105, min_days: 7, max_days: 10 },
{ pincode: 635107, min_days: 7, max_days: 10 },
{ pincode: 635109, min_days: 7, max_days: 10 },
{ pincode: 635110, min_days: 7, max_days: 10 },
{ pincode: 635114, min_days: 7, max_days: 10 },
{ pincode: 635116, min_days: 7, max_days: 10 },
{ pincode: 635117, min_days: 7, max_days: 10 },
{ pincode: 635118, min_days: 7, max_days: 10 },
{ pincode: 635119, min_days: 7, max_days: 10 },
{ pincode: 635124, min_days: 7, max_days: 10 },
{ pincode: 635125, min_days: 7, max_days: 10 },
{ pincode: 635126, min_days: 7, max_days: 10 },
{ pincode: 635601, min_days: 7, max_days: 10 },
{ pincode: 635704, min_days: 7, max_days: 10 },
{ pincode: 635705, min_days: 7, max_days: 10 },
{ pincode: 635706, min_days: 7, max_days: 10 },
{ pincode: 635707, min_days: 7, max_days: 10 },
{ pincode: 635708, min_days: 7, max_days: 10 },
{ pincode: 635709, min_days: 7, max_days: 10 },
{ pincode: 635710, min_days: 7, max_days: 10 },
{ pincode: 635751, min_days: 7, max_days: 10 },
{ pincode: 635752, min_days: 7, max_days: 10 },
{ pincode: 635753, min_days: 7, max_days: 10 },
{ pincode: 635754, min_days: 7, max_days: 10 },
{ pincode: 635755, min_days: 7, max_days: 10 },
{ pincode: 635756, min_days: 7, max_days: 10 },
{ pincode: 635757, min_days: 7, max_days: 10 },
{ pincode: 635758, min_days: 7, max_days: 10 },
{ pincode: 635801, min_days: 7, max_days: 10 },
{ pincode: 635802, min_days: 7, max_days: 10 },
{ pincode: 635803, min_days: 7, max_days: 10 },
{ pincode: 635804, min_days: 7, max_days: 10 },
{ pincode: 635805, min_days: 7, max_days: 10 },
{ pincode: 635806, min_days: 7, max_days: 10 },
{ pincode: 635807, min_days: 7, max_days: 10 },
{ pincode: 635808, min_days: 7, max_days: 10 },
{ pincode: 635809, min_days: 7, max_days: 10 },
{ pincode: 635810, min_days: 7, max_days: 10 },
{ pincode: 635811, min_days: 7, max_days: 10 },
{ pincode: 635812, min_days: 7, max_days: 10 },
{ pincode: 635813, min_days: 7, max_days: 10 },
{ pincode: 635814, min_days: 7, max_days: 10 },
{ pincode: 635851, min_days: 7, max_days: 10 },
{ pincode: 636001, min_days: 7, max_days: 10 },
{ pincode: 636002, min_days: 7, max_days: 10 },
{ pincode: 636003, min_days: 7, max_days: 10 },
{ pincode: 636004, min_days: 7, max_days: 10 },
{ pincode: 636005, min_days: 7, max_days: 10 },
{ pincode: 636006, min_days: 7, max_days: 10 },
{ pincode: 636007, min_days: 7, max_days: 10 },
{ pincode: 636008, min_days: 7, max_days: 10 },
{ pincode: 636009, min_days: 7, max_days: 10 },
{ pincode: 636010, min_days: 7, max_days: 10 },
{ pincode: 636011, min_days: 7, max_days: 10 },
{ pincode: 636012, min_days: 7, max_days: 10 },
{ pincode: 636013, min_days: 7, max_days: 10 },
{ pincode: 636014, min_days: 7, max_days: 10 },
{ pincode: 636015, min_days: 7, max_days: 10 },
{ pincode: 636016, min_days: 7, max_days: 10 },
{ pincode: 636018, min_days: 7, max_days: 10 },
{ pincode: 636030, min_days: 7, max_days: 10 },
{ pincode: 636102, min_days: 7, max_days: 10 },
{ pincode: 636103, min_days: 7, max_days: 10 },
{ pincode: 636104, min_days: 7, max_days: 10 },
{ pincode: 636106, min_days: 7, max_days: 10 },
{ pincode: 636107, min_days: 7, max_days: 10 },
{ pincode: 636108, min_days: 7, max_days: 10 },
{ pincode: 636109, min_days: 7, max_days: 10 },
{ pincode: 636111, min_days: 7, max_days: 10 },
{ pincode: 636113, min_days: 7, max_days: 10 },
{ pincode: 636114, min_days: 7, max_days: 10 },
{ pincode: 636115, min_days: 7, max_days: 10 },
{ pincode: 636117, min_days: 7, max_days: 10 },
{ pincode: 636118, min_days: 7, max_days: 10 },
{ pincode: 636119, min_days: 7, max_days: 10 },
{ pincode: 636122, min_days: 7, max_days: 10 },
{ pincode: 636131, min_days: 7, max_days: 10 },
{ pincode: 636137, min_days: 7, max_days: 10 },
{ pincode: 636139, min_days: 7, max_days: 10 },
{ pincode: 636140, min_days: 7, max_days: 10 },
{ pincode: 636142, min_days: 7, max_days: 10 },
{ pincode: 636201, min_days: 7, max_days: 10 },
{ pincode: 636202, min_days: 7, max_days: 10 },
{ pincode: 636203, min_days: 7, max_days: 10 },
{ pincode: 636204, min_days: 7, max_days: 10 },
{ pincode: 636205, min_days: 7, max_days: 10 },
{ pincode: 636301, min_days: 7, max_days: 10 },
{ pincode: 636302, min_days: 7, max_days: 10 },
{ pincode: 636303, min_days: 7, max_days: 10 },
{ pincode: 636304, min_days: 7, max_days: 10 },
{ pincode: 636305, min_days: 7, max_days: 10 },
{ pincode: 636306, min_days: 7, max_days: 10 },
{ pincode: 636307, min_days: 7, max_days: 10 },
{ pincode: 636308, min_days: 7, max_days: 10 },
{ pincode: 636309, min_days: 7, max_days: 10 },
{ pincode: 636315, min_days: 7, max_days: 10 },
{ pincode: 636318, min_days: 7, max_days: 10 },
{ pincode: 636319, min_days: 7, max_days: 10 },
{ pincode: 636321, min_days: 7, max_days: 10 },
{ pincode: 636351, min_days: 7, max_days: 10 },
{ pincode: 636354, min_days: 7, max_days: 10 },
{ pincode: 636361, min_days: 7, max_days: 10 },
{ pincode: 636401, min_days: 7, max_days: 10 },
{ pincode: 636402, min_days: 7, max_days: 10 },
{ pincode: 636403, min_days: 7, max_days: 10 },
{ pincode: 636404, min_days: 7, max_days: 10 },
{ pincode: 636406, min_days: 7, max_days: 10 },
{ pincode: 636451, min_days: 7, max_days: 10 },
{ pincode: 636452, min_days: 7, max_days: 10 },
{ pincode: 636453, min_days: 7, max_days: 10 },
{ pincode: 636454, min_days: 7, max_days: 10 },
{ pincode: 636455, min_days: 7, max_days: 10 },
{ pincode: 636456, min_days: 7, max_days: 10 },
{ pincode: 636457, min_days: 7, max_days: 10 },
{ pincode: 636458, min_days: 7, max_days: 10 },
{ pincode: 636501, min_days: 7, max_days: 10 },
{ pincode: 636502, min_days: 7, max_days: 10 },
{ pincode: 636503, min_days: 7, max_days: 10 },
{ pincode: 636504, min_days: 7, max_days: 10 },
{ pincode: 636506, min_days: 7, max_days: 10 },
{ pincode: 636601, min_days: 7, max_days: 10 },
{ pincode: 636602, min_days: 7, max_days: 10 },
{ pincode: 636604, min_days: 7, max_days: 10 },
{ pincode: 636807, min_days: 7, max_days: 10 },
{ pincode: 637001, min_days: 7, max_days: 10 },
{ pincode: 637002, min_days: 7, max_days: 10 },
{ pincode: 637003, min_days: 7, max_days: 10 },
{ pincode: 637004, min_days: 7, max_days: 10 },
{ pincode: 637005, min_days: 7, max_days: 10 },
{ pincode: 637014, min_days: 7, max_days: 10 },
{ pincode: 637018, min_days: 7, max_days: 10 },
{ pincode: 637019, min_days: 7, max_days: 10 },
{ pincode: 637020, min_days: 7, max_days: 10 },
{ pincode: 637022, min_days: 7, max_days: 10 },
{ pincode: 637023, min_days: 7, max_days: 10 },
{ pincode: 637024, min_days: 7, max_days: 10 },
{ pincode: 637025, min_days: 7, max_days: 10 },
{ pincode: 637026, min_days: 7, max_days: 10 },
{ pincode: 637101, min_days: 7, max_days: 10 },
{ pincode: 637102, min_days: 7, max_days: 10 },
{ pincode: 637103, min_days: 7, max_days: 10 },
{ pincode: 637104, min_days: 7, max_days: 10 },
{ pincode: 637105, min_days: 7, max_days: 10 },
{ pincode: 637107, min_days: 7, max_days: 10 },
{ pincode: 637109, min_days: 7, max_days: 10 },
{ pincode: 637111, min_days: 7, max_days: 10 },
{ pincode: 637112, min_days: 7, max_days: 10 },
{ pincode: 637113, min_days: 7, max_days: 10 },
{ pincode: 637127, min_days: 7, max_days: 10 },
{ pincode: 637152, min_days: 7, max_days: 10 },
{ pincode: 637201, min_days: 7, max_days: 10 },
{ pincode: 637202, min_days: 7, max_days: 10 },
{ pincode: 637203, min_days: 7, max_days: 10 },
{ pincode: 637205, min_days: 7, max_days: 10 },
{ pincode: 637207, min_days: 7, max_days: 10 },
{ pincode: 637209, min_days: 7, max_days: 10 },
{ pincode: 637210, min_days: 7, max_days: 10 },
{ pincode: 637211, min_days: 7, max_days: 10 },
{ pincode: 637212, min_days: 7, max_days: 10 },
{ pincode: 637213, min_days: 7, max_days: 10 },
{ pincode: 637214, min_days: 7, max_days: 10 },
{ pincode: 637215, min_days: 7, max_days: 10 },
{ pincode: 637216, min_days: 7, max_days: 10 },
{ pincode: 637217, min_days: 7, max_days: 10 },
{ pincode: 637219, min_days: 7, max_days: 10 },
{ pincode: 637301, min_days: 7, max_days: 10 },
{ pincode: 637302, min_days: 7, max_days: 10 },
{ pincode: 637303, min_days: 7, max_days: 10 },
{ pincode: 637304, min_days: 7, max_days: 10 },
{ pincode: 637305, min_days: 7, max_days: 10 },
{ pincode: 637306, min_days: 7, max_days: 10 },
{ pincode: 637307, min_days: 7, max_days: 10 },
{ pincode: 637401, min_days: 7, max_days: 10 },
{ pincode: 637402, min_days: 7, max_days: 10 },
{ pincode: 637403, min_days: 7, max_days: 10 },
{ pincode: 637404, min_days: 7, max_days: 10 },
{ pincode: 637405, min_days: 7, max_days: 10 },
{ pincode: 637406, min_days: 7, max_days: 10 },
{ pincode: 637407, min_days: 7, max_days: 10 },
{ pincode: 637408, min_days: 7, max_days: 10 },
{ pincode: 637409, min_days: 7, max_days: 10 },
{ pincode: 637410, min_days: 7, max_days: 10 },
{ pincode: 637412, min_days: 7, max_days: 10 },
{ pincode: 637420, min_days: 7, max_days: 10 },
{ pincode: 637422, min_days: 7, max_days: 10 },
{ pincode: 637423, min_days: 7, max_days: 10 },
{ pincode: 637501, min_days: 7, max_days: 10 },
{ pincode: 637502, min_days: 7, max_days: 10 },
{ pincode: 637503, min_days: 7, max_days: 10 },
{ pincode: 637504, min_days: 7, max_days: 10 },
{ pincode: 637505, min_days: 7, max_days: 10 },
{ pincode: 637507, min_days: 7, max_days: 10 },
{ pincode: 638001, min_days: 7, max_days: 10 },
{ pincode: 638002, min_days: 7, max_days: 10 },
{ pincode: 638003, min_days: 7, max_days: 10 },
{ pincode: 638004, min_days: 7, max_days: 10 },
{ pincode: 638005, min_days: 7, max_days: 10 },
{ pincode: 638006, min_days: 7, max_days: 10 },
{ pincode: 638007, min_days: 7, max_days: 10 },
{ pincode: 638008, min_days: 7, max_days: 10 },
{ pincode: 638009, min_days: 7, max_days: 10 },
{ pincode: 638010, min_days: 7, max_days: 10 },
{ pincode: 638011, min_days: 7, max_days: 10 },
{ pincode: 638012, min_days: 7, max_days: 10 },
{ pincode: 638051, min_days: 7, max_days: 10 },
{ pincode: 638052, min_days: 7, max_days: 10 },
{ pincode: 638053, min_days: 7, max_days: 10 },
{ pincode: 638054, min_days: 7, max_days: 10 },
{ pincode: 638055, min_days: 7, max_days: 10 },
{ pincode: 638056, min_days: 7, max_days: 10 },
{ pincode: 638057, min_days: 7, max_days: 10 },
{ pincode: 638058, min_days: 7, max_days: 10 },
{ pincode: 638101, min_days: 7, max_days: 10 },
{ pincode: 638102, min_days: 7, max_days: 10 },
{ pincode: 638103, min_days: 7, max_days: 10 },
{ pincode: 638104, min_days: 7, max_days: 10 },
{ pincode: 638105, min_days: 7, max_days: 10 },
{ pincode: 638107, min_days: 7, max_days: 10 },
{ pincode: 638108, min_days: 7, max_days: 10 },
{ pincode: 638109, min_days: 7, max_days: 10 },
{ pincode: 638110, min_days: 7, max_days: 10 },
{ pincode: 638111, min_days: 7, max_days: 10 },
{ pincode: 638112, min_days: 7, max_days: 10 },
{ pincode: 638115, min_days: 7, max_days: 10 },
{ pincode: 638116, min_days: 7, max_days: 10 },
{ pincode: 638153, min_days: 7, max_days: 10 },
{ pincode: 638154, min_days: 7, max_days: 10 },
{ pincode: 638183, min_days: 7, max_days: 10 },
{ pincode: 638184, min_days: 7, max_days: 10 },
{ pincode: 638301, min_days: 7, max_days: 10 },
{ pincode: 638303, min_days: 7, max_days: 10 },
{ pincode: 638307, min_days: 7, max_days: 10 },
{ pincode: 638308, min_days: 7, max_days: 10 },
{ pincode: 638312, min_days: 7, max_days: 10 },
{ pincode: 638313, min_days: 7, max_days: 10 },
{ pincode: 638315, min_days: 7, max_days: 10 },
{ pincode: 638316, min_days: 7, max_days: 10 },
{ pincode: 638402, min_days: 7, max_days: 10 },
{ pincode: 638452, min_days: 7, max_days: 10 },
{ pincode: 638453, min_days: 7, max_days: 10 },
{ pincode: 638454, min_days: 7, max_days: 10 },
{ pincode: 638455, min_days: 7, max_days: 10 },
{ pincode: 638456, min_days: 7, max_days: 10 },
{ pincode: 638457, min_days: 7, max_days: 10 },
{ pincode: 638458, min_days: 7, max_days: 10 },
{ pincode: 638459, min_days: 7, max_days: 10 },
{ pincode: 638460, min_days: 7, max_days: 10 },
{ pincode: 638462, min_days: 7, max_days: 10 },
{ pincode: 638476, min_days: 7, max_days: 10 },
{ pincode: 638501, min_days: 7, max_days: 10 },
{ pincode: 638502, min_days: 7, max_days: 10 },
{ pincode: 638505, min_days: 7, max_days: 10 },
{ pincode: 638506, min_days: 7, max_days: 10 },
{ pincode: 638601, min_days: 7, max_days: 10 },
{ pincode: 638602, min_days: 7, max_days: 10 },
{ pincode: 638603, min_days: 7, max_days: 10 },
{ pincode: 638605, min_days: 7, max_days: 10 },
{ pincode: 638606, min_days: 7, max_days: 10 },
{ pincode: 638607, min_days: 7, max_days: 10 },
{ pincode: 638611, min_days: 7, max_days: 10 },
{ pincode: 638612, min_days: 7, max_days: 10 },
{ pincode: 638644, min_days: 7, max_days: 10 },
{ pincode: 638649, min_days: 7, max_days: 10 },
{ pincode: 638651, min_days: 7, max_days: 10 },
{ pincode: 638652, min_days: 7, max_days: 10 },
{ pincode: 638653, min_days: 7, max_days: 10 },
{ pincode: 638654, min_days: 7, max_days: 10 },
{ pincode: 638655, min_days: 7, max_days: 10 },
{ pincode: 638656, min_days: 7, max_days: 10 },
{ pincode: 638657, min_days: 7, max_days: 10 },
{ pincode: 638658, min_days: 7, max_days: 10 },
{ pincode: 638659, min_days: 7, max_days: 10 },
{ pincode: 638660, min_days: 7, max_days: 10 },
{ pincode: 638662, min_days: 7, max_days: 10 },
{ pincode: 638663, min_days: 7, max_days: 10 },
{ pincode: 638664, min_days: 7, max_days: 10 },
{ pincode: 638665, min_days: 7, max_days: 10 },
{ pincode: 638666, min_days: 7, max_days: 10 },
{ pincode: 638667, min_days: 7, max_days: 10 },
{ pincode: 638668, min_days: 7, max_days: 10 },
{ pincode: 638669, min_days: 7, max_days: 10 },
{ pincode: 638670, min_days: 7, max_days: 10 },
{ pincode: 638671, min_days: 7, max_days: 10 },
{ pincode: 638672, min_days: 7, max_days: 10 },
{ pincode: 638673, min_days: 7, max_days: 10 },
{ pincode: 638674, min_days: 7, max_days: 10 },
{ pincode: 638675, min_days: 7, max_days: 10 },
{ pincode: 638681, min_days: 7, max_days: 10 },
{ pincode: 638684, min_days: 7, max_days: 10 },
{ pincode: 638687, min_days: 7, max_days: 10 },
{ pincode: 638690, min_days: 7, max_days: 10 },
{ pincode: 638691, min_days: 7, max_days: 10 },
{ pincode: 638696, min_days: 7, max_days: 10 },
{ pincode: 638697, min_days: 7, max_days: 10 },
{ pincode: 638698, min_days: 7, max_days: 10 },
{ pincode: 638701, min_days: 7, max_days: 10 },
{ pincode: 638702, min_days: 7, max_days: 10 },
{ pincode: 638703, min_days: 7, max_days: 10 },
{ pincode: 638704, min_days: 7, max_days: 10 },
{ pincode: 638705, min_days: 7, max_days: 10 },
{ pincode: 638706, min_days: 7, max_days: 10 },
{ pincode: 638709, min_days: 7, max_days: 10 },
{ pincode: 638751, min_days: 7, max_days: 10 },
{ pincode: 638752, min_days: 7, max_days: 10 },
{ pincode: 638802, min_days: 7, max_days: 10 },
{ pincode: 638804, min_days: 7, max_days: 10 },
{ pincode: 638807, min_days: 7, max_days: 10 },
{ pincode: 638812, min_days: 7, max_days: 10 },
{ pincode: 638856, min_days: 7, max_days: 10 },
{ pincode: 639002, min_days: 7, max_days: 10 },
{ pincode: 639101, min_days: 7, max_days: 10 },
{ pincode: 639103, min_days: 7, max_days: 10 },
{ pincode: 639104, min_days: 7, max_days: 10 },
{ pincode: 639105, min_days: 7, max_days: 10 },
{ pincode: 639107, min_days: 7, max_days: 10 },
{ pincode: 639110, min_days: 7, max_days: 10 },
{ pincode: 639111, min_days: 7, max_days: 10 },
{ pincode: 639112, min_days: 7, max_days: 10 },
{ pincode: 639115, min_days: 7, max_days: 10 },
{ pincode: 639119, min_days: 7, max_days: 10 },
{ pincode: 639120, min_days: 7, max_days: 10 },
{ pincode: 641001, min_days: 7, max_days: 10 },
{ pincode: 641002, min_days: 7, max_days: 10 },
{ pincode: 641003, min_days: 7, max_days: 10 },
{ pincode: 641004, min_days: 7, max_days: 10 },
{ pincode: 641005, min_days: 7, max_days: 10 },
{ pincode: 641006, min_days: 7, max_days: 10 },
{ pincode: 641007, min_days: 7, max_days: 10 },
{ pincode: 641008, min_days: 7, max_days: 10 },
{ pincode: 641009, min_days: 7, max_days: 10 },
{ pincode: 641010, min_days: 7, max_days: 10 },
{ pincode: 641011, min_days: 7, max_days: 10 },
{ pincode: 641012, min_days: 7, max_days: 10 },
{ pincode: 641013, min_days: 7, max_days: 10 },
{ pincode: 641014, min_days: 7, max_days: 10 },
{ pincode: 641015, min_days: 7, max_days: 10 },
{ pincode: 641016, min_days: 7, max_days: 10 },
{ pincode: 641017, min_days: 7, max_days: 10 },
{ pincode: 641018, min_days: 7, max_days: 10 },
{ pincode: 641019, min_days: 7, max_days: 10 },
{ pincode: 641020, min_days: 7, max_days: 10 },
{ pincode: 641021, min_days: 7, max_days: 10 },
{ pincode: 641022, min_days: 7, max_days: 10 },
{ pincode: 641023, min_days: 7, max_days: 10 },
{ pincode: 641024, min_days: 7, max_days: 10 },
{ pincode: 641025, min_days: 7, max_days: 10 },
{ pincode: 641026, min_days: 7, max_days: 10 },
{ pincode: 641027, min_days: 7, max_days: 10 },
{ pincode: 641028, min_days: 7, max_days: 10 },
{ pincode: 641029, min_days: 7, max_days: 10 },
{ pincode: 641030, min_days: 7, max_days: 10 },
{ pincode: 641031, min_days: 7, max_days: 10 },
{ pincode: 641032, min_days: 7, max_days: 10 },
{ pincode: 641033, min_days: 7, max_days: 10 },
{ pincode: 641034, min_days: 7, max_days: 10 },
{ pincode: 641035, min_days: 7, max_days: 10 },
{ pincode: 641036, min_days: 7, max_days: 10 },
{ pincode: 641037, min_days: 7, max_days: 10 },
{ pincode: 641038, min_days: 7, max_days: 10 },
{ pincode: 641039, min_days: 7, max_days: 10 },
{ pincode: 641040, min_days: 7, max_days: 10 },
{ pincode: 641041, min_days: 7, max_days: 10 },
{ pincode: 641042, min_days: 7, max_days: 10 },
{ pincode: 641043, min_days: 7, max_days: 10 },
{ pincode: 641044, min_days: 7, max_days: 10 },
{ pincode: 641045, min_days: 7, max_days: 10 },
{ pincode: 641046, min_days: 7, max_days: 10 },
{ pincode: 641047, min_days: 7, max_days: 10 },
{ pincode: 641048, min_days: 7, max_days: 10 },
{ pincode: 641049, min_days: 7, max_days: 10 },
{ pincode: 641050, min_days: 7, max_days: 10 },
{ pincode: 641061, min_days: 7, max_days: 10 },
{ pincode: 641062, min_days: 7, max_days: 10 },
{ pincode: 641063, min_days: 7, max_days: 10 },
{ pincode: 641064, min_days: 7, max_days: 10 },
{ pincode: 641065, min_days: 7, max_days: 10 },
{ pincode: 641101, min_days: 7, max_days: 10 },
{ pincode: 641103, min_days: 7, max_days: 10 },
{ pincode: 641104, min_days: 7, max_days: 10 },
{ pincode: 641105, min_days: 7, max_days: 10 },
{ pincode: 641107, min_days: 7, max_days: 10 },
{ pincode: 641108, min_days: 7, max_days: 10 },
{ pincode: 641109, min_days: 7, max_days: 10 },
{ pincode: 641110, min_days: 7, max_days: 10 },
{ pincode: 641111, min_days: 7, max_days: 10 },
{ pincode: 641112, min_days: 7, max_days: 10 },
{ pincode: 641113, min_days: 7, max_days: 10 },
{ pincode: 641114, min_days: 7, max_days: 10 },
{ pincode: 641115, min_days: 7, max_days: 10 },
{ pincode: 641116, min_days: 7, max_days: 10 },
{ pincode: 641117, min_days: 7, max_days: 10 },
{ pincode: 641118, min_days: 7, max_days: 10 },
{ pincode: 641201, min_days: 7, max_days: 10 },
{ pincode: 641202, min_days: 7, max_days: 10 },
{ pincode: 641301, min_days: 7, max_days: 10 },
{ pincode: 641302, min_days: 7, max_days: 10 },
{ pincode: 641305, min_days: 7, max_days: 10 },
{ pincode: 641401, min_days: 7, max_days: 10 },
{ pincode: 641402, min_days: 7, max_days: 10 },
{ pincode: 641403, min_days: 7, max_days: 10 },
{ pincode: 641404, min_days: 7, max_days: 10 },
{ pincode: 641405, min_days: 7, max_days: 10 },
{ pincode: 641406, min_days: 7, max_days: 10 },
{ pincode: 641407, min_days: 7, max_days: 10 },
{ pincode: 641408, min_days: 7, max_days: 10 },
{ pincode: 641601, min_days: 7, max_days: 10 },
{ pincode: 641602, min_days: 7, max_days: 10 },
{ pincode: 641603, min_days: 7, max_days: 10 },
{ pincode: 641604, min_days: 7, max_days: 10 },
{ pincode: 641605, min_days: 7, max_days: 10 },
{ pincode: 641606, min_days: 7, max_days: 10 },
{ pincode: 641607, min_days: 7, max_days: 10 },
{ pincode: 641608, min_days: 7, max_days: 10 },
{ pincode: 641609, min_days: 7, max_days: 10 },
{ pincode: 641652, min_days: 7, max_days: 10 },
{ pincode: 641653, min_days: 7, max_days: 10 },
{ pincode: 641654, min_days: 7, max_days: 10 },
{ pincode: 641655, min_days: 7, max_days: 10 },
{ pincode: 641658, min_days: 7, max_days: 10 },
{ pincode: 641659, min_days: 7, max_days: 10 },
{ pincode: 641660, min_days: 7, max_days: 10 },
{ pincode: 641662, min_days: 7, max_days: 10 },
{ pincode: 641663, min_days: 7, max_days: 10 },
{ pincode: 641664, min_days: 7, max_days: 10 },
{ pincode: 641665, min_days: 7, max_days: 10 },
{ pincode: 641666, min_days: 7, max_days: 10 },
{ pincode: 641667, min_days: 7, max_days: 10 },
{ pincode: 641668, min_days: 7, max_days: 10 },
{ pincode: 641669, min_days: 7, max_days: 10 },
{ pincode: 641670, min_days: 7, max_days: 10 },
{ pincode: 641671, min_days: 7, max_days: 10 },
{ pincode: 641687, min_days: 7, max_days: 10 },
{ pincode: 641695, min_days: 7, max_days: 10 },
{ pincode: 641697, min_days: 7, max_days: 10 },
{ pincode: 642001, min_days: 7, max_days: 10 },
{ pincode: 642002, min_days: 7, max_days: 10 },
{ pincode: 642003, min_days: 7, max_days: 10 },
{ pincode: 642004, min_days: 7, max_days: 10 },
{ pincode: 642005, min_days: 7, max_days: 10 },
{ pincode: 642006, min_days: 7, max_days: 10 },
{ pincode: 642007, min_days: 7, max_days: 10 },
{ pincode: 642103, min_days: 7, max_days: 10 },
{ pincode: 642104, min_days: 7, max_days: 10 },
{ pincode: 642106, min_days: 7, max_days: 10 },
{ pincode: 642109, min_days: 7, max_days: 10 },
{ pincode: 642110, min_days: 7, max_days: 10 },
{ pincode: 642111, min_days: 7, max_days: 10 },
{ pincode: 642114, min_days: 7, max_days: 10 },
{ pincode: 642120, min_days: 7, max_days: 10 },
{ pincode: 642123, min_days: 7, max_days: 10 },
{ pincode: 642128, min_days: 7, max_days: 10 },
{ pincode: 642129, min_days: 7, max_days: 10 },
{ pincode: 642130, min_days: 7, max_days: 10 },
{ pincode: 642134, min_days: 7, max_days: 10 },
{ pincode: 642201, min_days: 7, max_days: 10 },
{ pincode: 642202, min_days: 7, max_days: 10 },
{ pincode: 642206, min_days: 7, max_days: 10 },
{ pincode: 666667, min_days: 7, max_days: 10 },
{ pincode: 670007, min_days: 7, max_days: 10 },
{ pincode: 670101, min_days: 7, max_days: 10 },
{ pincode: 670102, min_days: 7, max_days: 10 },
{ pincode: 670103, min_days: 7, max_days: 10 },
{ pincode: 670104, min_days: 7, max_days: 10 },
{ pincode: 670105, min_days: 7, max_days: 10 },
{ pincode: 670106, min_days: 7, max_days: 10 },
{ pincode: 670107, min_days: 7, max_days: 10 },
{ pincode: 670304, min_days: 7, max_days: 10 },
{ pincode: 670305, min_days: 7, max_days: 10 },
{ pincode: 670307, min_days: 7, max_days: 10 },
{ pincode: 670308, min_days: 7, max_days: 10 },
{ pincode: 670309, min_days: 7, max_days: 10 },
{ pincode: 670310, min_days: 7, max_days: 10 },
{ pincode: 670311, min_days: 7, max_days: 10 },
{ pincode: 670327, min_days: 7, max_days: 10 },
{ pincode: 670501, min_days: 7, max_days: 10 },
{ pincode: 670503, min_days: 7, max_days: 10 },
{ pincode: 670504, min_days: 7, max_days: 10 },
{ pincode: 670521, min_days: 7, max_days: 10 },
{ pincode: 670621, min_days: 7, max_days: 10 },
{ pincode: 670622, min_days: 7, max_days: 10 },
{ pincode: 670641, min_days: 7, max_days: 10 },
{ pincode: 670642, min_days: 7, max_days: 10 },
{ pincode: 670649, min_days: 7, max_days: 10 },
{ pincode: 670661, min_days: 7, max_days: 10 },
{ pincode: 670662, min_days: 7, max_days: 10 },
{ pincode: 670663, min_days: 7, max_days: 10 },
{ pincode: 670671, min_days: 7, max_days: 10 },
{ pincode: 670672, min_days: 7, max_days: 10 },
{ pincode: 670675, min_days: 7, max_days: 10 },
{ pincode: 670676, min_days: 7, max_days: 10 },
{ pincode: 670691, min_days: 7, max_days: 10 },
{ pincode: 670692, min_days: 7, max_days: 10 },
{ pincode: 670694, min_days: 7, max_days: 10 },
{ pincode: 670741, min_days: 7, max_days: 10 },
{ pincode: 671121, min_days: 7, max_days: 10 },
{ pincode: 671123, min_days: 7, max_days: 10 },
{ pincode: 671310, min_days: 7, max_days: 10 },
{ pincode: 671311, min_days: 7, max_days: 10 },
{ pincode: 671345, min_days: 7, max_days: 10 },
{ pincode: 673000, min_days: 7, max_days: 10 },
{ pincode: 673001, min_days: 7, max_days: 10 },
{ pincode: 673002, min_days: 7, max_days: 10 },
{ pincode: 673003, min_days: 7, max_days: 10 },
{ pincode: 673004, min_days: 7, max_days: 10 },
{ pincode: 673005, min_days: 7, max_days: 10 },
{ pincode: 673006, min_days: 7, max_days: 10 },
{ pincode: 673007, min_days: 7, max_days: 10 },
{ pincode: 673008, min_days: 7, max_days: 10 },
{ pincode: 673009, min_days: 7, max_days: 10 },
{ pincode: 673010, min_days: 7, max_days: 10 },
{ pincode: 673011, min_days: 7, max_days: 10 },
{ pincode: 673012, min_days: 7, max_days: 10 },
{ pincode: 673013, min_days: 7, max_days: 10 },
{ pincode: 673014, min_days: 7, max_days: 10 },
{ pincode: 673015, min_days: 7, max_days: 10 },
{ pincode: 673016, min_days: 7, max_days: 10 },
{ pincode: 673017, min_days: 7, max_days: 10 },
{ pincode: 673018, min_days: 7, max_days: 10 },
{ pincode: 673019, min_days: 7, max_days: 10 },
{ pincode: 673020, min_days: 7, max_days: 10 },
{ pincode: 673021, min_days: 7, max_days: 10 },
{ pincode: 673022, min_days: 7, max_days: 10 },
{ pincode: 673023, min_days: 7, max_days: 10 },
{ pincode: 673024, min_days: 7, max_days: 10 },
{ pincode: 673025, min_days: 7, max_days: 10 },
{ pincode: 673026, min_days: 7, max_days: 10 },
{ pincode: 673027, min_days: 7, max_days: 10 },
{ pincode: 673028, min_days: 7, max_days: 10 },
{ pincode: 673029, min_days: 7, max_days: 10 },
{ pincode: 673031, min_days: 7, max_days: 10 },
{ pincode: 673032, min_days: 7, max_days: 10 },
{ pincode: 673035, min_days: 7, max_days: 10 },
{ pincode: 673037, min_days: 7, max_days: 10 },
{ pincode: 673051, min_days: 7, max_days: 10 },
{ pincode: 673055, min_days: 7, max_days: 10 },
{ pincode: 673101, min_days: 7, max_days: 10 },
{ pincode: 673102, min_days: 7, max_days: 10 },
{ pincode: 673103, min_days: 7, max_days: 10 },
{ pincode: 673104, min_days: 7, max_days: 10 },
{ pincode: 673105, min_days: 7, max_days: 10 },
{ pincode: 673106, min_days: 7, max_days: 10 },
{ pincode: 673107, min_days: 7, max_days: 10 },
{ pincode: 673108, min_days: 7, max_days: 10 },
{ pincode: 673109, min_days: 7, max_days: 10 },
{ pincode: 673110, min_days: 7, max_days: 10 },
{ pincode: 673112, min_days: 7, max_days: 10 },
{ pincode: 673300, min_days: 7, max_days: 10 },
{ pincode: 673301, min_days: 7, max_days: 10 },
{ pincode: 673302, min_days: 7, max_days: 10 },
{ pincode: 673303, min_days: 7, max_days: 10 },
{ pincode: 673304, min_days: 7, max_days: 10 },
{ pincode: 673305, min_days: 7, max_days: 10 },
{ pincode: 673306, min_days: 7, max_days: 10 },
{ pincode: 673307, min_days: 7, max_days: 10 },
{ pincode: 673308, min_days: 7, max_days: 10 },
{ pincode: 673309, min_days: 7, max_days: 10 },
{ pincode: 673312, min_days: 7, max_days: 10 },
{ pincode: 673313, min_days: 7, max_days: 10 },
{ pincode: 673314, min_days: 7, max_days: 10 },
{ pincode: 673315, min_days: 7, max_days: 10 },
{ pincode: 673316, min_days: 7, max_days: 10 },
{ pincode: 673317, min_days: 7, max_days: 10 },
{ pincode: 673318, min_days: 7, max_days: 10 },
{ pincode: 673321, min_days: 7, max_days: 10 },
{ pincode: 673323, min_days: 7, max_days: 10 },
{ pincode: 673324, min_days: 7, max_days: 10 },
{ pincode: 673325, min_days: 7, max_days: 10 },
{ pincode: 673326, min_days: 7, max_days: 10 },
{ pincode: 673327, min_days: 7, max_days: 10 },
{ pincode: 673328, min_days: 7, max_days: 10 },
{ pincode: 673500, min_days: 7, max_days: 10 },
{ pincode: 673501, min_days: 7, max_days: 10 },
{ pincode: 673502, min_days: 7, max_days: 10 },
{ pincode: 673503, min_days: 7, max_days: 10 },
{ pincode: 673504, min_days: 7, max_days: 10 },
{ pincode: 673505, min_days: 7, max_days: 10 },
{ pincode: 673506, min_days: 7, max_days: 10 },
{ pincode: 673507, min_days: 7, max_days: 10 },
{ pincode: 673508, min_days: 7, max_days: 10 },
{ pincode: 673509, min_days: 7, max_days: 10 },
{ pincode: 673510, min_days: 7, max_days: 10 },
{ pincode: 673511, min_days: 7, max_days: 10 },
{ pincode: 673512, min_days: 7, max_days: 10 },
{ pincode: 673513, min_days: 7, max_days: 10 },
{ pincode: 673514, min_days: 7, max_days: 10 },
{ pincode: 673515, min_days: 7, max_days: 10 },
{ pincode: 673516, min_days: 7, max_days: 10 },
{ pincode: 673518, min_days: 7, max_days: 10 },
{ pincode: 673519, min_days: 7, max_days: 10 },
{ pincode: 673520, min_days: 7, max_days: 10 },
{ pincode: 673521, min_days: 7, max_days: 10 },
{ pincode: 673522, min_days: 7, max_days: 10 },
{ pincode: 673523, min_days: 7, max_days: 10 },
{ pincode: 673524, min_days: 7, max_days: 10 },
{ pincode: 673525, min_days: 7, max_days: 10 },
{ pincode: 673526, min_days: 7, max_days: 10 },
{ pincode: 673527, min_days: 7, max_days: 10 },
{ pincode: 673528, min_days: 7, max_days: 10 },
{ pincode: 673529, min_days: 7, max_days: 10 },
{ pincode: 673530, min_days: 7, max_days: 10 },
{ pincode: 673531, min_days: 7, max_days: 10 },
{ pincode: 673532, min_days: 7, max_days: 10 },
{ pincode: 673533, min_days: 7, max_days: 10 },
{ pincode: 673534, min_days: 7, max_days: 10 },
{ pincode: 673535, min_days: 7, max_days: 10 },
{ pincode: 673541, min_days: 7, max_days: 10 },
{ pincode: 673542, min_days: 7, max_days: 10 },
{ pincode: 673543, min_days: 7, max_days: 10 },
{ pincode: 673544, min_days: 7, max_days: 10 },
{ pincode: 673555, min_days: 7, max_days: 10 },
{ pincode: 673557, min_days: 7, max_days: 10 },
{ pincode: 673558, min_days: 7, max_days: 10 },
{ pincode: 673570, min_days: 7, max_days: 10 },
{ pincode: 673571, min_days: 7, max_days: 10 },
{ pincode: 673572, min_days: 7, max_days: 10 },
{ pincode: 673573, min_days: 7, max_days: 10 },
{ pincode: 673574, min_days: 7, max_days: 10 },
{ pincode: 673576, min_days: 7, max_days: 10 },
{ pincode: 673580, min_days: 7, max_days: 10 },
{ pincode: 673582, min_days: 7, max_days: 10 },
{ pincode: 673583, min_days: 7, max_days: 10 },
{ pincode: 673585, min_days: 7, max_days: 10 },
{ pincode: 673586, min_days: 7, max_days: 10 },
{ pincode: 673587, min_days: 7, max_days: 10 },
{ pincode: 673588, min_days: 7, max_days: 10 },
{ pincode: 673600, min_days: 7, max_days: 10 },
{ pincode: 673601, min_days: 7, max_days: 10 },
{ pincode: 673602, min_days: 7, max_days: 10 },
{ pincode: 673603, min_days: 7, max_days: 10 },
{ pincode: 673604, min_days: 7, max_days: 10 },
{ pincode: 673607, min_days: 7, max_days: 10 },
{ pincode: 673611, min_days: 7, max_days: 10 },
{ pincode: 673612, min_days: 7, max_days: 10 },
{ pincode: 673613, min_days: 7, max_days: 10 },
{ pincode: 673614, min_days: 7, max_days: 10 },
{ pincode: 673615, min_days: 7, max_days: 10 },
{ pincode: 673616, min_days: 7, max_days: 10 },
{ pincode: 673617, min_days: 7, max_days: 10 },
{ pincode: 673618, min_days: 7, max_days: 10 },
{ pincode: 673619, min_days: 7, max_days: 10 },
{ pincode: 673620, min_days: 7, max_days: 10 },
{ pincode: 673623, min_days: 7, max_days: 10 },
{ pincode: 673624, min_days: 7, max_days: 10 },
{ pincode: 673631, min_days: 7, max_days: 10 },
{ pincode: 673632, min_days: 7, max_days: 10 },
{ pincode: 673633, min_days: 7, max_days: 10 },
{ pincode: 673634, min_days: 7, max_days: 10 },
{ pincode: 673635, min_days: 7, max_days: 10 },
{ pincode: 673636, min_days: 7, max_days: 10 },
{ pincode: 673637, min_days: 7, max_days: 10 },
{ pincode: 673638, min_days: 7, max_days: 10 },
{ pincode: 673639, min_days: 7, max_days: 10 },
{ pincode: 673640, min_days: 7, max_days: 10 },
{ pincode: 673641, min_days: 7, max_days: 10 },
{ pincode: 673642, min_days: 7, max_days: 10 },
{ pincode: 673643, min_days: 7, max_days: 10 },
{ pincode: 673644, min_days: 7, max_days: 10 },
{ pincode: 673645, min_days: 7, max_days: 10 },
{ pincode: 673647, min_days: 7, max_days: 10 },
{ pincode: 673648, min_days: 7, max_days: 10 },
{ pincode: 673649, min_days: 7, max_days: 10 },
{ pincode: 673650, min_days: 7, max_days: 10 },
{ pincode: 673652, min_days: 7, max_days: 10 },
{ pincode: 673655, min_days: 7, max_days: 10 },
{ pincode: 673661, min_days: 7, max_days: 10 },
{ pincode: 676101, min_days: 7, max_days: 10 },
{ pincode: 676102, min_days: 7, max_days: 10 },
{ pincode: 676103, min_days: 7, max_days: 10 },
{ pincode: 676104, min_days: 7, max_days: 10 },
{ pincode: 676105, min_days: 7, max_days: 10 },
{ pincode: 676106, min_days: 7, max_days: 10 },
{ pincode: 676107, min_days: 7, max_days: 10 },
{ pincode: 676108, min_days: 7, max_days: 10 },
{ pincode: 676109, min_days: 7, max_days: 10 },
{ pincode: 676110, min_days: 7, max_days: 10 },
{ pincode: 676111, min_days: 7, max_days: 10 },
{ pincode: 676121, min_days: 7, max_days: 10 },
{ pincode: 676122, min_days: 7, max_days: 10 },
{ pincode: 676123, min_days: 7, max_days: 10 },
{ pincode: 676126, min_days: 7, max_days: 10 },
{ pincode: 676127, min_days: 7, max_days: 10 },
{ pincode: 676301, min_days: 7, max_days: 10 },
{ pincode: 676302, min_days: 7, max_days: 10 },
{ pincode: 676303, min_days: 7, max_days: 10 },
{ pincode: 676304, min_days: 7, max_days: 10 },
{ pincode: 676305, min_days: 7, max_days: 10 },
{ pincode: 676306, min_days: 7, max_days: 10 },
{ pincode: 676307, min_days: 7, max_days: 10 },
{ pincode: 676308, min_days: 7, max_days: 10 },
{ pincode: 676309, min_days: 7, max_days: 10 },
{ pincode: 676310, min_days: 7, max_days: 10 },
{ pincode: 676311, min_days: 7, max_days: 10 },
{ pincode: 676312, min_days: 7, max_days: 10 },
{ pincode: 676313, min_days: 7, max_days: 10 },
{ pincode: 676314, min_days: 7, max_days: 10 },
{ pincode: 676315, min_days: 7, max_days: 10 },
{ pincode: 676317, min_days: 7, max_days: 10 },
{ pincode: 676318, min_days: 7, max_days: 10 },
{ pincode: 676319, min_days: 7, max_days: 10 },
{ pincode: 676320, min_days: 7, max_days: 10 },
{ pincode: 676329, min_days: 7, max_days: 10 },
{ pincode: 676501, min_days: 7, max_days: 10 },
{ pincode: 676502, min_days: 7, max_days: 10 },
{ pincode: 676503, min_days: 7, max_days: 10 },
{ pincode: 676504, min_days: 7, max_days: 10 },
{ pincode: 676505, min_days: 7, max_days: 10 },
{ pincode: 676506, min_days: 7, max_days: 10 },
{ pincode: 676507, min_days: 7, max_days: 10 },
{ pincode: 676508, min_days: 7, max_days: 10 },
{ pincode: 676509, min_days: 7, max_days: 10 },
{ pincode: 676510, min_days: 7, max_days: 10 },
{ pincode: 676511, min_days: 7, max_days: 10 },
{ pincode: 676512, min_days: 7, max_days: 10 },
{ pincode: 676513, min_days: 7, max_days: 10 },
{ pincode: 676514, min_days: 7, max_days: 10 },
{ pincode: 676516, min_days: 7, max_days: 10 },
{ pincode: 676517, min_days: 7, max_days: 10 },
{ pincode: 676518, min_days: 7, max_days: 10 },
{ pincode: 676519, min_days: 7, max_days: 10 },
{ pincode: 676520, min_days: 7, max_days: 10 },
{ pincode: 676521, min_days: 7, max_days: 10 },
{ pincode: 676522, min_days: 7, max_days: 10 },
{ pincode: 676526, min_days: 7, max_days: 10 },
{ pincode: 676528, min_days: 7, max_days: 10 },
{ pincode: 676541, min_days: 7, max_days: 10 },
{ pincode: 676542, min_days: 7, max_days: 10 },
{ pincode: 676551, min_days: 7, max_days: 10 },
{ pincode: 676552, min_days: 7, max_days: 10 },
{ pincode: 676553, min_days: 7, max_days: 10 },
{ pincode: 676554, min_days: 7, max_days: 10 },
{ pincode: 676556, min_days: 7, max_days: 10 },
{ pincode: 676557, min_days: 7, max_days: 10 },
{ pincode: 676561, min_days: 7, max_days: 10 },
{ pincode: 676562, min_days: 7, max_days: 10 },
{ pincode: 678001, min_days: 7, max_days: 10 },
{ pincode: 678002, min_days: 7, max_days: 10 },
{ pincode: 678003, min_days: 7, max_days: 10 },
{ pincode: 678004, min_days: 7, max_days: 10 },
{ pincode: 678005, min_days: 7, max_days: 10 },
{ pincode: 678006, min_days: 7, max_days: 10 },
{ pincode: 678007, min_days: 7, max_days: 10 },
{ pincode: 678008, min_days: 7, max_days: 10 },
{ pincode: 678009, min_days: 7, max_days: 10 },
{ pincode: 678010, min_days: 7, max_days: 10 },
{ pincode: 678011, min_days: 7, max_days: 10 },
{ pincode: 678012, min_days: 7, max_days: 10 },
{ pincode: 678013, min_days: 7, max_days: 10 },
{ pincode: 678014, min_days: 7, max_days: 10 },
{ pincode: 678015, min_days: 7, max_days: 10 },
{ pincode: 678016, min_days: 7, max_days: 10 },
{ pincode: 678017, min_days: 7, max_days: 10 },
{ pincode: 678018, min_days: 7, max_days: 10 },
{ pincode: 678019, min_days: 7, max_days: 10 },
{ pincode: 678020, min_days: 7, max_days: 10 },
{ pincode: 678021, min_days: 7, max_days: 10 },
{ pincode: 678022, min_days: 7, max_days: 10 },
{ pincode: 678023, min_days: 7, max_days: 10 },
{ pincode: 678024, min_days: 7, max_days: 10 },
{ pincode: 678101, min_days: 7, max_days: 10 },
{ pincode: 678102, min_days: 7, max_days: 10 },
{ pincode: 678103, min_days: 7, max_days: 10 },
{ pincode: 678104, min_days: 7, max_days: 10 },
{ pincode: 678105, min_days: 7, max_days: 10 },
{ pincode: 678501, min_days: 7, max_days: 10 },
{ pincode: 678502, min_days: 7, max_days: 10 },
{ pincode: 678503, min_days: 7, max_days: 10 },
{ pincode: 678504, min_days: 7, max_days: 10 },
{ pincode: 678505, min_days: 7, max_days: 10 },
{ pincode: 678506, min_days: 7, max_days: 10 },
{ pincode: 678507, min_days: 7, max_days: 10 },
{ pincode: 678508, min_days: 7, max_days: 10 },
{ pincode: 678509, min_days: 7, max_days: 10 },
{ pincode: 678510, min_days: 7, max_days: 10 },
{ pincode: 678511, min_days: 7, max_days: 10 },
{ pincode: 678512, min_days: 7, max_days: 10 },
{ pincode: 678513, min_days: 7, max_days: 10 },
{ pincode: 678531, min_days: 7, max_days: 10 },
{ pincode: 678532, min_days: 7, max_days: 10 },
{ pincode: 678533, min_days: 7, max_days: 10 },
{ pincode: 678534, min_days: 7, max_days: 10 },
{ pincode: 678541, min_days: 7, max_days: 10 },
{ pincode: 678542, min_days: 7, max_days: 10 },
{ pincode: 678543, min_days: 7, max_days: 10 },
{ pincode: 678544, min_days: 7, max_days: 10 },
{ pincode: 678545, min_days: 7, max_days: 10 },
{ pincode: 678546, min_days: 7, max_days: 10 },
{ pincode: 678547, min_days: 7, max_days: 10 },
{ pincode: 678548, min_days: 7, max_days: 10 },
{ pincode: 678551, min_days: 7, max_days: 10 },
{ pincode: 678552, min_days: 7, max_days: 10 },
{ pincode: 678553, min_days: 7, max_days: 10 },
{ pincode: 678554, min_days: 7, max_days: 10 },
{ pincode: 678555, min_days: 7, max_days: 10 },
{ pincode: 678556, min_days: 7, max_days: 10 },
{ pincode: 678557, min_days: 7, max_days: 10 },
{ pincode: 678558, min_days: 7, max_days: 10 },
{ pincode: 678559, min_days: 7, max_days: 10 },
{ pincode: 678571, min_days: 7, max_days: 10 },
{ pincode: 678572, min_days: 7, max_days: 10 },
{ pincode: 678573, min_days: 7, max_days: 10 },
{ pincode: 678574, min_days: 7, max_days: 10 },
{ pincode: 678575, min_days: 7, max_days: 10 },
{ pincode: 678578, min_days: 7, max_days: 10 },
{ pincode: 678583, min_days: 7, max_days: 10 },
{ pincode: 678584, min_days: 7, max_days: 10 },
{ pincode: 678586, min_days: 7, max_days: 10 },
{ pincode: 678587, min_days: 7, max_days: 10 },
{ pincode: 678589, min_days: 7, max_days: 10 },
{ pincode: 678591, min_days: 7, max_days: 10 },
{ pincode: 678592, min_days: 7, max_days: 10 },
{ pincode: 678593, min_days: 7, max_days: 10 },
{ pincode: 678594, min_days: 7, max_days: 10 },
{ pincode: 678595, min_days: 7, max_days: 10 },
{ pincode: 678596, min_days: 7, max_days: 10 },
{ pincode: 678597, min_days: 7, max_days: 10 },
{ pincode: 678598, min_days: 7, max_days: 10 },
{ pincode: 678600, min_days: 7, max_days: 10 },
{ pincode: 678601, min_days: 7, max_days: 10 },
{ pincode: 678602, min_days: 7, max_days: 10 },
{ pincode: 678603, min_days: 7, max_days: 10 },
{ pincode: 678604, min_days: 7, max_days: 10 },
{ pincode: 678605, min_days: 7, max_days: 10 },
{ pincode: 678606, min_days: 7, max_days: 10 },
{ pincode: 678609, min_days: 7, max_days: 10 },
{ pincode: 678611, min_days: 7, max_days: 10 },
{ pincode: 678612, min_days: 7, max_days: 10 },
{ pincode: 678613, min_days: 7, max_days: 10 },
{ pincode: 678614, min_days: 7, max_days: 10 },
{ pincode: 678615, min_days: 7, max_days: 10 },
{ pincode: 678616, min_days: 7, max_days: 10 },
{ pincode: 678621, min_days: 7, max_days: 10 },
{ pincode: 678622, min_days: 7, max_days: 10 },
{ pincode: 678623, min_days: 7, max_days: 10 },
{ pincode: 678624, min_days: 7, max_days: 10 },
{ pincode: 678631, min_days: 7, max_days: 10 },
{ pincode: 678632, min_days: 7, max_days: 10 },
{ pincode: 678633, min_days: 7, max_days: 10 },
{ pincode: 678634, min_days: 7, max_days: 10 },
{ pincode: 678635, min_days: 7, max_days: 10 },
{ pincode: 678637, min_days: 7, max_days: 10 },
{ pincode: 678638, min_days: 7, max_days: 10 },
{ pincode: 678641, min_days: 7, max_days: 10 },
{ pincode: 678642, min_days: 7, max_days: 10 },
{ pincode: 678651, min_days: 7, max_days: 10 },
{ pincode: 678671, min_days: 7, max_days: 10 },
{ pincode: 678678, min_days: 7, max_days: 10 },
{ pincode: 678681, min_days: 7, max_days: 10 },
{ pincode: 678682, min_days: 7, max_days: 10 },
{ pincode: 678683, min_days: 7, max_days: 10 },
{ pincode: 678684, min_days: 7, max_days: 10 },
{ pincode: 678685, min_days: 7, max_days: 10 },
{ pincode: 678686, min_days: 7, max_days: 10 },
{ pincode: 678687, min_days: 7, max_days: 10 },
{ pincode: 678688, min_days: 7, max_days: 10 },
{ pincode: 678689, min_days: 7, max_days: 10 },
{ pincode: 678701, min_days: 7, max_days: 10 },
{ pincode: 678702, min_days: 7, max_days: 10 },
{ pincode: 678703, min_days: 7, max_days: 10 },
{ pincode: 678704, min_days: 7, max_days: 10 },
{ pincode: 678705, min_days: 7, max_days: 10 },
{ pincode: 678706, min_days: 7, max_days: 10 },
{ pincode: 678707, min_days: 7, max_days: 10 },
{ pincode: 678708, min_days: 7, max_days: 10 },
{ pincode: 678709, min_days: 7, max_days: 10 },
{ pincode: 678721, min_days: 7, max_days: 10 },
{ pincode: 678722, min_days: 7, max_days: 10 },
{ pincode: 678731, min_days: 7, max_days: 10 },
{ pincode: 678732, min_days: 7, max_days: 10 },
{ pincode: 678733, min_days: 7, max_days: 10 },
{ pincode: 678761, min_days: 7, max_days: 10 },
{ pincode: 678762, min_days: 7, max_days: 10 },
{ pincode: 679101, min_days: 7, max_days: 10 },
{ pincode: 679102, min_days: 7, max_days: 10 },
{ pincode: 679103, min_days: 7, max_days: 10 },
{ pincode: 679104, min_days: 7, max_days: 10 },
{ pincode: 679105, min_days: 7, max_days: 10 },
{ pincode: 679106, min_days: 7, max_days: 10 },
{ pincode: 679121, min_days: 7, max_days: 10 },
{ pincode: 679122, min_days: 7, max_days: 10 },
{ pincode: 679123, min_days: 7, max_days: 10 },
{ pincode: 679124, min_days: 7, max_days: 10 },
{ pincode: 679125, min_days: 7, max_days: 10 },
{ pincode: 679301, min_days: 7, max_days: 10 },
{ pincode: 679302, min_days: 7, max_days: 10 },
{ pincode: 679303, min_days: 7, max_days: 10 },
{ pincode: 679304, min_days: 7, max_days: 10 },
{ pincode: 679305, min_days: 7, max_days: 10 },
{ pincode: 679306, min_days: 7, max_days: 10 },
{ pincode: 679307, min_days: 7, max_days: 10 },
{ pincode: 679308, min_days: 7, max_days: 10 },
{ pincode: 679309, min_days: 7, max_days: 10 },
{ pincode: 679310, min_days: 7, max_days: 10 },
{ pincode: 679312, min_days: 7, max_days: 10 },
{ pincode: 679313, min_days: 7, max_days: 10 },
{ pincode: 679314, min_days: 7, max_days: 10 },
{ pincode: 679321, min_days: 7, max_days: 10 },
{ pincode: 679322, min_days: 7, max_days: 10 },
{ pincode: 679323, min_days: 7, max_days: 10 },
{ pincode: 679324, min_days: 7, max_days: 10 },
{ pincode: 679325, min_days: 7, max_days: 10 },
{ pincode: 679326, min_days: 7, max_days: 10 },
{ pincode: 679328, min_days: 7, max_days: 10 },
{ pincode: 679335, min_days: 7, max_days: 10 },
{ pincode: 679336, min_days: 7, max_days: 10 },
{ pincode: 679337, min_days: 7, max_days: 10 },
{ pincode: 679338, min_days: 7, max_days: 10 },
{ pincode: 679340, min_days: 7, max_days: 10 },
{ pincode: 679350, min_days: 7, max_days: 10 },
{ pincode: 679351, min_days: 7, max_days: 10 },
{ pincode: 679352, min_days: 7, max_days: 10 },
{ pincode: 679356, min_days: 7, max_days: 10 },
{ pincode: 679357, min_days: 7, max_days: 10 },
{ pincode: 679501, min_days: 7, max_days: 10 },
{ pincode: 679502, min_days: 7, max_days: 10 },
{ pincode: 679503, min_days: 7, max_days: 10 },
{ pincode: 679504, min_days: 7, max_days: 10 },
{ pincode: 679505, min_days: 7, max_days: 10 },
{ pincode: 679506, min_days: 7, max_days: 10 },
{ pincode: 679508, min_days: 7, max_days: 10 },
{ pincode: 679511, min_days: 7, max_days: 10 },
{ pincode: 679512, min_days: 7, max_days: 10 },
{ pincode: 679513, min_days: 7, max_days: 10 },
{ pincode: 679514, min_days: 7, max_days: 10 },
{ pincode: 679515, min_days: 7, max_days: 10 },
{ pincode: 679516, min_days: 7, max_days: 10 },
{ pincode: 679517, min_days: 7, max_days: 10 },
{ pincode: 679518, min_days: 7, max_days: 10 },
{ pincode: 679519, min_days: 7, max_days: 10 },
{ pincode: 679521, min_days: 7, max_days: 10 },
{ pincode: 679522, min_days: 7, max_days: 10 },
{ pincode: 679523, min_days: 7, max_days: 10 },
{ pincode: 679528, min_days: 7, max_days: 10 },
{ pincode: 679531, min_days: 7, max_days: 10 },
{ pincode: 679532, min_days: 7, max_days: 10 },
{ pincode: 679533, min_days: 7, max_days: 10 },
{ pincode: 679534, min_days: 7, max_days: 10 },
{ pincode: 679535, min_days: 7, max_days: 10 },
{ pincode: 679536, min_days: 7, max_days: 10 },
{ pincode: 679537, min_days: 7, max_days: 10 },
{ pincode: 679538, min_days: 7, max_days: 10 },
{ pincode: 679539, min_days: 7, max_days: 10 },
{ pincode: 679551, min_days: 7, max_days: 10 },
{ pincode: 679552, min_days: 7, max_days: 10 },
{ pincode: 679553, min_days: 7, max_days: 10 },
{ pincode: 679554, min_days: 7, max_days: 10 },
{ pincode: 679556, min_days: 7, max_days: 10 },
{ pincode: 679561, min_days: 7, max_days: 10 },
{ pincode: 679562, min_days: 7, max_days: 10 },
{ pincode: 679563, min_days: 7, max_days: 10 },
{ pincode: 679564, min_days: 7, max_days: 10 },
{ pincode: 679571, min_days: 7, max_days: 10 },
{ pincode: 679572, min_days: 7, max_days: 10 },
{ pincode: 679573, min_days: 7, max_days: 10 },
{ pincode: 679574, min_days: 7, max_days: 10 },
{ pincode: 679575, min_days: 7, max_days: 10 },
{ pincode: 679576, min_days: 7, max_days: 10 },
{ pincode: 679577, min_days: 7, max_days: 10 },
{ pincode: 679578, min_days: 7, max_days: 10 },
{ pincode: 679579, min_days: 7, max_days: 10 },
{ pincode: 679580, min_days: 7, max_days: 10 },
{ pincode: 679581, min_days: 7, max_days: 10 },
{ pincode: 679582, min_days: 7, max_days: 10 },
{ pincode: 679583, min_days: 7, max_days: 10 },
{ pincode: 679584, min_days: 7, max_days: 10 },
{ pincode: 679585, min_days: 7, max_days: 10 },
{ pincode: 679586, min_days: 7, max_days: 10 },
{ pincode: 679587, min_days: 7, max_days: 10 },
{ pincode: 679588, min_days: 7, max_days: 10 },
{ pincode: 679589, min_days: 7, max_days: 10 },
{ pincode: 679590, min_days: 7, max_days: 10 },
{ pincode: 679591, min_days: 7, max_days: 10 },
{ pincode: 679592, min_days: 7, max_days: 10 },
{ pincode: 679594, min_days: 7, max_days: 10 },
{ pincode: 680000, min_days: 7, max_days: 10 },
{ pincode: 680001, min_days: 7, max_days: 10 },
{ pincode: 680002, min_days: 7, max_days: 10 },
{ pincode: 680003, min_days: 7, max_days: 10 },
{ pincode: 680004, min_days: 7, max_days: 10 },
{ pincode: 680005, min_days: 7, max_days: 10 },
{ pincode: 680006, min_days: 7, max_days: 10 },
{ pincode: 680007, min_days: 7, max_days: 10 },
{ pincode: 680008, min_days: 7, max_days: 10 },
{ pincode: 680009, min_days: 7, max_days: 10 },
{ pincode: 680010, min_days: 7, max_days: 10 },
{ pincode: 680011, min_days: 7, max_days: 10 },
{ pincode: 680012, min_days: 7, max_days: 10 },
{ pincode: 680013, min_days: 7, max_days: 10 },
{ pincode: 680014, min_days: 7, max_days: 10 },
{ pincode: 680015, min_days: 7, max_days: 10 },
{ pincode: 680016, min_days: 7, max_days: 10 },
{ pincode: 680017, min_days: 7, max_days: 10 },
{ pincode: 680018, min_days: 7, max_days: 10 },
{ pincode: 680019, min_days: 7, max_days: 10 },
{ pincode: 680020, min_days: 7, max_days: 10 },
{ pincode: 680021, min_days: 7, max_days: 10 },
{ pincode: 680022, min_days: 7, max_days: 10 },
{ pincode: 680026, min_days: 7, max_days: 10 },
{ pincode: 680027, min_days: 7, max_days: 10 },
{ pincode: 680028, min_days: 7, max_days: 10 },
{ pincode: 680101, min_days: 7, max_days: 10 },
{ pincode: 680102, min_days: 7, max_days: 10 },
{ pincode: 680103, min_days: 7, max_days: 10 },
{ pincode: 680104, min_days: 7, max_days: 10 },
{ pincode: 680121, min_days: 7, max_days: 10 },
{ pincode: 680122, min_days: 7, max_days: 10 },
{ pincode: 680123, min_days: 7, max_days: 10 },
{ pincode: 680125, min_days: 7, max_days: 10 },
{ pincode: 680301, min_days: 7, max_days: 10 },
{ pincode: 680302, min_days: 7, max_days: 10 },
{ pincode: 680303, min_days: 7, max_days: 10 },
{ pincode: 680304, min_days: 7, max_days: 10 },
{ pincode: 680305, min_days: 7, max_days: 10 },
{ pincode: 680306, min_days: 7, max_days: 10 },
{ pincode: 680307, min_days: 7, max_days: 10 },
{ pincode: 680308, min_days: 7, max_days: 10 },
{ pincode: 680309, min_days: 7, max_days: 10 },
{ pincode: 680310, min_days: 7, max_days: 10 },
{ pincode: 680311, min_days: 7, max_days: 10 },
{ pincode: 680312, min_days: 7, max_days: 10 },
{ pincode: 680313, min_days: 7, max_days: 10 },
{ pincode: 680314, min_days: 7, max_days: 10 },
{ pincode: 680315, min_days: 7, max_days: 10 },
{ pincode: 680316, min_days: 7, max_days: 10 },
{ pincode: 680317, min_days: 7, max_days: 10 },
{ pincode: 680318, min_days: 7, max_days: 10 },
{ pincode: 680319, min_days: 7, max_days: 10 },
{ pincode: 680321, min_days: 7, max_days: 10 },
{ pincode: 680322, min_days: 7, max_days: 10 },
{ pincode: 680323, min_days: 7, max_days: 10 },
{ pincode: 680324, min_days: 7, max_days: 10 },
{ pincode: 680325, min_days: 7, max_days: 10 },
{ pincode: 680501, min_days: 7, max_days: 10 },
{ pincode: 680502, min_days: 7, max_days: 10 },
{ pincode: 680503, min_days: 7, max_days: 10 },
{ pincode: 680504, min_days: 7, max_days: 10 },
{ pincode: 680505, min_days: 7, max_days: 10 },
{ pincode: 680506, min_days: 7, max_days: 10 },
{ pincode: 680507, min_days: 7, max_days: 10 },
{ pincode: 680508, min_days: 7, max_days: 10 },
{ pincode: 680509, min_days: 7, max_days: 10 },
{ pincode: 680510, min_days: 7, max_days: 10 },
{ pincode: 680511, min_days: 7, max_days: 10 },
{ pincode: 680512, min_days: 7, max_days: 10 },
{ pincode: 680513, min_days: 7, max_days: 10 },
{ pincode: 680514, min_days: 7, max_days: 10 },
{ pincode: 680515, min_days: 7, max_days: 10 },
{ pincode: 680516, min_days: 7, max_days: 10 },
{ pincode: 680517, min_days: 7, max_days: 10 },
{ pincode: 680518, min_days: 7, max_days: 10 },
{ pincode: 680519, min_days: 7, max_days: 10 },
{ pincode: 680520, min_days: 7, max_days: 10 },
{ pincode: 680521, min_days: 7, max_days: 10 },
{ pincode: 680522, min_days: 7, max_days: 10 },
{ pincode: 680523, min_days: 7, max_days: 10 },
{ pincode: 680524, min_days: 7, max_days: 10 },
{ pincode: 680525, min_days: 7, max_days: 10 },
{ pincode: 680534, min_days: 7, max_days: 10 },
{ pincode: 680541, min_days: 7, max_days: 10 },
{ pincode: 680542, min_days: 7, max_days: 10 },
{ pincode: 680543, min_days: 7, max_days: 10 },
{ pincode: 680544, min_days: 7, max_days: 10 },
{ pincode: 680545, min_days: 7, max_days: 10 },
{ pincode: 680546, min_days: 7, max_days: 10 },
{ pincode: 680547, min_days: 7, max_days: 10 },
{ pincode: 680549, min_days: 7, max_days: 10 },
{ pincode: 680551, min_days: 7, max_days: 10 },
{ pincode: 680552, min_days: 7, max_days: 10 },
{ pincode: 680553, min_days: 7, max_days: 10 },
{ pincode: 680554, min_days: 7, max_days: 10 },
{ pincode: 680555, min_days: 7, max_days: 10 },
{ pincode: 680561, min_days: 7, max_days: 10 },
{ pincode: 680562, min_days: 7, max_days: 10 },
{ pincode: 680563, min_days: 7, max_days: 10 },
{ pincode: 680564, min_days: 7, max_days: 10 },
{ pincode: 680565, min_days: 7, max_days: 10 },
{ pincode: 680566, min_days: 7, max_days: 10 },
{ pincode: 680567, min_days: 7, max_days: 10 },
{ pincode: 680568, min_days: 7, max_days: 10 },
{ pincode: 680569, min_days: 7, max_days: 10 },
{ pincode: 680570, min_days: 7, max_days: 10 },
{ pincode: 680571, min_days: 7, max_days: 10 },
{ pincode: 680572, min_days: 7, max_days: 10 },
{ pincode: 680573, min_days: 7, max_days: 10 },
{ pincode: 680574, min_days: 7, max_days: 10 },
{ pincode: 680575, min_days: 7, max_days: 10 },
{ pincode: 680581, min_days: 7, max_days: 10 },
{ pincode: 680582, min_days: 7, max_days: 10 },
{ pincode: 680583, min_days: 7, max_days: 10 },
{ pincode: 680584, min_days: 7, max_days: 10 },
{ pincode: 680585, min_days: 7, max_days: 10 },
{ pincode: 680586, min_days: 7, max_days: 10 },
{ pincode: 680587, min_days: 7, max_days: 10 },
{ pincode: 680588, min_days: 7, max_days: 10 },
{ pincode: 680589, min_days: 7, max_days: 10 },
{ pincode: 680590, min_days: 7, max_days: 10 },
{ pincode: 680591, min_days: 7, max_days: 10 },
{ pincode: 680592, min_days: 7, max_days: 10 },
{ pincode: 680593, min_days: 7, max_days: 10 },
{ pincode: 680594, min_days: 7, max_days: 10 },
{ pincode: 680595, min_days: 7, max_days: 10 },
{ pincode: 680596, min_days: 7, max_days: 10 },
{ pincode: 680597, min_days: 7, max_days: 10 },
{ pincode: 680600, min_days: 7, max_days: 10 },
{ pincode: 680601, min_days: 7, max_days: 10 },
{ pincode: 680602, min_days: 7, max_days: 10 },
{ pincode: 680603, min_days: 7, max_days: 10 },
{ pincode: 680604, min_days: 7, max_days: 10 },
{ pincode: 680608, min_days: 7, max_days: 10 },
{ pincode: 680609, min_days: 7, max_days: 10 },
{ pincode: 680610, min_days: 7, max_days: 10 },
{ pincode: 680611, min_days: 7, max_days: 10 },
{ pincode: 680612, min_days: 7, max_days: 10 },
{ pincode: 680613, min_days: 7, max_days: 10 },
{ pincode: 680614, min_days: 7, max_days: 10 },
{ pincode: 680615, min_days: 7, max_days: 10 },
{ pincode: 680616, min_days: 7, max_days: 10 },
{ pincode: 680617, min_days: 7, max_days: 10 },
{ pincode: 680618, min_days: 7, max_days: 10 },
{ pincode: 680619, min_days: 7, max_days: 10 },
{ pincode: 680620, min_days: 7, max_days: 10 },
{ pincode: 680621, min_days: 7, max_days: 10 },
{ pincode: 680623, min_days: 7, max_days: 10 },
{ pincode: 680631, min_days: 7, max_days: 10 },
{ pincode: 680641, min_days: 7, max_days: 10 },
{ pincode: 680642, min_days: 7, max_days: 10 },
{ pincode: 680651, min_days: 7, max_days: 10 },
{ pincode: 680652, min_days: 7, max_days: 10 },
{ pincode: 680653, min_days: 7, max_days: 10 },
{ pincode: 680654, min_days: 7, max_days: 10 },
{ pincode: 680655, min_days: 7, max_days: 10 },
{ pincode: 680656, min_days: 7, max_days: 10 },
{ pincode: 680657, min_days: 7, max_days: 10 },
{ pincode: 680661, min_days: 7, max_days: 10 },
{ pincode: 680662, min_days: 7, max_days: 10 },
{ pincode: 680663, min_days: 7, max_days: 10 },
{ pincode: 680664, min_days: 7, max_days: 10 },
{ pincode: 680665, min_days: 7, max_days: 10 },
{ pincode: 680666, min_days: 7, max_days: 10 },
{ pincode: 680667, min_days: 7, max_days: 10 },
{ pincode: 680668, min_days: 7, max_days: 10 },
{ pincode: 680669, min_days: 7, max_days: 10 },
{ pincode: 680670, min_days: 7, max_days: 10 },
{ pincode: 680671, min_days: 7, max_days: 10 },
{ pincode: 680672, min_days: 7, max_days: 10 },
{ pincode: 680673, min_days: 7, max_days: 10 },
{ pincode: 680681, min_days: 7, max_days: 10 },
{ pincode: 680682, min_days: 7, max_days: 10 },
{ pincode: 680683, min_days: 7, max_days: 10 },
{ pincode: 680684, min_days: 7, max_days: 10 },
{ pincode: 680685, min_days: 7, max_days: 10 },
{ pincode: 680686, min_days: 7, max_days: 10 },
{ pincode: 680687, min_days: 7, max_days: 10 },
{ pincode: 680688, min_days: 7, max_days: 10 },
{ pincode: 680689, min_days: 7, max_days: 10 },
{ pincode: 680691, min_days: 7, max_days: 10 },
{ pincode: 680692, min_days: 7, max_days: 10 },
{ pincode: 680693, min_days: 7, max_days: 10 },
{ pincode: 680695, min_days: 7, max_days: 10 },
{ pincode: 680697, min_days: 7, max_days: 10 },
{ pincode: 680698, min_days: 7, max_days: 10 },
{ pincode: 680699, min_days: 7, max_days: 10 },
{ pincode: 680701, min_days: 7, max_days: 10 },
{ pincode: 680702, min_days: 7, max_days: 10 },
{ pincode: 680703, min_days: 7, max_days: 10 },
{ pincode: 680704, min_days: 7, max_days: 10 },
{ pincode: 680711, min_days: 7, max_days: 10 },
{ pincode: 680712, min_days: 7, max_days: 10 },
{ pincode: 680721, min_days: 7, max_days: 10 },
{ pincode: 680722, min_days: 7, max_days: 10 },
{ pincode: 680723, min_days: 7, max_days: 10 },
{ pincode: 680724, min_days: 7, max_days: 10 },
{ pincode: 680731, min_days: 7, max_days: 10 },
{ pincode: 680732, min_days: 7, max_days: 10 },
{ pincode: 680733, min_days: 7, max_days: 10 },
{ pincode: 680734, min_days: 7, max_days: 10 },
{ pincode: 680735, min_days: 7, max_days: 10 },
{ pincode: 680736, min_days: 7, max_days: 10 },
{ pincode: 680741, min_days: 7, max_days: 10 },
{ pincode: 680751, min_days: 7, max_days: 10 },
{ pincode: 680752, min_days: 7, max_days: 10 },
{ pincode: 680771, min_days: 7, max_days: 10 },
{ pincode: 682000, min_days: 7, max_days: 10 },
{ pincode: 682001, min_days: 7, max_days: 10 },
{ pincode: 682002, min_days: 7, max_days: 10 },
{ pincode: 682003, min_days: 7, max_days: 10 },
{ pincode: 682004, min_days: 7, max_days: 10 },
{ pincode: 682005, min_days: 7, max_days: 10 },
{ pincode: 682006, min_days: 7, max_days: 10 },
{ pincode: 682007, min_days: 7, max_days: 10 },
{ pincode: 682008, min_days: 7, max_days: 10 },
{ pincode: 682009, min_days: 7, max_days: 10 },
{ pincode: 682010, min_days: 7, max_days: 10 },
{ pincode: 682011, min_days: 7, max_days: 10 },
{ pincode: 682012, min_days: 7, max_days: 10 },
{ pincode: 682013, min_days: 7, max_days: 10 },
{ pincode: 682014, min_days: 7, max_days: 10 },
{ pincode: 682015, min_days: 7, max_days: 10 },
{ pincode: 682016, min_days: 7, max_days: 10 },
{ pincode: 682017, min_days: 7, max_days: 10 },
{ pincode: 682018, min_days: 7, max_days: 10 },
{ pincode: 682019, min_days: 7, max_days: 10 },
{ pincode: 682020, min_days: 7, max_days: 10 },
{ pincode: 682021, min_days: 7, max_days: 10 },
{ pincode: 682022, min_days: 7, max_days: 10 },
{ pincode: 682023, min_days: 7, max_days: 10 },
{ pincode: 682024, min_days: 7, max_days: 10 },
{ pincode: 682025, min_days: 7, max_days: 10 },
{ pincode: 682026, min_days: 7, max_days: 10 },
{ pincode: 682027, min_days: 7, max_days: 10 },
{ pincode: 682028, min_days: 7, max_days: 10 },
{ pincode: 682029, min_days: 7, max_days: 10 },
{ pincode: 682030, min_days: 7, max_days: 10 },
{ pincode: 682031, min_days: 7, max_days: 10 },
{ pincode: 682032, min_days: 7, max_days: 10 },
{ pincode: 682033, min_days: 7, max_days: 10 },
{ pincode: 682034, min_days: 7, max_days: 10 },
{ pincode: 682035, min_days: 7, max_days: 10 },
{ pincode: 682036, min_days: 7, max_days: 10 },
{ pincode: 682037, min_days: 7, max_days: 10 },
{ pincode: 682038, min_days: 7, max_days: 10 },
{ pincode: 682039, min_days: 7, max_days: 10 },
{ pincode: 682040, min_days: 7, max_days: 10 },
{ pincode: 682041, min_days: 7, max_days: 10 },
{ pincode: 682042, min_days: 7, max_days: 10 },
{ pincode: 682043, min_days: 7, max_days: 10 },
{ pincode: 682044, min_days: 7, max_days: 10 },
{ pincode: 682050, min_days: 7, max_days: 10 },
{ pincode: 682051, min_days: 7, max_days: 10 },
{ pincode: 682054, min_days: 7, max_days: 10 },
{ pincode: 682301, min_days: 7, max_days: 10 },
{ pincode: 682302, min_days: 7, max_days: 10 },
{ pincode: 682303, min_days: 7, max_days: 10 },
{ pincode: 682304, min_days: 7, max_days: 10 },
{ pincode: 682305, min_days: 7, max_days: 10 },
{ pincode: 682306, min_days: 7, max_days: 10 },
{ pincode: 682307, min_days: 7, max_days: 10 },
{ pincode: 682308, min_days: 7, max_days: 10 },
{ pincode: 682309, min_days: 7, max_days: 10 },
{ pincode: 682310, min_days: 7, max_days: 10 },
{ pincode: 682311, min_days: 7, max_days: 10 },
{ pincode: 682312, min_days: 7, max_days: 10 },
{ pincode: 682313, min_days: 7, max_days: 10 },
{ pincode: 682314, min_days: 7, max_days: 10 },
{ pincode: 682315, min_days: 7, max_days: 10 },
{ pincode: 682316, min_days: 7, max_days: 10 },
{ pincode: 682317, min_days: 7, max_days: 10 },
{ pincode: 682319, min_days: 7, max_days: 10 },
{ pincode: 682320, min_days: 7, max_days: 10 },
{ pincode: 682501, min_days: 7, max_days: 10 },
{ pincode: 682502, min_days: 7, max_days: 10 },
{ pincode: 682503, min_days: 7, max_days: 10 },
{ pincode: 682504, min_days: 7, max_days: 10 },
{ pincode: 682505, min_days: 7, max_days: 10 },
{ pincode: 682506, min_days: 7, max_days: 10 },
{ pincode: 682507, min_days: 7, max_days: 10 },
{ pincode: 682508, min_days: 7, max_days: 10 },
{ pincode: 682509, min_days: 7, max_days: 10 },
{ pincode: 682510, min_days: 7, max_days: 10 },
{ pincode: 682511, min_days: 7, max_days: 10 },
{ pincode: 683101, min_days: 7, max_days: 10 },
{ pincode: 683102, min_days: 7, max_days: 10 },
{ pincode: 683103, min_days: 7, max_days: 10 },
{ pincode: 683104, min_days: 7, max_days: 10 },
{ pincode: 683105, min_days: 7, max_days: 10 },
{ pincode: 683106, min_days: 7, max_days: 10 },
{ pincode: 683107, min_days: 7, max_days: 10 },
{ pincode: 683108, min_days: 7, max_days: 10 },
{ pincode: 683109, min_days: 7, max_days: 10 },
{ pincode: 683110, min_days: 7, max_days: 10 },
{ pincode: 683111, min_days: 7, max_days: 10 },
{ pincode: 683112, min_days: 7, max_days: 10 },
{ pincode: 683117, min_days: 7, max_days: 10 },
{ pincode: 683501, min_days: 7, max_days: 10 },
{ pincode: 683502, min_days: 7, max_days: 10 },
{ pincode: 683503, min_days: 7, max_days: 10 },
{ pincode: 683504, min_days: 7, max_days: 10 },
{ pincode: 683505, min_days: 7, max_days: 10 },
{ pincode: 683506, min_days: 7, max_days: 10 },
{ pincode: 683510, min_days: 7, max_days: 10 },
{ pincode: 683511, min_days: 7, max_days: 10 },
{ pincode: 683512, min_days: 7, max_days: 10 },
{ pincode: 683513, min_days: 7, max_days: 10 },
{ pincode: 683514, min_days: 7, max_days: 10 },
{ pincode: 683515, min_days: 7, max_days: 10 },
{ pincode: 683516, min_days: 7, max_days: 10 },
{ pincode: 683517, min_days: 7, max_days: 10 },
{ pincode: 683518, min_days: 7, max_days: 10 },
{ pincode: 683519, min_days: 7, max_days: 10 },
{ pincode: 683520, min_days: 7, max_days: 10 },
{ pincode: 683521, min_days: 7, max_days: 10 },
{ pincode: 683522, min_days: 7, max_days: 10 },
{ pincode: 683523, min_days: 7, max_days: 10 },
{ pincode: 683524, min_days: 7, max_days: 10 },
{ pincode: 683525, min_days: 7, max_days: 10 },
{ pincode: 683527, min_days: 7, max_days: 10 },
{ pincode: 683541, min_days: 7, max_days: 10 },
{ pincode: 683542, min_days: 7, max_days: 10 },
{ pincode: 683543, min_days: 7, max_days: 10 },
{ pincode: 683544, min_days: 7, max_days: 10 },
{ pincode: 683545, min_days: 7, max_days: 10 },
{ pincode: 683546, min_days: 7, max_days: 10 },
{ pincode: 683547, min_days: 7, max_days: 10 },
{ pincode: 683548, min_days: 7, max_days: 10 },
{ pincode: 683549, min_days: 7, max_days: 10 },
{ pincode: 683550, min_days: 7, max_days: 10 },
{ pincode: 683553, min_days: 7, max_days: 10 },
{ pincode: 683554, min_days: 7, max_days: 10 },
{ pincode: 683555, min_days: 7, max_days: 10 },
{ pincode: 683556, min_days: 7, max_days: 10 },
{ pincode: 683557, min_days: 7, max_days: 10 },
{ pincode: 683561, min_days: 7, max_days: 10 },
{ pincode: 683562, min_days: 7, max_days: 10 },
{ pincode: 683563, min_days: 7, max_days: 10 },
{ pincode: 683564, min_days: 7, max_days: 10 },
{ pincode: 683565, min_days: 7, max_days: 10 },
{ pincode: 683571, min_days: 7, max_days: 10 },
{ pincode: 683572, min_days: 7, max_days: 10 },
{ pincode: 683573, min_days: 7, max_days: 10 },
{ pincode: 683574, min_days: 7, max_days: 10 },
{ pincode: 683575, min_days: 7, max_days: 10 },
{ pincode: 683576, min_days: 7, max_days: 10 },
{ pincode: 683577, min_days: 7, max_days: 10 },
{ pincode: 683578, min_days: 7, max_days: 10 },
{ pincode: 683579, min_days: 7, max_days: 10 },
{ pincode: 683580, min_days: 7, max_days: 10 },
{ pincode: 683581, min_days: 7, max_days: 10 },
{ pincode: 683582, min_days: 7, max_days: 10 },
{ pincode: 683583, min_days: 7, max_days: 10 },
{ pincode: 683584, min_days: 7, max_days: 10 },
{ pincode: 683585, min_days: 7, max_days: 10 },
{ pincode: 683586, min_days: 7, max_days: 10 },
{ pincode: 683587, min_days: 7, max_days: 10 },
{ pincode: 683589, min_days: 7, max_days: 10 },
{ pincode: 683591, min_days: 7, max_days: 10 },
{ pincode: 683592, min_days: 7, max_days: 10 },
{ pincode: 683593, min_days: 7, max_days: 10 },
{ pincode: 683594, min_days: 7, max_days: 10 },
{ pincode: 685581, min_days: 7, max_days: 10 },
{ pincode: 685605, min_days: 7, max_days: 10 },
{ pincode: 686001, min_days: 7, max_days: 10 },
{ pincode: 686002, min_days: 7, max_days: 10 },
{ pincode: 686003, min_days: 7, max_days: 10 },
{ pincode: 686004, min_days: 7, max_days: 10 },
{ pincode: 686005, min_days: 7, max_days: 10 },
{ pincode: 686006, min_days: 7, max_days: 10 },
{ pincode: 686007, min_days: 7, max_days: 10 },
{ pincode: 686008, min_days: 7, max_days: 10 },
{ pincode: 686009, min_days: 7, max_days: 10 },
{ pincode: 686010, min_days: 7, max_days: 10 },
{ pincode: 686011, min_days: 7, max_days: 10 },
{ pincode: 686012, min_days: 7, max_days: 10 },
{ pincode: 686013, min_days: 7, max_days: 10 },
{ pincode: 686014, min_days: 7, max_days: 10 },
{ pincode: 686015, min_days: 7, max_days: 10 },
{ pincode: 686016, min_days: 7, max_days: 10 },
{ pincode: 686017, min_days: 7, max_days: 10 },
{ pincode: 686018, min_days: 7, max_days: 10 },
{ pincode: 686019, min_days: 7, max_days: 10 },
{ pincode: 686020, min_days: 7, max_days: 10 },
{ pincode: 686021, min_days: 7, max_days: 10 },
{ pincode: 686022, min_days: 7, max_days: 10 },
{ pincode: 686026, min_days: 7, max_days: 10 },
{ pincode: 686029, min_days: 7, max_days: 10 },
{ pincode: 686031, min_days: 7, max_days: 10 },
{ pincode: 686032, min_days: 7, max_days: 10 },
{ pincode: 686033, min_days: 7, max_days: 10 },
{ pincode: 686034, min_days: 7, max_days: 10 },
{ pincode: 686037, min_days: 7, max_days: 10 },
{ pincode: 686038, min_days: 7, max_days: 10 },
{ pincode: 686040, min_days: 7, max_days: 10 },
{ pincode: 686041, min_days: 7, max_days: 10 },
{ pincode: 686101, min_days: 7, max_days: 10 },
{ pincode: 686141, min_days: 7, max_days: 10 },
{ pincode: 686142, min_days: 7, max_days: 10 },
{ pincode: 686143, min_days: 7, max_days: 10 },
{ pincode: 686144, min_days: 7, max_days: 10 },
{ pincode: 686146, min_days: 7, max_days: 10 },
{ pincode: 686501, min_days: 7, max_days: 10 },
{ pincode: 686516, min_days: 7, max_days: 10 },
{ pincode: 686525, min_days: 7, max_days: 10 },
{ pincode: 686531, min_days: 7, max_days: 10 },
{ pincode: 686532, min_days: 7, max_days: 10 },
{ pincode: 686533, min_days: 7, max_days: 10 },
{ pincode: 686537, min_days: 7, max_days: 10 },
{ pincode: 686552, min_days: 7, max_days: 10 },
{ pincode: 686560, min_days: 7, max_days: 10 },
{ pincode: 686561, min_days: 7, max_days: 10 },
{ pincode: 686562, min_days: 7, max_days: 10 },
{ pincode: 686563, min_days: 7, max_days: 10 },
{ pincode: 686567, min_days: 7, max_days: 10 },
{ pincode: 686568, min_days: 7, max_days: 10 },
{ pincode: 686595, min_days: 7, max_days: 10 },
{ pincode: 686596, min_days: 7, max_days: 10 },
{ pincode: 686601, min_days: 7, max_days: 10 },
{ pincode: 686602, min_days: 7, max_days: 10 },
{ pincode: 686603, min_days: 7, max_days: 10 },
{ pincode: 686604, min_days: 7, max_days: 10 },
{ pincode: 686605, min_days: 7, max_days: 10 },
{ pincode: 686606, min_days: 7, max_days: 10 },
{ pincode: 686607, min_days: 7, max_days: 10 },
{ pincode: 686608, min_days: 7, max_days: 10 },
{ pincode: 686609, min_days: 7, max_days: 10 },
{ pincode: 686610, min_days: 7, max_days: 10 },
{ pincode: 686611, min_days: 7, max_days: 10 },
{ pincode: 686612, min_days: 7, max_days: 10 },
{ pincode: 686613, min_days: 7, max_days: 10 },
{ pincode: 686616, min_days: 7, max_days: 10 },
{ pincode: 686630, min_days: 7, max_days: 10 },
{ pincode: 686631, min_days: 7, max_days: 10 },
{ pincode: 686632, min_days: 7, max_days: 10 },
{ pincode: 686633, min_days: 7, max_days: 10 },
{ pincode: 686634, min_days: 7, max_days: 10 },
{ pincode: 686636, min_days: 7, max_days: 10 },
{ pincode: 686637, min_days: 7, max_days: 10 },
{ pincode: 686638, min_days: 7, max_days: 10 },
{ pincode: 686640, min_days: 7, max_days: 10 },
{ pincode: 686642, min_days: 7, max_days: 10 },
{ pincode: 686646, min_days: 7, max_days: 10 },
{ pincode: 686661, min_days: 7, max_days: 10 },
{ pincode: 686662, min_days: 7, max_days: 10 },
{ pincode: 686663, min_days: 7, max_days: 10 },
{ pincode: 686664, min_days: 7, max_days: 10 },
{ pincode: 686665, min_days: 7, max_days: 10 },
{ pincode: 686666, min_days: 7, max_days: 10 },
{ pincode: 686667, min_days: 7, max_days: 10 },
{ pincode: 686668, min_days: 7, max_days: 10 },
{ pincode: 686669, min_days: 7, max_days: 10 },
{ pincode: 686670, min_days: 7, max_days: 10 },
{ pincode: 686671, min_days: 7, max_days: 10 },
{ pincode: 686672, min_days: 7, max_days: 10 },
{ pincode: 686673, min_days: 7, max_days: 10 },
{ pincode: 686674, min_days: 7, max_days: 10 },
{ pincode: 686679, min_days: 7, max_days: 10 },
{ pincode: 686683, min_days: 7, max_days: 10 },
{ pincode: 686689, min_days: 7, max_days: 10 },
{ pincode: 686691, min_days: 7, max_days: 10 },
{ pincode: 686692, min_days: 7, max_days: 10 },
{ pincode: 686693, min_days: 7, max_days: 10 },
{ pincode: 686721, min_days: 7, max_days: 10 },
{ pincode: 688001, min_days: 7, max_days: 10 },
{ pincode: 688002, min_days: 7, max_days: 10 },
{ pincode: 688003, min_days: 7, max_days: 10 },
{ pincode: 688004, min_days: 7, max_days: 10 },
{ pincode: 688005, min_days: 7, max_days: 10 },
{ pincode: 688006, min_days: 7, max_days: 10 },
{ pincode: 688007, min_days: 7, max_days: 10 },
{ pincode: 688008, min_days: 7, max_days: 10 },
{ pincode: 688009, min_days: 7, max_days: 10 },
{ pincode: 688010, min_days: 7, max_days: 10 },
{ pincode: 688011, min_days: 7, max_days: 10 },
{ pincode: 688012, min_days: 7, max_days: 10 },
{ pincode: 688013, min_days: 7, max_days: 10 },
{ pincode: 688014, min_days: 7, max_days: 10 },
{ pincode: 688016, min_days: 7, max_days: 10 },
{ pincode: 688017, min_days: 7, max_days: 10 },
{ pincode: 688018, min_days: 7, max_days: 10 },
{ pincode: 688019, min_days: 7, max_days: 10 },
{ pincode: 688501, min_days: 7, max_days: 10 },
{ pincode: 688502, min_days: 7, max_days: 10 },
{ pincode: 688503, min_days: 7, max_days: 10 },
{ pincode: 688504, min_days: 7, max_days: 10 },
{ pincode: 688505, min_days: 7, max_days: 10 },
{ pincode: 688507, min_days: 7, max_days: 10 },
{ pincode: 688508, min_days: 7, max_days: 10 },
{ pincode: 688512, min_days: 7, max_days: 10 },
{ pincode: 688521, min_days: 7, max_days: 10 },
{ pincode: 688522, min_days: 7, max_days: 10 },
{ pincode: 688523, min_days: 7, max_days: 10 },
{ pincode: 688524, min_days: 7, max_days: 10 },
{ pincode: 688525, min_days: 7, max_days: 10 },
{ pincode: 688526, min_days: 7, max_days: 10 },
{ pincode: 688527, min_days: 7, max_days: 10 },
{ pincode: 688528, min_days: 7, max_days: 10 },
{ pincode: 688529, min_days: 7, max_days: 10 },
{ pincode: 688530, min_days: 7, max_days: 10 },
{ pincode: 688531, min_days: 7, max_days: 10 },
{ pincode: 688532, min_days: 7, max_days: 10 },
{ pincode: 688533, min_days: 7, max_days: 10 },
{ pincode: 688534, min_days: 7, max_days: 10 },
{ pincode: 688535, min_days: 7, max_days: 10 },
{ pincode: 688536, min_days: 7, max_days: 10 },
{ pincode: 688537, min_days: 7, max_days: 10 },
{ pincode: 688538, min_days: 7, max_days: 10 },
{ pincode: 688539, min_days: 7, max_days: 10 },
{ pincode: 688540, min_days: 7, max_days: 10 },
{ pincode: 688541, min_days: 7, max_days: 10 },
{ pincode: 688546, min_days: 7, max_days: 10 },
{ pincode: 688555, min_days: 7, max_days: 10 },
{ pincode: 688561, min_days: 7, max_days: 10 },
{ pincode: 688562, min_days: 7, max_days: 10 },
{ pincode: 688564, min_days: 7, max_days: 10 },
{ pincode: 688567, min_days: 7, max_days: 10 },
{ pincode: 688570, min_days: 7, max_days: 10 },
{ pincode: 688582, min_days: 7, max_days: 10 },
{ pincode: 689595, min_days: 7, max_days: 10 },
{ pincode: 689622, min_days: 7, max_days: 10 },
{ pincode: 689623, min_days: 7, max_days: 10 },
{ pincode: 689627, min_days: 7, max_days: 10 },
{ pincode: 690101, min_days: 7, max_days: 10 },
{ pincode: 690102, min_days: 7, max_days: 10 },
{ pincode: 690103, min_days: 7, max_days: 10 },
{ pincode: 690104, min_days: 7, max_days: 10 },
{ pincode: 690105, min_days: 7, max_days: 10 },
{ pincode: 690106, min_days: 7, max_days: 10 },
{ pincode: 690108, min_days: 7, max_days: 10 },
{ pincode: 690110, min_days: 7, max_days: 10 },
{ pincode: 690502, min_days: 7, max_days: 10 },
{ pincode: 690503, min_days: 7, max_days: 10 },
{ pincode: 690506, min_days: 7, max_days: 10 },
{ pincode: 690507, min_days: 7, max_days: 10 },
{ pincode: 690508, min_days: 7, max_days: 10 },
{ pincode: 690509, min_days: 7, max_days: 10 },
{ pincode: 690510, min_days: 7, max_days: 10 },
{ pincode: 690511, min_days: 7, max_days: 10 },
{ pincode: 690512, min_days: 7, max_days: 10 },
{ pincode: 690513, min_days: 7, max_days: 10 },
{ pincode: 690514, min_days: 7, max_days: 10 },
{ pincode: 690515, min_days: 7, max_days: 10 },
{ pincode: 690516, min_days: 7, max_days: 10 },
{ pincode: 690517, min_days: 7, max_days: 10 },
{ pincode: 690527, min_days: 7, max_days: 10 },
{ pincode: 690531, min_days: 7, max_days: 10 },
{ pincode: 690532, min_days: 7, max_days: 10 },
{ pincode: 690533, min_days: 7, max_days: 10 },
{ pincode: 690535, min_days: 7, max_days: 10 },
{ pincode: 690537, min_days: 7, max_days: 10 },
{ pincode: 690547, min_days: 7, max_days: 10 },
{ pincode: 690548, min_days: 7, max_days: 10 },
{ pincode: 690551, min_days: 7, max_days: 10 },
{ pincode: 690559, min_days: 7, max_days: 10 },
{ pincode: 690572, min_days: 7, max_days: 10 },
{ pincode: 691001, min_days: 7, max_days: 10 },
{ pincode: 691002, min_days: 7, max_days: 10 },
{ pincode: 691003, min_days: 7, max_days: 10 },
{ pincode: 691004, min_days: 7, max_days: 10 },
{ pincode: 691005, min_days: 7, max_days: 10 },
{ pincode: 691006, min_days: 7, max_days: 10 },
{ pincode: 691007, min_days: 7, max_days: 10 },
{ pincode: 691008, min_days: 7, max_days: 10 },
{ pincode: 691009, min_days: 7, max_days: 10 },
{ pincode: 691010, min_days: 7, max_days: 10 },
{ pincode: 691011, min_days: 7, max_days: 10 },
{ pincode: 691012, min_days: 7, max_days: 10 },
{ pincode: 691013, min_days: 7, max_days: 10 },
{ pincode: 691014, min_days: 7, max_days: 10 },
{ pincode: 691015, min_days: 7, max_days: 10 },
{ pincode: 691016, min_days: 7, max_days: 10 },
{ pincode: 691017, min_days: 7, max_days: 10 },
{ pincode: 691018, min_days: 7, max_days: 10 },
{ pincode: 691019, min_days: 7, max_days: 10 },
{ pincode: 691020, min_days: 7, max_days: 10 },
{ pincode: 691021, min_days: 7, max_days: 10 },
{ pincode: 691301, min_days: 7, max_days: 10 },
{ pincode: 691302, min_days: 7, max_days: 10 },
{ pincode: 691303, min_days: 7, max_days: 10 },
{ pincode: 691304, min_days: 7, max_days: 10 },
{ pincode: 691319, min_days: 7, max_days: 10 },
{ pincode: 691321, min_days: 7, max_days: 10 },
{ pincode: 691334, min_days: 7, max_days: 10 },
{ pincode: 691502, min_days: 7, max_days: 10 },
{ pincode: 691503, min_days: 7, max_days: 10 },
{ pincode: 691505, min_days: 7, max_days: 10 },
{ pincode: 691506, min_days: 7, max_days: 10 },
{ pincode: 691508, min_days: 7, max_days: 10 },
{ pincode: 691509, min_days: 7, max_days: 10 },
{ pincode: 691510, min_days: 7, max_days: 10 },
{ pincode: 691511, min_days: 7, max_days: 10 },
{ pincode: 691512, min_days: 7, max_days: 10 },
{ pincode: 691514, min_days: 7, max_days: 10 },
{ pincode: 691518, min_days: 7, max_days: 10 },
{ pincode: 691521, min_days: 7, max_days: 10 },
{ pincode: 691522, min_days: 7, max_days: 10 },
{ pincode: 691523, min_days: 7, max_days: 10 },
{ pincode: 691524, min_days: 7, max_days: 10 },
{ pincode: 691530, min_days: 7, max_days: 10 },
{ pincode: 691531, min_days: 7, max_days: 10 },
{ pincode: 691532, min_days: 7, max_days: 10 },
{ pincode: 691533, min_days: 7, max_days: 10 },
{ pincode: 691534, min_days: 7, max_days: 10 },
{ pincode: 691535, min_days: 7, max_days: 10 },
{ pincode: 691536, min_days: 7, max_days: 10 },
{ pincode: 691537, min_days: 7, max_days: 10 },
{ pincode: 691538, min_days: 7, max_days: 10 },
{ pincode: 691539, min_days: 7, max_days: 10 },
{ pincode: 691540, min_days: 7, max_days: 10 },
{ pincode: 691541, min_days: 7, max_days: 10 },
{ pincode: 691544, min_days: 7, max_days: 10 },
{ pincode: 691547, min_days: 7, max_days: 10 },
{ pincode: 691548, min_days: 7, max_days: 10 },
{ pincode: 691550, min_days: 7, max_days: 10 },
{ pincode: 691559, min_days: 7, max_days: 10 },
{ pincode: 691560, min_days: 7, max_days: 10 },
{ pincode: 691573, min_days: 7, max_days: 10 },
{ pincode: 691574, min_days: 7, max_days: 10 },
{ pincode: 691577, min_days: 7, max_days: 10 },
{ pincode: 691578, min_days: 7, max_days: 10 },
{ pincode: 691579, min_days: 7, max_days: 10 },
{ pincode: 691580, min_days: 7, max_days: 10 },
{ pincode: 691581, min_days: 7, max_days: 10 },
{ pincode: 691582, min_days: 7, max_days: 10 },
{ pincode: 691583, min_days: 7, max_days: 10 },
{ pincode: 691589, min_days: 7, max_days: 10 },
{ pincode: 691590, min_days: 7, max_days: 10 },
{ pincode: 691601, min_days: 7, max_days: 10 },
{ pincode: 691602, min_days: 7, max_days: 10 },
{ pincode: 691604, min_days: 7, max_days: 10 },
{ pincode: 691623, min_days: 7, max_days: 10 },
{ pincode: 691624, min_days: 7, max_days: 10 },
{ pincode: 695001, min_days: 7, max_days: 10 },
{ pincode: 695002, min_days: 7, max_days: 10 },
{ pincode: 695003, min_days: 7, max_days: 10 },
{ pincode: 695004, min_days: 7, max_days: 10 },
{ pincode: 695005, min_days: 7, max_days: 10 },
{ pincode: 695006, min_days: 7, max_days: 10 },
{ pincode: 695007, min_days: 7, max_days: 10 },
{ pincode: 695008, min_days: 7, max_days: 10 },
{ pincode: 695009, min_days: 7, max_days: 10 },
{ pincode: 695010, min_days: 7, max_days: 10 },
{ pincode: 695011, min_days: 7, max_days: 10 },
{ pincode: 695012, min_days: 7, max_days: 10 },
{ pincode: 695013, min_days: 7, max_days: 10 },
{ pincode: 695014, min_days: 7, max_days: 10 },
{ pincode: 695015, min_days: 7, max_days: 10 },
{ pincode: 695016, min_days: 7, max_days: 10 },
{ pincode: 695017, min_days: 7, max_days: 10 },
{ pincode: 695018, min_days: 7, max_days: 10 },
{ pincode: 695019, min_days: 7, max_days: 10 },
{ pincode: 695020, min_days: 7, max_days: 10 },
{ pincode: 695021, min_days: 7, max_days: 10 },
{ pincode: 695022, min_days: 7, max_days: 10 },
{ pincode: 695023, min_days: 7, max_days: 10 },
{ pincode: 695024, min_days: 7, max_days: 10 },
{ pincode: 695025, min_days: 7, max_days: 10 },
{ pincode: 695026, min_days: 7, max_days: 10 },
{ pincode: 695027, min_days: 7, max_days: 10 },
{ pincode: 695028, min_days: 7, max_days: 10 },
{ pincode: 695029, min_days: 7, max_days: 10 },
{ pincode: 695030, min_days: 7, max_days: 10 },
{ pincode: 695031, min_days: 7, max_days: 10 },
{ pincode: 695032, min_days: 7, max_days: 10 },
{ pincode: 695033, min_days: 7, max_days: 10 },
{ pincode: 695034, min_days: 7, max_days: 10 },
{ pincode: 695035, min_days: 7, max_days: 10 },
{ pincode: 695036, min_days: 7, max_days: 10 },
{ pincode: 695037, min_days: 7, max_days: 10 },
{ pincode: 695038, min_days: 7, max_days: 10 },
{ pincode: 695039, min_days: 7, max_days: 10 },
{ pincode: 695040, min_days: 7, max_days: 10 },
{ pincode: 695041, min_days: 7, max_days: 10 },
{ pincode: 695042, min_days: 7, max_days: 10 },
{ pincode: 695043, min_days: 7, max_days: 10 },
{ pincode: 695044, min_days: 7, max_days: 10 },
{ pincode: 695047, min_days: 7, max_days: 10 },
{ pincode: 695049, min_days: 7, max_days: 10 },
{ pincode: 695099, min_days: 7, max_days: 10 },
{ pincode: 695101, min_days: 7, max_days: 10 },
{ pincode: 695102, min_days: 7, max_days: 10 },
{ pincode: 695103, min_days: 7, max_days: 10 },
{ pincode: 695104, min_days: 7, max_days: 10 },
{ pincode: 695105, min_days: 7, max_days: 10 },
{ pincode: 695109, min_days: 7, max_days: 10 },
{ pincode: 695120, min_days: 7, max_days: 10 },
{ pincode: 695121, min_days: 7, max_days: 10 },
{ pincode: 695122, min_days: 7, max_days: 10 },
{ pincode: 695123, min_days: 7, max_days: 10 },
{ pincode: 695124, min_days: 7, max_days: 10 },
{ pincode: 695125, min_days: 7, max_days: 10 },
{ pincode: 695126, min_days: 7, max_days: 10 },
{ pincode: 695127, min_days: 7, max_days: 10 },
{ pincode: 695128, min_days: 7, max_days: 10 },
{ pincode: 695130, min_days: 7, max_days: 10 },
{ pincode: 695131, min_days: 7, max_days: 10 },
{ pincode: 695132, min_days: 7, max_days: 10 },
{ pincode: 695133, min_days: 7, max_days: 10 },
{ pincode: 695134, min_days: 7, max_days: 10 },
{ pincode: 695141, min_days: 7, max_days: 10 },
{ pincode: 695142, min_days: 7, max_days: 10 },
{ pincode: 695143, min_days: 7, max_days: 10 },
{ pincode: 695144, min_days: 7, max_days: 10 },
{ pincode: 695145, min_days: 7, max_days: 10 },
{ pincode: 695146, min_days: 7, max_days: 10 },
{ pincode: 695301, min_days: 7, max_days: 10 },
{ pincode: 695302, min_days: 7, max_days: 10 },
{ pincode: 695303, min_days: 7, max_days: 10 },
{ pincode: 695304, min_days: 7, max_days: 10 },
{ pincode: 695305, min_days: 7, max_days: 10 },
{ pincode: 695306, min_days: 7, max_days: 10 },
{ pincode: 695307, min_days: 7, max_days: 10 },
{ pincode: 695308, min_days: 7, max_days: 10 },
{ pincode: 695309, min_days: 7, max_days: 10 },
{ pincode: 695310, min_days: 7, max_days: 10 },
{ pincode: 695311, min_days: 7, max_days: 10 },
{ pincode: 695312, min_days: 7, max_days: 10 },
{ pincode: 695313, min_days: 7, max_days: 10 },
{ pincode: 695314, min_days: 7, max_days: 10 },
{ pincode: 695315, min_days: 7, max_days: 10 },
{ pincode: 695316, min_days: 7, max_days: 10 },
{ pincode: 695317, min_days: 7, max_days: 10 },
{ pincode: 695318, min_days: 7, max_days: 10 },
{ pincode: 695501, min_days: 7, max_days: 10 },
{ pincode: 695502, min_days: 7, max_days: 10 },
{ pincode: 695503, min_days: 7, max_days: 10 },
{ pincode: 695504, min_days: 7, max_days: 10 },
{ pincode: 695505, min_days: 7, max_days: 10 },
{ pincode: 695506, min_days: 7, max_days: 10 },
{ pincode: 695507, min_days: 7, max_days: 10 },
{ pincode: 695508, min_days: 7, max_days: 10 },
{ pincode: 695509, min_days: 7, max_days: 10 },
{ pincode: 695510, min_days: 7, max_days: 10 },
{ pincode: 695512, min_days: 7, max_days: 10 },
{ pincode: 695513, min_days: 7, max_days: 10 },
{ pincode: 695521, min_days: 7, max_days: 10 },
{ pincode: 695522, min_days: 7, max_days: 10 },
{ pincode: 695523, min_days: 7, max_days: 10 },
{ pincode: 695524, min_days: 7, max_days: 10 },
{ pincode: 695525, min_days: 7, max_days: 10 },
{ pincode: 695526, min_days: 7, max_days: 10 },
{ pincode: 695527, min_days: 7, max_days: 10 },
{ pincode: 695528, min_days: 7, max_days: 10 },
{ pincode: 695541, min_days: 7, max_days: 10 },
{ pincode: 695542, min_days: 7, max_days: 10 },
{ pincode: 695543, min_days: 7, max_days: 10 },
{ pincode: 695544, min_days: 7, max_days: 10 },
{ pincode: 695547, min_days: 7, max_days: 10 },
{ pincode: 695551, min_days: 7, max_days: 10 },
{ pincode: 695557, min_days: 7, max_days: 10 },
{ pincode: 695560, min_days: 7, max_days: 10 },
{ pincode: 695561, min_days: 7, max_days: 10 },
{ pincode: 695562, min_days: 7, max_days: 10 },
{ pincode: 695563, min_days: 7, max_days: 10 },
{ pincode: 695564, min_days: 7, max_days: 10 },
{ pincode: 695566, min_days: 7, max_days: 10 },
{ pincode: 695568, min_days: 7, max_days: 10 },
{ pincode: 695570, min_days: 7, max_days: 10 },
{ pincode: 695571, min_days: 7, max_days: 10 },
{ pincode: 695572, min_days: 7, max_days: 10 },
{ pincode: 695573, min_days: 7, max_days: 10 },
{ pincode: 695574, min_days: 7, max_days: 10 },
{ pincode: 695575, min_days: 7, max_days: 10 },
{ pincode: 695576, min_days: 7, max_days: 10 },
{ pincode: 695581, min_days: 7, max_days: 10 },
{ pincode: 695582, min_days: 7, max_days: 10 },
{ pincode: 695583, min_days: 7, max_days: 10 },
{ pincode: 695584, min_days: 7, max_days: 10 },
{ pincode: 695585, min_days: 7, max_days: 10 },
{ pincode: 695586, min_days: 7, max_days: 10 },
{ pincode: 695587, min_days: 7, max_days: 10 },
{ pincode: 695588, min_days: 7, max_days: 10 },
{ pincode: 695589, min_days: 7, max_days: 10 },
{ pincode: 695601, min_days: 7, max_days: 10 },
{ pincode: 695602, min_days: 7, max_days: 10 },
{ pincode: 695603, min_days: 7, max_days: 10 },
{ pincode: 695604, min_days: 7, max_days: 10 },
{ pincode: 695605, min_days: 7, max_days: 10 },
{ pincode: 695606, min_days: 7, max_days: 10 },
{ pincode: 695607, min_days: 7, max_days: 10 },
{ pincode: 695608, min_days: 7, max_days: 10 },
{ pincode: 695609, min_days: 7, max_days: 10 },
{ pincode: 695610, min_days: 7, max_days: 10 },
{ pincode: 695611, min_days: 7, max_days: 10 },
{ pincode: 695612, min_days: 7, max_days: 10 },
{ pincode: 695614, min_days: 7, max_days: 10 },
{ pincode: 695615, min_days: 7, max_days: 10 },
{ pincode: 695616, min_days: 7, max_days: 10 },
{ pincode: 695618, min_days: 7, max_days: 10 },
{ pincode: 700000, min_days: 7, max_days: 10 },
{ pincode: 700001, min_days: 7, max_days: 10 },
{ pincode: 700002, min_days: 7, max_days: 10 },
{ pincode: 700003, min_days: 7, max_days: 10 },
{ pincode: 700004, min_days: 7, max_days: 10 },
{ pincode: 700005, min_days: 7, max_days: 10 },
{ pincode: 700006, min_days: 7, max_days: 10 },
{ pincode: 700007, min_days: 7, max_days: 10 },
{ pincode: 700008, min_days: 7, max_days: 10 },
{ pincode: 700009, min_days: 7, max_days: 10 },
{ pincode: 700010, min_days: 7, max_days: 10 },
{ pincode: 700011, min_days: 7, max_days: 10 },
{ pincode: 700012, min_days: 7, max_days: 10 },
{ pincode: 700013, min_days: 7, max_days: 10 },
{ pincode: 700014, min_days: 7, max_days: 10 },
{ pincode: 700015, min_days: 7, max_days: 10 },
{ pincode: 700016, min_days: 7, max_days: 10 },
{ pincode: 700017, min_days: 7, max_days: 10 },
{ pincode: 700018, min_days: 7, max_days: 10 },
{ pincode: 700019, min_days: 7, max_days: 10 },
{ pincode: 700020, min_days: 7, max_days: 10 },
{ pincode: 700021, min_days: 7, max_days: 10 },
{ pincode: 700022, min_days: 7, max_days: 10 },
{ pincode: 700023, min_days: 7, max_days: 10 },
{ pincode: 700024, min_days: 7, max_days: 10 },
{ pincode: 700025, min_days: 7, max_days: 10 },
{ pincode: 700026, min_days: 7, max_days: 10 },
{ pincode: 700027, min_days: 7, max_days: 10 },
{ pincode: 700028, min_days: 7, max_days: 10 },
{ pincode: 700029, min_days: 7, max_days: 10 },
{ pincode: 700030, min_days: 7, max_days: 10 },
{ pincode: 700031, min_days: 7, max_days: 10 },
{ pincode: 700032, min_days: 7, max_days: 10 },
{ pincode: 700033, min_days: 7, max_days: 10 },
{ pincode: 700034, min_days: 7, max_days: 10 },
{ pincode: 700035, min_days: 7, max_days: 10 },
{ pincode: 700036, min_days: 7, max_days: 10 },
{ pincode: 700037, min_days: 7, max_days: 10 },
{ pincode: 700038, min_days: 7, max_days: 10 },
{ pincode: 700039, min_days: 7, max_days: 10 },
{ pincode: 700040, min_days: 7, max_days: 10 },
{ pincode: 700041, min_days: 7, max_days: 10 },
{ pincode: 700042, min_days: 7, max_days: 10 },
{ pincode: 700043, min_days: 7, max_days: 10 },
{ pincode: 700044, min_days: 7, max_days: 10 },
{ pincode: 700045, min_days: 7, max_days: 10 },
{ pincode: 700046, min_days: 7, max_days: 10 },
{ pincode: 700047, min_days: 7, max_days: 10 },
{ pincode: 700048, min_days: 7, max_days: 10 },
{ pincode: 700049, min_days: 7, max_days: 10 },
{ pincode: 700050, min_days: 7, max_days: 10 },
{ pincode: 700051, min_days: 7, max_days: 10 },
{ pincode: 700052, min_days: 7, max_days: 10 },
{ pincode: 700053, min_days: 7, max_days: 10 },
{ pincode: 700054, min_days: 7, max_days: 10 },
{ pincode: 700055, min_days: 7, max_days: 10 },
{ pincode: 700056, min_days: 7, max_days: 10 },
{ pincode: 700057, min_days: 7, max_days: 10 },
{ pincode: 700058, min_days: 7, max_days: 10 },
{ pincode: 700059, min_days: 7, max_days: 10 },
{ pincode: 700060, min_days: 7, max_days: 10 },
{ pincode: 700061, min_days: 7, max_days: 10 },
{ pincode: 700062, min_days: 7, max_days: 10 },
{ pincode: 700063, min_days: 7, max_days: 10 },
{ pincode: 700064, min_days: 7, max_days: 10 },
{ pincode: 700065, min_days: 7, max_days: 10 },
{ pincode: 700066, min_days: 7, max_days: 10 },
{ pincode: 700067, min_days: 7, max_days: 10 },
{ pincode: 700068, min_days: 7, max_days: 10 },
{ pincode: 700069, min_days: 7, max_days: 10 },
{ pincode: 700070, min_days: 7, max_days: 10 },
{ pincode: 700071, min_days: 7, max_days: 10 },
{ pincode: 700072, min_days: 7, max_days: 10 },
{ pincode: 700073, min_days: 7, max_days: 10 },
{ pincode: 700074, min_days: 7, max_days: 10 },
{ pincode: 700075, min_days: 7, max_days: 10 },
{ pincode: 700076, min_days: 7, max_days: 10 },
{ pincode: 700077, min_days: 7, max_days: 10 },
{ pincode: 700078, min_days: 7, max_days: 10 },
{ pincode: 700079, min_days: 7, max_days: 10 },
{ pincode: 700080, min_days: 7, max_days: 10 },
{ pincode: 700081, min_days: 7, max_days: 10 },
{ pincode: 700082, min_days: 7, max_days: 10 },
{ pincode: 700083, min_days: 7, max_days: 10 },
{ pincode: 700084, min_days: 7, max_days: 10 },
{ pincode: 700085, min_days: 7, max_days: 10 },
{ pincode: 700086, min_days: 7, max_days: 10 },
{ pincode: 700087, min_days: 7, max_days: 10 },
{ pincode: 700088, min_days: 7, max_days: 10 },
{ pincode: 700089, min_days: 7, max_days: 10 },
{ pincode: 700090, min_days: 7, max_days: 10 },
{ pincode: 700091, min_days: 7, max_days: 10 },
{ pincode: 700092, min_days: 7, max_days: 10 },
{ pincode: 700093, min_days: 7, max_days: 10 },
{ pincode: 700094, min_days: 7, max_days: 10 },
{ pincode: 700095, min_days: 7, max_days: 10 },
{ pincode: 700096, min_days: 7, max_days: 10 },
{ pincode: 700097, min_days: 7, max_days: 10 },
{ pincode: 700098, min_days: 7, max_days: 10 },
{ pincode: 700099, min_days: 7, max_days: 10 },
{ pincode: 700100, min_days: 7, max_days: 10 },
{ pincode: 700101, min_days: 7, max_days: 10 },
{ pincode: 700102, min_days: 7, max_days: 10 },
{ pincode: 700103, min_days: 7, max_days: 10 },
{ pincode: 700104, min_days: 7, max_days: 10 },
{ pincode: 700105, min_days: 7, max_days: 10 },
{ pincode: 700106, min_days: 7, max_days: 10 },
{ pincode: 700107, min_days: 7, max_days: 10 },
{ pincode: 700108, min_days: 7, max_days: 10 },
{ pincode: 700109, min_days: 7, max_days: 10 },
{ pincode: 700110, min_days: 7, max_days: 10 },
{ pincode: 700111, min_days: 7, max_days: 10 },
{ pincode: 700112, min_days: 7, max_days: 10 },
{ pincode: 700113, min_days: 7, max_days: 10 },
{ pincode: 700114, min_days: 7, max_days: 10 },
{ pincode: 700115, min_days: 7, max_days: 10 },
{ pincode: 700116, min_days: 7, max_days: 10 },
{ pincode: 700117, min_days: 7, max_days: 10 },
{ pincode: 700118, min_days: 7, max_days: 10 },
{ pincode: 700119, min_days: 7, max_days: 10 },
{ pincode: 700120, min_days: 7, max_days: 10 },
{ pincode: 700121, min_days: 7, max_days: 10 },
{ pincode: 700122, min_days: 7, max_days: 10 },
{ pincode: 700123, min_days: 7, max_days: 10 },
{ pincode: 700124, min_days: 7, max_days: 10 },
{ pincode: 700125, min_days: 7, max_days: 10 },
{ pincode: 700126, min_days: 7, max_days: 10 },
{ pincode: 700127, min_days: 7, max_days: 10 },
{ pincode: 700128, min_days: 7, max_days: 10 },
{ pincode: 700129, min_days: 7, max_days: 10 },
{ pincode: 700130, min_days: 7, max_days: 10 },
{ pincode: 700131, min_days: 7, max_days: 10 },
{ pincode: 700132, min_days: 7, max_days: 10 },
{ pincode: 700133, min_days: 7, max_days: 10 },
{ pincode: 700134, min_days: 7, max_days: 10 },
{ pincode: 700135, min_days: 7, max_days: 10 },
{ pincode: 700136, min_days: 7, max_days: 10 },
{ pincode: 700137, min_days: 7, max_days: 10 },
{ pincode: 700138, min_days: 7, max_days: 10 },
{ pincode: 700139, min_days: 7, max_days: 10 },
{ pincode: 700140, min_days: 7, max_days: 10 },
{ pincode: 700141, min_days: 7, max_days: 10 },
{ pincode: 700142, min_days: 7, max_days: 10 },
{ pincode: 700143, min_days: 7, max_days: 10 },
{ pincode: 700144, min_days: 7, max_days: 10 },
{ pincode: 700145, min_days: 7, max_days: 10 },
{ pincode: 700146, min_days: 7, max_days: 10 },
{ pincode: 700147, min_days: 7, max_days: 10 },
{ pincode: 700148, min_days: 7, max_days: 10 },
{ pincode: 700149, min_days: 7, max_days: 10 },
{ pincode: 700150, min_days: 7, max_days: 10 },
{ pincode: 700151, min_days: 7, max_days: 10 },
{ pincode: 700152, min_days: 7, max_days: 10 },
{ pincode: 700153, min_days: 7, max_days: 10 },
{ pincode: 700154, min_days: 7, max_days: 10 },
{ pincode: 700155, min_days: 7, max_days: 10 },
{ pincode: 700156, min_days: 7, max_days: 10 },
{ pincode: 700157, min_days: 7, max_days: 10 },
{ pincode: 700158, min_days: 7, max_days: 10 },
{ pincode: 700159, min_days: 7, max_days: 10 },
{ pincode: 700160, min_days: 7, max_days: 10 },
{ pincode: 700161, min_days: 7, max_days: 10 },
{ pincode: 700163, min_days: 7, max_days: 10 },
{ pincode: 700177, min_days: 7, max_days: 10 },
{ pincode: 711101, min_days: 7, max_days: 10 },
{ pincode: 711102, min_days: 7, max_days: 10 },
{ pincode: 711103, min_days: 7, max_days: 10 },
{ pincode: 711104, min_days: 7, max_days: 10 },
{ pincode: 711105, min_days: 7, max_days: 10 },
{ pincode: 711106, min_days: 7, max_days: 10 },
{ pincode: 711107, min_days: 7, max_days: 10 },
{ pincode: 711108, min_days: 7, max_days: 10 },
{ pincode: 711109, min_days: 7, max_days: 10 },
{ pincode: 711110, min_days: 7, max_days: 10 },
{ pincode: 711111, min_days: 7, max_days: 10 },
{ pincode: 711112, min_days: 7, max_days: 10 },
{ pincode: 711113, min_days: 7, max_days: 10 },
{ pincode: 711114, min_days: 7, max_days: 10 },
{ pincode: 711115, min_days: 7, max_days: 10 },
{ pincode: 711201, min_days: 7, max_days: 10 },
{ pincode: 711202, min_days: 7, max_days: 10 },
{ pincode: 711203, min_days: 7, max_days: 10 },
{ pincode: 711204, min_days: 7, max_days: 10 },
{ pincode: 711205, min_days: 7, max_days: 10 },
{ pincode: 711206, min_days: 7, max_days: 10 },
{ pincode: 711212, min_days: 7, max_days: 10 },
{ pincode: 711214, min_days: 7, max_days: 10 },
{ pincode: 711223, min_days: 7, max_days: 10 },
{ pincode: 711224, min_days: 7, max_days: 10 },
{ pincode: 711225, min_days: 7, max_days: 10 },
{ pincode: 711226, min_days: 7, max_days: 10 },
{ pincode: 711227, min_days: 7, max_days: 10 },
{ pincode: 711247, min_days: 7, max_days: 10 },
{ pincode: 711302, min_days: 7, max_days: 10 },
{ pincode: 711303, min_days: 7, max_days: 10 },
{ pincode: 711304, min_days: 7, max_days: 10 },
{ pincode: 711305, min_days: 7, max_days: 10 },
{ pincode: 711306, min_days: 7, max_days: 10 },
{ pincode: 711307, min_days: 7, max_days: 10 },
{ pincode: 711308, min_days: 7, max_days: 10 },
{ pincode: 711309, min_days: 7, max_days: 10 },
{ pincode: 711310, min_days: 7, max_days: 10 },
{ pincode: 711311, min_days: 7, max_days: 10 },
{ pincode: 711312, min_days: 7, max_days: 10 },
{ pincode: 711313, min_days: 7, max_days: 10 },
{ pincode: 711315, min_days: 7, max_days: 10 },
{ pincode: 711316, min_days: 7, max_days: 10 },
{ pincode: 711317, min_days: 7, max_days: 10 },
{ pincode: 711321, min_days: 7, max_days: 10 },
{ pincode: 711322, min_days: 7, max_days: 10 },
{ pincode: 711323, min_days: 7, max_days: 10 },
{ pincode: 711324, min_days: 7, max_days: 10 },
{ pincode: 711325, min_days: 7, max_days: 10 },
{ pincode: 711326, min_days: 7, max_days: 10 },
{ pincode: 711327, min_days: 7, max_days: 10 },
{ pincode: 711328, min_days: 7, max_days: 10 },
{ pincode: 711401, min_days: 7, max_days: 10 },
{ pincode: 711402, min_days: 7, max_days: 10 },
{ pincode: 711403, min_days: 7, max_days: 10 },
{ pincode: 711404, min_days: 7, max_days: 10 },
{ pincode: 711405, min_days: 7, max_days: 10 },
{ pincode: 711407, min_days: 7, max_days: 10 },
{ pincode: 711408, min_days: 7, max_days: 10 },
{ pincode: 711409, min_days: 7, max_days: 10 },
{ pincode: 711410, min_days: 7, max_days: 10 },
{ pincode: 711411, min_days: 7, max_days: 10 },
{ pincode: 711412, min_days: 7, max_days: 10 },
{ pincode: 711413, min_days: 7, max_days: 10 },
{ pincode: 711414, min_days: 7, max_days: 10 },
{ pincode: 711415, min_days: 7, max_days: 10 },
{ pincode: 711416, min_days: 7, max_days: 10 },
{ pincode: 712101, min_days: 7, max_days: 10 },
{ pincode: 712102, min_days: 7, max_days: 10 },
{ pincode: 712103, min_days: 7, max_days: 10 },
{ pincode: 712104, min_days: 7, max_days: 10 },
{ pincode: 712105, min_days: 7, max_days: 10 },
{ pincode: 712106, min_days: 7, max_days: 10 },
{ pincode: 712107, min_days: 7, max_days: 10 },
{ pincode: 712108, min_days: 7, max_days: 10 },
{ pincode: 712109, min_days: 7, max_days: 10 },
{ pincode: 712121, min_days: 7, max_days: 10 },
{ pincode: 712123, min_days: 7, max_days: 10 },
{ pincode: 712124, min_days: 7, max_days: 10 },
{ pincode: 712125, min_days: 7, max_days: 10 },
{ pincode: 712134, min_days: 7, max_days: 10 },
{ pincode: 712135, min_days: 7, max_days: 10 },
{ pincode: 712136, min_days: 7, max_days: 10 },
{ pincode: 712137, min_days: 7, max_days: 10 },
{ pincode: 712138, min_days: 7, max_days: 10 },
{ pincode: 712139, min_days: 7, max_days: 10 },
{ pincode: 712146, min_days: 7, max_days: 10 },
{ pincode: 712147, min_days: 7, max_days: 10 },
{ pincode: 712148, min_days: 7, max_days: 10 },
{ pincode: 712149, min_days: 7, max_days: 10 },
{ pincode: 712152, min_days: 7, max_days: 10 },
{ pincode: 712156, min_days: 7, max_days: 10 },
{ pincode: 712157, min_days: 7, max_days: 10 },
{ pincode: 712158, min_days: 7, max_days: 10 },
{ pincode: 712201, min_days: 7, max_days: 10 },
{ pincode: 712202, min_days: 7, max_days: 10 },
{ pincode: 712203, min_days: 7, max_days: 10 },
{ pincode: 712204, min_days: 7, max_days: 10 },
{ pincode: 712205, min_days: 7, max_days: 10 },
{ pincode: 712206, min_days: 7, max_days: 10 },
{ pincode: 712208, min_days: 7, max_days: 10 },
{ pincode: 712211, min_days: 7, max_days: 10 },
{ pincode: 712216, min_days: 7, max_days: 10 },
{ pincode: 712222, min_days: 7, max_days: 10 },
{ pincode: 712223, min_days: 7, max_days: 10 },
{ pincode: 712224, min_days: 7, max_days: 10 },
{ pincode: 712231, min_days: 7, max_days: 10 },
{ pincode: 712232, min_days: 7, max_days: 10 },
{ pincode: 712233, min_days: 7, max_days: 10 },
{ pincode: 712234, min_days: 7, max_days: 10 },
{ pincode: 712235, min_days: 7, max_days: 10 },
{ pincode: 712236, min_days: 7, max_days: 10 },
{ pincode: 712237, min_days: 7, max_days: 10 },
{ pincode: 712238, min_days: 7, max_days: 10 },
{ pincode: 712239, min_days: 7, max_days: 10 },
{ pincode: 712241, min_days: 7, max_days: 10 },
{ pincode: 712242, min_days: 7, max_days: 10 },
{ pincode: 712243, min_days: 7, max_days: 10 },
{ pincode: 712244, min_days: 7, max_days: 10 },
{ pincode: 712245, min_days: 7, max_days: 10 },
{ pincode: 712246, min_days: 7, max_days: 10 },
{ pincode: 712247, min_days: 7, max_days: 10 },
{ pincode: 712248, min_days: 7, max_days: 10 },
{ pincode: 712249, min_days: 7, max_days: 10 },
{ pincode: 712250, min_days: 7, max_days: 10 },
{ pincode: 712251, min_days: 7, max_days: 10 },
{ pincode: 712252, min_days: 7, max_days: 10 },
{ pincode: 712253, min_days: 7, max_days: 10 },
{ pincode: 712254, min_days: 7, max_days: 10 },
{ pincode: 712255, min_days: 7, max_days: 10 },
{ pincode: 712256, min_days: 7, max_days: 10 },
{ pincode: 712257, min_days: 7, max_days: 10 },
{ pincode: 712258, min_days: 7, max_days: 10 },
{ pincode: 712301, min_days: 7, max_days: 10 },
{ pincode: 712302, min_days: 7, max_days: 10 },
{ pincode: 712303, min_days: 7, max_days: 10 },
{ pincode: 712304, min_days: 7, max_days: 10 },
{ pincode: 712305, min_days: 7, max_days: 10 },
{ pincode: 712306, min_days: 7, max_days: 10 },
{ pincode: 712308, min_days: 7, max_days: 10 },
{ pincode: 712310, min_days: 7, max_days: 10 },
{ pincode: 712311, min_days: 7, max_days: 10 },
{ pincode: 712312, min_days: 7, max_days: 10 },
{ pincode: 712314, min_days: 7, max_days: 10 },
{ pincode: 712316, min_days: 7, max_days: 10 },
{ pincode: 712401, min_days: 7, max_days: 10 },
{ pincode: 712402, min_days: 7, max_days: 10 },
{ pincode: 712403, min_days: 7, max_days: 10 },
{ pincode: 712404, min_days: 7, max_days: 10 },
{ pincode: 712405, min_days: 7, max_days: 10 },
{ pincode: 712407, min_days: 7, max_days: 10 },
{ pincode: 712408, min_days: 7, max_days: 10 },
{ pincode: 712409, min_days: 7, max_days: 10 },
{ pincode: 712410, min_days: 7, max_days: 10 },
{ pincode: 712411, min_days: 7, max_days: 10 },
{ pincode: 712412, min_days: 7, max_days: 10 },
{ pincode: 712413, min_days: 7, max_days: 10 },
{ pincode: 712414, min_days: 7, max_days: 10 },
{ pincode: 712415, min_days: 7, max_days: 10 },
{ pincode: 712416, min_days: 7, max_days: 10 },
{ pincode: 712418, min_days: 7, max_days: 10 },
{ pincode: 712419, min_days: 7, max_days: 10 },
{ pincode: 712424, min_days: 7, max_days: 10 },
{ pincode: 712426, min_days: 7, max_days: 10 },
{ pincode: 712501, min_days: 7, max_days: 10 },
{ pincode: 712502, min_days: 7, max_days: 10 },
{ pincode: 712503, min_days: 7, max_days: 10 },
{ pincode: 712504, min_days: 7, max_days: 10 },
{ pincode: 712512, min_days: 7, max_days: 10 },
{ pincode: 712513, min_days: 7, max_days: 10 },
{ pincode: 712514, min_days: 7, max_days: 10 },
{ pincode: 712515, min_days: 7, max_days: 10 },
{ pincode: 712601, min_days: 7, max_days: 10 },
{ pincode: 712613, min_days: 7, max_days: 10 },
{ pincode: 712615, min_days: 7, max_days: 10 },
{ pincode: 712701, min_days: 7, max_days: 10 },
{ pincode: 712702, min_days: 7, max_days: 10 },
{ pincode: 712703, min_days: 7, max_days: 10 },
{ pincode: 712704, min_days: 7, max_days: 10 },
{ pincode: 712705, min_days: 7, max_days: 10 },
{ pincode: 712706, min_days: 7, max_days: 10 },
{ pincode: 712707, min_days: 7, max_days: 10 },
{ pincode: 712708, min_days: 7, max_days: 10 },
{ pincode: 712712, min_days: 7, max_days: 10 },
{ pincode: 713148, min_days: 7, max_days: 10 },
{ pincode: 713160, min_days: 7, max_days: 10 },
{ pincode: 713166, min_days: 7, max_days: 10 },
{ pincode: 713201, min_days: 7, max_days: 10 },
{ pincode: 713202, min_days: 7, max_days: 10 },
{ pincode: 713203, min_days: 7, max_days: 10 },
{ pincode: 713204, min_days: 7, max_days: 10 },
{ pincode: 713205, min_days: 7, max_days: 10 },
{ pincode: 713206, min_days: 7, max_days: 10 },
{ pincode: 713207, min_days: 7, max_days: 10 },
{ pincode: 713208, min_days: 7, max_days: 10 },
{ pincode: 713209, min_days: 7, max_days: 10 },
{ pincode: 713210, min_days: 7, max_days: 10 },
{ pincode: 713211, min_days: 7, max_days: 10 },
{ pincode: 713212, min_days: 7, max_days: 10 },
{ pincode: 713213, min_days: 7, max_days: 10 },
{ pincode: 713214, min_days: 7, max_days: 10 },
{ pincode: 713215, min_days: 7, max_days: 10 },
{ pincode: 713216, min_days: 7, max_days: 10 },
{ pincode: 713217, min_days: 7, max_days: 10 },
{ pincode: 713218, min_days: 7, max_days: 10 },
{ pincode: 713219, min_days: 7, max_days: 10 },
{ pincode: 713301, min_days: 7, max_days: 10 },
{ pincode: 713302, min_days: 7, max_days: 10 },
{ pincode: 713303, min_days: 7, max_days: 10 },
{ pincode: 713304, min_days: 7, max_days: 10 },
{ pincode: 713321, min_days: 7, max_days: 10 },
{ pincode: 713322, min_days: 7, max_days: 10 },
{ pincode: 713323, min_days: 7, max_days: 10 },
{ pincode: 713325, min_days: 7, max_days: 10 },
{ pincode: 713332, min_days: 7, max_days: 10 },
{ pincode: 713338, min_days: 7, max_days: 10 },
{ pincode: 713339, min_days: 7, max_days: 10 },
{ pincode: 713340, min_days: 7, max_days: 10 },
{ pincode: 713341, min_days: 7, max_days: 10 },
{ pincode: 713342, min_days: 7, max_days: 10 },
{ pincode: 713346, min_days: 7, max_days: 10 },
{ pincode: 713347, min_days: 7, max_days: 10 },
{ pincode: 713358, min_days: 7, max_days: 10 },
{ pincode: 713359, min_days: 7, max_days: 10 },
{ pincode: 713362, min_days: 7, max_days: 10 },
{ pincode: 713363, min_days: 7, max_days: 10 },
{ pincode: 713371, min_days: 7, max_days: 10 },
{ pincode: 713376, min_days: 7, max_days: 10 },
{ pincode: 713378, min_days: 7, max_days: 10 },
{ pincode: 713381, min_days: 7, max_days: 10 },
{ pincode: 713383, min_days: 7, max_days: 10 },
{ pincode: 713384, min_days: 7, max_days: 10 },
{ pincode: 713385, min_days: 7, max_days: 10 },
{ pincode: 713404, min_days: 7, max_days: 10 },
{ pincode: 721000, min_days: 7, max_days: 10 },
{ pincode: 721101, min_days: 7, max_days: 10 },
{ pincode: 721102, min_days: 7, max_days: 10 },
{ pincode: 721103, min_days: 7, max_days: 10 },
{ pincode: 721122, min_days: 7, max_days: 10 },
{ pincode: 721129, min_days: 7, max_days: 10 },
{ pincode: 721130, min_days: 7, max_days: 10 },
{ pincode: 721134, min_days: 7, max_days: 10 },
{ pincode: 721135, min_days: 7, max_days: 10 },
{ pincode: 721137, min_days: 7, max_days: 10 },
{ pincode: 721145, min_days: 7, max_days: 10 },
{ pincode: 721151, min_days: 7, max_days: 10 },
{ pincode: 721154, min_days: 7, max_days: 10 },
{ pincode: 721158, min_days: 7, max_days: 10 },
{ pincode: 721171, min_days: 7, max_days: 10 },
{ pincode: 721301, min_days: 7, max_days: 10 },
{ pincode: 721302, min_days: 7, max_days: 10 },
{ pincode: 721303, min_days: 7, max_days: 10 },
{ pincode: 721304, min_days: 7, max_days: 10 },
{ pincode: 721305, min_days: 7, max_days: 10 },
{ pincode: 721306, min_days: 7, max_days: 10 },
{ pincode: 721636, min_days: 7, max_days: 10 },
{ pincode: 721641, min_days: 7, max_days: 10 },
{ pincode: 721653, min_days: 7, max_days: 10 },
{ pincode: 733207, min_days: 7, max_days: 10 },
{ pincode: 734000, min_days: 7, max_days: 10 },
{ pincode: 734001, min_days: 7, max_days: 10 },
{ pincode: 734002, min_days: 7, max_days: 10 },
{ pincode: 734003, min_days: 7, max_days: 10 },
{ pincode: 734004, min_days: 7, max_days: 10 },
{ pincode: 734005, min_days: 7, max_days: 10 },
{ pincode: 734006, min_days: 7, max_days: 10 },
{ pincode: 734007, min_days: 7, max_days: 10 },
{ pincode: 734008, min_days: 7, max_days: 10 },
{ pincode: 734009, min_days: 7, max_days: 10 },
{ pincode: 734010, min_days: 7, max_days: 10 },
{ pincode: 734011, min_days: 7, max_days: 10 },
{ pincode: 734012, min_days: 7, max_days: 10 },
{ pincode: 734013, min_days: 7, max_days: 10 },
{ pincode: 734014, min_days: 7, max_days: 10 },
{ pincode: 734015, min_days: 7, max_days: 10 },
{ pincode: 734016, min_days: 7, max_days: 10 },
{ pincode: 734203, min_days: 7, max_days: 10 },
{ pincode: 734204, min_days: 7, max_days: 10 },
{ pincode: 734209, min_days: 7, max_days: 10 },
{ pincode: 734210, min_days: 7, max_days: 10 },
{ pincode: 734212, min_days: 7, max_days: 10 },
{ pincode: 734214, min_days: 7, max_days: 10 },
{ pincode: 734217, min_days: 7, max_days: 10 },
{ pincode: 734218, min_days: 7, max_days: 10 },
{ pincode: 734220, min_days: 7, max_days: 10 },
{ pincode: 734222, min_days: 7, max_days: 10 },
{ pincode: 734223, min_days: 7, max_days: 10 },
{ pincode: 734224, min_days: 7, max_days: 10 },
{ pincode: 734225, min_days: 7, max_days: 10 },
{ pincode: 734226, min_days: 7, max_days: 10 },
{ pincode: 734227, min_days: 7, max_days: 10 },
{ pincode: 734312, min_days: 7, max_days: 10 },
{ pincode: 734313, min_days: 7, max_days: 10 },
{ pincode: 734317, min_days: 7, max_days: 10 },
{ pincode: 734318, min_days: 7, max_days: 10 },
{ pincode: 734320, min_days: 7, max_days: 10 },
{ pincode: 734401, min_days: 7, max_days: 10 },
{ pincode: 734402, min_days: 7, max_days: 10 },
{ pincode: 734403, min_days: 7, max_days: 10 },
{ pincode: 734404, min_days: 7, max_days: 10 },
{ pincode: 734405, min_days: 7, max_days: 10 },
{ pincode: 734406, min_days: 7, max_days: 10 },
{ pincode: 734407, min_days: 7, max_days: 10 },
{ pincode: 734421, min_days: 7, max_days: 10 },
{ pincode: 734422, min_days: 7, max_days: 10 },
{ pincode: 734423, min_days: 7, max_days: 10 },
{ pincode: 734424, min_days: 7, max_days: 10 },
{ pincode: 734426, min_days: 7, max_days: 10 },
{ pincode: 734427, min_days: 7, max_days: 10 },
{ pincode: 734429, min_days: 7, max_days: 10 },
{ pincode: 734431, min_days: 7, max_days: 10 },
{ pincode: 734433, min_days: 7, max_days: 10 },
{ pincode: 734434, min_days: 7, max_days: 10 },
{ pincode: 734436, min_days: 7, max_days: 10 },
{ pincode: 734500, min_days: 7, max_days: 10 },
{ pincode: 734501, min_days: 7, max_days: 10 },
{ pincode: 734503, min_days: 7, max_days: 10 },
{ pincode: 735100, min_days: 7, max_days: 10 },
{ pincode: 735101, min_days: 7, max_days: 10 },
{ pincode: 735102, min_days: 7, max_days: 10 },
{ pincode: 735106, min_days: 7, max_days: 10 },
{ pincode: 735121, min_days: 7, max_days: 10 },
{ pincode: 735132, min_days: 7, max_days: 10 },
{ pincode: 735133, min_days: 7, max_days: 10 },
{ pincode: 735134, min_days: 7, max_days: 10 },
{ pincode: 735135, min_days: 7, max_days: 10 },
{ pincode: 735136, min_days: 7, max_days: 10 },
{ pincode: 735137, min_days: 7, max_days: 10 },
{ pincode: 735138, min_days: 7, max_days: 10 },
{ pincode: 735139, min_days: 7, max_days: 10 },
{ pincode: 735140, min_days: 7, max_days: 10 },
{ pincode: 735203, min_days: 7, max_days: 10 },
{ pincode: 735206, min_days: 7, max_days: 10 },
{ pincode: 735209, min_days: 7, max_days: 10 },
{ pincode: 735210, min_days: 7, max_days: 10 },
{ pincode: 735218, min_days: 7, max_days: 10 },
{ pincode: 735219, min_days: 7, max_days: 10 },
{ pincode: 735221, min_days: 7, max_days: 10 },
{ pincode: 735222, min_days: 7, max_days: 10 },
{ pincode: 735223, min_days: 7, max_days: 10 },
{ pincode: 735224, min_days: 7, max_days: 10 },
{ pincode: 735229, min_days: 7, max_days: 10 },
{ pincode: 735230, min_days: 7, max_days: 10 },
{ pincode: 735231, min_days: 7, max_days: 10 },
{ pincode: 735234, min_days: 7, max_days: 10 },
{ pincode: 735235, min_days: 7, max_days: 10 },
{ pincode: 735236, min_days: 7, max_days: 10 },
{ pincode: 735237, min_days: 7, max_days: 10 },
{ pincode: 735302, min_days: 7, max_days: 10 },
{ pincode: 735305, min_days: 7, max_days: 10 },
{ pincode: 735306, min_days: 7, max_days: 10 },
{ pincode: 736101, min_days: 7, max_days: 10 },
{ pincode: 736118, min_days: 7, max_days: 10 },
{ pincode: 736133, min_days: 7, max_days: 10 },
{ pincode: 736156, min_days: 7, max_days: 10 },
{ pincode: 736165, min_days: 7, max_days: 10 },
{ pincode: 736170, min_days: 7, max_days: 10 },
{ pincode: 736179, min_days: 7, max_days: 10 },
{ pincode: 736180, min_days: 7, max_days: 10 },
{ pincode: 736257, min_days: 7, max_days: 10 },
{ pincode: 741221, min_days: 7, max_days: 10 },
{ pincode: 741222, min_days: 7, max_days: 10 },
{ pincode: 741232, min_days: 7, max_days: 10 },
{ pincode: 741234, min_days: 7, max_days: 10 },
{ pincode: 741235, min_days: 7, max_days: 10 },
{ pincode: 741245, min_days: 7, max_days: 10 },
{ pincode: 741247, min_days: 7, max_days: 10 },
{ pincode: 741248, min_days: 7, max_days: 10 },
{ pincode: 741249, min_days: 7, max_days: 10 },
{ pincode: 741250, min_days: 7, max_days: 10 },
{ pincode: 741251, min_days: 7, max_days: 10 },
{ pincode: 741252, min_days: 7, max_days: 10 },
{ pincode: 741255, min_days: 7, max_days: 10 },
{ pincode: 741256, min_days: 7, max_days: 10 },
{ pincode: 741257, min_days: 7, max_days: 10 },
{ pincode: 742000, min_days: 7, max_days: 10 },
{ pincode: 742101, min_days: 7, max_days: 10 },
{ pincode: 742102, min_days: 7, max_days: 10 },
{ pincode: 742103, min_days: 7, max_days: 10 },
{ pincode: 742109, min_days: 7, max_days: 10 },
{ pincode: 742123, min_days: 7, max_days: 10 },
{ pincode: 742124, min_days: 7, max_days: 10 },
{ pincode: 742131, min_days: 7, max_days: 10 },
{ pincode: 742149, min_days: 7, max_days: 10 },
{ pincode: 742150, min_days: 7, max_days: 10 },
{ pincode: 742160, min_days: 7, max_days: 10 },
{ pincode: 742165, min_days: 7, max_days: 10 },
{ pincode: 742173, min_days: 7, max_days: 10 },
{ pincode: 742180, min_days: 7, max_days: 10 },
{ pincode: 742182, min_days: 7, max_days: 10 },
{ pincode: 742183, min_days: 7, max_days: 10 },
{ pincode: 742186, min_days: 7, max_days: 10 },
{ pincode: 742187, min_days: 7, max_days: 10 },
{ pincode: 742188, min_days: 7, max_days: 10 },
{ pincode: 742191, min_days: 7, max_days: 10 },
{ pincode: 742407, min_days: 7, max_days: 10 },
{ pincode: 743122, min_days: 7, max_days: 10 },
{ pincode: 743123, min_days: 7, max_days: 10 },
{ pincode: 743125, min_days: 7, max_days: 10 },
{ pincode: 743126, min_days: 7, max_days: 10 },
{ pincode: 743127, min_days: 7, max_days: 10 },
{ pincode: 743128, min_days: 7, max_days: 10 },
{ pincode: 743129, min_days: 7, max_days: 10 },
{ pincode: 743130, min_days: 7, max_days: 10 },
{ pincode: 743133, min_days: 7, max_days: 10 },
{ pincode: 743134, min_days: 7, max_days: 10 },
{ pincode: 743135, min_days: 7, max_days: 10 },
{ pincode: 743136, min_days: 7, max_days: 10 },
{ pincode: 743144, min_days: 7, max_days: 10 },
{ pincode: 743145, min_days: 7, max_days: 10 },
{ pincode: 743155, min_days: 7, max_days: 10 },
{ pincode: 743165, min_days: 7, max_days: 10 },
{ pincode: 743166, min_days: 7, max_days: 10 },
{ pincode: 743193, min_days: 7, max_days: 10 },
{ pincode: 743194, min_days: 7, max_days: 10 },
{ pincode: 743195, min_days: 7, max_days: 10 },
{ pincode: 743200, min_days: 7, max_days: 10 },
{ pincode: 743201, min_days: 7, max_days: 10 },
{ pincode: 743202, min_days: 7, max_days: 10 },
{ pincode: 743203, min_days: 7, max_days: 10 },
{ pincode: 743204, min_days: 7, max_days: 10 },
{ pincode: 743206, min_days: 7, max_days: 10 },
{ pincode: 743211, min_days: 7, max_days: 10 },
{ pincode: 743212, min_days: 7, max_days: 10 },
{ pincode: 743221, min_days: 7, max_days: 10 },
{ pincode: 743222, min_days: 7, max_days: 10 },
{ pincode: 743223, min_days: 7, max_days: 10 },
{ pincode: 743231, min_days: 7, max_days: 10 },
{ pincode: 743233, min_days: 7, max_days: 10 },
{ pincode: 743234, min_days: 7, max_days: 10 },
{ pincode: 743235, min_days: 7, max_days: 10 },
{ pincode: 743236, min_days: 7, max_days: 10 },
{ pincode: 743240, min_days: 7, max_days: 10 },
{ pincode: 743244, min_days: 7, max_days: 10 },
{ pincode: 743245, min_days: 7, max_days: 10 },
{ pincode: 743246, min_days: 7, max_days: 10 },
{ pincode: 743247, min_days: 7, max_days: 10 },
{ pincode: 743248, min_days: 7, max_days: 10 },
{ pincode: 743249, min_days: 7, max_days: 10 },
{ pincode: 743250, min_days: 7, max_days: 10 },
{ pincode: 743252, min_days: 7, max_days: 10 },
{ pincode: 743263, min_days: 7, max_days: 10 },
{ pincode: 743266, min_days: 7, max_days: 10 },
{ pincode: 743268, min_days: 7, max_days: 10 },
{ pincode: 743271, min_days: 7, max_days: 10 },
{ pincode: 743272, min_days: 7, max_days: 10 },
{ pincode: 743273, min_days: 7, max_days: 10 },
{ pincode: 743274, min_days: 7, max_days: 10 },
{ pincode: 743276, min_days: 7, max_days: 10 },
{ pincode: 743286, min_days: 7, max_days: 10 },
{ pincode: 743287, min_days: 7, max_days: 10 },
{ pincode: 743288, min_days: 7, max_days: 10 },
{ pincode: 743289, min_days: 7, max_days: 10 },
{ pincode: 743290, min_days: 7, max_days: 10 },
{ pincode: 743291, min_days: 7, max_days: 10 },
{ pincode: 743292, min_days: 7, max_days: 10 },
{ pincode: 743293, min_days: 7, max_days: 10 },
{ pincode: 743294, min_days: 7, max_days: 10 },
{ pincode: 743295, min_days: 7, max_days: 10 },
{ pincode: 743298, min_days: 7, max_days: 10 },
{ pincode: 743299, min_days: 7, max_days: 10 },
{ pincode: 743313, min_days: 7, max_days: 10 },
{ pincode: 743316, min_days: 7, max_days: 10 },
{ pincode: 743318, min_days: 7, max_days: 10 },
{ pincode: 743329, min_days: 7, max_days: 10 },
{ pincode: 743330, min_days: 7, max_days: 10 },
{ pincode: 743331, min_days: 7, max_days: 10 },
{ pincode: 743332, min_days: 7, max_days: 10 },
{ pincode: 743336, min_days: 7, max_days: 10 },
{ pincode: 743337, min_days: 7, max_days: 10 },
{ pincode: 743338, min_days: 7, max_days: 10 },
{ pincode: 743345, min_days: 7, max_days: 10 },
{ pincode: 743354, min_days: 7, max_days: 10 },
{ pincode: 743355, min_days: 7, max_days: 10 },
{ pincode: 743363, min_days: 7, max_days: 10 },
{ pincode: 743368, min_days: 7, max_days: 10 },
{ pincode: 743372, min_days: 7, max_days: 10 },
{ pincode: 743375, min_days: 7, max_days: 10 },
{ pincode: 743376, min_days: 7, max_days: 10 },
{ pincode: 743377, min_days: 7, max_days: 10 },
{ pincode: 743384, min_days: 7, max_days: 10 },
{ pincode: 743385, min_days: 7, max_days: 10 },
{ pincode: 743387, min_days: 7, max_days: 10 },
{ pincode: 743391, min_days: 7, max_days: 10 },
{ pincode: 743395, min_days: 7, max_days: 10 },
{ pincode: 743396, min_days: 7, max_days: 10 },
{ pincode: 743398, min_days: 7, max_days: 10 },
{ pincode: 743401, min_days: 7, max_days: 10 },
{ pincode: 743402, min_days: 7, max_days: 10 },
{ pincode: 743405, min_days: 7, max_days: 10 },
{ pincode: 743411, min_days: 7, max_days: 10 },
{ pincode: 743412, min_days: 7, max_days: 10 },
{ pincode: 743414, min_days: 7, max_days: 10 },
{ pincode: 743422, min_days: 7, max_days: 10 },
{ pincode: 743423, min_days: 7, max_days: 10 },
{ pincode: 743424, min_days: 7, max_days: 10 },
{ pincode: 743425, min_days: 7, max_days: 10 },
{ pincode: 743426, min_days: 7, max_days: 10 },
{ pincode: 743427, min_days: 7, max_days: 10 },
{ pincode: 743428, min_days: 7, max_days: 10 },
{ pincode: 743429, min_days: 7, max_days: 10 },
{ pincode: 743434, min_days: 7, max_days: 10 },
{ pincode: 743436, min_days: 7, max_days: 10 },
{ pincode: 743437, min_days: 7, max_days: 10 },
{ pincode: 743438, min_days: 7, max_days: 10 },
{ pincode: 743440, min_days: 7, max_days: 10 },
{ pincode: 743441, min_days: 7, max_days: 10 },
{ pincode: 743442, min_days: 7, max_days: 10 },
{ pincode: 743443, min_days: 7, max_days: 10 },
{ pincode: 743445, min_days: 7, max_days: 10 },
{ pincode: 743456, min_days: 7, max_days: 10 },
{ pincode: 743486, min_days: 7, max_days: 10 },
{ pincode: 743492, min_days: 7, max_days: 10 },
{ pincode: 743500, min_days: 7, max_days: 10 },
{ pincode: 743502, min_days: 7, max_days: 10 },
{ pincode: 743503, min_days: 7, max_days: 10 },
{ pincode: 743504, min_days: 7, max_days: 10 },
{ pincode: 743506, min_days: 7, max_days: 10 },
{ pincode: 743507, min_days: 7, max_days: 10 },
{ pincode: 743508, min_days: 7, max_days: 10 },
{ pincode: 743513, min_days: 7, max_days: 10 },
{ pincode: 743601, min_days: 7, max_days: 10 },
{ pincode: 743603, min_days: 7, max_days: 10 },
{ pincode: 743609, min_days: 7, max_days: 10 },
{ pincode: 743610, min_days: 7, max_days: 10 },
{ pincode: 743613, min_days: 7, max_days: 10 },
{ pincode: 743701, min_days: 7, max_days: 10 },
{ pincode: 743702, min_days: 7, max_days: 10 },
{ pincode: 743703, min_days: 7, max_days: 10 },
{ pincode: 743704, min_days: 7, max_days: 10 },
{ pincode: 743705, min_days: 7, max_days: 10 },
{ pincode: 743706, min_days: 7, max_days: 10 },
{ pincode: 743707, min_days: 7, max_days: 10 },
{ pincode: 743708, min_days: 7, max_days: 10 },
{ pincode: 743710, min_days: 7, max_days: 10 },
{ pincode: 743711, min_days: 7, max_days: 10 },
{ pincode: 743744, min_days: 7, max_days: 10 },
{ pincode: 750017, min_days: 7, max_days: 10 },
{ pincode: 750019, min_days: 7, max_days: 10 },
{ pincode: 751001, min_days: 7, max_days: 10 },
{ pincode: 751002, min_days: 7, max_days: 10 },
{ pincode: 751003, min_days: 7, max_days: 10 },
{ pincode: 751004, min_days: 7, max_days: 10 },
{ pincode: 751005, min_days: 7, max_days: 10 },
{ pincode: 751006, min_days: 7, max_days: 10 },
{ pincode: 751007, min_days: 7, max_days: 10 },
{ pincode: 751008, min_days: 7, max_days: 10 },
{ pincode: 751009, min_days: 7, max_days: 10 },
{ pincode: 751010, min_days: 7, max_days: 10 },
{ pincode: 751011, min_days: 7, max_days: 10 },
{ pincode: 751012, min_days: 7, max_days: 10 },
{ pincode: 751013, min_days: 7, max_days: 10 },
{ pincode: 751014, min_days: 7, max_days: 10 },
{ pincode: 751015, min_days: 7, max_days: 10 },
{ pincode: 751016, min_days: 7, max_days: 10 },
{ pincode: 751017, min_days: 7, max_days: 10 },
{ pincode: 751018, min_days: 7, max_days: 10 },
{ pincode: 751019, min_days: 7, max_days: 10 },
{ pincode: 751020, min_days: 7, max_days: 10 },
{ pincode: 751021, min_days: 7, max_days: 10 },
{ pincode: 751022, min_days: 7, max_days: 10 },
{ pincode: 751023, min_days: 7, max_days: 10 },
{ pincode: 751024, min_days: 7, max_days: 10 },
{ pincode: 751025, min_days: 7, max_days: 10 },
{ pincode: 751026, min_days: 7, max_days: 10 },
{ pincode: 751027, min_days: 7, max_days: 10 },
{ pincode: 751028, min_days: 7, max_days: 10 },
{ pincode: 751029, min_days: 7, max_days: 10 },
{ pincode: 751030, min_days: 7, max_days: 10 },
{ pincode: 751031, min_days: 7, max_days: 10 },
{ pincode: 752014, min_days: 7, max_days: 10 },
{ pincode: 752015, min_days: 7, max_days: 10 },
{ pincode: 752016, min_days: 7, max_days: 10 },
{ pincode: 752017, min_days: 7, max_days: 10 },
{ pincode: 752018, min_days: 7, max_days: 10 },
{ pincode: 752019, min_days: 7, max_days: 10 },
{ pincode: 752020, min_days: 7, max_days: 10 },
{ pincode: 752021, min_days: 7, max_days: 10 },
{ pincode: 752023, min_days: 7, max_days: 10 },
{ pincode: 752024, min_days: 7, max_days: 10 },
{ pincode: 752026, min_days: 7, max_days: 10 },
{ pincode: 752028, min_days: 7, max_days: 10 },
{ pincode: 752029, min_days: 7, max_days: 10 },
{ pincode: 752037, min_days: 7, max_days: 10 },
{ pincode: 752038, min_days: 7, max_days: 10 },
{ pincode: 752045, min_days: 7, max_days: 10 },
{ pincode: 752046, min_days: 7, max_days: 10 },
{ pincode: 752050, min_days: 7, max_days: 10 },
{ pincode: 752051, min_days: 7, max_days: 10 },
{ pincode: 752053, min_days: 7, max_days: 10 },
{ pincode: 752054, min_days: 7, max_days: 10 },
{ pincode: 752055, min_days: 7, max_days: 10 },
{ pincode: 752056, min_days: 7, max_days: 10 },
{ pincode: 752057, min_days: 7, max_days: 10 },
{ pincode: 752058, min_days: 7, max_days: 10 },
{ pincode: 752059, min_days: 7, max_days: 10 },
{ pincode: 752060, min_days: 7, max_days: 10 },
{ pincode: 752061, min_days: 7, max_days: 10 },
{ pincode: 752062, min_days: 7, max_days: 10 },
{ pincode: 752063, min_days: 7, max_days: 10 },
{ pincode: 752064, min_days: 7, max_days: 10 },
{ pincode: 752065, min_days: 7, max_days: 10 },
{ pincode: 752066, min_days: 7, max_days: 10 },
{ pincode: 752067, min_days: 7, max_days: 10 },
{ pincode: 752100, min_days: 7, max_days: 10 },
{ pincode: 752101, min_days: 7, max_days: 10 },
{ pincode: 752102, min_days: 7, max_days: 10 },
{ pincode: 752103, min_days: 7, max_days: 10 },
{ pincode: 752104, min_days: 7, max_days: 10 },
{ pincode: 752105, min_days: 7, max_days: 10 },
{ pincode: 752106, min_days: 7, max_days: 10 },
{ pincode: 752110, min_days: 7, max_days: 10 },
{ pincode: 752113, min_days: 7, max_days: 10 },
{ pincode: 752114, min_days: 7, max_days: 10 },
{ pincode: 752115, min_days: 7, max_days: 10 },
{ pincode: 752116, min_days: 7, max_days: 10 },
{ pincode: 752120, min_days: 7, max_days: 10 },
{ pincode: 752121, min_days: 7, max_days: 10 },
{ pincode: 753001, min_days: 7, max_days: 10 },
{ pincode: 753002, min_days: 7, max_days: 10 },
{ pincode: 753003, min_days: 7, max_days: 10 },
{ pincode: 753004, min_days: 7, max_days: 10 },
{ pincode: 753005, min_days: 7, max_days: 10 },
{ pincode: 753006, min_days: 7, max_days: 10 },
{ pincode: 753007, min_days: 7, max_days: 10 },
{ pincode: 753008, min_days: 7, max_days: 10 },
{ pincode: 753009, min_days: 7, max_days: 10 },
{ pincode: 753010, min_days: 7, max_days: 10 },
{ pincode: 753011, min_days: 7, max_days: 10 },
{ pincode: 753012, min_days: 7, max_days: 10 },
{ pincode: 753013, min_days: 7, max_days: 10 },
{ pincode: 753014, min_days: 7, max_days: 10 },
{ pincode: 753015, min_days: 7, max_days: 10 },
{ pincode: 753021, min_days: 7, max_days: 10 },
{ pincode: 754001, min_days: 7, max_days: 10 },
{ pincode: 754002, min_days: 7, max_days: 10 },
{ pincode: 754003, min_days: 7, max_days: 10 },
{ pincode: 754004, min_days: 7, max_days: 10 },
{ pincode: 754005, min_days: 7, max_days: 10 },
{ pincode: 754006, min_days: 7, max_days: 10 },
{ pincode: 754007, min_days: 7, max_days: 10 },
{ pincode: 754008, min_days: 7, max_days: 10 },
{ pincode: 754009, min_days: 7, max_days: 10 },
{ pincode: 754010, min_days: 7, max_days: 10 },
{ pincode: 754011, min_days: 7, max_days: 10 },
{ pincode: 754012, min_days: 7, max_days: 10 },
{ pincode: 754014, min_days: 7, max_days: 10 },
{ pincode: 754015, min_days: 7, max_days: 10 },
{ pincode: 754017, min_days: 7, max_days: 10 },
{ pincode: 754018, min_days: 7, max_days: 10 },
{ pincode: 754021, min_days: 7, max_days: 10 },
{ pincode: 754022, min_days: 7, max_days: 10 },
{ pincode: 754023, min_days: 7, max_days: 10 },
{ pincode: 754025, min_days: 7, max_days: 10 },
{ pincode: 754027, min_days: 7, max_days: 10 },
{ pincode: 754028, min_days: 7, max_days: 10 },
{ pincode: 754029, min_days: 7, max_days: 10 },
{ pincode: 754030, min_days: 7, max_days: 10 },
{ pincode: 754035, min_days: 7, max_days: 10 },
{ pincode: 754071, min_days: 7, max_days: 10 },
{ pincode: 754082, min_days: 7, max_days: 10 },
{ pincode: 754100, min_days: 7, max_days: 10 },
{ pincode: 754102, min_days: 7, max_days: 10 },
{ pincode: 754103, min_days: 7, max_days: 10 },
{ pincode: 754105, min_days: 7, max_days: 10 },
{ pincode: 754109, min_days: 7, max_days: 10 },
{ pincode: 754111, min_days: 7, max_days: 10 },
{ pincode: 754112, min_days: 7, max_days: 10 },
{ pincode: 754114, min_days: 7, max_days: 10 },
{ pincode: 754130, min_days: 7, max_days: 10 },
{ pincode: 754131, min_days: 7, max_days: 10 },
{ pincode: 754132, min_days: 7, max_days: 10 },
{ pincode: 754134, min_days: 7, max_days: 10 },
{ pincode: 754200, min_days: 7, max_days: 10 },
{ pincode: 754201, min_days: 7, max_days: 10 },
{ pincode: 754202, min_days: 7, max_days: 10 },
{ pincode: 754203, min_days: 7, max_days: 10 },
{ pincode: 754204, min_days: 7, max_days: 10 },
{ pincode: 754206, min_days: 7, max_days: 10 },
{ pincode: 754207, min_days: 7, max_days: 10 },
{ pincode: 754221, min_days: 7, max_days: 10 },
{ pincode: 754290, min_days: 7, max_days: 10 },
{ pincode: 759001, min_days: 7, max_days: 10 },
{ pincode: 759013, min_days: 7, max_days: 10 },
{ pincode: 760001, min_days: 7, max_days: 10 },
{ pincode: 760002, min_days: 7, max_days: 10 },
{ pincode: 760003, min_days: 7, max_days: 10 },
{ pincode: 760004, min_days: 7, max_days: 10 },
{ pincode: 760005, min_days: 7, max_days: 10 },
{ pincode: 760007, min_days: 7, max_days: 10 },
{ pincode: 760008, min_days: 7, max_days: 10 },
{ pincode: 760009, min_days: 7, max_days: 10 },
{ pincode: 760010, min_days: 7, max_days: 10 },
{ pincode: 760013, min_days: 7, max_days: 10 },
{ pincode: 761001, min_days: 7, max_days: 10 },
{ pincode: 761002, min_days: 7, max_days: 10 },
{ pincode: 761003, min_days: 7, max_days: 10 },
{ pincode: 761008, min_days: 7, max_days: 10 },
{ pincode: 761054, min_days: 7, max_days: 10 },
{ pincode: 761056, min_days: 7, max_days: 10 },
{ pincode: 761100, min_days: 7, max_days: 10 },
{ pincode: 761101, min_days: 7, max_days: 10 },
{ pincode: 768001, min_days: 7, max_days: 10 },
{ pincode: 768002, min_days: 7, max_days: 10 },
{ pincode: 768003, min_days: 7, max_days: 10 },
{ pincode: 768004, min_days: 7, max_days: 10 },
{ pincode: 768006, min_days: 7, max_days: 10 },
{ pincode: 768010, min_days: 7, max_days: 10 },
{ pincode: 768011, min_days: 7, max_days: 10 },
{ pincode: 768013, min_days: 7, max_days: 10 },
{ pincode: 768014, min_days: 7, max_days: 10 },
{ pincode: 768015, min_days: 7, max_days: 10 },
{ pincode: 768016, min_days: 7, max_days: 10 },
{ pincode: 768017, min_days: 7, max_days: 10 },
{ pincode: 768018, min_days: 7, max_days: 10 },
{ pincode: 768019, min_days: 7, max_days: 10 },
{ pincode: 768020, min_days: 7, max_days: 10 },
{ pincode: 768025, min_days: 7, max_days: 10 },
{ pincode: 769002, min_days: 7, max_days: 10 },
{ pincode: 769003, min_days: 7, max_days: 10 },
{ pincode: 769005, min_days: 7, max_days: 10 },
{ pincode: 769006, min_days: 7, max_days: 10 },
{ pincode: 769007, min_days: 7, max_days: 10 },
{ pincode: 769008, min_days: 7, max_days: 10 },
{ pincode: 769009, min_days: 7, max_days: 10 },
{ pincode: 769010, min_days: 7, max_days: 10 },
{ pincode: 769011, min_days: 7, max_days: 10 },
{ pincode: 769013, min_days: 7, max_days: 10 },
{ pincode: 769014, min_days: 7, max_days: 10 },
{ pincode: 769016, min_days: 7, max_days: 10 },
{ pincode: 769017, min_days: 7, max_days: 10 },
{ pincode: 769018, min_days: 7, max_days: 10 },
{ pincode: 769019, min_days: 7, max_days: 10 },
{ pincode: 769032, min_days: 7, max_days: 10 },
{ pincode: 769041, min_days: 7, max_days: 10 },
{ pincode: 769042, min_days: 7, max_days: 10 },
{ pincode: 769043, min_days: 7, max_days: 10 },
{ pincode: 777777, min_days: 7, max_days: 10 },
{ pincode: 781000, min_days: 7, max_days: 10 },
{ pincode: 781001, min_days: 7, max_days: 10 },
{ pincode: 781002, min_days: 7, max_days: 10 },
{ pincode: 781003, min_days: 7, max_days: 10 },
{ pincode: 781004, min_days: 7, max_days: 10 },
{ pincode: 781005, min_days: 7, max_days: 10 },
{ pincode: 781006, min_days: 7, max_days: 10 },
{ pincode: 781007, min_days: 7, max_days: 10 },
{ pincode: 781008, min_days: 7, max_days: 10 },
{ pincode: 781009, min_days: 7, max_days: 10 },
{ pincode: 781010, min_days: 7, max_days: 10 },
{ pincode: 781011, min_days: 7, max_days: 10 },
{ pincode: 781012, min_days: 7, max_days: 10 },
{ pincode: 781013, min_days: 7, max_days: 10 },
{ pincode: 781014, min_days: 7, max_days: 10 },
{ pincode: 781015, min_days: 7, max_days: 10 },
{ pincode: 781016, min_days: 7, max_days: 10 },
{ pincode: 781017, min_days: 7, max_days: 10 },
{ pincode: 781018, min_days: 7, max_days: 10 },
{ pincode: 781019, min_days: 7, max_days: 10 },
{ pincode: 781020, min_days: 7, max_days: 10 },
{ pincode: 781021, min_days: 7, max_days: 10 },
{ pincode: 781022, min_days: 7, max_days: 10 },
{ pincode: 781023, min_days: 7, max_days: 10 },
{ pincode: 781024, min_days: 7, max_days: 10 },
{ pincode: 781025, min_days: 7, max_days: 10 },
{ pincode: 781026, min_days: 7, max_days: 10 },
{ pincode: 781027, min_days: 7, max_days: 10 },
{ pincode: 781028, min_days: 7, max_days: 10 },
{ pincode: 781029, min_days: 7, max_days: 10 },
{ pincode: 781030, min_days: 7, max_days: 10 },
{ pincode: 781031, min_days: 7, max_days: 10 },
{ pincode: 781032, min_days: 7, max_days: 10 },
{ pincode: 781033, min_days: 7, max_days: 10 },
{ pincode: 781034, min_days: 7, max_days: 10 },
{ pincode: 781035, min_days: 7, max_days: 10 },
{ pincode: 781036, min_days: 7, max_days: 10 },
{ pincode: 781037, min_days: 7, max_days: 10 },
{ pincode: 781038, min_days: 7, max_days: 10 },
{ pincode: 781039, min_days: 7, max_days: 10 },
{ pincode: 781040, min_days: 7, max_days: 10 },
{ pincode: 781101, min_days: 7, max_days: 10 },
{ pincode: 781102, min_days: 7, max_days: 10 },
{ pincode: 781103, min_days: 7, max_days: 10 },
{ pincode: 781104, min_days: 7, max_days: 10 },
{ pincode: 781120, min_days: 7, max_days: 10 },
{ pincode: 781121, min_days: 7, max_days: 10 },
{ pincode: 781122, min_days: 7, max_days: 10 },
{ pincode: 781123, min_days: 7, max_days: 10 },
{ pincode: 781124, min_days: 7, max_days: 10 },
{ pincode: 781125, min_days: 7, max_days: 10 },
{ pincode: 781128, min_days: 7, max_days: 10 },
{ pincode: 781130, min_days: 7, max_days: 10 },
{ pincode: 781131, min_days: 7, max_days: 10 },
{ pincode: 781132, min_days: 7, max_days: 10 },
{ pincode: 781133, min_days: 7, max_days: 10 },
{ pincode: 781134, min_days: 7, max_days: 10 },
{ pincode: 781136, min_days: 7, max_days: 10 },
{ pincode: 781137, min_days: 7, max_days: 10 },
{ pincode: 781141, min_days: 7, max_days: 10 },
{ pincode: 781171, min_days: 7, max_days: 10 },
{ pincode: 781302, min_days: 7, max_days: 10 },
{ pincode: 781310, min_days: 7, max_days: 10 },
{ pincode: 781320, min_days: 7, max_days: 10 },
{ pincode: 781334, min_days: 7, max_days: 10 },
{ pincode: 781339, min_days: 7, max_days: 10 },
{ pincode: 781347, min_days: 7, max_days: 10 },
{ pincode: 781348, min_days: 7, max_days: 10 },
{ pincode: 781350, min_days: 7, max_days: 10 },
{ pincode: 781351, min_days: 7, max_days: 10 },
{ pincode: 781354, min_days: 7, max_days: 10 },
{ pincode: 781365, min_days: 7, max_days: 10 },
{ pincode: 781366, min_days: 7, max_days: 10 },
{ pincode: 781376, min_days: 7, max_days: 10 },
{ pincode: 781380, min_days: 7, max_days: 10 },
{ pincode: 781381, min_days: 7, max_days: 10 },
{ pincode: 781382, min_days: 7, max_days: 10 },
{ pincode: 781385, min_days: 7, max_days: 10 },
{ pincode: 782401, min_days: 7, max_days: 10 },
{ pincode: 782402, min_days: 7, max_days: 10 },
{ pincode: 782403, min_days: 7, max_days: 10 },
{ pincode: 784001, min_days: 7, max_days: 10 },
{ pincode: 784002, min_days: 7, max_days: 10 },
{ pincode: 784003, min_days: 7, max_days: 10 },
{ pincode: 784004, min_days: 7, max_days: 10 },
{ pincode: 784010, min_days: 7, max_days: 10 },
{ pincode: 784025, min_days: 7, max_days: 10 },
{ pincode: 784026, min_days: 7, max_days: 10 },
{ pincode: 784027, min_days: 7, max_days: 10 },
{ pincode: 784028, min_days: 7, max_days: 10 },
{ pincode: 784105, min_days: 7, max_days: 10 },
{ pincode: 784145, min_days: 7, max_days: 10 },
{ pincode: 784148, min_days: 7, max_days: 10 },
{ pincode: 784150, min_days: 7, max_days: 10 },
{ pincode: 784151, min_days: 7, max_days: 10 },
{ pincode: 784153, min_days: 7, max_days: 10 },
{ pincode: 784154, min_days: 7, max_days: 10 },
{ pincode: 784501, min_days: 7, max_days: 10 },
{ pincode: 784502, min_days: 7, max_days: 10 },
{ pincode: 785001, min_days: 7, max_days: 10 },
{ pincode: 785002, min_days: 7, max_days: 10 },
{ pincode: 785003, min_days: 7, max_days: 10 },
{ pincode: 785004, min_days: 7, max_days: 10 },
{ pincode: 785005, min_days: 7, max_days: 10 },
{ pincode: 785006, min_days: 7, max_days: 10 },
{ pincode: 785007, min_days: 7, max_days: 10 },
{ pincode: 785008, min_days: 7, max_days: 10 },
{ pincode: 785009, min_days: 7, max_days: 10 },
{ pincode: 785010, min_days: 7, max_days: 10 },
{ pincode: 785011, min_days: 7, max_days: 10 },
{ pincode: 785012, min_days: 7, max_days: 10 },
{ pincode: 785013, min_days: 7, max_days: 10 },
{ pincode: 785014, min_days: 7, max_days: 10 },
{ pincode: 785015, min_days: 7, max_days: 10 },
{ pincode: 785016, min_days: 7, max_days: 10 },
{ pincode: 785018, min_days: 7, max_days: 10 },
{ pincode: 785100, min_days: 7, max_days: 10 },
{ pincode: 785101, min_days: 7, max_days: 10 },
{ pincode: 785102, min_days: 7, max_days: 10 },
{ pincode: 785103, min_days: 7, max_days: 10 },
{ pincode: 785104, min_days: 7, max_days: 10 },
{ pincode: 785105, min_days: 7, max_days: 10 },
{ pincode: 785106, min_days: 7, max_days: 10 },
{ pincode: 785107, min_days: 7, max_days: 10 },
{ pincode: 785108, min_days: 7, max_days: 10 },
{ pincode: 785109, min_days: 7, max_days: 10 },
{ pincode: 785110, min_days: 7, max_days: 10 },
{ pincode: 785111, min_days: 7, max_days: 10 },
{ pincode: 785112, min_days: 7, max_days: 10 },
{ pincode: 785113, min_days: 7, max_days: 10 },
{ pincode: 785603, min_days: 7, max_days: 10 },
{ pincode: 785604, min_days: 7, max_days: 10 },
{ pincode: 785610, min_days: 7, max_days: 10 },
{ pincode: 785611, min_days: 7, max_days: 10 },
{ pincode: 785613, min_days: 7, max_days: 10 },
{ pincode: 785614, min_days: 7, max_days: 10 },
{ pincode: 785615, min_days: 7, max_days: 10 },
{ pincode: 785616, min_days: 7, max_days: 10 },
{ pincode: 785617, min_days: 7, max_days: 10 },
{ pincode: 785618, min_days: 7, max_days: 10 },
{ pincode: 785619, min_days: 7, max_days: 10 },
{ pincode: 785620, min_days: 7, max_days: 10 },
{ pincode: 785621, min_days: 7, max_days: 10 },
{ pincode: 785622, min_days: 7, max_days: 10 },
{ pincode: 785625, min_days: 7, max_days: 10 },
{ pincode: 785626, min_days: 7, max_days: 10 },
{ pincode: 785630, min_days: 7, max_days: 10 },
{ pincode: 785631, min_days: 7, max_days: 10 },
{ pincode: 785632, min_days: 7, max_days: 10 },
{ pincode: 785633, min_days: 7, max_days: 10 },
{ pincode: 785634, min_days: 7, max_days: 10 },
{ pincode: 785635, min_days: 7, max_days: 10 },
{ pincode: 785636, min_days: 7, max_days: 10 },
{ pincode: 785637, min_days: 7, max_days: 10 },
{ pincode: 785638, min_days: 7, max_days: 10 },
{ pincode: 785639, min_days: 7, max_days: 10 },
{ pincode: 785640, min_days: 7, max_days: 10 },
{ pincode: 785642, min_days: 7, max_days: 10 },
{ pincode: 785643, min_days: 7, max_days: 10 },
{ pincode: 785644, min_days: 7, max_days: 10 },
{ pincode: 785645, min_days: 7, max_days: 10 },
{ pincode: 785646, min_days: 7, max_days: 10 },
{ pincode: 785647, min_days: 7, max_days: 10 },
{ pincode: 785648, min_days: 7, max_days: 10 },
{ pincode: 785649, min_days: 7, max_days: 10 },
{ pincode: 785650, min_days: 7, max_days: 10 },
{ pincode: 785651, min_days: 7, max_days: 10 },
{ pincode: 785660, min_days: 7, max_days: 10 },
{ pincode: 785661, min_days: 7, max_days: 10 },
{ pincode: 785662, min_days: 7, max_days: 10 },
{ pincode: 785663, min_days: 7, max_days: 10 },
{ pincode: 785664, min_days: 7, max_days: 10 },
{ pincode: 785665, min_days: 7, max_days: 10 },
{ pincode: 785666, min_days: 7, max_days: 10 },
{ pincode: 785667, min_days: 7, max_days: 10 },
{ pincode: 785668, min_days: 7, max_days: 10 },
{ pincode: 785669, min_days: 7, max_days: 10 },
{ pincode: 785670, min_days: 7, max_days: 10 },
{ pincode: 785671, min_days: 7, max_days: 10 },
{ pincode: 785672, min_days: 7, max_days: 10 },
{ pincode: 785673, min_days: 7, max_days: 10 },
{ pincode: 785674, min_days: 7, max_days: 10 },
{ pincode: 785675, min_days: 7, max_days: 10 },
{ pincode: 785676, min_days: 7, max_days: 10 },
{ pincode: 785680, min_days: 7, max_days: 10 },
{ pincode: 785681, min_days: 7, max_days: 10 },
{ pincode: 785682, min_days: 7, max_days: 10 },
{ pincode: 785683, min_days: 7, max_days: 10 },
{ pincode: 785684, min_days: 7, max_days: 10 },
{ pincode: 785685, min_days: 7, max_days: 10 },
{ pincode: 785686, min_days: 7, max_days: 10 },
{ pincode: 785687, min_days: 7, max_days: 10 },
{ pincode: 785688, min_days: 7, max_days: 10 },
{ pincode: 785691, min_days: 7, max_days: 10 },
{ pincode: 785692, min_days: 7, max_days: 10 },
{ pincode: 785694, min_days: 7, max_days: 10 },
{ pincode: 785695, min_days: 7, max_days: 10 },
{ pincode: 785696, min_days: 7, max_days: 10 },
{ pincode: 785697, min_days: 7, max_days: 10 },
{ pincode: 785698, min_days: 7, max_days: 10 },
{ pincode: 785699, min_days: 7, max_days: 10 },
{ pincode: 785700, min_days: 7, max_days: 10 },
{ pincode: 785701, min_days: 7, max_days: 10 },
{ pincode: 785702, min_days: 7, max_days: 10 },
{ pincode: 785703, min_days: 7, max_days: 10 },
{ pincode: 785704, min_days: 7, max_days: 10 },
{ pincode: 785705, min_days: 7, max_days: 10 },
{ pincode: 786001, min_days: 7, max_days: 10 },
{ pincode: 786002, min_days: 7, max_days: 10 },
{ pincode: 786003, min_days: 7, max_days: 10 },
{ pincode: 786004, min_days: 7, max_days: 10 },
{ pincode: 786005, min_days: 7, max_days: 10 },
{ pincode: 786006, min_days: 7, max_days: 10 },
{ pincode: 786007, min_days: 7, max_days: 10 },
{ pincode: 786008, min_days: 7, max_days: 10 },
{ pincode: 786009, min_days: 7, max_days: 10 },
{ pincode: 786010, min_days: 7, max_days: 10 },
{ pincode: 786011, min_days: 7, max_days: 10 },
{ pincode: 786012, min_days: 7, max_days: 10 },
{ pincode: 786013, min_days: 7, max_days: 10 },
{ pincode: 786014, min_days: 7, max_days: 10 },
{ pincode: 786015, min_days: 7, max_days: 10 },
{ pincode: 786016, min_days: 7, max_days: 10 },
{ pincode: 786052, min_days: 7, max_days: 10 },
{ pincode: 786053, min_days: 7, max_days: 10 },
{ pincode: 786054, min_days: 7, max_days: 10 },
{ pincode: 786101, min_days: 7, max_days: 10 },
{ pincode: 786102, min_days: 7, max_days: 10 },
{ pincode: 786103, min_days: 7, max_days: 10 },
{ pincode: 786121, min_days: 7, max_days: 10 },
{ pincode: 786124, min_days: 7, max_days: 10 },
{ pincode: 786125, min_days: 7, max_days: 10 },
{ pincode: 786126, min_days: 7, max_days: 10 },
{ pincode: 786130, min_days: 7, max_days: 10 },
{ pincode: 786131, min_days: 7, max_days: 10 },
{ pincode: 786132, min_days: 7, max_days: 10 },
{ pincode: 786133, min_days: 7, max_days: 10 },
{ pincode: 786134, min_days: 7, max_days: 10 },
{ pincode: 786135, min_days: 7, max_days: 10 },
{ pincode: 786136, min_days: 7, max_days: 10 },
{ pincode: 786137, min_days: 7, max_days: 10 },
{ pincode: 786138, min_days: 7, max_days: 10 },
{ pincode: 786139, min_days: 7, max_days: 10 },
{ pincode: 786145, min_days: 7, max_days: 10 },
{ pincode: 786146, min_days: 7, max_days: 10 },
{ pincode: 786147, min_days: 7, max_days: 10 },
{ pincode: 786158, min_days: 7, max_days: 10 },
{ pincode: 786170, min_days: 7, max_days: 10 },
{ pincode: 786172, min_days: 7, max_days: 10 },
{ pincode: 786180, min_days: 7, max_days: 10 },
{ pincode: 786183, min_days: 7, max_days: 10 },
{ pincode: 786184, min_days: 7, max_days: 10 },
{ pincode: 786185, min_days: 7, max_days: 10 },
{ pincode: 786186, min_days: 7, max_days: 10 },
{ pincode: 786189, min_days: 7, max_days: 10 },
{ pincode: 786191, min_days: 7, max_days: 10 },
{ pincode: 786192, min_days: 7, max_days: 10 },
{ pincode: 786602, min_days: 7, max_days: 10 },
{ pincode: 786610, min_days: 7, max_days: 10 },
{ pincode: 786611, min_days: 7, max_days: 10 },
{ pincode: 786612, min_days: 7, max_days: 10 },
{ pincode: 786613, min_days: 7, max_days: 10 },
{ pincode: 786614, min_days: 7, max_days: 10 },
{ pincode: 786621, min_days: 7, max_days: 10 },
{ pincode: 786622, min_days: 7, max_days: 10 },
{ pincode: 786623, min_days: 7, max_days: 10 },
{ pincode: 786624, min_days: 7, max_days: 10 },
{ pincode: 786629, min_days: 7, max_days: 10 },
{ pincode: 786692, min_days: 7, max_days: 10 },
{ pincode: 788001, min_days: 7, max_days: 10 },
{ pincode: 788002, min_days: 7, max_days: 10 },
{ pincode: 788003, min_days: 7, max_days: 10 },
{ pincode: 788004, min_days: 7, max_days: 10 },
{ pincode: 788005, min_days: 7, max_days: 10 },
{ pincode: 788006, min_days: 7, max_days: 10 },
{ pincode: 788007, min_days: 7, max_days: 10 },
{ pincode: 788008, min_days: 7, max_days: 10 },
{ pincode: 788009, min_days: 7, max_days: 10 },
{ pincode: 788010, min_days: 7, max_days: 10 },
{ pincode: 788011, min_days: 7, max_days: 10 },
{ pincode: 788012, min_days: 7, max_days: 10 },
{ pincode: 788013, min_days: 7, max_days: 10 },
{ pincode: 788014, min_days: 7, max_days: 10 },
{ pincode: 788015, min_days: 7, max_days: 10 },
{ pincode: 788016, min_days: 7, max_days: 10 },
{ pincode: 788017, min_days: 7, max_days: 10 },
{ pincode: 788018, min_days: 7, max_days: 10 },
{ pincode: 788019, min_days: 7, max_days: 10 },
{ pincode: 788025, min_days: 7, max_days: 10 },
{ pincode: 788026, min_days: 7, max_days: 10 },
{ pincode: 788030, min_days: 7, max_days: 10 },
{ pincode: 788031, min_days: 7, max_days: 10 },
{ pincode: 788098, min_days: 7, max_days: 10 },
{ pincode: 788099, min_days: 7, max_days: 10 },
{ pincode: 788101, min_days: 7, max_days: 10 },
{ pincode: 788102, min_days: 7, max_days: 10 },
{ pincode: 788103, min_days: 7, max_days: 10 },
{ pincode: 788104, min_days: 7, max_days: 10 },
{ pincode: 788106, min_days: 7, max_days: 10 },
{ pincode: 788107, min_days: 7, max_days: 10 },
{ pincode: 788108, min_days: 7, max_days: 10 },
{ pincode: 788109, min_days: 7, max_days: 10 },
{ pincode: 788110, min_days: 7, max_days: 10 },
{ pincode: 788111, min_days: 7, max_days: 10 },
{ pincode: 788112, min_days: 7, max_days: 10 },
{ pincode: 788113, min_days: 7, max_days: 10 },
{ pincode: 788114, min_days: 7, max_days: 10 },
{ pincode: 788115, min_days: 7, max_days: 10 },
{ pincode: 788116, min_days: 7, max_days: 10 },
{ pincode: 788117, min_days: 7, max_days: 10 },
{ pincode: 788118, min_days: 7, max_days: 10 },
{ pincode: 788119, min_days: 7, max_days: 10 },
{ pincode: 788121, min_days: 7, max_days: 10 },
{ pincode: 788122, min_days: 7, max_days: 10 },
{ pincode: 788123, min_days: 7, max_days: 10 },
{ pincode: 788124, min_days: 7, max_days: 10 },
{ pincode: 788125, min_days: 7, max_days: 10 },
{ pincode: 788126, min_days: 7, max_days: 10 },
{ pincode: 788127, min_days: 7, max_days: 10 },
{ pincode: 788150, min_days: 7, max_days: 10 },
{ pincode: 788151, min_days: 7, max_days: 10 },
{ pincode: 788152, min_days: 7, max_days: 10 },
{ pincode: 788155, min_days: 7, max_days: 10 },
{ pincode: 788156, min_days: 7, max_days: 10 },
{ pincode: 788160, min_days: 7, max_days: 10 },
{ pincode: 788163, min_days: 7, max_days: 10 },
{ pincode: 788164, min_days: 7, max_days: 10 },
{ pincode: 788167, min_days: 7, max_days: 10 },
{ pincode: 788168, min_days: 7, max_days: 10 },
{ pincode: 788169, min_days: 7, max_days: 10 },
{ pincode: 788731, min_days: 7, max_days: 10 },
{ pincode: 788734, min_days: 7, max_days: 10 },
{ pincode: 788801, min_days: 7, max_days: 10 },
{ pincode: 788802, min_days: 7, max_days: 10 },
{ pincode: 788803, min_days: 7, max_days: 10 },
{ pincode: 788804, min_days: 7, max_days: 10 },
{ pincode: 788805, min_days: 7, max_days: 10 },
{ pincode: 788806, min_days: 7, max_days: 10 },
{ pincode: 788808, min_days: 7, max_days: 10 },
{ pincode: 788812, min_days: 7, max_days: 10 },
{ pincode: 788814, min_days: 7, max_days: 10 },
{ pincode: 788815, min_days: 7, max_days: 10 },
{ pincode: 788816, min_days: 7, max_days: 10 },
{ pincode: 788817, min_days: 7, max_days: 10 },
{ pincode: 788820, min_days: 7, max_days: 10 },
{ pincode: 793001, min_days: 7, max_days: 10 },
{ pincode: 793002, min_days: 7, max_days: 10 },
{ pincode: 793003, min_days: 7, max_days: 10 },
{ pincode: 793004, min_days: 7, max_days: 10 },
{ pincode: 793005, min_days: 7, max_days: 10 },
{ pincode: 793006, min_days: 7, max_days: 10 },
{ pincode: 793007, min_days: 7, max_days: 10 },
{ pincode: 793008, min_days: 7, max_days: 10 },
{ pincode: 793010, min_days: 7, max_days: 10 },
{ pincode: 793011, min_days: 7, max_days: 10 },
{ pincode: 793014, min_days: 7, max_days: 10 },
{ pincode: 793016, min_days: 7, max_days: 10 },
{ pincode: 793017, min_days: 7, max_days: 10 },
{ pincode: 793018, min_days: 7, max_days: 10 },
{ pincode: 793019, min_days: 7, max_days: 10 },
{ pincode: 793022, min_days: 7, max_days: 10 },
{ pincode: 796001, min_days: 7, max_days: 10 },
{ pincode: 796005, min_days: 7, max_days: 10 },
{ pincode: 796007, min_days: 7, max_days: 10 },
{ pincode: 796008, min_days: 7, max_days: 10 },
{ pincode: 796012, min_days: 7, max_days: 10 },
{ pincode: 796016, min_days: 7, max_days: 10 },
{ pincode: 800000, min_days: 7, max_days: 10 },
{ pincode: 800001, min_days: 7, max_days: 10 },
{ pincode: 800002, min_days: 7, max_days: 10 },
{ pincode: 800003, min_days: 7, max_days: 10 },
{ pincode: 800004, min_days: 7, max_days: 10 },
{ pincode: 800005, min_days: 7, max_days: 10 },
{ pincode: 800006, min_days: 7, max_days: 10 },
{ pincode: 800007, min_days: 7, max_days: 10 },
{ pincode: 800008, min_days: 7, max_days: 10 },
{ pincode: 800009, min_days: 7, max_days: 10 },
{ pincode: 800010, min_days: 7, max_days: 10 },
{ pincode: 800011, min_days: 7, max_days: 10 },
{ pincode: 800012, min_days: 7, max_days: 10 },
{ pincode: 800013, min_days: 7, max_days: 10 },
{ pincode: 800014, min_days: 7, max_days: 10 },
{ pincode: 800015, min_days: 7, max_days: 10 },
{ pincode: 800016, min_days: 7, max_days: 10 },
{ pincode: 800017, min_days: 7, max_days: 10 },
{ pincode: 800018, min_days: 7, max_days: 10 },
{ pincode: 800019, min_days: 7, max_days: 10 },
{ pincode: 800020, min_days: 7, max_days: 10 },
{ pincode: 800021, min_days: 7, max_days: 10 },
{ pincode: 800022, min_days: 7, max_days: 10 },
{ pincode: 800023, min_days: 7, max_days: 10 },
{ pincode: 800024, min_days: 7, max_days: 10 },
{ pincode: 800025, min_days: 7, max_days: 10 },
{ pincode: 800026, min_days: 7, max_days: 10 },
{ pincode: 800027, min_days: 7, max_days: 10 },
{ pincode: 800028, min_days: 7, max_days: 10 },
{ pincode: 800029, min_days: 7, max_days: 10 },
{ pincode: 800030, min_days: 7, max_days: 10 },
{ pincode: 800111, min_days: 7, max_days: 10 },
{ pincode: 801101, min_days: 7, max_days: 10 },
{ pincode: 801102, min_days: 7, max_days: 10 },
{ pincode: 801103, min_days: 7, max_days: 10 },
{ pincode: 801104, min_days: 7, max_days: 10 },
{ pincode: 801105, min_days: 7, max_days: 10 },
{ pincode: 801108, min_days: 7, max_days: 10 },
{ pincode: 801109, min_days: 7, max_days: 10 },
{ pincode: 801110, min_days: 7, max_days: 10 },
{ pincode: 801111, min_days: 7, max_days: 10 },
{ pincode: 801112, min_days: 7, max_days: 10 },
{ pincode: 801113, min_days: 7, max_days: 10 },
{ pincode: 801114, min_days: 7, max_days: 10 },
{ pincode: 801115, min_days: 7, max_days: 10 },
{ pincode: 801116, min_days: 7, max_days: 10 },
{ pincode: 801117, min_days: 7, max_days: 10 },
{ pincode: 801301, min_days: 7, max_days: 10 },
{ pincode: 801302, min_days: 7, max_days: 10 },
{ pincode: 801304, min_days: 7, max_days: 10 },
{ pincode: 801305, min_days: 7, max_days: 10 },
{ pincode: 801306, min_days: 7, max_days: 10 },
{ pincode: 801307, min_days: 7, max_days: 10 },
{ pincode: 801501, min_days: 7, max_days: 10 },
{ pincode: 801503, min_days: 7, max_days: 10 },
{ pincode: 801505, min_days: 7, max_days: 10 },
{ pincode: 801506, min_days: 7, max_days: 10 },
{ pincode: 801507, min_days: 7, max_days: 10 },
{ pincode: 801508, min_days: 7, max_days: 10 },
{ pincode: 801509, min_days: 7, max_days: 10 },
{ pincode: 803108, min_days: 7, max_days: 10 },
{ pincode: 803110, min_days: 7, max_days: 10 },
{ pincode: 803111, min_days: 7, max_days: 10 },
{ pincode: 803112, min_days: 7, max_days: 10 },
{ pincode: 803113, min_days: 7, max_days: 10 },
{ pincode: 803114, min_days: 7, max_days: 10 },
{ pincode: 803115, min_days: 7, max_days: 10 },
{ pincode: 803118, min_days: 7, max_days: 10 },
{ pincode: 803119, min_days: 7, max_days: 10 },
{ pincode: 803120, min_days: 7, max_days: 10 },
{ pincode: 803201, min_days: 7, max_days: 10 },
{ pincode: 803202, min_days: 7, max_days: 10 },
{ pincode: 803203, min_days: 7, max_days: 10 },
{ pincode: 803206, min_days: 7, max_days: 10 },
{ pincode: 803211, min_days: 7, max_days: 10 },
{ pincode: 803212, min_days: 7, max_days: 10 },
{ pincode: 803216, min_days: 7, max_days: 10 },
{ pincode: 803217, min_days: 7, max_days: 10 },
{ pincode: 803218, min_days: 7, max_days: 10 },
{ pincode: 803219, min_days: 7, max_days: 10 },
{ pincode: 803220, min_days: 7, max_days: 10 },
{ pincode: 803232, min_days: 7, max_days: 10 },
{ pincode: 804403, min_days: 7, max_days: 10 },
{ pincode: 804404, min_days: 7, max_days: 10 },
{ pincode: 804405, min_days: 7, max_days: 10 },
{ pincode: 804406, min_days: 7, max_days: 10 },
{ pincode: 804407, min_days: 7, max_days: 10 },
{ pincode: 804408, min_days: 7, max_days: 10 },
{ pincode: 804417, min_days: 7, max_days: 10 },
{ pincode: 804418, min_days: 7, max_days: 10 },
{ pincode: 804420, min_days: 7, max_days: 10 },
{ pincode: 804422, min_days: 7, max_days: 10 },
{ pincode: 804423, min_days: 7, max_days: 10 },
{ pincode: 804425, min_days: 7, max_days: 10 },
{ pincode: 804427, min_days: 7, max_days: 10 },
{ pincode: 804431, min_days: 7, max_days: 10 },
{ pincode: 804432, min_days: 7, max_days: 10 },
{ pincode: 804433, min_days: 7, max_days: 10 },
{ pincode: 804434, min_days: 7, max_days: 10 },
{ pincode: 804451, min_days: 7, max_days: 10 },
{ pincode: 804452, min_days: 7, max_days: 10 },
{ pincode: 804453, min_days: 7, max_days: 10 },
{ pincode: 804454, min_days: 7, max_days: 10 },
{ pincode: 804457, min_days: 7, max_days: 10 },
{ pincode: 805131, min_days: 7, max_days: 10 },
{ pincode: 811201, min_days: 7, max_days: 10 },
{ pincode: 811203, min_days: 7, max_days: 10 },
{ pincode: 811204, min_days: 7, max_days: 10 },
{ pincode: 811205, min_days: 7, max_days: 10 },
{ pincode: 811206, min_days: 7, max_days: 10 },
{ pincode: 811207, min_days: 7, max_days: 10 },
{ pincode: 811208, min_days: 7, max_days: 10 },
{ pincode: 811209, min_days: 7, max_days: 10 },
{ pincode: 811210, min_days: 7, max_days: 10 },
{ pincode: 811211, min_days: 7, max_days: 10 },
{ pincode: 811212, min_days: 7, max_days: 10 },
{ pincode: 811214, min_days: 7, max_days: 10 },
{ pincode: 811269, min_days: 7, max_days: 10 },
{ pincode: 812001, min_days: 7, max_days: 10 },
{ pincode: 812002, min_days: 7, max_days: 10 },
{ pincode: 812003, min_days: 7, max_days: 10 },
{ pincode: 812004, min_days: 7, max_days: 10 },
{ pincode: 812005, min_days: 7, max_days: 10 },
{ pincode: 812006, min_days: 7, max_days: 10 },
{ pincode: 812007, min_days: 7, max_days: 10 },
{ pincode: 813105, min_days: 7, max_days: 10 },
{ pincode: 813210, min_days: 7, max_days: 10 },
{ pincode: 814112, min_days: 7, max_days: 10 },
{ pincode: 814113, min_days: 7, max_days: 10 },
{ pincode: 814114, min_days: 7, max_days: 10 },
{ pincode: 814115, min_days: 7, max_days: 10 },
{ pincode: 814116, min_days: 7, max_days: 10 },
{ pincode: 814117, min_days: 7, max_days: 10 },
{ pincode: 814122, min_days: 7, max_days: 10 },
{ pincode: 814124, min_days: 7, max_days: 10 },
{ pincode: 814142, min_days: 7, max_days: 10 },
{ pincode: 814143, min_days: 7, max_days: 10 },
{ pincode: 823001, min_days: 7, max_days: 10 },
{ pincode: 823002, min_days: 7, max_days: 10 },
{ pincode: 823003, min_days: 7, max_days: 10 },
{ pincode: 823004, min_days: 7, max_days: 10 },
{ pincode: 823005, min_days: 7, max_days: 10 },
{ pincode: 824209, min_days: 7, max_days: 10 },
{ pincode: 824231, min_days: 7, max_days: 10 },
{ pincode: 824234, min_days: 7, max_days: 10 },
{ pincode: 825101, min_days: 7, max_days: 10 },
{ pincode: 825110, min_days: 7, max_days: 10 },
{ pincode: 825301, min_days: 7, max_days: 10 },
{ pincode: 825302, min_days: 7, max_days: 10 },
{ pincode: 825303, min_days: 7, max_days: 10 },
{ pincode: 825304, min_days: 7, max_days: 10 },
{ pincode: 825316, min_days: 7, max_days: 10 },
{ pincode: 825317, min_days: 7, max_days: 10 },
{ pincode: 825319, min_days: 7, max_days: 10 },
{ pincode: 825335, min_days: 7, max_days: 10 },
{ pincode: 825414, min_days: 7, max_days: 10 },
{ pincode: 826001, min_days: 7, max_days: 10 },
{ pincode: 826002, min_days: 7, max_days: 10 },
{ pincode: 826003, min_days: 7, max_days: 10 },
{ pincode: 826004, min_days: 7, max_days: 10 },
{ pincode: 826005, min_days: 7, max_days: 10 },
{ pincode: 826007, min_days: 7, max_days: 10 },
{ pincode: 826009, min_days: 7, max_days: 10 },
{ pincode: 826015, min_days: 7, max_days: 10 },
{ pincode: 827001, min_days: 7, max_days: 10 },
{ pincode: 827002, min_days: 7, max_days: 10 },
{ pincode: 827003, min_days: 7, max_days: 10 },
{ pincode: 827004, min_days: 7, max_days: 10 },
{ pincode: 827005, min_days: 7, max_days: 10 },
{ pincode: 827006, min_days: 7, max_days: 10 },
{ pincode: 827007, min_days: 7, max_days: 10 },
{ pincode: 827008, min_days: 7, max_days: 10 },
{ pincode: 827009, min_days: 7, max_days: 10 },
{ pincode: 827010, min_days: 7, max_days: 10 },
{ pincode: 827011, min_days: 7, max_days: 10 },
{ pincode: 827012, min_days: 7, max_days: 10 },
{ pincode: 827013, min_days: 7, max_days: 10 },
{ pincode: 827014, min_days: 7, max_days: 10 },
{ pincode: 827015, min_days: 7, max_days: 10 },
{ pincode: 828101, min_days: 7, max_days: 10 },
{ pincode: 828104, min_days: 7, max_days: 10 },
{ pincode: 828106, min_days: 7, max_days: 10 },
{ pincode: 828110, min_days: 7, max_days: 10 },
{ pincode: 828111, min_days: 7, max_days: 10 },
{ pincode: 828112, min_days: 7, max_days: 10 },
{ pincode: 828116, min_days: 7, max_days: 10 },
{ pincode: 828117, min_days: 7, max_days: 10 },
{ pincode: 828119, min_days: 7, max_days: 10 },
{ pincode: 828121, min_days: 7, max_days: 10 },
{ pincode: 828126, min_days: 7, max_days: 10 },
{ pincode: 828127, min_days: 7, max_days: 10 },
{ pincode: 828129, min_days: 7, max_days: 10 },
{ pincode: 828130, min_days: 7, max_days: 10 },
{ pincode: 828132, min_days: 7, max_days: 10 },
{ pincode: 828135, min_days: 7, max_days: 10 },
{ pincode: 828147, min_days: 7, max_days: 10 },
{ pincode: 828301, min_days: 7, max_days: 10 },
{ pincode: 828302, min_days: 7, max_days: 10 },
{ pincode: 828309, min_days: 7, max_days: 10 },
{ pincode: 829101, min_days: 7, max_days: 10 },
{ pincode: 829102, min_days: 7, max_days: 10 },
{ pincode: 829103, min_days: 7, max_days: 10 },
{ pincode: 829105, min_days: 7, max_days: 10 },
{ pincode: 829106, min_days: 7, max_days: 10 },
{ pincode: 829108, min_days: 7, max_days: 10 },
{ pincode: 829109, min_days: 7, max_days: 10 },
{ pincode: 829117, min_days: 7, max_days: 10 },
{ pincode: 829118, min_days: 7, max_days: 10 },
{ pincode: 829119, min_days: 7, max_days: 10 },
{ pincode: 829120, min_days: 7, max_days: 10 },
{ pincode: 829122, min_days: 7, max_days: 10 },
{ pincode: 829125, min_days: 7, max_days: 10 },
{ pincode: 829126, min_days: 7, max_days: 10 },
{ pincode: 829129, min_days: 7, max_days: 10 },
{ pincode: 829133, min_days: 7, max_days: 10 },
{ pincode: 829134, min_days: 7, max_days: 10 },
{ pincode: 829135, min_days: 7, max_days: 10 },
{ pincode: 829143, min_days: 7, max_days: 10 },
{ pincode: 829150, min_days: 7, max_days: 10 },
{ pincode: 829205, min_days: 7, max_days: 10 },
{ pincode: 829208, min_days: 7, max_days: 10 },
{ pincode: 829209, min_days: 7, max_days: 10 },
{ pincode: 829211, min_days: 7, max_days: 10 },
{ pincode: 831000, min_days: 7, max_days: 10 },
{ pincode: 831001, min_days: 7, max_days: 10 },
{ pincode: 831002, min_days: 7, max_days: 10 },
{ pincode: 831003, min_days: 7, max_days: 10 },
{ pincode: 831004, min_days: 7, max_days: 10 },
{ pincode: 831005, min_days: 7, max_days: 10 },
{ pincode: 831006, min_days: 7, max_days: 10 },
{ pincode: 831007, min_days: 7, max_days: 10 },
{ pincode: 831008, min_days: 7, max_days: 10 },
{ pincode: 831009, min_days: 7, max_days: 10 },
{ pincode: 831010, min_days: 7, max_days: 10 },
{ pincode: 831011, min_days: 7, max_days: 10 },
{ pincode: 831012, min_days: 7, max_days: 10 },
{ pincode: 831013, min_days: 7, max_days: 10 },
{ pincode: 831014, min_days: 7, max_days: 10 },
{ pincode: 831015, min_days: 7, max_days: 10 },
{ pincode: 831016, min_days: 7, max_days: 10 },
{ pincode: 831017, min_days: 7, max_days: 10 },
{ pincode: 831018, min_days: 7, max_days: 10 },
{ pincode: 831019, min_days: 7, max_days: 10 },
{ pincode: 831020, min_days: 7, max_days: 10 },
{ pincode: 831021, min_days: 7, max_days: 10 },
{ pincode: 831025, min_days: 7, max_days: 10 },
{ pincode: 831219, min_days: 7, max_days: 10 },
{ pincode: 832014, min_days: 7, max_days: 10 },
{ pincode: 832100, min_days: 7, max_days: 10 },
{ pincode: 832102, min_days: 7, max_days: 10 },
{ pincode: 832103, min_days: 7, max_days: 10 },
{ pincode: 832104, min_days: 7, max_days: 10 },
{ pincode: 832105, min_days: 7, max_days: 10 },
{ pincode: 832106, min_days: 7, max_days: 10 },
{ pincode: 832107, min_days: 7, max_days: 10 },
{ pincode: 832108, min_days: 7, max_days: 10 },
{ pincode: 832109, min_days: 7, max_days: 10 },
{ pincode: 832110, min_days: 7, max_days: 10 },
{ pincode: 832111, min_days: 7, max_days: 10 },
{ pincode: 832119, min_days: 7, max_days: 10 },
{ pincode: 832302, min_days: 7, max_days: 10 },
{ pincode: 832303, min_days: 7, max_days: 10 },
{ pincode: 832304, min_days: 7, max_days: 10 },
{ pincode: 832401, min_days: 7, max_days: 10 },
{ pincode: 832402, min_days: 7, max_days: 10 },
{ pincode: 832404, min_days: 7, max_days: 10 },
{ pincode: 833219, min_days: 7, max_days: 10 },
{ pincode: 833220, min_days: 7, max_days: 10 },
{ pincode: 834001, min_days: 7, max_days: 10 },
{ pincode: 834002, min_days: 7, max_days: 10 },
{ pincode: 834003, min_days: 7, max_days: 10 },
{ pincode: 834004, min_days: 7, max_days: 10 },
{ pincode: 834005, min_days: 7, max_days: 10 },
{ pincode: 834006, min_days: 7, max_days: 10 },
{ pincode: 834007, min_days: 7, max_days: 10 },
{ pincode: 834008, min_days: 7, max_days: 10 },
{ pincode: 834009, min_days: 7, max_days: 10 },
{ pincode: 834010, min_days: 7, max_days: 10 },
{ pincode: 834011, min_days: 7, max_days: 10 },
{ pincode: 834012, min_days: 7, max_days: 10 },
{ pincode: 834013, min_days: 7, max_days: 10 },
{ pincode: 834016, min_days: 7, max_days: 10 },
{ pincode: 835101, min_days: 7, max_days: 10 },
{ pincode: 835103, min_days: 7, max_days: 10 },
{ pincode: 835104, min_days: 7, max_days: 10 },
{ pincode: 835125, min_days: 7, max_days: 10 },
{ pincode: 835202, min_days: 7, max_days: 10 },
{ pincode: 835204, min_days: 7, max_days: 10 },
{ pincode: 835205, min_days: 7, max_days: 10 },
{ pincode: 835209, min_days: 7, max_days: 10 },
{ pincode: 835210, min_days: 7, max_days: 10 },
{ pincode: 835214, min_days: 7, max_days: 10 },
{ pincode: 835215, min_days: 7, max_days: 10 },
{ pincode: 835216, min_days: 7, max_days: 10 },
{ pincode: 835217, min_days: 7, max_days: 10 },
{ pincode: 835219, min_days: 7, max_days: 10 },
{ pincode: 835221, min_days: 7, max_days: 10 },
{ pincode: 835222, min_days: 7, max_days: 10 },
{ pincode: 835225, min_days: 7, max_days: 10 },
{ pincode: 835234, min_days: 7, max_days: 10 },
{ pincode: 835236, min_days: 7, max_days: 10 },
{ pincode: 835237, min_days: 7, max_days: 10 },
{ pincode: 835238, min_days: 7, max_days: 10 },
{ pincode: 835239, min_days: 7, max_days: 10 },
{ pincode: 835240, min_days: 7, max_days: 10 },
{ pincode: 835244, min_days: 7, max_days: 10 },
{ pincode: 835301, min_days: 7, max_days: 10 },
{ pincode: 835303, min_days: 7, max_days: 10 },
{ pincode: 835314, min_days: 7, max_days: 10 },
{ pincode: 838303, min_days: 7, max_days: 10 },
{ pincode: 841101, min_days: 7, max_days: 10 },
{ pincode: 841202, min_days: 7, max_days: 10 },
{ pincode: 841207, min_days: 7, max_days: 10 },
{ pincode: 841211, min_days: 7, max_days: 10 },
{ pincode: 841215, min_days: 7, max_days: 10 },
{ pincode: 841216, min_days: 7, max_days: 10 },
{ pincode: 841217, min_days: 7, max_days: 10 },
{ pincode: 841218, min_days: 7, max_days: 10 },
{ pincode: 841219, min_days: 7, max_days: 10 },
{ pincode: 841220, min_days: 7, max_days: 10 },
{ pincode: 841221, min_days: 7, max_days: 10 },
{ pincode: 841222, min_days: 7, max_days: 10 },
{ pincode: 841225, min_days: 7, max_days: 10 },
{ pincode: 841247, min_days: 7, max_days: 10 },
{ pincode: 841301, min_days: 7, max_days: 10 },
{ pincode: 841302, min_days: 7, max_days: 10 },
{ pincode: 841305, min_days: 7, max_days: 10 },
{ pincode: 841311, min_days: 7, max_days: 10 },
{ pincode: 841312, min_days: 7, max_days: 10 },
{ pincode: 841316, min_days: 7, max_days: 10 },
{ pincode: 841317, min_days: 7, max_days: 10 },
{ pincode: 841318, min_days: 7, max_days: 10 },
{ pincode: 841339, min_days: 7, max_days: 10 },
{ pincode: 841402, min_days: 7, max_days: 10 },
{ pincode: 841414, min_days: 7, max_days: 10 },
{ pincode: 841415, min_days: 7, max_days: 10 },
{ pincode: 841428, min_days: 7, max_days: 10 },
{ pincode: 841429, min_days: 7, max_days: 10 },
{ pincode: 841430, min_days: 7, max_days: 10 },
{ pincode: 841431, min_days: 7, max_days: 10 },
{ pincode: 841440, min_days: 7, max_days: 10 },
{ pincode: 841460, min_days: 7, max_days: 10 },
{ pincode: 841505, min_days: 7, max_days: 10 },
{ pincode: 842001, min_days: 7, max_days: 10 },
{ pincode: 842002, min_days: 7, max_days: 10 },
{ pincode: 842003, min_days: 7, max_days: 10 },
{ pincode: 842004, min_days: 7, max_days: 10 },
{ pincode: 842005, min_days: 7, max_days: 10 },
{ pincode: 842007, min_days: 7, max_days: 10 },
{ pincode: 842008, min_days: 7, max_days: 10 },
{ pincode: 842009, min_days: 7, max_days: 10 },
{ pincode: 843001, min_days: 7, max_days: 10 },
{ pincode: 843014, min_days: 7, max_days: 10 },
{ pincode: 843031, min_days: 7, max_days: 10 },
{ pincode: 843100, min_days: 7, max_days: 10 },
{ pincode: 843101, min_days: 7, max_days: 10 },
{ pincode: 843102, min_days: 7, max_days: 10 },
{ pincode: 843103, min_days: 7, max_days: 10 },
{ pincode: 843104, min_days: 7, max_days: 10 },
{ pincode: 843105, min_days: 7, max_days: 10 },
{ pincode: 843106, min_days: 7, max_days: 10 },
{ pincode: 843107, min_days: 7, max_days: 10 },
{ pincode: 843108, min_days: 7, max_days: 10 },
{ pincode: 843109, min_days: 7, max_days: 10 },
{ pincode: 843110, min_days: 7, max_days: 10 },
{ pincode: 843111, min_days: 7, max_days: 10 },
{ pincode: 843112, min_days: 7, max_days: 10 },
{ pincode: 843113, min_days: 7, max_days: 10 },
{ pincode: 843114, min_days: 7, max_days: 10 },
{ pincode: 843115, min_days: 7, max_days: 10 },
{ pincode: 843116, min_days: 7, max_days: 10 },
{ pincode: 843117, min_days: 7, max_days: 10 },
{ pincode: 843118, min_days: 7, max_days: 10 },
{ pincode: 843119, min_days: 7, max_days: 10 },
{ pincode: 843120, min_days: 7, max_days: 10 },
{ pincode: 843121, min_days: 7, max_days: 10 },
{ pincode: 843122, min_days: 7, max_days: 10 },
{ pincode: 843123, min_days: 7, max_days: 10 },
{ pincode: 843124, min_days: 7, max_days: 10 },
{ pincode: 843125, min_days: 7, max_days: 10 },
{ pincode: 843126, min_days: 7, max_days: 10 },
{ pincode: 843127, min_days: 7, max_days: 10 },
{ pincode: 843128, min_days: 7, max_days: 10 },
{ pincode: 843129, min_days: 7, max_days: 10 },
{ pincode: 843130, min_days: 7, max_days: 10 },
{ pincode: 843131, min_days: 7, max_days: 10 },
{ pincode: 843132, min_days: 7, max_days: 10 },
{ pincode: 843133, min_days: 7, max_days: 10 },
{ pincode: 843134, min_days: 7, max_days: 10 },
{ pincode: 843135, min_days: 7, max_days: 10 },
{ pincode: 843136, min_days: 7, max_days: 10 },
{ pincode: 843137, min_days: 7, max_days: 10 },
{ pincode: 843138, min_days: 7, max_days: 10 },
{ pincode: 843139, min_days: 7, max_days: 10 },
{ pincode: 843140, min_days: 7, max_days: 10 },
{ pincode: 843141, min_days: 7, max_days: 10 },
{ pincode: 843142, min_days: 7, max_days: 10 },
{ pincode: 843143, min_days: 7, max_days: 10 },
{ pincode: 843144, min_days: 7, max_days: 10 },
{ pincode: 843145, min_days: 7, max_days: 10 },
{ pincode: 843146, min_days: 7, max_days: 10 },
{ pincode: 843147, min_days: 7, max_days: 10 },
{ pincode: 843148, min_days: 7, max_days: 10 },
{ pincode: 843149, min_days: 7, max_days: 10 },
{ pincode: 843150, min_days: 7, max_days: 10 },
{ pincode: 843151, min_days: 7, max_days: 10 },
{ pincode: 843152, min_days: 7, max_days: 10 },
{ pincode: 843153, min_days: 7, max_days: 10 },
{ pincode: 843154, min_days: 7, max_days: 10 },
{ pincode: 843155, min_days: 7, max_days: 10 },
{ pincode: 843156, min_days: 7, max_days: 10 },
{ pincode: 843157, min_days: 7, max_days: 10 },
{ pincode: 843158, min_days: 7, max_days: 10 },
{ pincode: 843159, min_days: 7, max_days: 10 },
{ pincode: 843160, min_days: 7, max_days: 10 },
{ pincode: 843161, min_days: 7, max_days: 10 },
{ pincode: 843162, min_days: 7, max_days: 10 },
{ pincode: 843163, min_days: 7, max_days: 10 },
{ pincode: 843164, min_days: 7, max_days: 10 },
{ pincode: 843165, min_days: 7, max_days: 10 },
{ pincode: 843301, min_days: 7, max_days: 10 },
{ pincode: 843311, min_days: 7, max_days: 10 },
{ pincode: 843312, min_days: 7, max_days: 10 },
{ pincode: 843314, min_days: 7, max_days: 10 },
{ pincode: 843315, min_days: 7, max_days: 10 },
{ pincode: 843316, min_days: 7, max_days: 10 },
{ pincode: 843318, min_days: 7, max_days: 10 },
{ pincode: 843321, min_days: 7, max_days: 10 },
{ pincode: 843323, min_days: 7, max_days: 10 },
{ pincode: 843325, min_days: 7, max_days: 10 },
{ pincode: 843326, min_days: 7, max_days: 10 },
{ pincode: 843328, min_days: 7, max_days: 10 },
{ pincode: 843329, min_days: 7, max_days: 10 },
{ pincode: 843333, min_days: 7, max_days: 10 },
{ pincode: 843334, min_days: 7, max_days: 10 },
{ pincode: 843335, min_days: 7, max_days: 10 },
{ pincode: 843336, min_days: 7, max_days: 10 },
{ pincode: 843337, min_days: 7, max_days: 10 },
{ pincode: 843338, min_days: 7, max_days: 10 },
{ pincode: 843339, min_days: 7, max_days: 10 },
{ pincode: 843340, min_days: 7, max_days: 10 },
{ pincode: 843341, min_days: 7, max_days: 10 },
{ pincode: 843342, min_days: 7, max_days: 10 },
{ pincode: 843343, min_days: 7, max_days: 10 },
{ pincode: 843344, min_days: 7, max_days: 10 },
{ pincode: 843346, min_days: 7, max_days: 10 },
{ pincode: 843347, min_days: 7, max_days: 10 },
{ pincode: 843348, min_days: 7, max_days: 10 },
{ pincode: 843349, min_days: 7, max_days: 10 },
{ pincode: 843350, min_days: 7, max_days: 10 },
{ pincode: 843352, min_days: 7, max_days: 10 },
{ pincode: 843353, min_days: 7, max_days: 10 },
{ pincode: 843354, min_days: 7, max_days: 10 },
{ pincode: 843355, min_days: 7, max_days: 10 },
{ pincode: 843357, min_days: 7, max_days: 10 },
{ pincode: 843358, min_days: 7, max_days: 10 },
{ pincode: 843359, min_days: 7, max_days: 10 },
{ pincode: 843360, min_days: 7, max_days: 10 },
{ pincode: 843361, min_days: 7, max_days: 10 },
{ pincode: 843362, min_days: 7, max_days: 10 },
{ pincode: 843363, min_days: 7, max_days: 10 },
{ pincode: 843364, min_days: 7, max_days: 10 },
{ pincode: 843365, min_days: 7, max_days: 10 },
{ pincode: 843366, min_days: 7, max_days: 10 },
{ pincode: 843367, min_days: 7, max_days: 10 },
{ pincode: 844101, min_days: 7, max_days: 10 },
{ pincode: 844102, min_days: 7, max_days: 10 },
{ pincode: 844103, min_days: 7, max_days: 10 },
{ pincode: 844111, min_days: 7, max_days: 10 },
{ pincode: 844112, min_days: 7, max_days: 10 },
{ pincode: 844113, min_days: 7, max_days: 10 },
{ pincode: 844114, min_days: 7, max_days: 10 },
{ pincode: 844115, min_days: 7, max_days: 10 },
{ pincode: 844116, min_days: 7, max_days: 10 },
{ pincode: 844117, min_days: 7, max_days: 10 },
{ pincode: 844118, min_days: 7, max_days: 10 },
{ pincode: 844119, min_days: 7, max_days: 10 },
{ pincode: 844120, min_days: 7, max_days: 10 },
{ pincode: 844121, min_days: 7, max_days: 10 },
{ pincode: 844122, min_days: 7, max_days: 10 },
{ pincode: 844123, min_days: 7, max_days: 10 },
{ pincode: 844124, min_days: 7, max_days: 10 },
{ pincode: 844125, min_days: 7, max_days: 10 },
{ pincode: 844126, min_days: 7, max_days: 10 },
{ pincode: 844127, min_days: 7, max_days: 10 },
{ pincode: 844128, min_days: 7, max_days: 10 },
{ pincode: 844139, min_days: 7, max_days: 10 },
{ pincode: 844501, min_days: 7, max_days: 10 },
{ pincode: 844502, min_days: 7, max_days: 10 },
{ pincode: 844503, min_days: 7, max_days: 10 },
{ pincode: 844504, min_days: 7, max_days: 10 },
{ pincode: 844505, min_days: 7, max_days: 10 },
{ pincode: 844506, min_days: 7, max_days: 10 },
{ pincode: 844507, min_days: 7, max_days: 10 },
{ pincode: 844508, min_days: 7, max_days: 10 },
{ pincode: 844509, min_days: 7, max_days: 10 },
{ pincode: 845406, min_days: 7, max_days: 10 },
{ pincode: 845426, min_days: 7, max_days: 10 },
{ pincode: 845436, min_days: 7, max_days: 10 },
{ pincode: 845438, min_days: 7, max_days: 10 },
{ pincode: 845450, min_days: 7, max_days: 10 },
{ pincode: 845459, min_days: 7, max_days: 10 },
{ pincode: 845461, min_days: 7, max_days: 10 },
{ pincode: 845462, min_days: 7, max_days: 10 },
{ pincode: 845463, min_days: 7, max_days: 10 },
{ pincode: 845464, min_days: 7, max_days: 10 },
{ pincode: 845466, min_days: 7, max_days: 10 },
{ pincode: 845471, min_days: 7, max_days: 10 },
{ pincode: 845473, min_days: 7, max_days: 10 },
{ pincode: 845474, min_days: 7, max_days: 10 },
{ pincode: 845475, min_days: 7, max_days: 10 },
{ pincode: 845476, min_days: 7, max_days: 10 },
{ pincode: 845477, min_days: 7, max_days: 10 },
{ pincode: 845478, min_days: 7, max_days: 10 },
{ pincode: 845479, min_days: 7, max_days: 10 },
{ pincode: 845480, min_days: 7, max_days: 10 },
{ pincode: 845481, min_days: 7, max_days: 10 },
{ pincode: 845483, min_days: 7, max_days: 10 },
{ pincode: 845485, min_days: 7, max_days: 10 },
{ pincode: 845486, min_days: 7, max_days: 10 },
{ pincode: 845490, min_days: 7, max_days: 10 },
{ pincode: 845491, min_days: 7, max_days: 10 },
{ pincode: 845492, min_days: 7, max_days: 10 },
{ pincode: 845494, min_days: 7, max_days: 10 },
{ pincode: 845496, min_days: 7, max_days: 10 },
{ pincode: 845498, min_days: 7, max_days: 10 },
{ pincode: 845499, min_days: 7, max_days: 10 },
{ pincode: 845500, min_days: 7, max_days: 10 },
{ pincode: 845508, min_days: 7, max_days: 10 },
{ pincode: 845509, min_days: 7, max_days: 10 },
{ pincode: 845513, min_days: 7, max_days: 10 },
{ pincode: 846001, min_days: 7, max_days: 10 },
{ pincode: 846002, min_days: 7, max_days: 10 },
{ pincode: 846003, min_days: 7, max_days: 10 },
{ pincode: 846004, min_days: 7, max_days: 10 },
{ pincode: 846005, min_days: 7, max_days: 10 },
{ pincode: 846006, min_days: 7, max_days: 10 },
{ pincode: 846007, min_days: 7, max_days: 10 },
{ pincode: 846008, min_days: 7, max_days: 10 },
{ pincode: 846009, min_days: 7, max_days: 10 },
{ pincode: 847104, min_days: 7, max_days: 10 },
{ pincode: 847106, min_days: 7, max_days: 10 },
{ pincode: 847107, min_days: 7, max_days: 10 },
{ pincode: 847115, min_days: 7, max_days: 10 },
{ pincode: 847121, min_days: 7, max_days: 10 },
{ pincode: 847123, min_days: 7, max_days: 10 },
{ pincode: 847306, min_days: 7, max_days: 10 },
{ pincode: 847428, min_days: 7, max_days: 10 },
{ pincode: 847429, min_days: 7, max_days: 10 },
{ pincode: 848101, min_days: 7, max_days: 10 },
{ pincode: 848102, min_days: 7, max_days: 10 },
{ pincode: 848113, min_days: 7, max_days: 10 },
{ pincode: 848115, min_days: 7, max_days: 10 },
{ pincode: 848121, min_days: 7, max_days: 10 },
{ pincode: 848122, min_days: 7, max_days: 10 },
{ pincode: 848125, min_days: 7, max_days: 10 },
{ pincode: 848129, min_days: 7, max_days: 10 },
{ pincode: 848130, min_days: 7, max_days: 10 },
{ pincode: 848131, min_days: 7, max_days: 10 },
{ pincode: 848132, min_days: 7, max_days: 10 },
{ pincode: 848301, min_days: 7, max_days: 10 },
{ pincode: 848302, min_days: 7, max_days: 10 },
{ pincode: 848505, min_days: 7, max_days: 10 },
{ pincode: 851101, min_days: 7, max_days: 10 },
{ pincode: 851116, min_days: 7, max_days: 10 },
{ pincode: 851117, min_days: 7, max_days: 10 },
{ pincode: 851122, min_days: 7, max_days: 10 },
{ pincode: 851126, min_days: 7, max_days: 10 },
{ pincode: 851127, min_days: 7, max_days: 10 },
{ pincode: 851131, min_days: 7, max_days: 10 },
{ pincode: 851134, min_days: 7, max_days: 10 },
{ pincode: 851135, min_days: 7, max_days: 10 },
{ pincode: 851210, min_days: 7, max_days: 10 },
{ pincode: 851211, min_days: 7, max_days: 10 },
{ pincode: 852151, min_days: 7, max_days: 10 },
{ pincode: 852233, min_days: 7, max_days: 10 },
{ pincode: 853208, min_days: 7, max_days: 10 },
{ pincode: 854001, min_days: 7, max_days: 10 },
{ pincode: 854207, min_days: 7, max_days: 10 },
{ pincode: 854209, min_days: 7, max_days: 10 },
{ pincode: 854301, min_days: 7, max_days: 10 },
{ pincode: 854302, min_days: 7, max_days: 10 },
{ pincode: 854303, min_days: 7, max_days: 10 },
{ pincode: 854304, min_days: 7, max_days: 10 },
{ pincode: 854305, min_days: 7, max_days: 10 },
{ pincode: 854319, min_days: 7, max_days: 10 },
{ pincode: 854321, min_days: 7, max_days: 10 },
{ pincode: 854326, min_days: 7, max_days: 10 },
{ pincode: 854349, min_days: 7, max_days: 10 },
{ pincode: 854350, min_days: 7, max_days: 10 },
{ pincode: 854352, min_days: 7, max_days: 10 },
{ pincode: 854353, min_days: 7, max_days: 10 },
{ pincode: 854354, min_days: 7, max_days: 10 },
{ pincode: 854358, min_days: 7, max_days: 10 },
{ pincode: 854360, min_days: 7, max_days: 10 },
{ pincode: 854364, min_days: 7, max_days: 10 },
{ pincode: 855126, min_days: 7, max_days: 10 },
{ pincode: 855276, min_days: 7, max_days: 10 },
{ pincode: 855315, min_days: 7, max_days: 10 },
{ pincode: 888887, min_days: 7, max_days: 10 },
]